var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleCarousel;
        (function (articleCarousel) {
            'use strict';
            angular.module('ute.common.articleCarousel', [
                'ute.common.owlCarousel'
            ]);
        })(articleCarousel = common.articleCarousel || (common.articleCarousel = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleChild;
        (function (articleChild) {
            'use strict';
            angular.module('ute.common.articleChild', []);
        })(articleChild = common.articleChild || (common.articleChild = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleComponent;
        (function (articleComponent) {
            'use strict';
            angular.module('ute.common.articleComponent', [
                'ute.common.articleCarousel',
                'ute.common.articleSelector',
                'ute.common.brightcoveVideo',
                'ute.common.groupedAccordion',
                'ute.common.relatedQuestions',
                'ute.common.simpleHtml',
                'angularMoment',
                'ute.common.youtubeComponent'
            ]);
        })(articleComponent = common.articleComponent || (common.articleComponent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleFeedback;
        (function (articleFeedback) {
            'use strict';
            angular.module('ute.common.articleFeedback', ['ute.common.boldChat']);
        })(articleFeedback = common.articleFeedback || (common.articleFeedback = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleSelector;
        (function (articleSelector) {
            'use strict';
            angular.module('ute.common.articleSelector', [
                'ute.common.articleChild'
            ]);
        })(articleSelector = common.articleSelector || (common.articleSelector = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var boldChat;
        (function (boldChat) {
            'use strict';
            angular.module('ute.common.boldChat', []);
        })(boldChat = common.boldChat || (common.boldChat = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var breadcrumbsBar;
        (function (breadcrumbsBar) {
            'use strict';
            angular.module('ute.common.breadcrumbsBar', [
                'immutable'
            ]);
        })(breadcrumbsBar = common.breadcrumbsBar || (common.breadcrumbsBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var brightcoveVideo;
        (function (brightcoveVideo) {
            'use strict';
            angular.module('ute.common.brightcoveVideo', ['ui.bootstrap', 'ngSanitize']);
        })(brightcoveVideo = common.brightcoveVideo || (common.brightcoveVideo = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            'use strict';
            angular.module('ute.common.channelRecommendation', [
                'ute.common.channelRecommendation.badge',
                'ute.common.channelRecommendation.badge.popover',
                'ute.common.owlCarousel',
                'immutable'
            ]);
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var groupedAccordion;
        (function (groupedAccordion) {
            'use strict';
            angular.module('ute.common.groupedAccordion', [
                'ute.common.htmlContent',
                'ute.blocks.messages.bus'
            ]);
        })(groupedAccordion = common.groupedAccordion || (common.groupedAccordion = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var htmlContent;
        (function (htmlContent) {
            'use strict';
            angular.module('ute.common.htmlContent', [
                'immutable'
            ]);
        })(htmlContent = common.htmlContent || (common.htmlContent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var owlCarousel;
        (function (owlCarousel) {
            'use strict';
            angular.module('ute.common.owlCarousel', []);
        })(owlCarousel = common.owlCarousel || (common.owlCarousel = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var paginationBar;
        (function (paginationBar) {
            'use strict';
            angular.module('ute.common.paginationBar', [
                'immutable'
            ]);
        })(paginationBar = common.paginationBar || (common.paginationBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var relatedQuestions;
        (function (relatedQuestions) {
            'use strict';
            angular.module('ute.common.relatedQuestions', []);
        })(relatedQuestions = common.relatedQuestions || (common.relatedQuestions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchBar;
        (function (searchBar) {
            'use strict';
            angular.module('ute.common.searchBar', [
                'pascalprecht.translate',
                'immutable'
            ]);
        })(searchBar = common.searchBar || (common.searchBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchFilter;
        (function (searchFilter) {
            'use strict';
            angular.module('ute.common.searchFilter', [
                'immutable'
            ]);
        })(searchFilter = common.searchFilter || (common.searchFilter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchResults;
        (function (searchResults) {
            'use strict';
            angular.module('ute.common.searchResults', [
                'immutable'
            ]);
        })(searchResults = common.searchResults || (common.searchResults = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            angular.module('ute.common.searchSection', [
                'ute.assembler.mediator',
                'ute.common.breadcrumbsBar',
                'ute.common.searchBar',
                'ute.common.searchFilter',
                'ute.common.channelRecommendation',
                'ute.common.tvGuide',
                'ute.common.spotlightCallout',
                'ute.common.searchResults',
                'ute.common.paginationBar',
                'ute.common.searchSection.actions',
                'ute.common.searchSection.reducer',
                'ute.common.searchSection.services',
                'ngRedux',
                'immutable',
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simpleHtml;
        (function (simpleHtml) {
            'use strict';
            angular.module('ute.common.simpleHtml', [
                'ute.common.htmlContent',
                'immutable'
            ]);
        })(simpleHtml = common.simpleHtml || (common.simpleHtml = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var spotlightCallout;
        (function (spotlightCallout) {
            'use strict';
            angular.module('ute.common.spotlightCallout', [
                'ute.common.htmlContent',
                'immutable'
            ]);
        })(spotlightCallout = common.spotlightCallout || (common.spotlightCallout = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            angular.module('ute.common.supportSection', [
                'ute.assembler.mediator',
                'ute.common.articleComponent',
                'ute.common.articleFeedback',
                'ute.common.breadcrumbsBar',
                'ute.common.supportSection.actions',
                'ute.common.supportSection.reducer',
                'ute.common.supportSection.services',
                'ngRedux'
            ]);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var tvGuide;
        (function (tvGuide) {
            'use strict';
            angular.module('ute.common.tvGuide', [
                'ute.common.htmlContent',
                'immutable'
            ]);
        })(tvGuide = common.tvGuide || (common.tvGuide = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var youtubeComponent;
        (function (youtubeComponent) {
            'use strict';
            angular.module('ute.common.youtubeComponent', ['ngSanitize']);
        })(youtubeComponent = common.youtubeComponent || (common.youtubeComponent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            angular.module('ute.core.components', [
                'ute.common.core.shared',
                'ute.common.core.locale',
                'ute.common.core.endpoint',
                'ute.common.core.content',
                'ute.common.core.cookies',
                'ute.common.core.userPreferences',
                'ute.common.core.agentSession'
            ]);
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            'use strict';
            angular.module('ute.common.user', [
                'ute.blocks.persistent.storage',
                'ute.blocks.exception',
                'ute.common.utils',
                'ute.blocks.messages.bus',
                // ute.common.utils.UtilsStatic.getCookieModule()
                angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'
            ]);
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var assembler;
    (function (assembler) {
        var mediator;
        (function (mediator) {
            'use strict';
            angular.module('ute.assembler.mediator', [
                'ute.assembler.mediator.constants',
                'ute.assembler.mediator.services'
            ]);
        })(mediator = assembler.mediator || (assembler.mediator = {}));
    })(assembler = ute.assembler || (ute.assembler = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            angular.module('ute.common.core', [
                angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies',
                'ute.common.core.brtswitch',
                'ute.common.core.caching',
                'ute.common.core.subpub'
            ]);
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchFilter;
        (function (searchFilter) {
            'use strict';
            angular.module('ute.common.searchFilter', []);
        })(searchFilter = common.searchFilter || (common.searchFilter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
            angular.module('ute.common.utils', []);
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var services;
    (function (services) {
        var cookies;
        (function (cookies) {
            'use strict';
            angular.module('ute.services.cookies', [
                angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'
            ]);
        })(cookies = services.cookies || (services.cookies = {}));
    })(services = ute.services || (ute.services = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var userPreferences;
            (function (userPreferences) {
                'use strict';
                angular.module('ute.common.core.agentSession', [
                    'ute.common.core.userPreferences'
                ]);
            })(userPreferences = core.userPreferences || (core.userPreferences = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var content;
            (function (content) {
                'use strict';
                angular.module('ute.common.core.content', [
                    'ute.common.core.endpoint',
                    'ute.common.core.userPreferences'
                ]);
            })(content = core.content || (core.content = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var cookies;
            (function (cookies) {
                'use strict';
                angular.module('ute.common.core.cookies', [
                    'ute.common.utils',
                    //ute.common.utils.UtilsStatic.getCookieModule()
                    (angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies')
                ]);
            })(cookies = core.cookies || (core.cookies = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var endpoint;
            (function (endpoint) {
                'use strict';
                angular.module('ute.common.core.endpoint', []);
            })(endpoint = core.endpoint || (core.endpoint = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));
;

/** Contains locale-related features such as language and province selector directives, all under the same roof.
 * TBD if we want to create separate modules for language and province selectors - they're quite small.
 */
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var locale;
            (function (locale) {
                'use strict';
                angular.module('ute.common.core.locale', [
                    'ute.common.core.userPreferences'
                ]);
            })(locale = core.locale || (core.locale = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var shared;
            (function (shared) {
                'use strict';
                angular.module('ute.common.core.shared', []);
            })(shared = core.shared || (core.shared = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var userPreferences;
            (function (userPreferences) {
                'use strict';
                angular.module('ute.common.core.userPreferences', [
                    'ute.common.core.cookies',
                    'ute.common.utils',
                    'ute.blocks.messages.bus'
                ]);
            })(userPreferences = core.userPreferences || (core.userPreferences = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                angular.module('ute.blocks.language.switcher', [angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies', 'pascalprecht.translate', 'tmh.dynamicLocale']);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var messages;
        (function (messages) {
            var bus;
            (function (bus) {
                'use strict';
                angular.module('ute.blocks.messages.bus', ['ute.blocks.logger']);
            })(bus = messages.bus || (messages.bus = {}));
        })(messages = blocks.messages || (blocks.messages = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                angular.module('ute.blocks.persistent.storage', [
                    'ngStorage'
                ]);
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
            angular.module('ute.common.security', [
                'ute.blocks.logger',
                'ute.common.user'
            ]);
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            var badge;
            (function (badge) {
                'use strict';
                angular.module('ute.common.channelRecommendation.badge', ['ui.bootstrap']);
            })(badge = channelRecommendation.badge || (channelRecommendation.badge = {}));
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            var badge;
            (function (badge) {
                var popover;
                (function (popover) {
                    'use strict';
                    angular.module('ute.common.channelRecommendation.badge.popover', []);
                })(popover = badge.popover || (badge.popover = {}));
            })(badge = channelRecommendation.badge || (channelRecommendation.badge = {}));
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var subpub;
            (function (subpub) {
                'use strict';
                angular.module('ute.common.core.subpub', []);
            })(subpub = core.subpub || (core.subpub = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                angular.module('ute.common.core.brtswitch', ['ute.blocks.exception']);
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
                angular.module('ute.common.core.caching', [
                    'ute.common.core.subpub'
                ]);
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var environment;
        (function (environment) {
            'use strict';
            angular.module('ute.blocks.environment', ['ute.blocks.exception', 'config']);
        })(environment = blocks.environment || (blocks.environment = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception) {
            'use strict';
            angular.module('ute.blocks.exception', ['ute.blocks.logger']);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var logger;
        (function (logger) {
            'use strict';
            angular.module('ute.blocks.logger', []);
        })(logger = blocks.logger || (blocks.logger = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            angular.module('ute.blocks.router', [
                'ui.router',
                'ute.blocks.logger',
                'pascalprecht.translate'
            ]);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

/// <reference path="../../.tmp/typings/tsd.d.ts" />
/// <reference path="../../bower_components/immutable/dist/immutable.d.ts" />
var app;
(function (app) {
    'use strict';
    angular.module('app', [
        'ngRedux',
        'ui.bootstrap',
        'ngCookies',
        'ute.core',
        'ute.common.core.locale',
        'app.actions',
        'app.reducer',
        'app.services',
        'app.store',
        'app.config',
        'ute.assembler.mediator',
        'ute.blocks.environment',
        'ute.blocks.layout',
        'ute.common.core',
        'ute.common.searchSection',
        'ute.common.supportSection',
        'ute.sse.tsls',
        'ute.common.user',
        'ute.blocks.persistent.storage',
        'pascalprecht.translate'
    ]);
})(app || (app = {}));

var TSLSSSE;
(function (TSLSSSE) {
    'use strict';
    angular.module('ute.sse.tsls', [
        'ute.services.cookies'
    ]);
})(TSLSSSE || (TSLSSSE = {}));

var app;
(function (app) {
    var config;
    (function (config) {
        'use strict';
        angular.module('app.config', [
            'ute.blocks.environment',
            'pascalprecht.translate',
            'ute.core',
            'ute.core.components',
            'translations',
            'ute.common.user',
            'ute.blocks.persistent.storage'
        ]);
    })(config = app.config || (app.config = {}));
})(app || (app = {}));

var ute;
(function (ute) {
    var core;
    (function (core) {
        'use strict';
        angular.module('ute.core', [
            'ngAnimate',
            'ngSanitize',
            'ute.blocks.exception',
            'ute.blocks.router',
            'ngplus',
            'pascalprecht.translate',
            'ute.blocks.language.switcher',
            'ute.blocks.environment',
            'translations',
            'ute.date.time.picker'
        ]);
    })(core = ute.core || (ute.core = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var layout;
        (function (layout) {
            'use strict';
            angular.module('ute.blocks.layout', ['ute.core']);
        })(layout = blocks.layout || (blocks.layout = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

/// <reference path="../../../.tmp/typings/tsd.d.ts" />

var ute;
(function (ute) {
    var date;
    (function (date) {
        var time;
        (function (time) {
            var picker;
            (function (picker) {
                'use strict';
                angular.module('ute.date.time.picker', ['ui.bootstrap']);
            })(picker = time.picker || (time.picker = {}));
        })(time = date.time || (date.time = {}));
    })(date = ute.date || (ute.date = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user_1) {
            var service;
            (function (service) {
                'use strict';
            })(service = user_1.service || (user_1.service = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleCarousel;
        (function (articleCarousel) {
            'use strict';
            ;
        })(articleCarousel = common.articleCarousel || (common.articleCarousel = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleFeedback;
        (function (articleFeedback) {
            'use strict';
            ;
        })(articleFeedback = common.articleFeedback || (common.articleFeedback = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleSelector;
        (function (articleSelector) {
            'use strict';
        })(articleSelector = common.articleSelector || (common.articleSelector = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var boldChat;
        (function (boldChat) {
            'use strict';
            ;
        })(boldChat = common.boldChat || (common.boldChat = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var breadcrumbsBar;
        (function (breadcrumbsBar) {
            'use strict';
        })(breadcrumbsBar = common.breadcrumbsBar || (common.breadcrumbsBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var brightcoveVideo;
        (function (brightcoveVideo) {
            'use strict';
        })(brightcoveVideo = common.brightcoveVideo || (common.brightcoveVideo = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            'use strict';
            ;
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var paginationBar;
        (function (paginationBar) {
            'use strict';
            ;
        })(paginationBar = common.paginationBar || (common.paginationBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var relatedQuestions;
        (function (relatedQuestions) {
            'use strict';
            ;
        })(relatedQuestions = common.relatedQuestions || (common.relatedQuestions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchFilter;
        (function (searchFilter) {
            'use strict';
            ;
        })(searchFilter = common.searchFilter || (common.searchFilter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchResults;
        (function (searchResults) {
            'use strict';
            ;
        })(searchResults = common.searchResults || (common.searchResults = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                'use strict';
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var youtubeComponent;
        (function (youtubeComponent) {
            'use strict';
            ;
        })(youtubeComponent = common.youtubeComponent || (common.youtubeComponent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var services;
    (function (services) {
        var cookies;
        (function (cookies) {
            'use strict';
        })(cookies = services.cookies || (services.cookies = {}));
    })(services = ute.services || (ute.services = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var cookies;
            (function (cookies) {
                'use strict';
            })(cookies = core.cookies || (core.cookies = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var endpoint;
            (function (endpoint) {
                'use strict';
            })(endpoint = core.endpoint || (core.endpoint = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

// module ute.common.core.locale {
//   'use strict';
//
//   export interface ILocaleService {
//     language: string;
//     country: string;
//     province: string;
//     //actualProvince: string;
//     locale: string;
//   }
//
// }

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                var RogersStoreKeys = (function () {
                    function RogersStoreKeys() {
                    }
                    RogersStoreKeys.IS_LOGIN = 'ute.rogers.signin.service.isLogin';
                    RogersStoreKeys.ROGERS_SIGNIN_USER = 'ute.rogers.signin.user';
                    RogersStoreKeys.ROGERS_DEEP_LINK_STATE = 'ute.rogers.deep.link.state';
                    RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER = 'phoneNumber';
                    RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER = 'homePhoneNumber';
                    RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER = 'tvAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_SHM_ACCOUNT_NUMBER = 'shmAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_IPTV_ACCOUNT_NUMBER = 'iptvAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER = 'internetAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER = 'accountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER = 'accountTypeNumber';
                    RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION = 'ssoCodeVerification';
                    return RogersStoreKeys;
                }());
                storage.RogersStoreKeys = RogersStoreKeys;
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                /**
                 * List of all available BRT switches
                 */
                (function (BrtSwitches) {
                    BrtSwitches[BrtSwitches["PPC_UTE"] = 0] = "PPC_UTE";
                    BrtSwitches[BrtSwitches["NPPC_UTE"] = 1] = "NPPC_UTE";
                    BrtSwitches[BrtSwitches["ONEVIEW_RLH"] = 2] = "ONEVIEW_RLH";
                    BrtSwitches[BrtSwitches["REGISTRATION"] = 3] = "REGISTRATION";
                    BrtSwitches[BrtSwitches["USERNAME_MIGRATION"] = 4] = "USERNAME_MIGRATION";
                    BrtSwitches[BrtSwitches["ONEVIEW_HUP"] = 5] = "ONEVIEW_HUP";
                    BrtSwitches[BrtSwitches["BRITEBILL_UTE"] = 6] = "BRITEBILL_UTE";
                    BrtSwitches[BrtSwitches["HUP_UTE"] = 7] = "HUP_UTE";
                    BrtSwitches[BrtSwitches["HUP_RESP_MIGRATION"] = 8] = "HUP_RESP_MIGRATION";
                    BrtSwitches[BrtSwitches["NRS"] = 9] = "NRS";
                    BrtSwitches[BrtSwitches["SSA"] = 10] = "SSA";
                    BrtSwitches[BrtSwitches["REVOLUTION"] = 11] = "REVOLUTION";
                    BrtSwitches[BrtSwitches["RFR"] = 12] = "RFR";
                    BrtSwitches[BrtSwitches["MULTI_NPPC_UTE"] = 13] = "MULTI_NPPC_UTE";
                    BrtSwitches[BrtSwitches["CHANGE_SIM_CARD"] = 14] = "CHANGE_SIM_CARD";
                    BrtSwitches[BrtSwitches["JANRAIN_REGISTRATION"] = 15] = "JANRAIN_REGISTRATION";
                })(brtswitch.BrtSwitches || (brtswitch.BrtSwitches = {}));
                var BrtSwitches = brtswitch.BrtSwitches;
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var StateHandlerPriority = (function () {
                function StateHandlerPriority() {
                }
                StateHandlerPriority.LOW = 0;
                StateHandlerPriority.MEDIUM_LOW = 2500;
                StateHandlerPriority.MEDIUM = 5000;
                StateHandlerPriority.MEDIUM_HIGH = 7500;
                StateHandlerPriority.HIGH = 10000;
                return StateHandlerPriority;
            }());
            router.StateHandlerPriority = StateHandlerPriority;
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTestAbstract = (function () {
                    function UserTestAbstract() {
                        this.restrict = 'E';
                        this.transclude = true;
                        this.template = '<div data-ng-if="user.test()"><ng-transclude></ng-transclude></div>';
                        this.scope = {};
                        this.controllerAs = 'user';
                    }
                    return UserTestAbstract;
                }());
                directives.UserTestAbstract = UserTestAbstract;
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var subpub;
            (function (subpub) {
                'use strict';
                var SubPubGeneric = (function () {
                    function SubPubGeneric(logPrefix) {
                        var _this = this;
                        this.logPrefix = logPrefix;
                        this.onDataChangeSubs = [];
                        /**
                         * @param callback
                         * @param id
                         * @returns {boolean}
                         */
                        this.registerOnDataChangeHandler = function (callback, id) {
                            if (callback && id) {
                                var found = _.find(_this.onDataChangeSubs, function (val) { return val.id === id; });
                                if (found) {
                                    found.callback = callback;
                                }
                                else {
                                    _this.onDataChangeSubs.push({ callback: callback, id: id });
                                }
                                // console.log(this.logPrefix + '->registerOnDataChangeHandler: Subs size=', this.onDataChangeSubs.length, 'id=', id, 'subs=', this.onDataChangeSubs);
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        this.unregisterOnDataChangeHandler = function (id) {
                            _this.onDataChangeSubs = _this.onDataChangeSubs.filter(function (o, index, array) { return o.id !== id; });
                            // if (this.subPubConfig.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                            // console.log(this.logPrefix + '->unregisterOnDataChangeHandler: onDataChangeSubs size=', this.onDataChangeSubs.length, 'id=', id, 'subs=', this.onDataChangeSubs);
                            // }
                            return true; // TODO
                        };
                        this.getSubsSize = function () { return _this.onDataChangeSubs.length; };
                        this.notifySubs = function () {
                            _this.onDataChangeSubs.forEach(function (handler) {
                                try {
                                    // console.log(this.logPrefix + '->notifySubs: handlerId=', handler.id, this.getChangableData());
                                    // noinspection TypeScriptValidateTypes
                                    handler.callback(_this.getChangableData());
                                }
                                catch (e) {
                                    console.log(_this.logPrefix + '->notifySubs->handler.callback->catch:', e, handler.id, _this.getChangableData());
                                }
                            });
                        };
                    }
                    return SubPubGeneric;
                }());
                subpub.SubPubGeneric = SubPubGeneric;
                angular.module('ute.common.core.subpub').constant('SubPubGeneric', SubPubGeneric);
            })(subpub = core.subpub || (core.subpub = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
                var CacheableDataGeneric = (function (_super) {
                    __extends(CacheableDataGeneric, _super);
                    function CacheableDataGeneric(data, config, securityService, $http, $q, $timeout, userService, request) {
                        var _this = this;
                        _super.call(this, config.basic.logPrefix);
                        this.data = data;
                        this.config = config;
                        this.securityService = securityService;
                        this.$http = $http;
                        this.$q = $q;
                        this.$timeout = $timeout;
                        this.userService = userService;
                        this.request = request;
                        /**
                         * @returns {IPromise<T>}
                         */
                        this.getData = function () {
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->getData: onDataChangeHandlers.size=', _this.getSubsSize(), 'cachedResultInfo=', _.get(_this.cacheableData, 'cachedResultInfo'), 'isCallInProgress=', _this.isCallInProgress(), 'logLevel=', _this.config.basic.logLevel, ute.common.typescript.api.log.LogLevel.DEBUG);
                            }
                            if (_this.isDataLocallyCached()) {
                                if (!_this.callInProgress) {
                                    if (_this.config.basic.isCachableOnBackend && !_this.isBackendDataUpToDate()) {
                                        // returned locally cached data but schedule call to MW and notify all subs when data arrived
                                        _this.getDataRefresh(true, true);
                                    }
                                    else if (!_this.isLocalDataUpToDate()) {
                                        // returned locally cached data but schedule call to Play!/Cassandra and notify all subs when data arrived
                                        _this.getDataRefresh(false, true);
                                    }
                                }
                                // return this.$q.when<IAccountOverview>(angular.copy(this.accountOverviewData.data)); // old style
                                return new _this.$q(function (resolve) { return resolve(_.cloneDeep(_this.cacheableData.data)); });
                            }
                            else if (_this.callInProgress) {
                                // other call with the same request data
                                return _this.callInProgress;
                            }
                            else {
                                // Fastest way to get it from Play!/Cassandra
                                return _this.getDataRefresh(false);
                            }
                        };
                        /**
                         *
                         * @param refresh - true | false | undefined
                         * @param async - true - call has been instantiated internally and result will be processed by subpub
                         * @returns {IPromise<T>}
                         */
                        this.getDataRefresh = function (refresh, async) {
                            if (async === void 0) { async = false; }
                            var base = {
                                applicationId: _this.config.basic.applicationId,
                            };
                            if (_this.config.basic.isCachableOnBackend && !_.isUndefined(refresh)) {
                                base.refresh = refresh;
                            }
                            var config = angular.isObject(_this.$http.defaults) ? {
                                transformRequest: (_.get(_this.config, 'basic.$http.transformRequest') ? [].concat(_this.$http.defaults.transformRequest, _this.config.basic.$http.transformRequest) : _this.$http.defaults.transformRequest),
                                transformResponse: (_.get(_this.config, 'basic.$http.transformResponse') ? [].concat(_this.$http.defaults.transformResponse, _this.config.basic.$http.transformResponse) : _this.$http.defaults.transformResponse)
                            } : {};
                            config = angular.extend(config, async ? { extraInfo: { async: async } } : {});
                            // const config: IRequestShortcutConfig & any = async ? {extraInfo: {async: async}} : undefined;
                            var request = _.assign(base, _this.request);
                            _this.callInProgress = _this.$http.post(_this.securityService.getBackendUrl(_this.config.basic.partialApiUrl), request, config)
                                .then(_this.processOk)
                                .catch(_this.processError);
                            return _this.callInProgress;
                        };
                        /**
                         * @param response
                         * @returns {T}
                         */
                        this.processOk = function (response) {
                            _this.callInProgress = null;
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->processOk:', 'response.config.data=', response.config.data, 'cachedResultInfo=', response.data.cachedResultInfo, 'onDataChangeHandlers.size=', _this.getSubsSize());
                            }
                            var cachedResponse = false;
                            // Cachable or Not Cachable response
                            if (_.has(response.data, 'cachedResultInfo.cachedDate')) {
                                cachedResponse = true;
                                // incomming data just a string
                                response.data.cachedResultInfo.cachedDate = new Date(response.data.cachedResultInfo.cachedDate.toString());
                            }
                            // If No Local Cache or backend(Play!/Cassandra) cache has been updated
                            if (!_this.isDataLocallyCached() || !cachedResponse || _this.isBackendCacheHasBeenUpdated(response.data.cachedResultInfo.cachedDate)) {
                                var rawData = angular.extend({}, response.data);
                                if (cachedResponse) {
                                    var cachedResultInfo = {
                                        cachedDate: response.data.cachedResultInfo.cachedDate,
                                        cacheExpiryDate: new Date(response.data.cachedResultInfo.cacheExpiryDate.toString()),
                                        expired: Boolean(response.data.cachedResultInfo.expired)
                                    };
                                    delete response.data.cachedResultInfo; // Do not expose cachedResultInfo to the public
                                    // local cache
                                    _this.cacheableData = {
                                        cachedResultInfo: cachedResultInfo,
                                        localCachedDate: new Date(),
                                        data: _this.normalizeData(angular.extend(_this.data, response.data), rawData)
                                    };
                                }
                                else {
                                    delete response.data.cachedResultInfo; // Do not expose cachedResultInfo to the public
                                    // local cache
                                    _this.cacheableData = {
                                        localCachedDate: new Date(),
                                        data: _this.normalizeData(angular.extend(_this.data, response.data), rawData)
                                    };
                                }
                                if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                    console.log(_this.config.basic.logPrefix + '->LocalCache:', 'cacheableData:', _this.cacheableData);
                                }
                                if (_this.config.basic.isCachableOnBackend && !_this.isRefreshRequested(response.config.data) && !_this.isBackendDataUpToDate()) {
                                    _this.getDataRefresh(true, true);
                                }
                                // only if it's background call //TODO clear distinct between original call with promise returned to the caller and background async call
                                if (_.get(response.config, 'extraInfo.async')) {
                                    // if (this.isRefreshRequested(response.config.data)) {
                                    _this._notifySubs();
                                }
                            }
                            else {
                                _this.cacheableData.localCachedDate = new Date();
                            }
                            // if (this.isBackendDataUpToDate()) {
                            //   this.refreshCount = 1;
                            // } else {
                            // if backend return already expired data on refreshed request - schedule it
                            // If No scheduled and we tried already
                            /*
                             if (!this.scheduledRefresh && this.isRefreshRequested(response.config.data)) {
                             if (this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                             console.log(this.config.basic.logPrefix + '->scheduledRefresh: scheduled full refresh from MW in ' + 10 * this.refreshCount + ' sec');
                             }
                             this.scheduledRefresh = this.$timeout(() => {
                             this.getDataRefresh(true, true); // TODO if refreshable
                             }, 10000 * this.refreshCount); // 10 sec * n
                             this.refreshCount++;
                      
                             this.scheduledRefresh.finally(() => this.scheduledRefresh = null);
                             }
                             */
                            // }
                            // return immutable copy
                            return _.cloneDeep(_this.cacheableData.data);
                        };
                        /**
                         * normalizer backend datatypes
                         * default implementation - do nothing
                         * @param input
                         * @returns {T}
                         */
                        this.normalizeData = function (input, rawData) {
                            return input;
                        };
                        /**
                         * @param requestData
                         * @returns {boolean}
                         */
                        this.isRefreshRequested = function (requestData) {
                            return requestData.refresh === true;
                        };
                        /**
                         * @param error
                         * @returns {T}
                         */
                        this.processError = function (error) {
                            _this.callInProgress = null;
                            return new _this.$q(function (resolve, reject) { return reject(error); });
                        };
                        this.resetData = function () {
                            try {
                                _this.cleanup();
                            }
                            catch (e) {
                            }
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isCallInProgress = function () {
                            // return this.isCallInProgress;
                            return !!_this.callInProgress;
                        };
                        this._notifySubs = function () {
                            if (_this.isDataLocallyCached()) {
                                _this.notifySubs();
                            }
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isBackendCacheHasBeenUpdated = function (cachedDate) {
                            return angular.isDate(_.get(_this.cacheableData, 'cachedResultInfo.cachedDate')) && _this.cacheableData.cachedResultInfo.cachedDate.getTime() !== cachedDate.getTime();
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isDataLocallyCached = function () {
                            return _.isObject(_this.cacheableData);
                        };
                        /**
                         * Check if backend/Play!/Cassandra data up to date
                         * @returns {boolean}
                         */
                        this.isBackendDataUpToDate = function () {
                            var retval = _this.isDataLocallyCached() && (!_.get(_this.cacheableData, 'cachedResultInfo.expired', false) || _.get(_this.cacheableData, 'cachedResultInfo.expired', true) === false &&
                                _this.cacheableData.cachedResultInfo.cacheExpiryDate > new Date());
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG && _this.isDataLocallyCached() && _.has(_this.cacheableData, 'cachedResultInfo.cacheExpiryDate')) {
                                console.log(_this.config.basic.logPrefix + '->isBackendDataUpToDate:', retval, 'diffTimestamp=', _this.cacheableData.cachedResultInfo.cacheExpiryDate.getTime() - new Date().getTime(), 'backend cacheExpiryDate=', _this.cacheableData.cachedResultInfo.cacheExpiryDate);
                            }
                            return retval;
                        };
                        this.cleanup = function () {
                            _this.cacheableData = null;
                            if (_this.scheduledRefresh) {
                                _this.$timeout.cancel(_this.scheduledRefresh);
                            }
                        };
                        /**
                         * Check if local data up to date - 60 sec for now
                         * @returns {boolean}
                         */
                        this.isLocalDataUpToDate = function () {
                            // TODO 60000
                            var retval = _this.isDataLocallyCached() /*&& this.isBackendDataUpToDate()*/ && new Date().getTime() - _this.cacheableData.localCachedDate.getTime() <= 60000;
                            if (_this.isDataLocallyCached() && _this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->isLocalDataUpToDate:', retval, 'diff=', new Date().getTime() - _this.cacheableData.localCachedDate.getTime(), 'localCachedDate=', _this.cacheableData.localCachedDate);
                            }
                            return retval;
                        };
                        this.config.basic.isCachableOnBackend = _.isUndefined(this.config.basic.isCachableOnBackend) ? true : this.config.basic.isCachableOnBackend;
                        this.config.basic.logLevel = this.config.basic.logLevel || ute.common.typescript.api.log.LogLevel.OFF;
                        this.userService.registerSigninHandler(this.cleanup, this);
                    }
                    ;
                    /**
                     * @override
                     * @returns {T}
                     */
                    CacheableDataGeneric.prototype.getChangableData = function () {
                        return _.get(this.cacheableData, 'data');
                    };
                    return CacheableDataGeneric;
                }(ute.common.core.subpub.SubPubGeneric));
                caching.CacheableDataGeneric = CacheableDataGeneric;
                angular.module('ute.common.core.caching').constant('CacheableDataGeneric', CacheableDataGeneric);
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            var ProviderBase = (function () {
                function ProviderBase() {
                    var _this = this;
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    /**
                     * @returns {C}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                }
                return ProviderBase;
            }());
            core.ProviderBase = ProviderBase;
            angular.module('ute.common.core').constant('ProviderBase', ProviderBase);
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var service;
            (function (service) {
                'use strict';
                var ResponseErrorHandlerGeneric = (function () {
                    function ResponseErrorHandlerGeneric(defaultFrontEndErrorCode, defaultBackEndErrorCode, logPrefix, $injector) {
                        var _this = this;
                        this.defaultFrontEndErrorCode = defaultFrontEndErrorCode;
                        this.defaultBackEndErrorCode = defaultBackEndErrorCode;
                        this.logPrefix = logPrefix;
                        this.errorCodesMap = {};
                        this.isCallInProgress = false;
                        this.openModalPopup = function (codeEntry) { return null; };
                        /**
                         * @param code
                         * @returns {boolean}
                         */
                        this.addCode = function (code) {
                            _this.errorCodesMap[code.frontendCode] = code;
                        };
                        /**
                         * @param backendCode
                         * @returns {<CE>}
                         */
                        this.findCodeEntry = function (backendCode) { return (_.find(_this.errorCodesMap, function (ce) {
                            return ce.backendCode === backendCode;
                        }) || _this.errorCodesMap[_this.defaultFrontEndErrorCode]); };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processOk = function (response) {
                            var backendCode = _.get(response, 'data.status.code', _this.defaultBackEndErrorCode);
                            var retval = _this.findCodeEntry(backendCode);
                            console.log(_this.logPrefix + '->processOk:', 'response:', response, 'backendCode:', backendCode, 'retval:', retval);
                            return retval;
                        };
                        /**
                         * @param error
                         * @return {any}
                         */
                        this.processError = function (error) {
                            var backendCode = _.get(error, 'data.status.code', _this.defaultBackEndErrorCode);
                            var retval = _this.findCodeEntry(backendCode);
                            console.log(_this.logPrefix + '->processError:', 'error:', error, 'backendCode:', backendCode);
                            if (retval.windowTemplateUrl) {
                                return _this.openModalPopup(retval);
                            }
                            else {
                                return new _this.$q(function (resolve, reject) { return reject(retval); });
                            }
                        };
                        this.finaliseCall = function () {
                            _this.isCallInProgress = false;
                        };
                        this.$q = $injector.get('$q');
                    }
                    ;
                    return ResponseErrorHandlerGeneric;
                }());
                service.ResponseErrorHandlerGeneric = ResponseErrorHandlerGeneric;
                angular.module('ute.common.core').constant('ResponseErrorHandlerGeneric', ResponseErrorHandlerGeneric);
            })(service = core.service || (core.service = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var TestAbstract = (function () {
                        function TestAbstract() {
                            this.restrict = 'E';
                            this.transclude = true;
                            this.template = '<span data-ng-if="$ctrl.test"><ng-transclude></ng-transclude></span>';
                            this.scope = {};
                            this.controllerAs = '$ctrl';
                        }
                        return TestAbstract;
                    }());
                    directives.TestAbstract = TestAbstract;
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user_1) {
            var service;
            (function (service) {
                'use strict';
                var UserService = (function () {
                    /* @ngInject */
                    function UserService($injector, config) {
                        var _this = this;
                        this.$injector = $injector;
                        this.config = config;
                        //private failSafeKey: string = this.utilsService.randomString();
                        this.failSafeKey = '7RvnncDPUc535aBZftoarnFdYXM1zlfY';
                        this.signinHandlers = [];
                        this.signoutHandlers = [];
                        this.isSigned = function () {
                            //console.log('isSigned', !!this.user);
                            return !!_this.user;
                        };
                        this.signed = function (user) {
                            // because this called from pure JavaScript
                            if (angular.isString(user.userType)) {
                                //noinspection TypeScriptUnresolvedFunction
                                user.userType = user_1.UserType[user.userType.toString()];
                            }
                            _this.callSigninHandlers();
                            //console.log('ute.user.service.UserService.signed: user=', user, ' cache=', (<any>this.getEncryptionKey).cache);
                            var userWithoutPassword = _.cloneDeep(user);
                            delete userWithoutPassword.userPassword;
                            _this.user = userWithoutPassword;
                            _this.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER, userWithoutPassword);
                            _this.messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, _this.user);
                            //this.storageService.put('ute.rogers.signin.user', userWithoutPassword);
                        };
                        /**
                         * !!! do not use this method in real application !!!
                         */
                        this.signout = function () {
                            // TODO still not real signout, real signout provider must be called here
                            // this is temporary
                            // const options: any = {path: '/', domain: '.rogers.com'};
                            // this.$cookies.remove('SMSESSION', options);
                            // this.$cookies.remove('SM_USERAUTHENTICATED', options);
                            _this.config.advanced.signoutCallback(_this.$injector);
                            // this.unsigned();
                        };
                        this.unsigned = function () {
                            _this.callSignoutHandlers();
                            //console.log('ute.user.service.UserService.unsigned: user=', this.user, ' cache=', (<any>this.getEncryptionKey).cache);
                            _this.user = null;
                            _this.storageService.removeFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER);
                            _this.messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSignoutSuccessful);
                            //this.storageService.remove('ute.rogers.signin.user');
                        };
                        /**
                         * @returns {ute.common.user.IUser}
                         */
                        this.getUser = function () {
                            return angular.copy(_this.user);
                        };
                        this.setUsername = function (newUsername) {
                            _this.updateUsername(newUsername);
                        };
                        /**
                         * @returns {string}
                         */
                        this.getUserType = function () {
                            if (angular.isDefined(_this.user)) {
                                var ut = _.get(_this.user, 'userType');
                                return angular.isUndefined(ut) ? undefined : user_1.UserType[ut];
                            }
                            else {
                                return undefined;
                            }
                        };
                        /**
                         * @param partialUrl
                         * @returns {string}
                         */
                        this.getBackendUrl = function (partialUrl) {
                            // console.log('ute.common.security.service->getBackendUrl', (this.config.roleToUrlBase[this.userService.getUserType()]) + partialUrl);
                            return (_.get(_this.config, 'roleToUrlBase.' + _this.getUserType() + '.baseUrl') || UserProvider.protectedUrlPrefix) + partialUrl;
                        };
                        this.getPersistentService = function () {
                            return _.get(_this.config, 'roleToUrlBase.' + _this.getUserType() + '.persistentService') || _this.$injector.get('ute.blocks.persistent.storage.service').getLocalStoreService();
                        };
                        this.isAnyRoleGranted = function (userRoles) {
                            var rolesArray = userRoles ? userRoles.split(',').map(function (s) { return s.trim(); }) : [];
                            return _.include(rolesArray, _this.getUserType());
                        };
                        /**
                         * @param callBack
                         * @param thisArg
                         * @param argArray
                         */
                        this.registerSigninHandler = function (callBack, thisArg, argArray) {
                            if (callBack && thisArg) {
                                _this.signinHandlers.push({ callBack: callBack, thisArg: thisArg, argArray: argArray });
                            }
                        };
                        /**
                         * @param callBack
                         * @param thisArg
                         * @param argArray
                         */
                        this.registerSignoutHandler = function (callBack, thisArg, argArray) {
                            if (callBack && thisArg) {
                                _this.signoutHandlers.push({ callBack: callBack, thisArg: thisArg, argArray: argArray });
                            }
                        };
                        /**
                         * @returns {any}
                         * @private
                         */
                        this._getEncryptionKey = function () {
                            if (_this.isSigned()) {
                                return _this.$http.get(_this.getBackendUrl('v1/myKey'))
                                    .then(_this.processEncryptionKeyResponse)
                                    .catch(_.curry(_this.fail)('processEncryptionKeyResponse failed.'));
                            }
                            else {
                                return new _this.$q(function (resolve) { return resolve(_this.failSafeKey); });
                            }
                        };
                        /**
                         * @returns {any}
                         */
                        this.getUserName = function () {
                            return _.get(_this.user, 'userName');
                        };
                        this.updateUsername = function (newUsername) {
                            _this.user.userEmail = newUsername;
                            _this.user.userName = newUsername;
                            _this.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER, _this.user);
                        };
                        this.callSigninHandlers = function () {
                            _this.callHandlers(_this.signinHandlers);
                        };
                        this.callSignoutHandlers = function () {
                            _this.callHandlers(_this.signoutHandlers);
                        };
                        /**
                         * @param handlers
                         */
                        this.callHandlers = function (handlers) {
                            handlers.forEach(function (handler) {
                                try {
                                    // TODO async
                                    handler.callBack.apply(handler.thisArg, handler.argArray);
                                }
                                catch (e) {
                                }
                            });
                        };
                        this.getCacheName = function () {
                            return 'EncryptionKeyCacheName';
                        };
                        this.cleanCache = function () {
                            //console.log('ute.user.service.UserService.cleanCache: cache=', (<any>this.getEncryptionKey).cache);
                            _this.getEncryptionKey.cache.delete(_this.getCacheName());
                        };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processEncryptionKeyResponse = function (response) {
                            //console.log('ute.user.service.UserService.processEncryptionKeyResponse', _.get<string>(response, 'data.content.key', this.failSafeKey));
                            return _.get(response, 'data.content.key', _this.failSafeKey);
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {string}
                         */
                        //private fail: (reason: string, error: any) => ng.IPromise<any> = (reason: string, error: any) => {
                        this.fail = function (reason, error) {
                            //var msg = _.get(error, 'data.description', error);
                            //this.exceptionHandler.catcher(msg)(reason, 'ute.common.user.service');
                            //return this.$q.reject(msg);
                            //console.log('ute.user.service.UserService.fail', this.failSafeKey + this.getUserName());
                            return _this.failSafeKey + _this.getUserName();
                        };
                        this.storageService = $injector.get('ute.blocks.persistent.storage.service');
                        this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                        this.$q = $injector.get('$q');
                        this.$http = $injector.get('$http');
                        // ute.common.utils.UtilsStatic.getCookieService(),
                        this.$cookies = $injector.get(angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies');
                        // we don't know who the user is at this point, so we try form both: local and session
                        this.user = this.storageService.getFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER) ||
                            this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER);
                        this.getEncryptionKey = _.memoize(this._getEncryptionKey, this.getCacheName);
                        this.registerSigninHandler(this.cleanCache, this);
                        this.getUserRole = this.getUserType;
                    }
                    UserService.$inject = [
                        '$injector'
                    ];
                    return UserService;
                }());
                var UserProvider = (function () {
                    /* @ngInject */
                    function UserProvider() {
                        var _this = this;
                        this.config = {
                            // roles: [UserType.care, UserType.dealer, UserType.consumer],
                            roleToUrlBase: {}
                        };
                        /* @ngInject */
                        this.$get = function ($injector) {
                            _this.$injector = $injector;
                            var storeService = $injector.get('ute.blocks.persistent.storage.service');
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.care]].persistentService = storeService.getSessionStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.careRep]].persistentService = storeService.getSessionStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.dealer]].persistentService = storeService.getLocalStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.consumer]].persistentService = storeService.getLocalStoreService();
                            return new UserService($injector, _this.config);
                        };
                        this.$get.$inject = [
                            '$injector'
                        ];
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.care]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.careRep]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.dealer]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.consumer]] = { baseUrl: UserProvider.protectedUrlPrefix };
                    }
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    UserProvider.prototype.configure = function (config) {
                        this.config = _.merge(this.config, config);
                        return true;
                    };
                    UserProvider.protectedUrlPrefix = '/web/RogersServices.portal/totes/api/';
                    UserProvider.publicUrlPrefix = '/web/totes/api/';
                    UserProvider.$inject = [];
                    return UserProvider;
                }());
                angular.module('ute.common.user').provider('ute.common.user.service', UserProvider);
            })(service = user_1.service || (user_1.service = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            'use strict';
            (function (UserType) {
                UserType[UserType["dealer"] = 0] = "dealer";
                UserType[UserType["care"] = 1] = "care";
                UserType[UserType["consumer"] = 2] = "consumer";
                UserType[UserType["careRep"] = 3] = "careRep";
            })(user.UserType || (user.UserType = {}));
            var UserType = user.UserType;
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleCarousel;
        (function (articleCarousel) {
            'use strict';
            var ArticleCarouselController = (function () {
                function ArticleCarouselController() {
                }
                ArticleCarouselController.controllerName = 'ute.common.articleCarousel.controller';
                ArticleCarouselController.$inject = [];
                return ArticleCarouselController;
            }());
            articleCarousel.ArticleCarouselController = ArticleCarouselController;
            angular.module('ute.common.articleCarousel').controller(ArticleCarouselController.controllerName, ArticleCarouselController);
        })(articleCarousel = common.articleCarousel || (common.articleCarousel = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleCarousel;
        (function (articleCarousel) {
            'use strict';
            var ArticleCarousel = (function () {
                function ArticleCarousel() {
                    // DDO properties
                    this.templateUrl = 'module/uteArticleCarousel/articleCarousel.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.articleCarousel.controller';
                    this.controllerAs = 'articleCarousel';
                    this.scope = {
                        carouselOptions: '=',
                        carouselItems: '=',
                        slideNumber: '=',
                        sectionTitle: '='
                    };
                    this.bindToController = true;
                }
                ArticleCarousel.factory = function () {
                    var directive = function () { return new ArticleCarousel(); };
                    directive.$inject = [];
                    return directive;
                };
                return ArticleCarousel;
            }());
            angular.module('ute.common.articleCarousel').directive('uteArticleCarousel', ArticleCarousel.factory());
        })(articleCarousel = common.articleCarousel || (common.articleCarousel = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleChild;
        (function (articleChild) {
            'use strict';
            var ArticleChildController = (function () {
                function ArticleChildController($timeout, $window) {
                    var _this = this;
                    this.$timeout = $timeout;
                    this.$window = $window;
                    $timeout(function () { return _this.expandAndScroll.call(_this); });
                }
                ArticleChildController.prototype.expandAndScroll = function () {
                    if (!location.hash) {
                        return;
                    }
                    var $ = this.$window.$;
                    var $accordion = $(location.hash);
                    if ($accordion.length) {
                        // expand the accordion
                        $accordion.trigger('click');
                        // HACK - to prevent browser default hash load scroll
                        $('[id="' + location.hash.substr(1) + '"]')
                            .removeAttr('id')
                            .attr('data-id', location.hash.substr(1));
                        var scrollToAccordion = function () {
                            var headerHeight = $('#header').outerHeight();
                            var accordionTopOffset = $accordion.offset().top;
                            $('html, body').animate({ scrollTop: accordionTopOffset - headerHeight });
                        };
                        // check if header is already loaded or wait for the event.
                        $('#header').length ? scrollToAccordion() : $(document.body).one('cms:loaded:header', function () { return scrollToAccordion(); });
                    }
                };
                ArticleChildController.controllerName = 'ute.common.articleChild.controller';
                ArticleChildController.$inject = [
                    '$timeout',
                    '$window'
                ];
                return ArticleChildController;
            }());
            articleChild.ArticleChildController = ArticleChildController;
            angular.module('ute.common.articleChild').controller(ArticleChildController.controllerName, ArticleChildController);
        })(articleChild = common.articleChild || (common.articleChild = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleChild;
        (function (articleChild) {
            'use strict';
            var ArticleChild = (function () {
                function ArticleChild() {
                    // DDO properties
                    this.templateUrl = 'module/uteArticleChild/articleChild.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.articleChild.controller';
                    this.scope = {
                        articleTitle: '=',
                        articleContents: '='
                    };
                }
                ArticleChild.factory = function () {
                    var directive = function () { return new ArticleChild(); };
                    directive.$inject = [];
                    return directive;
                };
                return ArticleChild;
            }());
            angular.module('ute.common.articleChild').directive('uteArticleChild', ArticleChild.factory());
        })(articleChild = common.articleChild || (common.articleChild = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleComponent;
        (function (articleComponent) {
            'use strict';
            var ArticleComponentController = (function () {
                function ArticleComponentController($scope, messagesService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.messagesService = messagesService;
                    this.$scope.articleData = [];
                    this.messagesService.register('ute-common-groupedAccordion-toggleExpand', function (evt, accordionData) {
                        console.log('huh');
                        _this.$scope.expandedAccordionData = accordionData;
                        console.log(accordionData);
                        if (!_this.$scope.expandedAccordionData.setTo) {
                            _this.$scope.expandedAccordionData.expandedIndex = -1;
                        }
                    });
                }
                ArticleComponentController.controllerName = 'ute.common.articleComponent.controller';
                ArticleComponentController.$inject = ['$scope', 'ute.blocks.messages.bus.service'];
                return ArticleComponentController;
            }());
            articleComponent.ArticleComponentController = ArticleComponentController;
            angular.module('ute.common.articleComponent').controller(ArticleComponentController.controllerName, ArticleComponentController);
        })(articleComponent = common.articleComponent || (common.articleComponent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleComponent;
        (function (articleComponent) {
            'use strict';
            var ArticleComponent = (function () {
                function ArticleComponent() {
                    // DDO properties
                    this.templateUrl = 'module/uteArticleComponent/articleComponent.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.articleComponent.controller';
                    this.scope = {
                        articleId: '@',
                        articleDateModified: '=',
                        articleTitle: '=',
                        articleContents: '=',
                        childArticle: '=',
                        onSelectChildArticle: '&'
                    };
                }
                ArticleComponent.factory = function () {
                    var directive = function () { return new ArticleComponent(); };
                    directive.$inject = [];
                    return directive;
                };
                return ArticleComponent;
            }());
            angular.module('ute.common.articleComponent')
                .directive('uteArticleComponent', ArticleComponent.factory());
        })(articleComponent = common.articleComponent || (common.articleComponent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleFeedback;
        (function (articleFeedback) {
            'use strict';
            var ArticleFeedbackController = (function () {
                /* @ngInject */
                function ArticleFeedbackController($ngRedux, $scope, $sce, SupportActions) {
                    this.$ngRedux = $ngRedux;
                    this.$scope = $scope;
                    this.$sce = $sce;
                    this.SupportActions = SupportActions;
                    // onSubmitFeedback: (feedback: Array<any>) => void;
                    this.feedbackAnswer = 'none';
                    // unsubscribe from Redux updates when controller is destroyed
                    var unsubscribe = $ngRedux.connect(this.mapStateToThis, SupportActions)(this);
                    $scope.$on('$destroy', unsubscribe);
                }
                ArticleFeedbackController.prototype.feedbackQuestions = function (answer) {
                    this.feedbackAnswer = answer;
                    this.$ngRedux.dispatch(this.SupportActions.submitArticleFeedback('', answer));
                    if (answer === 'yes') {
                        this.feedbackCaptcha = 'thankYou';
                        this.feedbackAnswer = '';
                    }
                };
                ;
                ArticleFeedbackController.prototype.resetForm = function () {
                    this.feedbackAnswer = 'none';
                };
                ;
                ArticleFeedbackController.prototype.onSubmitFeedback = function (feedback) {
                    var userAnswer = $('#g-recaptcha-response').val();
                    if (userAnswer && userAnswer.length > 0) {
                        this.$ngRedux.dispatch(this.SupportActions.submitArticleFeedback(feedback, this.feedbackAnswer));
                        this.feedbackCaptcha = 'thankYou';
                        this.feedbackAnswer = '';
                    }
                    else {
                        this.feedbackCaptcha = 'error';
                    }
                };
                // map Redux store's properties to controller properties
                ArticleFeedbackController.prototype.mapStateToThis = function (state) {
                    return {
                        feedback: state.get('feedback')
                    };
                };
                ArticleFeedbackController.controllerName = 'ute.common.articleFeedback.controller';
                ArticleFeedbackController.$inject = [
                    '$ngRedux',
                    '$scope',
                    '$sce',
                    'SupportActions'
                ];
                return ArticleFeedbackController;
            }());
            articleFeedback.ArticleFeedbackController = ArticleFeedbackController;
            angular.module('ute.common.articleFeedback').controller(ArticleFeedbackController.controllerName, ArticleFeedbackController);
        })(articleFeedback = common.articleFeedback || (common.articleFeedback = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleFeedback;
        (function (articleFeedback) {
            'use strict';
            var ArticleFeedback = (function () {
                function ArticleFeedback() {
                    // DDO properties
                    this.templateUrl = 'module/uteArticleFeedback/articleFeedback.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.articleFeedback.controller';
                    this.controllerAs = 'articleFeedback';
                    this.scope = {
                        minLength: '=',
                        maxLength: '=',
                        captchaKey: '=',
                        feedbackQuestion: '=',
                        feedbackForm: '=',
                        feedbackAnswerYes: '=',
                        feedbackAnswerNo: '=',
                        language: '@'
                    };
                    this.bindToController = true;
                }
                ArticleFeedback.factory = function () {
                    var directive = function () { return new ArticleFeedback(); };
                    directive.$inject = [];
                    return directive;
                };
                return ArticleFeedback;
            }());
            angular.module('ute.common.articleFeedback').directive('uteArticleFeedback', ArticleFeedback.factory());
        })(articleFeedback = common.articleFeedback || (common.articleFeedback = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleSelector;
        (function (articleSelector) {
            'use strict';
            var ArticleSelectorController = (function () {
                /* @ngInject */
                function ArticleSelectorController($state) {
                    var _this = this;
                    this.$state = $state;
                    this.selectedOption = '';
                    this.optionsList.map(function (option) {
                        if (option.dimensionValue === _this.$state.params.childArticleId) {
                            _this.selectedOption = option;
                        }
                    });
                }
                ArticleSelectorController.prototype.multipleSelector = function () {
                    return this.optionsList && this.optionsList.length > 2;
                };
                ;
                ArticleSelectorController.controllerName = 'ute.common.articleSelector.controller';
                ArticleSelectorController.$inject = ['$state'];
                return ArticleSelectorController;
            }());
            articleSelector.ArticleSelectorController = ArticleSelectorController;
            angular.module('ute.common.articleSelector').controller(ArticleSelectorController.controllerName, ArticleSelectorController);
        })(articleSelector = common.articleSelector || (common.articleSelector = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var articleSelector;
        (function (articleSelector) {
            'use strict';
            var ArticleSelector = (function () {
                function ArticleSelector() {
                    // DDO properties
                    this.templateUrl = 'module/uteArticleSelector/articleSelector.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.articleSelector.controller';
                    this.controllerAs = 'articleSelector';
                    this.scope = {
                        optionsList: '=?',
                        mainLabel: '=',
                        optionsLabel: '=',
                        childArticle: '=',
                        onSelectOption: '&'
                    };
                    this.bindToController = true;
                }
                ArticleSelector.factory = function () {
                    var directive = function () { return new ArticleSelector(); };
                    directive.$inject = [];
                    return directive;
                };
                return ArticleSelector;
            }());
            angular.module('ute.common.articleSelector').directive('uteArticleSelector', ArticleSelector.factory());
        })(articleSelector = common.articleSelector || (common.articleSelector = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var boldChat;
        (function (boldChat) {
            'use strict';
            var BoldChatController = (function () {
                function BoldChatController($scope) {
                    this.$scope = $scope;
                    this.randomId = Math.random();
                    this._bcvma = [];
                    this.VisitorName = window.localStorage.fullName || '';
                    this.visitorPhone = window.localStorage.firstCTN || '';
                    this.custTrackingid = window.custTrackingid || '';
                    this.isLoggedIn = window.isLoggedIn;
                    this.createChatButton();
                }
                ////////////////////////
                // BOLD CHAT
                ////////////////////////
                /**
                 * Secure params function for Bold Chat Button
                 * @param  {Function} callback [description]
                 * @param  {[type]}   type     [description]
                 * @return {[type]}            [description]
                 */
                BoldChatController.prototype.secureParams = function (callback, type) {
                    customParams(function () {
                        if (window.pageViewer && pageViewer.load) {
                            window.pageViewer.setParameter('VisitName', this.VisitorName);
                            window.pageViewer.setParameter('VisitPhone', this.visitorPhone);
                            window.pageViewer.setParameter('VisitEmail', this.VisitorEmail);
                            window.pageViewer.setParameter('VisitRef', this.language);
                        }
                        else {
                            this._bcvma.push(['setParameter', 'VisitName', this.VisitorName]);
                            this._bcvma.push(['setParameter', 'VisitPhone', this.visitorPhone]);
                            this._bcvma.push(['setParameter', 'VisitEmail', this.VisitorEmail]);
                            this._bcvma.push(['setParameter', 'VisitRef', this.language]);
                        }
                    });
                    var allVariablesToPassThrough = 'Unsecured=' + encodeURIComponent('url&referrer&vn&vr&vi&ve&vp&curl&vicon&oicon&ln&vn&eq&cr&ci&ca&lc&cbdid&cwdid&rdid&roid&ccid&idid&');
                    if (type === 'visit' || !window.isLoggedIn) {
                        callback(allVariablesToPassThrough + 'customField_CxPageTitle=' + encodeURIComponent(document.title) + '&customField_custtrackingid=' + encodeURIComponent(this.custTrackingid));
                    }
                    else {
                        generateToken(function (ssoToken, delStatus) {
                            callback(allVariablesToPassThrough + '&customField_ssoToken=' + encodeURIComponent(ssoToken) + '&customField_CxLogin=' + userLogin + '&customField_CxAccnt=' + selectedAcctNumber +
                                '&customField_CxErrorMessage=' + encodeURIComponent(CxErrorMessage) + '&customField_CxPageTitle=' + encodeURIComponent(document.title) + '&customField_custtrackingid=' + encodeURIComponent(this.custTrackingid) +
                                '&vi=' + delStatus);
                        });
                    }
                };
                /**
                 * Setup pageviewer for Bold Chat Button
                 * @return {[type]} [description]
                 */
                BoldChatController.prototype.setupPageViewer = function () {
                    if (window.pageViewer && pageViewer.load) {
                        window.pageViewer.check(1, 2);
                        window.pageViewer = window._bcvm.getPageViewer();
                        window.pageViewer.setAccountID('369303105785976989');
                        window.pageViewer.setParameter('WebsiteID', '236757985006933441');
                        window.pageViewer.setParameter('VisitName', this.VisitorName);
                        window.pageViewer.setParameter('VisitPhone', this.visitorPhone);
                        window.pageViewer.setParameter('VisitEmail', this.VisitorEmail);
                    }
                    else {
                        this._bcvma.push(['setAccountID', '369303105785976989']);
                        this._bcvma.push(['setParameter', 'WebsiteID', '236757985006933441']);
                        this._bcvma.push(['setParameter', 'CustomUrl', '']);
                        this._bcvma.push(['setParameter', 'VisitName', this.VisitorName]);
                        this._bcvma.push(['setParameter', 'VisitPhone', this.visitorPhone]);
                        this._bcvma.push(['setParameter', 'VisitEmail', this.VisitorEmail]);
                        this._bcvma.push(['setParameter', 'VisitRef', this.language]);
                    }
                };
                /**
                 * Setup live chat button
                 * @return {[type]} [description]
                 */
                BoldChatController.prototype.createChatButton = function () {
                    var bdidVal = window[this.buttonId] || '', bccbId = this.randomId;
                    this.setupPageViewer();
                    if (window.pageViewer) {
                        window.pageViewer.addStatic({ type: 'chat', bdid: bdidVal, id: bccbId });
                        window.pageViewer.pageViewed();
                    }
                    else {
                        this._bcvma.push(['addStatic', { type: 'chat', bdid: bdidVal, id: bccbId }]);
                    }
                };
                BoldChatController.controllerName = 'ute.common.boldChat.controller';
                BoldChatController.$inject = ['$scope'];
                return BoldChatController;
            }());
            boldChat.BoldChatController = BoldChatController;
            angular.module('ute.common.boldChat').controller(BoldChatController.controllerName, BoldChatController);
        })(boldChat = common.boldChat || (common.boldChat = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var boldChat;
        (function (boldChat) {
            'use strict';
            var BoldChat = (function () {
                function BoldChat() {
                    // DDO properties
                    this.templateUrl = 'module/uteBoldChat/boldChat.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.boldChat.controller';
                    this.controllerAs = 'boldChat';
                    this.replace = true;
                    this.scope = {
                        buttonId: '@'
                    };
                    this.bindToController = true;
                }
                BoldChat.factory = function () {
                    var directive = function () { return new BoldChat(); };
                    directive.$inject = ['$interpolate'];
                    return directive;
                };
                return BoldChat;
            }());
            angular.module('ute.common.boldChat').directive('uteBoldChat', BoldChat.factory());
        })(boldChat = common.boldChat || (common.boldChat = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var breadcrumbsBar;
        (function (breadcrumbsBar) {
            'use strict';
            var BreadcrumbsBarController = (function () {
                function BreadcrumbsBarController($scope) {
                    this.$scope = $scope;
                }
                BreadcrumbsBarController.prototype.getUrl = function (breadcrumb, businessUnit) {
                    if (!angular.isObject(breadcrumb)) {
                        return;
                    }
                    if (breadcrumb.url) {
                        return breadcrumb.url;
                    }
                    if (breadcrumb.label !== 'Help & Support') {
                        return;
                    }
                    switch (businessUnit) {
                        case 'consumer':
                            breadcrumb.url = '/consumer/support';
                            break;
                        case 'smallbusiness':
                            breadcrumb.url = '/small-business/help-and-resources/support';
                            break;
                        case 'enterprise':
                            breadcrumb.url = '';
                            break;
                        default:
                            breadcrumb.url = '/consumer/support';
                    }
                    return breadcrumb.url;
                };
                BreadcrumbsBarController.prototype.printArticle = function () {
                    window.print();
                };
                BreadcrumbsBarController.controllerName = 'ute.common.breadcrumbsBar.controller';
                BreadcrumbsBarController.$inject = ['$scope'];
                return BreadcrumbsBarController;
            }());
            breadcrumbsBar.BreadcrumbsBarController = BreadcrumbsBarController;
            angular.module('ute.common.breadcrumbsBar').controller(BreadcrumbsBarController.controllerName, BreadcrumbsBarController);
        })(breadcrumbsBar = common.breadcrumbsBar || (common.breadcrumbsBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var breadcrumbsBar;
        (function (breadcrumbsBar) {
            'use strict';
            var BreadcrumbsBar = (function () {
                function BreadcrumbsBar() {
                    // DDO properties
                    this.templateUrl = 'module/uteBreadcrumbsBar/breadcrumbsBar.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.breadcrumbsBar.controller';
                    this.controllerAs = 'breadcrumbsBar';
                    this.scope = {
                        breadcrumbs: '=',
                        businessUnit: '=?',
                        articleEmailContent: '=',
                        articleEmailKey: '=',
                        articlePrintKey: '='
                    };
                }
                // bindToController: boolean = true;
                BreadcrumbsBar.factory = function () {
                    var directive = function () { return new BreadcrumbsBar(); };
                    directive.$inject = [];
                    return directive;
                };
                return BreadcrumbsBar;
            }());
            angular.module('ute.common.breadcrumbsBar').directive('uteBreadcrumbsBar', BreadcrumbsBar.factory());
        })(breadcrumbsBar = common.breadcrumbsBar || (common.breadcrumbsBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var brightcoveVideo;
        (function (brightcoveVideo) {
            'use strict';
            var BrightcoveVideoController = (function () {
                function BrightcoveVideoController($scope, $modal, $sce) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$modal = $modal;
                    this.$sce = $sce;
                    this.scriptUrl = '//players.brightcove.net/' + this.accountNumber + '/default_default/index.min.js';
                    this.uteVideoModalOpen = function () {
                        _this.$modal.open({
                            templateUrl: 'module/uteBrightcoveVideo/brightcoveVideoModal.directive.view.html',
                            controller: 'ute.common.brightcoveVideo.controller',
                            scope: _this.$scope
                        });
                    };
                }
                BrightcoveVideoController.prototype.trustAsResourceUrl = function (url) {
                    return this.$sce.trustAsResourceUrl(url);
                };
                ;
                BrightcoveVideoController.controllerName = 'ute.common.brightcoveVideo.controller';
                BrightcoveVideoController.$inject = ['$scope', '$modal', '$sce'];
                return BrightcoveVideoController;
            }());
            brightcoveVideo.BrightcoveVideoController = BrightcoveVideoController;
            angular.module('ute.common.brightcoveVideo')
                .controller(BrightcoveVideoController.controllerName, BrightcoveVideoController);
        })(brightcoveVideo = common.brightcoveVideo || (common.brightcoveVideo = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var brightcoveVideo;
        (function (brightcoveVideo) {
            'use strict';
            var BrightcoveVideo = (function () {
                function BrightcoveVideo() {
                    // DDO properties
                    this.templateUrl = 'module/uteBrightcoveVideo/brightcoveVideo.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.brightcoveVideo.controller';
                    this.controllerAs = 'brightcove';
                    this.scope = {
                        videoId: '@',
                        accountNumber: '@?',
                        posterUrl: '@?',
                        posterDescription: '@?',
                        playerId: '@?',
                        playerKey: '@?',
                        htmlMode: '=?',
                        openInModal: '=?'
                    };
                    this.bindToController = true;
                }
                BrightcoveVideo.factory = function () {
                    var directive = function () { return new BrightcoveVideo(); };
                    directive.$inject = [];
                    return directive;
                };
                return BrightcoveVideo;
            }());
            angular.module('ute.common.brightcoveVideo').directive('uteBrightcoveVideo', BrightcoveVideo.factory());
        })(brightcoveVideo = common.brightcoveVideo || (common.brightcoveVideo = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            'use strict';
            var ChannelRecommendationController = (function () {
                function ChannelRecommendationController($scope, $timeout) {
                    this.$scope = $scope;
                    this.$timeout = $timeout;
                    this.showPopover = false;
                    // because angular-immutable trips out over nested variables
                    $scope.whatsOnList = $scope.whatsOn.get('list');
                    $scope.selectedData = {
                        selectedCity: $scope.selectedCity && $scope.selectedCity.toJS(),
                        selectedProvince: $scope.selectedProvince && $scope.selectedProvince.toJS()
                    };
                    $scope.$watch('selectedCity', function (newSelectedCity) {
                        $scope.selectedData.selectedCity = newSelectedCity.toJS();
                    });
                    $scope.$watch('selectedProvince', function (newSelectedProvince) {
                        $scope.selectedData.selectedProvince = newSelectedProvince.toJS();
                    });
                    $scope.showChannelDetails = function (description, images, logo, evnt) {
                        if ($scope.showPopover) {
                            $scope.showPopover = false;
                            $timeout(function () {
                                $scope.showPopover = true;
                            }, 0);
                        }
                        else {
                            $scope.showPopover = true;
                        }
                        $scope.positionLeft = angular.element(evnt.target).offset().left - 25;
                        $scope.positionTop = angular.element(evnt.target).offset().top - 25;
                        $scope.detailsData = {
                            description: description,
                            images: images,
                            logo: logo
                        };
                    };
                    $scope.hideChannelDetails = function () {
                        $scope.showPopover = false;
                    };
                }
                ChannelRecommendationController.controllerName = 'ute.common.channelRecommendation.controller';
                ChannelRecommendationController.$inject = ['$scope', '$timeout'];
                return ChannelRecommendationController;
            }());
            channelRecommendation.ChannelRecommendationController = ChannelRecommendationController;
            angular.module('ute.common.channelRecommendation').controller(ChannelRecommendationController.controllerName, ChannelRecommendationController);
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            'use strict';
            var ChannelRecommendation = (function () {
                function ChannelRecommendation() {
                    // DDO properties
                    this.templateUrl = 'module/uteChannelRecommendation/channelRecommendation.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.channelRecommendation.controller';
                    this.scope = {
                        channelDetails: '=',
                        channelNumberLabel: '=',
                        channelType: '=',
                        cities: '=',
                        label: '@',
                        provinces: '=',
                        recommendedChannel: '=',
                        recommendedShow: '=',
                        relatedChannels: '=',
                        selectedCity: '=',
                        selectedProvince: '=',
                        showAllLink: '=',
                        whatsOn: '=',
                        userLanguage: '=',
                        onSelectProvince: '&',
                        onSelectCity: '&'
                    };
                }
                ChannelRecommendation.factory = function () {
                    var directive = function () { return new ChannelRecommendation(); };
                    directive.$inject = [];
                    return directive;
                };
                return ChannelRecommendation;
            }());
            angular.module('ute.common.channelRecommendation').directive('uteChannelRecommendation', ChannelRecommendation.factory());
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            var RogersCookies = (function () {
                function RogersCookies() {
                }
                RogersCookies.SM_USERNOTFOUND = 'SM_USERNOTFOUND';
                //static SM_USERAUTHENTICATED = 'SM_USERAUTHENTICATED';
                RogersCookies.SMTRYNO = 'SMTRYNO';
                RogersCookies.SM_USER = 'SM_USER';
                RogersCookies.SMLOCK = 'SMLOCK';
                //static SMSESSION = 'SMSESSION';
                RogersCookies.SM_QUERY_STRING = 'SM_QUERY_STRING';
                RogersCookies.LANGUAGE = 'language';
                RogersCookies.ROGERS_LEGACY_DEEP_LINK = 'deepJSON';
                return RogersCookies;
            }());
            core.RogersCookies = RogersCookies;
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var groupedAccordion;
        (function (groupedAccordion) {
            'use strict';
            var GroupedAccordionController = (function () {
                function GroupedAccordionController($scope, $timeout, $window, $rootScope, messagesService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$timeout = $timeout;
                    this.$window = $window;
                    this.$rootScope = $rootScope;
                    this.messagesService = messagesService;
                    this.defaultId = 'grouped-accordion';
                    this.scrollHandled = false;
                    var expanding = false;
                    // $timeout(() => this.expandAndScroll.call(this));
                    this.$scope.$watch(function () { return location.hash; }, function () {
                        if (!expanding) {
                            expanding = true;
                            $timeout(function () {
                                _this.scrollHandled = false;
                                expanding = false;
                                _this.expandAndScroll.call(_this);
                            }, 1);
                        }
                    });
                }
                GroupedAccordionController.prototype.expandToggle = function (index, opened) {
                    this.messagesService.publish('ute-common-groupedAccordion-toggleExpand', {
                        parentIndex: parseInt(this.$scope.groupedAccordion.parentIndex, 10),
                        expandedIndex: index,
                        setTo: opened
                    });
                    var winHeight = window.innerHeight;
                    var accordID = "#heading-grouped-accordion-" + parseInt(this.$scope.groupedAccordion.parentIndex, 10) + "-" + index;
                    var $accordion = $(accordID);
                    var self = this;
                    setTimeout(function () {
                        var accordOffset = $accordion.closest('.panel-default').offset().top;
                        var accordOutHeight = $accordion.closest('.panel-default').outerHeight();
                        if ((!self.isScrolledIntoView($accordion.closest('.panel-default'))) && (accordOutHeight < winHeight)) {
                            var scroll = accordOffset - winHeight + accordOutHeight;
                            $('html,body').animate({ scrollTop: scroll }, 100);
                        }
                    }, 100);
                };
                GroupedAccordionController.prototype.expandAndScroll = function () {
                    if (this.scrollHandled || !location.hash || this.$scope.$eval('$parent.$parent.$last')) {
                        return;
                    }
                    var $ = this.$window.$;
                    var $accordion = $(location.hash);
                    if (!$accordion.length) {
                        return;
                    }
                    // expand the accordion.
                    $accordion.closest('a').trigger('click');
                    $accordion
                        .removeAttr('id')
                        .attr('data-id', location.hash.substr(1));
                    var scrollToAccordion = function () {
                        var headerHeight = $('#header').outerHeight();
                        var accordionTopOffset = $accordion.offset().top;
                        $('html, body').animate({ scrollTop: accordionTopOffset - headerHeight });
                    };
                    // check if header is already loaded or wait for the event.
                    $('#header').length ? scrollToAccordion() : $(document.body).one('cms:loaded:header', function () { return scrollToAccordion(); });
                    // mark it as handled.
                    this.scrollHandled = true;
                };
                GroupedAccordionController.prototype.isScrolledIntoView = function (elem) {
                    var $elem = $(elem);
                    var $window = $(window);
                    var docViewTop = $window.scrollTop();
                    var docViewBottom = docViewTop + $window.height();
                    var elemTop = $elem.offset().top;
                    var elemBottom = elemTop + $elem.height();
                    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
                };
                GroupedAccordionController.controllerName = 'ute.common.groupedAccordion.controller';
                GroupedAccordionController.$inject = [
                    '$scope',
                    '$timeout',
                    '$window',
                    '$rootScope',
                    'ute.blocks.messages.bus.service'
                ];
                return GroupedAccordionController;
            }());
            groupedAccordion.GroupedAccordionController = GroupedAccordionController;
            angular.module('ute.common.groupedAccordion').controller(GroupedAccordionController.controllerName, GroupedAccordionController);
        })(groupedAccordion = common.groupedAccordion || (common.groupedAccordion = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var groupedAccordion;
        (function (groupedAccordion) {
            'use strict';
            var GroupedAccordion = (function () {
                function GroupedAccordion() {
                    // DDO properties
                    this.templateUrl = 'module/uteGroupedAccordion/groupedAccordion.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.groupedAccordion.controller';
                    this.controllerAs = 'groupedAccordion';
                    this.scope = {
                        parentIndex: '@',
                        mainLabel: '=',
                        list: '=',
                        expandedAccordionData: '='
                    };
                    this.bindToController = true;
                }
                GroupedAccordion.factory = function () {
                    var directive = function () { return new GroupedAccordion(); };
                    directive.$inject = [];
                    return directive;
                };
                return GroupedAccordion;
            }());
            angular.module('ute.common.groupedAccordion').directive('uteGroupedAccordion', GroupedAccordion.factory());
        })(groupedAccordion = common.groupedAccordion || (common.groupedAccordion = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var htmlContent;
        (function (htmlContent) {
            'use strict';
            var HtmlContentController = (function () {
                function HtmlContentController($scope, $sce) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$sce = $sce;
                    $scope.asSafeContent = function (content) {
                        return _this.$sce.trustAsHtml(content || '');
                    };
                }
                HtmlContentController.controllerName = 'ute.common.htmlContent.controller';
                HtmlContentController.$inject = ['$scope', '$sce'];
                return HtmlContentController;
            }());
            htmlContent.HtmlContentController = HtmlContentController;
            angular.module('ute.common.htmlContent').controller(HtmlContentController.controllerName, HtmlContentController);
        })(htmlContent = common.htmlContent || (common.htmlContent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var htmlContent;
        (function (htmlContent) {
            'use strict';
            var HtmlContent = (function () {
                function HtmlContent() {
                    // DDO properties
                    this.templateUrl = 'module/uteHtmlContent/htmlContent.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.htmlContent.controller';
                    this.scope = {
                        content: '='
                    };
                }
                HtmlContent.factory = function () {
                    var directive = function () { return new HtmlContent(); };
                    directive.$inject = [];
                    return directive;
                };
                return HtmlContent;
            }());
            angular.module('ute.common.htmlContent').directive('uteHtmlContent', HtmlContent.factory());
        })(htmlContent = common.htmlContent || (common.htmlContent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var owlCarousel;
        (function (owlCarousel) {
            'use strict';
            var OwlCarousel = (function () {
                function OwlCarousel() {
                    // DDO properties
                    this.restrict = 'E';
                    this.transclude = false;
                    this.link = function (scope, element, attrs) {
                        scope.initCarousel = function (element) {
                            // provide any default options you want
                            var defaultOptions = {
                                items: 3,
                                itemsDesktop: [1199, 3],
                                itemsDesktopSmall: [900, 3],
                                itemsTablet: [600, 2],
                                itemsMobile: [480, 1],
                                pagination: false,
                                paginationNumbers: false,
                                autoHeight: false,
                                rewindNav: false,
                                navigation: true,
                                lazyLoad: true,
                                scrollPerPage: true,
                                navigationText: ['<i class="ute-icon-chevron"></i>', '<i class="ute-icon-chevron"></i>']
                            };
                            var customOptions = scope.$eval($(element).attr('data-options'));
                            // combine the two options objects
                            scope.options = angular.extend({}, defaultOptions, customOptions);
                            // init carousel
                            var selectedElement = $(element);
                            if (!selectedElement.data('owl-init')) {
                                selectedElement.owlCarousel(scope.options);
                            }
                        };
                    };
                }
                OwlCarousel.factory = function () {
                    var directive = function () { return new OwlCarousel(); };
                    directive.$inject = ['$timeout'];
                    return directive;
                };
                return OwlCarousel;
            }());
            angular.module('ute.common.owlCarousel')
                .directive('uteOwlCarousel', OwlCarousel.factory());
        })(owlCarousel = common.owlCarousel || (common.owlCarousel = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var owlCarousel;
        (function (owlCarousel) {
            'use strict';
            var OwlCarouselItem = (function () {
                function OwlCarouselItem($timeout) {
                    var _this = this;
                    this.$timeout = $timeout;
                    // DDO properties
                    this.restrict = 'A';
                    this.transclude = false;
                    this.link = function (scope, element, attrs) {
                        // wait for the last item in the ng-repeat then call init
                        if (scope.$last) {
                            var parentContainer_1 = element.parents('.owl-carousel');
                            var owl = parentContainer_1.data('owlCarousel');
                            if (parentContainer_1.data('owl-init')) {
                                owl.destroy();
                                _this.$timeout(function () {
                                    parentContainer_1.owlCarousel(scope.options);
                                }, 0);
                            }
                            else {
                                _this.$timeout(function () {
                                    scope.initCarousel(element.parent());
                                }, 0);
                            }
                        }
                    };
                }
                OwlCarouselItem.factory = function () {
                    var directive = function ($timeout) { return new OwlCarouselItem($timeout); };
                    directive.$inject = ['$timeout'];
                    return directive;
                };
                return OwlCarouselItem;
            }());
            angular.module('ute.common.owlCarousel')
                .directive('uteOwlCarouselItem', OwlCarouselItem.factory());
        })(owlCarousel = common.owlCarousel || (common.owlCarousel = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var paginationBar;
        (function (paginationBar) {
            'use strict';
            var PaginationBarController = (function () {
                function PaginationBarController(paginationBarService, $window) {
                    this.paginationBarService = paginationBarService;
                    this.$window = $window;
                }
                Object.defineProperty(PaginationBarController.prototype, "paginationRange", {
                    get: function () {
                        return this.paginationBarService.getPaginationRange(this.start, this.end);
                    },
                    enumerable: true,
                    configurable: true
                });
                PaginationBarController.prototype.paginate = function (newPageNumber, recordsPerPage) {
                    var offset = recordsPerPage * (newPageNumber - 1);
                    this.onGoToPage(newPageNumber, offset, recordsPerPage);
                    this.$window.scrollTo(0, 0);
                };
                PaginationBarController.controllerName = 'ute.common.paginationBar.controller';
                PaginationBarController.$inject = ['utePaginationBarService', '$window'];
                return PaginationBarController;
            }());
            paginationBar.PaginationBarController = PaginationBarController;
            angular.module('ute.common.paginationBar').controller(PaginationBarController.controllerName, PaginationBarController);
        })(paginationBar = common.paginationBar || (common.paginationBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var paginationBar;
        (function (paginationBar) {
            'use strict';
            var PaginationBar = (function () {
                function PaginationBar() {
                    // DDO properties
                    this.templateUrl = 'module/utePaginationBar/paginationBar.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.paginationBar.controller';
                    this.controllerAs = 'paginationBar';
                    this.scope = {
                        start: '=',
                        end: '=',
                        current: '=',
                        total: '=',
                        recordsPerPage: '=',
                        onGoToPage: '='
                    };
                    this.bindToController = true;
                }
                PaginationBar.factory = function () {
                    var directive = function () { return new PaginationBar(); };
                    directive.$inject = [];
                    return directive;
                };
                return PaginationBar;
            }());
            angular.module('ute.common.paginationBar').directive('utePaginationBar', PaginationBar.factory());
        })(paginationBar = common.paginationBar || (common.paginationBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var paginationBar;
        (function (paginationBar) {
            'use strict';
            var PaginationBarService = (function () {
                function PaginationBarService() {
                }
                PaginationBarService.prototype.getPageCount = function (start, end) {
                    if (!(start && end) || (start > end)) {
                        return 0;
                    }
                    return end - start + 1;
                };
                PaginationBarService.prototype.getPaginationRange = function (start, end) {
                    if (!(start && end) || (start > end)) {
                        return [];
                    }
                    return Array.apply(null, Array(this.getPageCount(start, end)))
                        .map(function (_, index) { return index + start; });
                };
                return PaginationBarService;
            }());
            angular.module('ute.common.paginationBar')
                .service('utePaginationBarService', PaginationBarService);
        })(paginationBar = common.paginationBar || (common.paginationBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var relatedQuestions;
        (function (relatedQuestions) {
            'use strict';
            var RelatedQuestionsController = (function () {
                function RelatedQuestionsController($scope) {
                    this.$scope = $scope;
                }
                RelatedQuestionsController.controllerName = 'ute.common.relatedQuestions.controller';
                RelatedQuestionsController.$inject = ['$scope'];
                return RelatedQuestionsController;
            }());
            relatedQuestions.RelatedQuestionsController = RelatedQuestionsController;
            angular.module('ute.common.relatedQuestions').controller(RelatedQuestionsController.controllerName, RelatedQuestionsController);
        })(relatedQuestions = common.relatedQuestions || (common.relatedQuestions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var relatedQuestions;
        (function (relatedQuestions) {
            'use strict';
            var RelatedQuestions = (function () {
                function RelatedQuestions() {
                    // DDO properties
                    this.templateUrl = 'module/uteRelatedQuestions/relatedQuestions.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.relatedQuestions.controller';
                    this.scope = {
                        label: '=',
                        questionsList: '='
                    };
                }
                RelatedQuestions.factory = function () {
                    var directive = function () { return new RelatedQuestions(); };
                    directive.$inject = [];
                    return directive;
                };
                return RelatedQuestions;
            }());
            angular.module('ute.common.relatedQuestions').directive('uteRelatedQuestions', RelatedQuestions.factory());
        })(relatedQuestions = common.relatedQuestions || (common.relatedQuestions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchBar;
        (function (searchBar) {
            'use strict';
            var SearchBarController = (function () {
                function SearchBarController($element, $scope) {
                    this.$element = $element;
                    this.$scope = $scope;
                    $element.get(0).addEventListener('ute.sse.searchSubmit', function (event) {
                        $scope.onSearchSubmit({
                            search: {
                                searchTerm: event.detail.searchTerm,
                                url: event.detail.url
                            }
                        });
                    });
                }
                SearchBarController.controllerName = 'ute.common.searchBar.controller';
                SearchBarController.$inject = [
                    '$element',
                    '$scope'
                ];
                return SearchBarController;
            }());
            searchBar.SearchBarController = SearchBarController;
            angular.module('ute.common.searchBar')
                .controller(SearchBarController.controllerName, SearchBarController);
        })(searchBar = common.searchBar || (common.searchBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchBar;
        (function (searchBar) {
            'use strict';
            var SearchBar = (function () {
                function SearchBar() {
                    // DDO properties
                    this.templateUrl = 'module/uteSearchBar/searchBar.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.searchBar.controller';
                    this.scope = {
                        label: '@',
                        inputLabel: '@',
                        submitText: '@',
                        language: '@',
                        onSearchSubmit: '&',
                        placeholder: '@',
                        province: '@',
                        searchTerm: '=',
                        site: '='
                    };
                }
                SearchBar.factory = function () {
                    var directive = function () { return new SearchBar(); };
                    directive.$inject = [];
                    return directive;
                };
                return SearchBar;
            }());
            angular.module('ute.common.searchBar').directive('uteSearchBar', SearchBar.factory());
        })(searchBar = common.searchBar || (common.searchBar = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchFilter;
        (function (searchFilter) {
            'use strict';
            var SearchFilterController = (function () {
                function SearchFilterController($scope) {
                    this.$scope = $scope;
                    this.isChecked = false;
                    $scope.updateFilters = this.updateFilters;
                    $scope.isChecked = this.isChecked;
                }
                SearchFilterController.prototype.updateFilters = function (searchTerm, filters) {
                    this.isChecked = !this.isChecked;
                    this.onUpdateFilter({ searchTerm: searchTerm, filters: filters, isChecked: this.isChecked });
                };
                SearchFilterController.controllerName = 'ute.common.searchFilter.controller';
                SearchFilterController.$inject = ['$scope'];
                return SearchFilterController;
            }());
            searchFilter.SearchFilterController = SearchFilterController;
            angular.module('ute.common.searchFilter')
                .controller(SearchFilterController.controllerName, SearchFilterController);
        })(searchFilter = common.searchFilter || (common.searchFilter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchFilter;
        (function (searchFilter) {
            'use strict';
            var SearchFilter = (function () {
                function SearchFilter() {
                    // DDO properties
                    this.templateUrl = 'module/uteSearchFilter/searchFilter.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.searchFilter.controller';
                    this.scope = {
                        filterLabel: '@',
                        resultCount: '=',
                        resultCountLabel: '=',
                        filters: '=',
                        searchTerm: '=',
                        onUpdateFilter: '&'
                    };
                }
                SearchFilter.factory = function () {
                    var directive = function () { return new SearchFilter(); };
                    directive.$inject = [];
                    return directive;
                };
                return SearchFilter;
            }());
            angular.module('ute.common.searchFilter').directive('uteSearchFilter', SearchFilter.factory());
        })(searchFilter = common.searchFilter || (common.searchFilter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchResults;
        (function (searchResults) {
            'use strict';
            var SearchResultsController = (function () {
                function SearchResultsController($scope) {
                    this.$scope = $scope;
                    $scope.viewSearchResult = this.viewSearchResult.bind(this);
                }
                SearchResultsController.prototype.viewSearchResult = function ($event, $index, title, sref, recordClass) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    this.$scope.onResultClick({ index: $index, title: title, sref: sref, recordClass: recordClass });
                };
                SearchResultsController.controllerName = 'ute.common.searchResults.controller';
                SearchResultsController.$inject = ['$scope'];
                return SearchResultsController;
            }());
            searchResults.SearchResultsController = SearchResultsController;
            angular.module('ute.common.searchResults').controller(SearchResultsController.controllerName, SearchResultsController);
        })(searchResults = common.searchResults || (common.searchResults = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchResults;
        (function (searchResults) {
            'use strict';
            var SearchResults = (function () {
                function SearchResults() {
                    // DDO properties
                    this.templateUrl = 'module/uteSearchResults/searchResults.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.searchResults.controller';
                    this.scope = {
                        resultsList: '=',
                        onResultClick: '&'
                    };
                }
                SearchResults.factory = function () {
                    var directive = function () { return new SearchResults(); };
                    directive.$inject = [];
                    return directive;
                };
                return SearchResults;
            }());
            angular.module('ute.common.searchResults').directive('uteSearchResults', SearchResults.factory());
        })(searchResults = common.searchResults || (common.searchResults = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var TabbedCardController = (function () {
                /* @ngInject */
                function TabbedCardController($ngRedux, $scope, SearchActions) {
                    this.$ngRedux = $ngRedux;
                    this.$scope = $scope;
                    this.SearchActions = SearchActions;
                    this.isTabVisible = function (tab) {
                        //Suppressing Ignite tab - remove the 'or' condition for both digital and ignite results
                        if (!tab || (tab.getIn(['labelEn']) !== 'Digital TV')) {
                            return false;
                        }
                        var tvComponents = tab.getIn(['tvComponents'], Immutable.List.of());
                        var provinces;
                        var channels;
                        var defaultProvince;
                        var cbv;
                        defaultProvince = {
                            displayName: 'Ontario',
                            value: '3191615402',
                            dimensionName: 'ute.province'
                        };
                        if (tvComponents.size === 0) {
                            return false;
                        }
                        cbv = tvComponents.getIn(['0', 'provinces']);
                        provinces = cbv.size === 0 ? Immutable.List.of(defaultProvince) : cbv;
                        //console.log('provinces: ', provinces.toJS());
                        channels = tvComponents.getIn(['1', 'channels'], Immutable.List.of());
                        return provinces.size > 0 && channels.size > 0;
                    };
                    // const unsubscribe = $ngRedux.connect(this.mapStateToThis, SearchActions)(this);
                    $ngRedux.connect(this.mapStateToThis, SearchActions)(this);
                }
                // map Redux store's properties to controller properties
                TabbedCardController.prototype.mapStateToThis = function (state) {
                    var defaultSelectedProvince = { displayName: 'Ontario', value: '3191615402', dimensionName: 'ute.province' };
                    var provr = Immutable.List.of(Immutable.fromJS(defaultSelectedProvince)).toObject();
                    return {
                        userLanguage: state.getIn(['locale', 'language']),
                        tabs: state.getIn(['search', 'tabbedCards', 'tabs']),
                        selectedProvince: (typeof state.getIn(['search', 'tabbedCards', 'selectedProvince']) === 'undefined') ? provr[0] : state.getIn(['search', 'tabbedCards', 'selectedProvince'])
                    };
                };
                TabbedCardController.controllerName = 'ute.common.tabbedCard.controller';
                TabbedCardController.$inject = [
                    '$ngRedux',
                    '$scope',
                    'SearchActions'
                ];
                return TabbedCardController;
            }());
            searchSection.TabbedCardController = TabbedCardController;
            angular.module('ute.common.searchSection').controller(TabbedCardController.controllerName, TabbedCardController);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var TabbedCard = (function () {
                function TabbedCard() {
                    // DDO properties
                    this.templateUrl = 'module/tabbedCard/tabbedCard.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.tabbedCard.controller';
                    this.controllerAs = 'tabbedCard';
                    this.scope = {
                        tabs: '=',
                        userLanguage: '=',
                        onSelectProvince: '&',
                        onSelectCity: '&'
                    };
                }
                // bindToController: boolean = true;
                TabbedCard.factory = function () {
                    var directive = function () { return new TabbedCard(); };
                    directive.$inject = [];
                    return directive;
                };
                return TabbedCard;
            }());
            angular.module('ute.common.searchSection').directive('uteTabbedCard', TabbedCard.factory());
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchSectionController = (function () {
                /* @ngInject */
                function SearchSectionController($ngRedux, $scope, SearchActions) {
                    this.$ngRedux = $ngRedux;
                    this.$scope = $scope;
                    this.SearchActions = SearchActions;
                    // unsubscribe from Redux updates when controller is destroyed
                    var unsubscribe = $ngRedux.connect(this.mapStateToThis, SearchActions)(this);
                    $scope.$on('$destroy', unsubscribe);
                    // console.log('search section: ', this);
                }
                SearchSectionController.prototype.searchResultsUpdated = function (search) {
                    this.$ngRedux.dispatch(this.appActions.goToSearch(search, search.url));
                };
                ;
                SearchSectionController.prototype.updateSearchFilter = function (searchTerm, filtersArray, isChecked) {
                    this.$ngRedux.dispatch(this.SearchActions.fetchFilteredSearchResults(searchTerm, filtersArray, isChecked));
                };
                // map Redux store's properties to controller properties
                SearchSectionController.prototype.mapStateToThis = function (state) {
                    return {
                        language: state.getIn(['app', 'language']),
                        province: state.getIn(['app', 'province']),
                        search: state.get('search'),
                        tabs: Immutable.fromJS([]).concat(state.getIn(['search', 'tabbedCards', 'tabs'])),
                        businessUnit: state.getIn(['app', 'businessUnit'])
                    };
                };
                SearchSectionController.controllerName = 'ute.common.searchSection.controller';
                SearchSectionController.$inject = [
                    '$ngRedux',
                    '$scope',
                    'SearchActions'
                ];
                return SearchSectionController;
            }());
            searchSection.SearchSectionController = SearchSectionController;
            angular.module('ute.common.searchSection').controller(SearchSectionController.controllerName, SearchSectionController);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchSection = (function () {
                function SearchSection() {
                    // DDO properties
                    this.templateUrl = 'module/uteSearchSection/searchSection.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.searchSection.controller';
                    this.controllerAs = 'searchSection';
                    this.scope = {
                        appActions: '='
                    };
                    this.bindToController = true;
                }
                SearchSection.factory = function () {
                    var directive = function () { return new SearchSection(); };
                    directive.$inject = [];
                    return directive;
                };
                return SearchSection;
            }());
            angular.module('ute.common.searchSection').directive('uteSearchSection', SearchSection.factory());
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simpleHtml;
        (function (simpleHtml) {
            'use strict';
            var SimpleHtmlController = (function () {
                function SimpleHtmlController() {
                }
                SimpleHtmlController.controllerName = 'ute.common.simpleHtml.controller';
                SimpleHtmlController.$inject = [];
                return SimpleHtmlController;
            }());
            simpleHtml.SimpleHtmlController = SimpleHtmlController;
            angular.module('ute.common.simpleHtml').controller(SimpleHtmlController.controllerName, SimpleHtmlController);
        })(simpleHtml = common.simpleHtml || (common.simpleHtml = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simpleHtml;
        (function (simpleHtml) {
            'use strict';
            var SimpleHtml = (function () {
                function SimpleHtml() {
                    // DDO properties
                    this.templateUrl = 'module/uteSimpleHtml/simpleHtml.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.simpleHtml.controller';
                    this.controllerAs = 'simpleHtml';
                    this.scope = {
                        title: '=',
                        content: '='
                    };
                    this.bindToController = true;
                }
                SimpleHtml.factory = function () {
                    var directive = function () { return new SimpleHtml(); };
                    directive.$inject = [];
                    return directive;
                };
                return SimpleHtml;
            }());
            angular.module('ute.common.simpleHtml').directive('uteSimpleHtml', SimpleHtml.factory());
        })(simpleHtml = common.simpleHtml || (common.simpleHtml = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var spotlightCallout;
        (function (spotlightCallout) {
            'use strict';
            var SpotlightCalloutController = (function () {
                function SpotlightCalloutController($scope) {
                    this.$scope = $scope;
                }
                SpotlightCalloutController.controllerName = 'ute.common.spotlightCallout.controller';
                SpotlightCalloutController.$inject = ['$scope'];
                return SpotlightCalloutController;
            }());
            spotlightCallout.SpotlightCalloutController = SpotlightCalloutController;
            angular.module('ute.common.spotlightCallout').controller(SpotlightCalloutController.controllerName, SpotlightCalloutController);
        })(spotlightCallout = common.spotlightCallout || (common.spotlightCallout = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var spotlightCallout;
        (function (spotlightCallout) {
            'use strict';
            var SpotlightCallout = (function () {
                function SpotlightCallout() {
                    // DDO properties
                    this.templateUrl = 'module/uteSpotlightCallout/spotlightCallout.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.spotlightCallout.controller';
                    this.scope = {
                        label: '=',
                        icon: '=',
                        description: '=',
                        list: '='
                    };
                }
                SpotlightCallout.factory = function () {
                    var directive = function () { return new SpotlightCallout(); };
                    directive.$inject = [];
                    return directive;
                };
                return SpotlightCallout;
            }());
            angular.module('ute.common.spotlightCallout').directive('uteSpotlightCallout', SpotlightCallout.factory());
        })(spotlightCallout = common.spotlightCallout || (common.spotlightCallout = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var spotlightCallout;
        (function (spotlightCallout) {
            'use strict';
            angular.module('ute.common.spotlightCallout')
                .filter('isHighlightFilter', function () {
                return function (input, flag) {
                    return input.filter(function (item) {
                        return item.isHighlight === flag;
                    });
                };
            });
        })(spotlightCallout = common.spotlightCallout || (common.spotlightCallout = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportSectionController = (function () {
                /* @ngInject */
                function SupportSectionController($ngRedux, $scope, $state, SupportActions) {
                    this.$ngRedux = $ngRedux;
                    this.$scope = $scope;
                    this.$state = $state;
                    this.SupportActions = SupportActions;
                    // unsubscribe from Redux updates when controller is destroyed
                    var unsubscribe = $ngRedux.connect(this.mapStateToThis, SupportActions)(this);
                    $scope.$on('$destroy', unsubscribe);
                }
                SupportSectionController.prototype.printArticle = function () {
                    window.print();
                };
                SupportSectionController.prototype.onSelectChildArticle = function (childArticleProperties, articleId) {
                    this.$state.go('support.article', {
                        articleId: articleId,
                        childArticleId: childArticleProperties.dimensionValue
                    }, {
                        location: true,
                        notify: false,
                        reload: false,
                        inherit: true
                    });
                    this.$ngRedux.dispatch(this.SupportActions.fetchSupportChildArticle(childArticleProperties));
                };
                //Show hide helpfulness rating based on routing for paper-bill and online-bill.
                SupportSectionController.prototype.isNotOnlineAndPaperBillingFaqs = function () {
                    var url = window.location.href;
                    return ((url.indexOf('/online-and-paper-billing-faqs') > -1 &&
                        (url.indexOf('/online-and-paper-billing-faqs/paper-bill') > -1 ||
                            url.indexOf('/online-and-paper-billing-faqs/online-bill') > -1)) || (url.indexOf('/online-and-paper-billing-faqs') === -1));
                };
                // map Redux store's properties to controller properties
                SupportSectionController.prototype.mapStateToThis = function (state) {
                    return {
                        breadcrumbs: state.getIn(['support', 'breadcrumbs']),
                        support: state.get('support'),
                        app: state.get('app'),
                        businessUnit: state.getIn(['app', 'businessUnit'])
                    };
                };
                SupportSectionController.prototype.getEmailContent = function (articleTitle) {
                    return "mailto:?subject=" + articleTitle + "&body=" + window.location.href;
                };
                SupportSectionController.controllerName = 'ute.common.supportSection.controller';
                SupportSectionController.$inject = [
                    '$ngRedux',
                    '$scope',
                    '$state',
                    'SupportActions'
                ];
                return SupportSectionController;
            }());
            supportSection.SupportSectionController = SupportSectionController;
            angular.module('ute.common.supportSection').controller(SupportSectionController.controllerName, SupportSectionController);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportSection = (function () {
                function SupportSection() {
                    // DDO properties
                    this.templateUrl = 'module/uteSupportSection/supportSection.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.supportSection.controller';
                    this.controllerAs = 'supportSection';
                }
                SupportSection.factory = function () {
                    var directive = function () { return new SupportSection(); };
                    directive.$inject = [];
                    return directive;
                };
                return SupportSection;
            }());
            angular.module('ute.common.supportSection')
                .directive('uteSupportSection', SupportSection.factory());
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var tvGuide;
        (function (tvGuide) {
            'use strict';
            var TvGuideController = (function () {
                function TvGuideController($scope) {
                    this.$scope = $scope;
                }
                TvGuideController.controllerName = 'ute.common.tvGuide.controller';
                TvGuideController.$inject = [];
                return TvGuideController;
            }());
            tvGuide.TvGuideController = TvGuideController;
            angular.module('ute.common.tvGuide').controller(TvGuideController.controllerName, TvGuideController);
        })(tvGuide = common.tvGuide || (common.tvGuide = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var tvGuide;
        (function (tvGuide) {
            'use strict';
            var TvGuide = (function () {
                function TvGuide() {
                    // DDO properties
                    this.templateUrl = 'module/uteTvGuide/tvGuide.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.tvGuide.controller';
                    this.scope = {
                        label: '=',
                        list: '='
                    };
                }
                TvGuide.factory = function () {
                    var directive = function () { return new TvGuide(); };
                    directive.$inject = [];
                    return directive;
                };
                return TvGuide;
            }());
            angular.module('ute.common.tvGuide')
                .directive('uteTvGuide', TvGuide.factory());
        })(tvGuide = common.tvGuide || (common.tvGuide = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var log;
                (function (log) {
                    'use strict';
                    (function (LogLevel) {
                        LogLevel[LogLevel["OFF"] = 0] = "OFF";
                        LogLevel[LogLevel["FATAL"] = 1] = "FATAL";
                        LogLevel[LogLevel["ERROR"] = 2] = "ERROR";
                        LogLevel[LogLevel["WARN"] = 3] = "WARN";
                        LogLevel[LogLevel["INFO"] = 4] = "INFO";
                        LogLevel[LogLevel["DEBUG"] = 5] = "DEBUG";
                        LogLevel[LogLevel["TRACE"] = 6] = "TRACE";
                        LogLevel[LogLevel["ALL"] = 7] = "ALL";
                    })(log.LogLevel || (log.LogLevel = {}));
                    var LogLevel = log.LogLevel;
                })(log = api.log || (api.log = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var mixin;
                (function (mixin) {
                    'use strict';
                    var MixinHelper = (function () {
                        function MixinHelper() {
                        }
                        /**
                         * apply Mixins pattern to the derivedCtor class
                         * example:
                         * class SmartObject implements Disposable, Activatable {
                         *   ...
                         * }
                         * applyMixins(SmartObject, [Disposable, Activatable]);
                         *
                         * @param derivedCtor
                         * @param baseCtors
                         */
                        MixinHelper.applyMixins = function (derivedCtor, baseCtors) {
                            baseCtors.forEach(function (baseCtor) {
                                Object.getOwnPropertyNames(baseCtor.prototype).forEach(function (name) {
                                    derivedCtor.prototype[name] = baseCtor.prototype[name];
                                });
                            });
                        };
                        return MixinHelper;
                    }());
                    mixin.MixinHelper = MixinHelper;
                })(mixin = api.mixin || (api.mixin = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var types;
                (function (types) {
                    'use strict';
                })(types = api.types || (api.types = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
            var UtilsStatic = (function () {
                function UtilsStatic() {
                }
                UtilsStatic.memoizeResolver = function (o) {
                    // console.log(UtilsProvider.serviceName + '->memoizeResolver->input:', o);
                    // console.log(UtilsProvider.serviceName + '->memoizeResolver->output:', _.chain(o).filter(e => angular.isDefined(e)).values().value().sort().join('_'));
                    return _.chain(o).filter(function (e) { return angular.isDefined(e); }).values().value().sort().join('_');
                };
                UtilsStatic.getCookieModule = function () { return angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'; };
                UtilsStatic.getCookieService = function () { return angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'; };
                return UtilsStatic;
            }());
            utils.UtilsStatic = UtilsStatic;
            var UtilsProvider = (function () {
                /* @ngInject */
                function UtilsProvider() {
                    var _this = this;
                    this.config = {}; // defaults
                    /* @ngInject */
                    this.$get = function ($injector) {
                        _this.$window = $injector.get('$window');
                        return {
                            randomString: _this.randomString,
                            parseTimer: _this.parseTimer,
                            formatPhoneNumber: _this.formatPhoneNumber,
                            objectToArray: _this.objectToArray,
                            arrayToObject: _this.arrayToObject,
                            getQuerystringParameter: _this.getQuerystringParameter,
                            calculateAge: _this.calculateAge,
                            isNullOrEmptyObject: _this.isNullOrEmptyObject,
                            isAlphabetOnly: _this.isAlphabetOnly,
                            isAlphanumeric: _this.isAlphanumeric,
                            isNumericOnly: _this.isNumericOnly,
                            stringContains: _this.stringContains,
                            detectBrowser: _this.detectBrowser,
                            getQueryParameters: _this.getQueryParameters,
                            getHomePage: _this.getHomePage
                        };
                    };
                    /**
                     * TODO validation + defaults
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    this.randomString = function (length, chars) {
                        if (length && chars) {
                            var result = '';
                            for (var i = length; i > 0; --i) {
                                result += chars[Math.floor(Math.random() * chars.length)];
                            }
                            return result;
                        }
                        else {
                            return _this.randomString(32, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
                        }
                    };
                    this.parseTimer = function (t) {
                        var days, hours, minutes, seconds;
                        days = Math.floor(t / 86400);
                        t -= days * 86400;
                        hours = Math.floor(t / 3600) % 24;
                        t -= hours * 3600;
                        minutes = Math.floor(t / 60) % 60;
                        t -= minutes * 60;
                        seconds = t % 60;
                        if (minutes < 10) {
                            minutes = '0' + minutes;
                        }
                        if (seconds < 10) {
                            seconds = '0' + seconds;
                        }
                        return minutes + ":" + seconds;
                    };
                    this.formatPhoneNumber = function (n, regex) {
                        if (n == null) {
                            return n;
                        }
                        if (regex == null) {
                            regex = /[\-\s\.]/g;
                        }
                        return n.replace(regex, '');
                    };
                    this.objectToArray = function (obj) {
                        var arr = [];
                        for (var prop in obj) {
                            if (obj.hasOwnProperty(prop)) {
                                //console.log('o.' + prop + ' = ' + obj[prop]);
                                arr.push(obj[prop]);
                            }
                        }
                        return arr;
                    };
                    this.arrayToObject = function (arr) {
                        var obj = {};
                        arr.forEach(function (el, index) {
                            obj[index] = el;
                        });
                        return obj;
                    };
                    this.getQuerystringParameter = function (name) {
                        var nm = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                        var regex = new RegExp('[\\?&]' + nm + '=([^&#]*)');
                        var results = regex.exec(location.href.replace('&amp;', '&'));
                        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
                    };
                    this.calculateAge = function (birthDate, currentDate) {
                        var bd = new Date(birthDate);
                        if (currentDate == null) {
                            currentDate = new Date();
                        }
                        var years = (currentDate.getFullYear() - bd.getFullYear());
                        if (currentDate.getMonth() < bd.getMonth() ||
                            currentDate.getMonth() === bd.getMonth() &&
                                currentDate.getDay() < bd.getDay()) {
                            years--;
                        }
                        return years;
                    };
                    // former isUndefinedOrNull
                    this.isNullOrEmptyObject = function (val) {
                        if (angular.isUndefined(val) || val === null) {
                            return true;
                        }
                        var jsonStr;
                        try {
                            jsonStr = angular.toJson(val);
                        }
                        catch (e) {
                            return false;
                        }
                        return jsonStr === '{}';
                    };
                    this.stringContains = function (s, val) {
                        return s.indexOf(val) !== -1;
                    };
                    this.detectBrowser = function () {
                        var ua = navigator.userAgent;
                        var tem;
                        var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                        if (/trident/i.test(M[1])) {
                            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                            return {
                                type: 'ie',
                                version: (tem[1] || '')
                            };
                        }
                        if (M[1] === 'Chrome') {
                            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                            if (tem != null) {
                                return {
                                    type: tem.slice(1).join(' ').replace('OPR', 'Opera'),
                                    version: M[1]
                                };
                            }
                        }
                        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                            M.splice(1, 1, tem[1]);
                        }
                        return {
                            type: M[0].toLowerCase(),
                            version: M[1]
                        };
                    };
                    this.isNumericOnly = function (test) {
                        return (/^[0-9]+$/g).test(test);
                    };
                    this.isAlphabetOnly = function (test) {
                        return (/^[a-zA-Z]+$/g).test(test);
                    };
                    this.isAlphanumeric = function (test) {
                        return (/^[a-zA-Z0-9]+$/g).test(test);
                    };
                    /**
                     * Parse location query params and return hashmap
                     *
                     * @example http://example.com/test?lunch=sandwich&dinner=stirfry will return { "lunch": "sandwich", "dinner": "stirfry" }
                     *
                     * @param str
                     * @returns {*}
                     */
                    this.getQueryParameters = function (str) {
                        return _.chain((str || _this.$window.location.search).replace(/(^\?)/, '').split('&')).map(function (params) {
                            var p = params.split('=');
                            return [p[0], angular.isUndefined(p[1]) ? true : p[1]];
                        }).object().value();
                    };
                    this.getHomePage = function () {
                        var wl = _this.$window.location;
                        if (!wl.origin) {
                            // polyfill for IE
                            wl.origin = wl.protocol + '//' + wl.hostname + (wl.port ? ':' + wl.port : '');
                        }
                        return wl.origin;
                    };
                    this.$get.$inject = [
                        '$injector'
                    ];
                }
                UtilsProvider.$inject = [];
                UtilsProvider.serviceName = 'ute.common.utils.service';
                return UtilsProvider;
            }());
            angular.module('ute.common.utils').provider(UtilsProvider.serviceName, UtilsProvider);
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var YoutubeComponent;
        (function (YoutubeComponent) {
            'use strict';
            var YoutubeComponentController = (function () {
                function YoutubeComponentController($sce) {
                    this.$sce = $sce;
                }
                ;
                YoutubeComponentController.prototype.trustAsResourceUrl = function (url) {
                    return this.$sce.trustAsResourceUrl(url);
                };
                ;
                YoutubeComponentController.controllerName = 'ute.common.youtubeComponent.controller';
                YoutubeComponentController.$inject = ['$sce'];
                return YoutubeComponentController;
            }());
            YoutubeComponent.YoutubeComponentController = YoutubeComponentController;
            angular.module('ute.common.youtubeComponent')
                .controller(YoutubeComponentController.controllerName, YoutubeComponentController);
        })(YoutubeComponent = common.YoutubeComponent || (common.YoutubeComponent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var YoutubeComponent;
        (function (YoutubeComponent_1) {
            'use strict';
            var YoutubeComponent = (function () {
                function YoutubeComponent() {
                    // DDO properties
                    this.templateUrl = 'module/uteYoutubeComponent/youtubeComponent.directive.view.html';
                    this.restrict = 'E';
                    this.controller = 'ute.common.youtubeComponent.controller';
                    this.controllerAs = 'youtube';
                    this.scope = {
                        videoUrl: '=',
                        videoTitle: '=',
                    };
                    this.bindToController = true;
                }
                YoutubeComponent.factory = function () {
                    var directive = function () { return new YoutubeComponent(); };
                    directive.$inject = [];
                    return directive;
                };
                return YoutubeComponent;
            }());
            angular.module('ute.common.youtubeComponent').directive('uteYoutubeComponent', YoutubeComponent.factory());
        })(YoutubeComponent = common.YoutubeComponent || (common.YoutubeComponent = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var services;
    (function (services) {
        var cookies;
        (function (cookies) {
            'use strict';
            var CookiesServiceProvider = (function () {
                /* @ngInject */
                function CookiesServiceProvider() {
                    var _this = this;
                    this.config = {
                        basic: {
                            domain: 'localhost' // default!
                        }
                    };
                    /* @ngInject */
                    this.$get = function ($injector) {
                        var cookieServiceName = (angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies');
                        var cookieService = $injector.get(cookieServiceName);
                        return new cookies.CookiesService(cookieService, _this.config, _this);
                    };
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    this.$get.$inject = [
                        '$injector',
                    ];
                }
                CookiesServiceProvider.$inject = [
                    '$injector'
                ];
                return CookiesServiceProvider;
            }());
            angular.module('ute.services.cookies').provider('ute.services.cookies.service', CookiesServiceProvider);
        })(cookies = services.cookies || (services.cookies = {}));
    })(services = ute.services || (ute.services = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var services;
    (function (services) {
        var cookies;
        (function (cookies) {
            'use strict';
            /**
             * Provides access to browser cookies and user preferences
             */
            var CookiesService = (function () {
                function CookiesService($cookies, config, provider) {
                    var _this = this;
                    this.$cookies = $cookies;
                    this.config = config;
                    this.provider = provider;
                    this.configure = this.provider.configure;
                    /**
                     * @description reads cookie
                     * @param name
                     * @param isJson
                     */
                    this.getCookie = function (name, isJson) {
                        if (isJson) {
                            if (_this.$cookies.getObject) {
                                return _this.$cookies.getObject(name);
                            }
                            else {
                                return _this.$cookies.get(name);
                            }
                        }
                        else {
                            return _this.$cookies.get(name);
                        }
                    };
                    /**
                     * @description sets cookie
                     * @param name
                     * @param value
                     * @param options
                     * @param isJson
                     */
                    this.setCookie = function (name, value, isJson, options) {
                        var date = new Date();
                        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
                        options = options || {};
                        options.domain = _this.config.basic.domain;
                        options.path = '/';
                        options.end = date.toGMTString();
                        if (options.expires != null && typeof options.expires === 'number') {
                            if (options.expires <= 0) {
                                // no expiration
                                options.expires = null;
                            }
                            else {
                                // numeric expiry date means "number of days from now"
                                var d = new Date();
                                d.setDate(d.getDate() + options.expires); // add days to the current date
                                options.expires = d;
                            }
                        }
                        if (isJson) {
                            if (_this.$cookies.putObject) {
                                _this.$cookies.putObject(name, value, options);
                            }
                            else {
                                _this.$cookies.put(name, value, options);
                            }
                        }
                        else {
                            _this.$cookies.put(name, value, options);
                        }
                    };
                    /** Deletes cookie
                     * default options are:
                     *  {
                     *    path: '/',
                     *    domain: this.config.basic.domain
                     *  }
                     */
                    this.deleteCookie = function (name, options) {
                        options = options || {
                            path: '/',
                            domain: _this.config.basic.domain
                        };
                        _this.$cookies.remove(name, options);
                    };
                }
                return CookiesService;
            }());
            cookies.CookiesService = CookiesService;
        })(cookies = services.cookies || (services.cookies = {}));
    })(services = ute.services || (ute.services = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var agentSession;
            (function (agentSession) {
                'use strict';
            })(agentSession = core.agentSession || (core.agentSession = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var agentSession;
            (function (agentSession) {
                'use strict';
                /**
                 * Manages global values that should be available to all modules in the app.
                 */
                var AgentSessionService = (function () {
                    /* @ngInject */
                    function AgentSessionService($window, $state, userPreference) {
                        var _this = this;
                        this.$window = $window;
                        this.$state = $state;
                        this.userPreference = userPreference;
                        /**
                         * @description
                         * @returns {string}
                         */
                        this.endAgentSession = function () {
                            if (_this.userPreference.multiPageMode) {
                                _this.$window.location.reload();
                            }
                            else {
                                var path = _this.userPreference.info.cfaInfo.sourceURL ?
                                    _this.userPreference.info.cfaInfo.sourceURL + _this.userPreference.info.cfaInfo.signOutURL + ';jsessionid=' + _this.userPreference.info.cfaInfo.jSessionID : '';
                                _this.userPreference.info = {};
                                // if the url to ssp is not available, go to home of ute
                                if (!path) {
                                    _this.$state.go('home');
                                }
                                else {
                                    _this.$window.location.href = path.toString();
                                }
                            }
                        };
                    }
                    AgentSessionService.$inject = ['$window', '$state', 'ute.common.core.userPreferences.service'];
                    return AgentSessionService;
                }());
                angular.module('ute.common.core.agentSession').service('ute.common.core.agentSession.service', AgentSessionService);
            })(agentSession = core.agentSession || (core.agentSession = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var content;
            (function (content) {
                'use strict';
            })(content = core.content || (core.content = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var content;
            (function (content) {
                'use strict';
                var ContentInjector = (function () {
                    /* @ngInject */
                    function ContentInjector($interpolate, userPreferencesService, uteEndpoint, uteContentLoaderFactory) {
                        var _this = this;
                        this.$interpolate = $interpolate;
                        this.userPreferencesService = userPreferencesService;
                        this.uteEndpoint = uteEndpoint;
                        //endregion
                        //region Public
                        this.restrict = 'EA';
                        this.replace = true;
                        this.scope = {
                            localContentId: '@',
                            contentId: '@',
                            compile: '=',
                            province: '@',
                            language: '@'
                        };
                        this.link = function ($scope, $element, $attrs) {
                            // toggle for showing meta data for developer purposes
                            var metaShown = false;
                            var containerWidth = $element[0].offsetWidth;
                            // if less than n then add certain CSS class
                            if (containerWidth <= 500) {
                                $element.addClass('cms-content-width-narrow');
                            }
                            // toggle hidden dev divs and displays metadata after user clicks hidden cms-metadata-toggle div
                            var displayMetadata = function () {
                                metaShown = !metaShown;
                                var settings = {
                                    scope: $scope,
                                    element: $element,
                                    method: 'GET',
                                    dataType: 'json',
                                    fileType: '.json',
                                    contentId: $scope.contentId,
                                    compile: !!$scope.compile,
                                    language: $scope.language || _this.userPreferencesService.language,
                                    province: $scope.province || _this.userPreferencesService.province,
                                    localContentId: $scope.localContentId,
                                    teamsiteUrl: _this.uteEndpoint('', 'teamsite')
                                };
                                metaShown ? _this.uteContentLoader.makeRequest(settings) : $element.children().children()[0].remove();
                            };
                            //region Setup watchers
                            $scope.$watch($attrs.language, function (newValue, oldValue) {
                                if (newValue !== oldValue && !isNaN(newValue)) {
                                    $scope.language = newValue;
                                    _this.makeRequest($scope, $element);
                                }
                            });
                            $scope.$watch($attrs.province, function (newValue, oldValue) {
                                if (newValue !== oldValue && !isNaN(newValue)) {
                                    $scope.province = newValue;
                                    _this.makeRequest($scope, $element);
                                }
                            });
                            $scope.$watch($attrs.contentId, function (newValue, oldValue) {
                                if (newValue !== oldValue && !isNaN(newValue)) {
                                    $scope.contentId = newValue;
                                    _this.makeRequest($scope, $element);
                                }
                            });
                            $scope.$watch($attrs.localContentId, function (newValue, oldValue) {
                                if (newValue !== oldValue && !isNaN(newValue)) {
                                    $scope.localContentId = newValue;
                                    _this.makeRequest($scope, $element);
                                }
                            });
                            //endregion
                            //region Init the directive
                            var metadataActive = function () {
                                var internalCmsMetadata = angular.element($element[0].querySelector('.cms-metadata'));
                                if (internalCmsMetadata) {
                                    internalCmsMetadata.toggleClass('active');
                                }
                            };
                            $element.on('click', metadataActive);
                            $element.addClass('preloader loading');
                            _this.makeRequest($scope, $element);
                            // cms-metadata-toggle is a 'secretly hidden' button in the header (left-right corner).
                            // Clicking on it shows the metadata handlers for each content injector.
                            // Useful for debugging and CMS management.
                            // This button is removed in production.
                            angular.element(document.getElementById('cms-metadata-toggle')).on('click', displayMetadata);
                            //endregion
                        };
                        //endregion
                        //region Private
                        /** Makes http request, also called by watchers */
                        this.makeRequest = function ($scope, $element) {
                            var settings = {
                                scope: $scope,
                                element: $element,
                                method: 'GET',
                                dataType: 'html',
                                fileType: '.html',
                                contentId: $scope.contentId,
                                localContentId: $scope.localContentId || null,
                                compile: !!$scope.compile,
                                language: $scope.language || _this.userPreferencesService.language,
                                province: $scope.province || _this.userPreferencesService.province,
                                teamsiteUrl: _this.uteEndpoint('', 'teamsite')
                            };
                            if (!_this.uteContentLoader) {
                                throw Error('uteContentLoader is undefined');
                            }
                            $scope.localizedUrl = _this.uteContentLoader.makeRequest(settings);
                        };
                        this.uteContentLoader = uteContentLoaderFactory();
                    }
                    ContentInjector.factory = function () {
                        var directive = function ($interpolate, userPreferencesService, uteEndpoint, uteContentLoaderFactory) {
                            return new ContentInjector($interpolate, userPreferencesService, uteEndpoint, uteContentLoaderFactory);
                        };
                        directive.$inject = ContentInjector.$inject;
                        return directive;
                    };
                    //region Static & Constructor
                    ContentInjector.$inject = ['$interpolate', 'ute.common.core.userPreferences.service', 'ute.common.core.endpoint', 'ute.common.core.content.loader.factory'];
                    return ContentInjector;
                }());
                angular.module('ute.common.core.content').directive('uteContentInjector', ContentInjector.factory());
            })(content = core.content || (core.content = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var content;
            (function (content) {
                'use strict';
                /** Content Loader service.
                 * Responsible for getting CMS content from the server via HTTP calls.
                 * This class is not exported, and never injected as a singleton service - due to instance-specific values such as
                 * path, contentObjects and isLocalContent.
                 * Use ute.common.core.content.loader.factory to instantiate this class.
                 */
                var ContentLoader = (function () {
                    /* @ngInject */
                    function ContentLoader($http, $compile, uteEndpoint) {
                        var _this = this;
                        this.$http = $http;
                        this.$compile = $compile;
                        this.uteEndpoint = uteEndpoint;
                        //region Properties
                        this.isLocalContent = false;
                        /**
                         * @property uteContentLoader.contentObjects
                         * @type {Array}
                         * @description holds each instance of the directive that calls the makeRequest method, using to loop through and match after loading content
                         */
                        this.contentObjects = [];
                        //endregion
                        //region Methods
                        /** @description returns a string with the language and province appended
                         * @param config - object containing language and province
                         * @returns {string}
                         */
                        this.localizedUrl = function (config) {
                            var contentId;
                            var separator = '_';
                            var cmsPath;
                            var parts;
                            var removedContentId;
                            if (angular.isDefined(config.contentId)) {
                                contentId = config.contentId;
                                // take parts of configObj.contentId and remove trailing content id after final
                                if (contentId.indexOf('/') !== -1) {
                                    parts = contentId.split('/');
                                    removedContentId = contentId.replace(parts[parts.length - 1], '');
                                    // use full config.contentId if dateType is html, if dataType is json reform the $scope.contentId to have json subfolder added to it
                                    contentId = config.dataType === 'json' ? removedContentId + '/json/' + parts[parts.length - 1] : contentId;
                                }
                                if (contentId.indexOf('integration') === -1) {
                                }
                                else {
                                    separator = '-';
                                    config.fileType = '.xml';
                                }
                                cmsPath = contentId + _this.getUrlPart(config.language, separator) + _this.getUrlPart(config.province, separator);
                                return _this.uteEndpoint(cmsPath, 'cms');
                            }
                            else if (angular.isDefined(config.localContentId)) {
                                contentId = config.localContentId;
                                _this.isLocalContent = true;
                                // take parts of configObj.contentId and remove trailing content id after final
                                if (contentId.indexOf('/') !== -1) {
                                    parts = contentId.split('/');
                                    removedContentId = contentId.replace(parts[parts.length - 1], '');
                                    // use full config.contentId if dateType is html, if dataType is json reform the $scope.contentId to have json subfolder added to it
                                    contentId = config.dataType === 'json' ? removedContentId + '/json/' + parts[parts.length - 1] : contentId;
                                }
                                cmsPath = contentId + _this.getUrlPart(config.language, separator) + _this.getUrlPart(config.province, separator);
                                return cmsPath;
                            }
                            else {
                                throw new Error('UTE-UI error: must define either attribute content-id or local-content-id');
                            }
                        };
                        /** @description converts ascii/html characters to < > characters, also replaces ampersands and a specific pattenr of double quotes
                         * @param escapedHTML - string to convert
                         * @returns {string}
                         */
                        this.unescapeHTML = function (escapedHTML) {
                            return escapedHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/\\"/g, '"');
                        };
                        this.getUrlPart = function (val, separator) {
                            if (val == null) {
                                return '';
                            }
                            return separator + val.toLowerCase();
                        };
                        /** @description callback for CMS loading success
                         * @param {object} currentContentObj - config object
                         * @param {object} result - data containing html markup
                         */
                        this.onCMSLoadSuccess = function (currentContentObj, result) {
                            var convertedHTML;
                            var matchedContent = null;
                            // find the matching content and its config object in the concent array
                            // TODO: we should be using array.find() here, however it's not available in TS for some reason (ES6 has it)
                            _this.contentObjects.some(function (eachContent) {
                                return currentContentObj.rid === eachContent.rid
                                    && currentContentObj.element === eachContent.element
                                    && (matchedContent = currentContentObj); // assignment here! Hack used to find the matching element
                            });
                            if (matchedContent == null) {
                                throw new Error('uteContentLoader error "matchedContent" was not defined');
                            }
                            // if attribute option compile is set to true then compile the markup
                            if (matchedContent.compile) {
                                // populate that markup into the html
                                matchedContent.element.html(result.data);
                                // compile only the inner markup so there's no recursive loop
                                _this.$compile(matchedContent.element.contents())(matchedContent.scope.$parent);
                            }
                            else if (matchedContent.fileType === '.json') {
                                // replace content url with proper url based on attr param
                                if (currentContentObj.teamsiteUrl !== 'undefined') {
                                    result.data.cmsContentURL = currentContentObj.teamsiteUrl + result.data.cmsContentURL;
                                }
                                /* we could use something like this to eliminate dependency on 'moment' - TBD
                                let editDateNumber: number = Date.parse((result.data.editDate || Date.now()).toLocaleString()); // not sure if REST returns Date object or string, covering both here
                                let editDate: Date = new Date(editDateNumber);
                                */
                                var editTimestamp = moment(result.data.editDate, 'MMMM Do YYYY, h:mm:ss a');
                                /*jshint camelcase: false */
                                matchedContent.element.children().prepend("\n          <div class=\"cms-metadata\">\n            <span class=\"content-url\">" + _this.path.replace('.json', '.html') + "</span>\n            <span class=\"edit-date\">" + editTimestamp + "</span>\n            <span class=\"version\">" + result.data.version + "</span>\n            <span class=\"is-published\">" + result.data.is_active + "</span>\n            <span class=\"content-edit-url\"><a href=\"" + result.data.cmsContentURL + "\" target=\"_blank\">Edit</a></span>\n          </div>");
                            }
                            else {
                                convertedHTML = _this.unescapeHTML(result.data);
                                matchedContent.element.html(convertedHTML);
                            }
                            matchedContent.element.removeClass('preloader loading');
                        };
                        /** @description callback for CMS loading error error
                         * @param {HTMLElement} currentContentObj - config object
                         */
                        this.onCMSLoadError = function (currentContentObj) {
                            var placeholder = "\n        <div class=\"cms-error\">\n          <h6 class=\"ute-col-alert-danger copy-6 margin-0\" title=\"" + (_this.localizedUrl(currentContentObj) + currentContentObj.fileType) + "\">\n            <i class=\"ute-icon-error ute-col-alert-danger\"></i>\n            <ins translate=\"global.error.inline.cms.loading\"></ins>\n          </h6>\n      </div>";
                            currentContentObj.element.removeClass('preloader loading');
                            currentContentObj.element.html(placeholder);
                        };
                        /** @description sets all the default options before making the $http request
                         * @param {IContentLoaderConfig} config - config object
                         */
                        this.setOptions = function (config) {
                            config.rid = Math.round(Math.random() * 1000);
                            // push processed object into array
                            _this.contentObjects.push(config);
                            return config;
                        };
                        /**
                         * @property uteContentLoader.makeRequest
                         * @type {function}
                         * @description make $http request to retrieve content of either html or json file
                         * @param {object} configObj - object which contains all the data associated with request
                         */
                        this.makeRequest = function (configObj) {
                            // save current config object and push to array
                            // returns object with rid defined
                            var config = _this.setOptions(configObj);
                            // set the path
                            var cmsPath = _this.localizedUrl(config) + config.fileType;
                            var rqConfig = {
                                method: config.method,
                                headers: {},
                                data: null,
                                //dataType: config.dataType, // irrelevant, not used anymore
                                url: cmsPath
                            };
                            var rq = _this.$http(rqConfig);
                            rq.then(function (result) {
                                _this.onCMSLoadSuccess(config, result);
                            });
                            rq.error(function (reason) {
                                _this.onCMSLoadError(config);
                            });
                            return cmsPath;
                        };
                        /** @description make $http request to retrieve content of either html or json file
                         * @param {object} configObj - object which contains all the data associated with request
                         * @returns promise
                         */
                        this.getContent = function (configObj) {
                            // save current config object and push to array
                            // returns object with rid defined
                            var config = _this.setOptions(configObj);
                            // set the path
                            var cmsPath = _this.localizedUrl(config) + config.fileType;
                            return _this.$http({
                                method: config.method,
                                url: cmsPath
                            });
                        };
                    }
                    /* @ngInject */
                    ContentLoader.createInstance = function ($http, $compile, uteEndpoint) {
                        return function () { return new ContentLoader($http, $compile, uteEndpoint); };
                    };
                    ContentLoader.$inject = ['$http', '$compile', 'ute.common.core.endpoint'];
                    return ContentLoader;
                }());
                ContentLoader.createInstance.$inject = ContentLoader.$inject;
                angular.module('ute.common.core.content').factory('ute.common.core.content.loader.factory', ContentLoader.createInstance);
            })(content = core.content || (core.content = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var cookies;
            (function (cookies) {
                'use strict';
                var CookieManagerProvider = (function () {
                    /* @ngInject */
                    function CookieManagerProvider() {
                        var _this = this;
                        this.config = {
                            basic: {}
                        };
                        /* @ngInject */
                        this.$get = function ($injector) {
                            //const utils = $injector.get('ute.common.utils');
                            var cookieServiceName = (angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies');
                            var cookieService = $injector.get(cookieServiceName);
                            var service = new cookies.CookieManagerService(cookieService);
                            service.setDomain(_this.config.basic.domain);
                            return service;
                        };
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.$get.$inject = [
                            '$injector'
                        ];
                    }
                    CookieManagerProvider.$inject = [
                        '$injector'
                    ];
                    return CookieManagerProvider;
                }());
                cookies.CookieManagerProvider = CookieManagerProvider;
                angular.module('ute.common.core.cookies').provider('ute.common.core.cookies.cookieManagerService', CookieManagerProvider);
            })(cookies = core.cookies || (core.cookies = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var cookies;
            (function (cookies) {
                'use strict';
                /**
                 * Provides access to browser cookies and user preferences
                 */
                var CookieManagerService = (function () {
                    //endregion
                    function CookieManagerService($cookies) {
                        var _this = this;
                        this.$cookies = $cookies;
                        this.cookieNames = {
                            userPref: 'userPref',
                            userInfo: 'userInfo',
                            atg: 'atg',
                            province: 'province',
                            language: 'language'
                        };
                        /**
                         * @description reads cookie
                         * @param name
                         * @param isJson
                         */
                        this.getCookie = function (name, isJson) {
                            if (isJson) {
                                if (_this.$cookies.getObject) {
                                    return _this.$cookies.getObject(name);
                                }
                                else {
                                    return _this.$cookies.get(name);
                                }
                            }
                            else {
                                return _this.$cookies.get(name);
                            }
                        };
                        /**
                         * @description sets cookie
                         * @param name
                         * @param value
                         * @param options
                         * @param isJson
                         */
                        this.setCookie = function (name, value, options, isJson) {
                            var date = new Date();
                            date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
                            options = options || {};
                            options.domain = _this.domain;
                            options.path = '/';
                            options.end = date.toGMTString();
                            if (options.expires != null && typeof options.expires === 'number') {
                                if (options.expires <= 0) {
                                    // no expiration
                                    options.expires = null;
                                }
                                else {
                                    // numeric expiry date means "number of days from now"
                                    var d = new Date();
                                    d.setDate(d.getDate() + options.expires); // add days to the current date
                                    options.expires = d;
                                }
                            }
                            if (isJson) {
                                if (_this.$cookies.putObject) {
                                    _this.$cookies.putObject(name, value, options);
                                }
                                else {
                                    _this.$cookies.put(name, value, options);
                                }
                            }
                            else {
                                _this.$cookies.put(name, value, options);
                            }
                        };
                        /** Deletes cookie
                         * default options are:
                         *  {
                         *    path: '/',
                         *    domain: this.domain
                         *  }
                         */
                        this.deleteCookie = function (name, options) {
                            options = options || {
                                path: '/',
                                domain: _this.domain
                            };
                            _this.$cookies.remove(name, options);
                        };
                        /** We need to cleanup the language cookie to sync selected language between Eclipse and Rogers-Client.
                         * RC may set an extra 'language' cookie, at 'www.<root>' domain, and that cookies is never modified by the ute-ui
                         * language selection, making RC language to go out of sync
                         */
                        this.deleteLanguageCookie = function () {
                            _this.deleteCookie(_this.cookieNames.language, {
                                path: '/' // do not specify the domain
                            });
                        };
                        this.deleteProvinceCookie = function () {
                            _this.deleteCookie(_this.cookieNames.province, {
                                path: '/'
                            });
                        };
                        // set legacy cookies
                        if (!this.language) {
                            this.language = 'en'; // default language is always set
                        }
                        // default province is not - user is presented with a dialog to select the province
                    }
                    //region Public
                    //region Common use
                    CookieManagerService.prototype.setDomain = function (domain) {
                        this.domain = domain;
                    };
                    Object.defineProperty(CookieManagerService.prototype, "province", {
                        //endregion
                        //region Specific to Province and Language storage
                        //TBD: move out of the cookie manager into uteLocaleStorage or something?
                        get: function () {
                            return this.getCookie(this.cookieNames.province, false);
                        },
                        set: function (value) {
                            this.setCookie(this.cookieNames.province, value, {
                                expires: 0,
                                path: '/'
                            }, false);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(CookieManagerService.prototype, "language", {
                        get: function () {
                            return this.getCookie(this.cookieNames.language, false);
                        },
                        set: function (value) {
                            if (value === undefined) {
                                return; // skip, there's some event (not sure which one) that triggers this update for some reason - to be investigated.
                            }
                            this.setCookie(this.cookieNames.language, value, {
                                expires: 0,
                                path: '/'
                            }, false);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return CookieManagerService;
                }());
                cookies.CookieManagerService = CookieManagerService;
            })(cookies = core.cookies || (core.cookies = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var endpoint;
            (function (endpoint) {
                'use strict';
                /**
                 * @ngdoc service
                 * @class ute-ui
                 * @memberOf ute-ui
                 * @param key Endpoint key name to generate a complete url
                 * @description
                 *   Returns endpoint url for http(s) services
                 *
                 * Requirements;
                 *
                 *   Input/Configuration/Parameter;
                 *
                 *     . MUST be able to configure `baseUrl`
                 *     . MUST be able to configure `basePath`
                 *     . MUST be able to configure keys to override the default behaviour
                 *
                 *   Output
                 *
                 *     . MUST return complete url starting from http, https, or //
                 *
                 * @example
                 * <script>
                 *   app.config(function(uteEndpointProvider) {
                 *     uteEndpointProvider.setBaseUrl("http://base.url.com");
                 *     uteEndpointProvider.setBasePath("/base/path");
                 *     uteEndpointProvider.setEndpoints({
                 *       'custom1': "http://custom.com/foo",
                 *       'custom2': "/foo/bar",
                 *       'custom3': "bar",
                 *     });
                 *     uteEndpointProvider.set('custom4', "http://custom.com/bar");
                 *   });
                 *
                 *  app.controller('MyCtrl', function($scope, uteEndpoint) {
                 *    uteEndpoint("foo");     // http://base.url.com/base/path/foo
                 *    uteEndpoint("bar");     // http://base.url.com/base/path/bar
                 *    uteEndpoint("/foo");    // http://base.url.com/foo
                 *    uteEndpoint("custom1"); // http://custom.com/foo
                 *    uteEndpoint("custom2"); // http://base.url.com/foo/bar
                 *    uteEndpoint("custom3"); // http://base.url.com/base/path/bar
                 *    uteEndpoint("custom4"); // http://custom.com/bar
                 *  });
                 * </script>
                 */
                var EndpointProvider = (function () {
                    /* @ngInject */
                    function EndpointProvider() {
                        var _this = this;
                        this.baseUrl = '';
                        this.basePath = '';
                        this.cmsContentURL = '';
                        this.teamsiteURL = '';
                        this.endpoints = {};
                        /**
                         * @memberof uteEndpointProvider
                         * @description set all options
                         * @param {Object} options
                         * @example
                         *   uteEndpointProvider.configure({baseUrl:"http://foo.com", basePath: "/bar"});
                         */
                        this.configure = function (options) {
                            _this.baseUrl = options.baseUrl;
                            _this.basePath = options.basePath;
                            _this.cmsContentURL = options.cmsContentURL;
                            _this.endpoints = options.endpoints;
                            return true;
                            //TBD:
                            // 1. Store everything in a single private variable. i.e.
                            // private _config: IEndpointProviderConfig;
                            //
                            // 2. _.merge (or angular.merge - 1.4.x) with existing values
                        };
                        /**
                         * @memberof uteEndpointProvider
                         * @description set base url
                         * @param {String} url
                         * @example
                         *   uteEndpointProvider.setBaseUrl("http://foo.com");
                         */
                        this.setBaseUrl = function (url) {
                            _this.baseUrl = url;
                        };
                        /**
                         * @memberof uteEndpointProvider
                         * @description set base path
                         * @param {String} path
                         * @example
                         *   uteEndpointProvider.setBasePath("/bar");
                         */
                        this.setBasePath = function (path) {
                            _this.basePath = path;
                        };
                        /**
                         * @memberof uteEndpointProvider
                         * @description set all custom endpoints to override the default behaviour
                         * @param {Object}  endpoints object with key/value
                         * @example
                         *   uteEndpointProvider.setEndpoints({foo:"/foo", bar: "https://foo.com/bar"});
                         */
                        this.setEndpoints = function (endpoints) {
                            _this.endpoints = endpoints;
                        };
                        this.setCMSContentURL = function (url) {
                            _this.cmsContentURL = url;
                        };
                        this.setTeamsiteURL = function (url) {
                            _this.teamsiteURL = url;
                        };
                        /**
                         * @memberof uteEndpointProvider
                         * @description set a single custom endpoint to override the default behaviour
                         * @param key key of endpoint, i.e. 'myurl"
                         * @param url url, i.e. 'https://my.custom.com/url/endpoint"
                         * @example
                         *   uteEndpointProvider.set("foo", "https://foo.com/bar");
                         */
                        this.set = function (key, url) {
                            _this.endpoints[key] = url;
                        };
                        /* @ngInject */
                        this.$get = function () {
                            return function (key, typeOfEndpoint) {
                                // if it's a cms call
                                if (typeOfEndpoint === 'cms') {
                                    if (!_this.cmsContentURL) {
                                        _this.cmsContentURL = _this.baseUrl;
                                    }
                                    return _this.cmsContentURL + key;
                                }
                                // if it's a teamsite call
                                if (typeOfEndpoint === 'teamsite') {
                                    return _this.teamsiteURL + key;
                                }
                                // not a cms call
                                var url = _this.endpoints[key];
                                if (url) {
                                    if (url.match(/^http/)) {
                                        return url;
                                    }
                                    else if (url.match(/^\//)) {
                                        return _this.baseUrl + url;
                                    }
                                    else {
                                        return _this.baseUrl + _this.basePath + '/' + url;
                                    }
                                }
                                else if (key.match(/^\//)) {
                                    return _this.baseUrl + key;
                                }
                                else {
                                    return _this.baseUrl + _this.basePath + '/' + key;
                                }
                            };
                        };
                        this.$get.$inject = [];
                    }
                    EndpointProvider.$inject = [];
                    return EndpointProvider;
                }());
                angular.module('ute.common.core.endpoint').provider('ute.common.core.endpoint', EndpointProvider);
            })(endpoint = core.endpoint || (core.endpoint = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

// module ute.common.core.locale {
//   'use strict';
//
//   /**
//    * @description Deprecated. Use ute.common.core.userPreferences.service instead.
//    * Kept for backwards compatibility only; merely a gateway to the corresponding properties of UserPreferenceService
//    * To be retired eventually, when everything's switched to UserPreferenceService directly.
//    */
//   export class LocaleService implements ILocaleService {
//
//     static $inject = ['ute.common.core.userPreferences.service'];
//
//     /* @ngInject */
//     constructor(private userPreferences: ute.common.core.userPreferences.IUserPreferenceService) {
//     }
//
//     get province() {
//       return this.userPreferences.province;
//     }
//     set province(newValue: string) {
//       if (!newValue) {
//         return;
//       }
//       this.userPreferences.province = newValue;
//     }
//
//     get language() {
//       return this.userPreferences.language;
//     }
//     set language(newValue: string) {
//       if (!newValue) {
//         return;
//       }
//       this.userPreferences.language = newValue;
//     }
//
//     get country() {
//       return this.userPreferences.country;
//     }
//
//     get locale() {
//       return this.userPreferences.locale;
//     }
//   }
//
//   angular.module('ute.common.core.locale').service('ute.common.core.locale.service', LocaleService);
//
// }

/* this should be defined in the parent app:

module ute.common.core.shared {
  'use strict';

  angular.module('ute.common.core.shared')
    .config(['$sceDelegateProvider', function ($sceDelegateProvider: ng.ISCEDelegateProvider) {

      $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from our assets domain.  Notice the difference between * and **.
        'http://*.fido.ca/**'
      ]);

    }]);
}
*/

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var shared;
            (function (shared) {
                'use strict';
            })(shared = core.shared || (core.shared = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var shared;
            (function (shared) {
                'use strict';
                /**
                 * Manages global values that should be available to all modules in the app.
                 */
                var SharedService = (function () {
                    /* @ngInject */
                    function SharedService() {
                        var _this = this;
                        /**
                         * @description
                         * @returns {string}
                         */
                        this.detectBrowser = function () {
                            var browser = {}, ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                            if (/trident/i.test(M[1])) {
                                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                                browser.type = 'ie';
                                browser.version = (tem[1] || '');
                                return browser;
                            }
                            if (M[1] === 'Chrome') {
                                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                                if (tem != null) {
                                    return tem.slice(1).join(' ').replace('OPR', 'Opera');
                                }
                            }
                            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                            if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                                M.splice(1, 1, tem[1]);
                            }
                            browser.type = M[0].toLowerCase();
                            browser.version = M[1];
                            return browser;
                        };
                        /** calculate the precise number of all channels */
                        this.calcAllChannelPreciseCount = function (iptvOffer) {
                            var count = _this.calcFlexChannelPreciseCount(iptvOffer) + _this.calcBasicChannelPreciseCount(iptvOffer);
                            return count;
                        };
                        /** calculate the precise number of Flex channels */
                        this.calcFlexChannelPreciseCount = function (iptvOffer) {
                            var count = 0;
                            if (iptvOffer && iptvOffer.channels) {
                                if (iptvOffer.channels.flex) {
                                    count += iptvOffer.channels.flex.length;
                                }
                                if (iptvOffer.channels.mandatory) {
                                    count += iptvOffer.channels.mandatory.length;
                                }
                            }
                            return count;
                        };
                        /** calculate the precise number of Basic channels */
                        this.calcBasicChannelPreciseCount = function (iptvOffer) {
                            var count = 0;
                            if (iptvOffer && iptvOffer.channels) {
                                if (iptvOffer.channels.basic) {
                                    count += iptvOffer.channels.basic.length;
                                }
                            }
                            return count;
                        };
                        /** calculates the discounted price from an offer and promo */
                        this.calcDiscountPrice = function (offer, promo) {
                            var discountPrice = offer.selectedInternet.offerPrice.price;
                            if (promo) {
                                discountPrice -= promo.discountPrice;
                            }
                            return discountPrice;
                        };
                        /**
                         * @description is valid language
                         * @param language
                         * @returns {boolean}
                         */
                        // TBD: move to uteLocale ?
                        this.isValidLanguage = function (language) {
                            return ['en', 'fr'].indexOf(language.toLowerCase()) !== -1;
                        };
                        /**
                         * @description
                         * @param ccNumber
                         * @returns {*}
                         */
                        this.getCCType = function (ccNumber) {
                            if (ccNumber.length > 3) {
                                if (ccNumber.match(/^(34|37)/)) {
                                    return 'AMEX';
                                }
                                else if (ccNumber.match(/^(4[0-9])/)) {
                                    return 'VISA';
                                }
                                else if (ccNumber.match(/^5[1-5]/)) {
                                    return 'MASTER';
                                }
                            }
                            else {
                                return '';
                            }
                        };
                        /**
                         * @description
                         * @param formValue
                         * @returns {boolean}
                         */
                        this.validateFormOnSubmit = function (formValue) {
                            /* function being used to make form to display postback results */
                            // dont submit if form is invalid and allow angular to show form invalid messages
                            if (formValue.$invalid) {
                                for (var field in formValue) {
                                    // look at each form input with a name attribute set
                                    // checking if it is pristine and not a '$' special field
                                    if (field[0] !== '$' && formValue[field].$pristine) {
                                        formValue[field].$setTouched();
                                    }
                                }
                                return false;
                            }
                            return true;
                        };
                        //region TBD: set/getCachedVariable functions are one-liners and look useless, the client can just go ahead and assign variables to singleton services directly
                        // keeping for backwards compatibility for now
                        /**
                         * @description
                         * @param variable
                         * @param value
                         * @returns {boolean}
                         */
                        this.setCacheVariable = function (variable, value) {
                            /* set cache variable here, used to use accross the different controlleres */
                            _this[variable] = value;
                            return true;
                        };
                        /**
                         * @description
                         * @param variable
                         * @returns {*}
                         */
                        this.getCacheVariable = function (variable) {
                            /* get cache variable here */
                            return _this[variable];
                        };
                        /**
                         * @description
                         * @param name
                         * @returns {string}
                         */
                        this.getParameterByName = function (name) {
                            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'), results = regex.exec(location.href.replace('&amp;', '&'));
                            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
                        };
                        // empty intentionally
                    }
                    SharedService.$inject = [];
                    return SharedService;
                }());
                angular.module('ute.common.core.shared').service('ute.common.core.shared.service', SharedService);
            })(shared = core.shared || (core.shared = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var userPreferences;
            (function (userPreferences) {
                'use strict';
            })(userPreferences = core.userPreferences || (core.userPreferences = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var userPreferences;
            (function (userPreferences) {
                'use strict';
                /**
                 * Represents properties and methods for the current user
                 */
                var UserPreferenceService = (function () {
                    //endregion
                    //region Constructor
                    /* @ngInject */
                    function UserPreferenceService($timeout, uteCookieManager, utils, messageBus) {
                        //region set defaults
                        var _this = this;
                        this.$timeout = $timeout;
                        this.uteCookieManager = uteCookieManager;
                        this.utils = utils;
                        this.messageBus = messageBus;
                        this.setFromUrlParams = function (livesiteLang, lithiumLang, livesiteProvince) {
                            if (livesiteLang && _.contains(_this.allLanguages, livesiteLang)) {
                                //console.log('livesite language:', livesiteLang);
                                _this.language = livesiteLang;
                            }
                            else if (lithiumLang && _.contains(_this.allLanguages, lithiumLang)) {
                                //console.log('lithium language:', lithiumLang);
                                _this.language = lithiumLang;
                            }
                            if (livesiteProvince && _.contains(_this.allProvinces, livesiteProvince)) {
                                //console.log('livesite province:', livesiteProvince);
                                _this.province = livesiteProvince;
                            }
                        };
                        this.allLanguages = ['en', 'fr'];
                        this.allProvinces = ['ab', 'bc', 'mb', 'nb', 'nl', 'ns', 'on', 'pe', 'qc', 'sk'];
                        this.eventIds = {
                            beforeProvinceUpdate: 'ute.before.province.update',
                            provinceUpdated: 'ute.province.updated',
                            beforeLanguageUpdate: 'ute.before.language.update',
                            languageUpdated: 'ute.language.updated',
                            provinceNotSet: 'ute.province.not.set'
                        };
                        this.fireBeforeEvents = false; // this can be changed anytime
                        this.multiPageMode = false;
                        this._preferences = {
                            firstTimeUser: true,
                            samKey: 'default'
                        };
                        this._atg = {
                            userId: {
                                value: 'default'
                            },
                            hashKey: {
                                value: 'default'
                            }
                        };
                        this._info = {};
                        //endregion
                        //region get settings from the current url, if any:
                        var livesiteLang = utils.getQuerystringParameter('setLanguage').toLowerCase();
                        var lithiumLang = utils.getQuerystringParameter('lang').toLowerCase();
                        var livesiteProvince = utils.getQuerystringParameter('setProvince').toLowerCase();
                        this.setFromUrlParams(livesiteLang, lithiumLang, livesiteProvince);
                        this._preferences = _.merge(this._preferences, this.uteCookieManager.getCookie(this.uteCookieManager.cookieNames.userPref, true));
                        this._info = _.merge(this._info, this.uteCookieManager.getCookie(this.uteCookieManager.cookieNames.userInfo, true));
                        this._atg = _.merge(this._atg, this.uteCookieManager.getCookie(this.uteCookieManager.cookieNames.atg, true));
                        //endregion
                        // if undefined - try to get from permanent storage
                        if (!this._province) {
                            this.province = this.uteCookieManager.province;
                            // if cookie province is not there, set ip up with the default one
                            if (!this.province) {
                                this.province = this.uteCookieManager.province = 'ON';
                            }
                        }
                        if (!this._language) {
                            this.language = this.uteCookieManager.language;
                        }
                    }
                    Object.defineProperty(UserPreferenceService.prototype, "isProvinceSet", {
                        get: function () {
                            return !!this._province;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(UserPreferenceService.prototype, "province", {
                        //region Province
                        get: function () {
                            if (this.isProvinceSet) {
                                return this._province;
                            }
                            else {
                                // fire an event and return default.
                                // subscriber can handle this case by asking the user or auto-detecting the province.
                                // once province is set, this event is never fired
                                this.messageBus.publish(this.eventIds.provinceNotSet);
                                return this.defaultProvince;
                            }
                        },
                        /** Sets the province value, enforcing the upper-case.
                         * Deletes the root-level province cookie if null value is passed.
                         */
                        set: function (val) {
                            var _this = this;
                            if (val != null) {
                                val = val.toLocaleUpperCase();
                            }
                            if (this.fireBeforeEvents) {
                                this.messageBus.publish(this.eventIds.beforeProvinceUpdate, val);
                                this.$timeout(function () {
                                    _this.updateProvince(val);
                                });
                            }
                            else {
                                this.updateProvince(val);
                            }
                        },
                        enumerable: true,
                        configurable: true
                    });
                    UserPreferenceService.prototype.updateProvince = function (val) {
                        this._province = val;
                        this.uteCookieManager.deleteProvinceCookie();
                        if (val !== null) {
                            this.uteCookieManager.province = val;
                        }
                        this.messageBus.publish(this.eventIds.provinceUpdated, val);
                    };
                    Object.defineProperty(UserPreferenceService.prototype, "language", {
                        //endregion
                        //region Language
                        get: function () {
                            return this._language;
                        },
                        /**
                         * Deletes the root-level language cookie if null value is passed
                         */
                        set: function (val) {
                            var _this = this;
                            if (val === undefined) {
                                return; // do nothing if undefined is passed
                            }
                            if (val === null) {
                                /** We need to cleanup the language cookie to sync selected language between Eclipse and Rogers-Client.
                                 * RC may set an extra 'language' cookie, at 'www.<root>' domain, and that cookies is never modified by the ute-ui
                                 * language selection, making RC language to go out of sync
                                 */
                                this.uteCookieManager.deleteLanguageCookie();
                            }
                            else {
                                if (this.fireBeforeEvents) {
                                    this.messageBus.publish(this.eventIds.beforeLanguageUpdate, val);
                                    this.$timeout(function () {
                                        _this.updateLanguage(val);
                                    });
                                }
                                else {
                                    this.updateLanguage(val);
                                }
                            }
                        },
                        enumerable: true,
                        configurable: true
                    });
                    UserPreferenceService.prototype.updateLanguage = function (val) {
                        this._language = val;
                        this.uteCookieManager.deleteLanguageCookie();
                        this.uteCookieManager.language = val;
                        this.messageBus.publish(this.eventIds.languageUpdated, val);
                    };
                    Object.defineProperty(UserPreferenceService.prototype, "preferences", {
                        //endregion
                        get: function () {
                            return this._preferences;
                        },
                        set: function (val) {
                            if (!val) {
                                return;
                            }
                            this._preferences = val;
                            this.uteCookieManager.setCookie(this.uteCookieManager.cookieNames.userInfo, val, {
                                expires: 30,
                                path: '/'
                            }, true);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(UserPreferenceService.prototype, "info", {
                        get: function () {
                            return this._info;
                        },
                        set: function (val) {
                            if (!val) {
                                return;
                            }
                            this._info = val;
                            this.uteCookieManager.setCookie(this.uteCookieManager.cookieNames.userInfo, val, {
                                expires: 30,
                                path: '/'
                            }, true);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(UserPreferenceService.prototype, "atg", {
                        get: function () {
                            return this._atg;
                        },
                        set: function (val) {
                            if (!val) {
                                return;
                            }
                            this._atg = val;
                            this.uteCookieManager.setCookie(this.uteCookieManager.cookieNames.atg, val, {
                                expires: 30,
                                path: '/'
                            }, true);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(UserPreferenceService.prototype, "country", {
                        get: function () {
                            return 'ca';
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(UserPreferenceService.prototype, "locale", {
                        get: function () {
                            return this.language + '-' + this.country;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    //region Static
                    UserPreferenceService.$inject = ['$timeout', 'ute.common.core.cookies.cookieManagerService', 'ute.common.utils.service', 'ute.blocks.messages.bus.service'];
                    return UserPreferenceService;
                }());
                angular.module('ute.common.core.userPreferences').service('ute.common.core.userPreferences.service', UserPreferenceService);
            })(userPreferences = core.userPreferences || (core.userPreferences = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                // TODO where it used?
                var locales = {
                    'locales': {
                        'fr_CA': 'Français',
                        'en_CA': 'English'
                    },
                    'preferredLocale': 'en_CA'
                };
                angular.module('ute.blocks.language.switcher').config(configure).constant('LOCALES', locales);
                configure.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];
                /* @ngInject */
                function configure($translateProvider, tmhDynamicLocaleProvider) {
                    // TODO 'en' move to config
                    $translateProvider
                        .preferredLanguage('en')
                        .useStorage('ute.blocks.language.switcher.customLocaleStorage')
                        .useSanitizeValueStrategy(null);
                    tmhDynamicLocaleProvider.localeLocationPattern('scripts/angular-i18n/angular-locale_{{locale}}.js');
                }
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var CustomLocaleStorage = (function () {
                    /* @ngInject */
                    function CustomLocaleStorage($cookies) {
                        var _this = this;
                        this.$cookies = $cookies;
                        // TODO provider and configure
                        this.path = '/';
                        this.domain = '.rogers.com';
                        this.LANG_KEY = 'NG_TRANSLATE_LANG_KEY';
                        this.put = function (name, value) {
                            //console.log('CustomLocaleStorage->put: name=', name, ' value=', value);
                            if (name === _this.LANG_KEY) {
                                _this.$cookies.put(ute.common.core.RogersCookies.LANGUAGE, value, { path: _this.path, domain: _this.domain });
                                _this.$cookies.put(ute.common.core.RogersCookies.LANGUAGE, value, { path: _this.path }); // to support ute.ui
                            }
                        };
                        this.get = function (name) {
                            //console.log('CustomLocaleStorage->get: name=', name);
                            if (name === _this.LANG_KEY) {
                                return _this.getCurrentLanguage();
                            }
                        };
                        this.getCurrentLanguage = function () {
                            // TODO use default lang from angular-translate
                            return _this.$cookies.get(ute.common.core.RogersCookies.LANGUAGE) || 'en';
                        };
                    }
                    CustomLocaleStorage.$inject = [angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'];
                    return CustomLocaleStorage;
                }());
                angular.module('ute.blocks.language.switcher').service('ute.blocks.language.switcher.customLocaleStorage', CustomLocaleStorage);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var LanguageSwitchController = (function () {
                    /* @ngInject */
                    function LanguageSwitchController($translate, tmhDynamicLocale, languageSwitcher) {
                        var _this = this;
                        this.$translate = $translate;
                        this.tmhDynamicLocale = tmhDynamicLocale;
                        this.languageSwitcher = languageSwitcher;
                        this.changeLanguage = function () {
                            if (angular.isDefined($)) {
                                $('html').attr('lang', _this.$translate.instant('ute.blocks.language.switcher.to'));
                            }
                            return _this.languageSwitcher.changeLanguage(_this.$translate.instant('ute.blocks.language.switcher.to'));
                        };
                    }
                    LanguageSwitchController.$inject = ['$translate', 'tmhDynamicLocale', 'ute.blocks.language.switcher'];
                    return LanguageSwitchController;
                }());
                switcher.LanguageSwitchController = LanguageSwitchController;
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var LanguageSwitch = (function () {
                    function LanguageSwitch() {
                        this.bindToController = true;
                        //controller: string = 'ute.common.core.LanguageSwitchController';
                        this.controller = switcher.LanguageSwitchController;
                        this.controllerAs = 'languageSwitch';
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = 'module/language.switcher/languageSwitch.html';
                    }
                    //constructor(private $translate: ng.translate.ITranslateService) {
                    //}
                    LanguageSwitch.factory = function () {
                        var directive = function () { return new LanguageSwitch(); };
                        //directive.$inject = ['$translate'];
                        return directive;
                    };
                    return LanguageSwitch;
                }());
                angular.module('ute.blocks.language.switcher').directive('uteLanguageSwitch', LanguageSwitch.factory());
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var SubPubGeneric = ute.common.core.subpub.SubPubGeneric;
                var LanguageSwitcher = (function (_super) {
                    __extends(LanguageSwitcher, _super);
                    /* @ngInject */
                    function LanguageSwitcher($translate, tmhDynamicLocale, localeStorage, routerHelper, $location) {
                        var _this = this;
                        _super.call(this, 'LanguageSwitcher');
                        this.$translate = $translate;
                        this.tmhDynamicLocale = tmhDynamicLocale;
                        this.$location = $location;
                        this.lang2locale = {
                            fr: 'fr-ca',
                            en: 'en-ca'
                        };
                        this.getCurrentLanguage = function () { return _this.currentLanguage; };
                        /**
                         * @param switchToLang
                         * @returns {boolean}
                         */
                        this.changeLanguage = function (switchToLang) {
                            if (!_.include(LanguageSwitcher.supportedLanguages, switchToLang)) {
                                return false;
                            }
                            var search = _this.$location.search();
                            if (_.has(search, 'lang')) {
                                _this.$location.search(_.assign(search, { lang: switchToLang }));
                            }
                            _this.currentLanguage = switchToLang;
                            // console.log('changeLanguage: switchToLang=' + switchToLang,
                            //     'tmhDynamicLocale.get()=', this.tmhDynamicLocale.get(),
                            //     'currentLanguage=', this.currentLanguage);
                            _this.$translate.use(switchToLang);
                            _this.tmhDynamicLocale.set(_this.lang2locale[switchToLang]);
                            _this.notifySubs();
                            return true;
                        };
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            var search = _this.$location.search();
                            if (_.has(search, 'lang')) {
                                _this.changeLanguage(search.lang);
                            }
                            return true;
                        };
                        this.currentLanguage = localeStorage.getCurrentLanguage();
                        LanguageSwitcher.supportedLanguages.forEach(function (lang) { return _this.tmhDynamicLocale.set(_this.lang2locale[lang]); });
                        this.tmhDynamicLocale.set(this.lang2locale[this.currentLanguage]);
                        routerHelper.registerGlobalFromStateHandler(this, ute.blocks.router.StateHandlerPriority.HIGH);
                    }
                    LanguageSwitcher.prototype.getChangableData = function () {
                        return this.currentLanguage;
                    };
                    LanguageSwitcher.$inject = [
                        '$translate',
                        'tmhDynamicLocale',
                        'ute.blocks.language.switcher.customLocaleStorage',
                        'ute.blocks.router',
                        '$location'];
                    LanguageSwitcher.supportedLanguages = ['en', 'fr'];
                    return LanguageSwitcher;
                }(SubPubGeneric));
                angular.module('ute.blocks.language.switcher').service('ute.blocks.language.switcher', LanguageSwitcher);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var messages;
        (function (messages) {
            var bus;
            (function (bus) {
                'use strict';
                var Messages = (function () {
                    function Messages() {
                    }
                    Messages.uteRogersInterceptorsAuthSigninRequired = 'ute.rogers.interceptors.auth.signin.required';
                    Messages.uteRogersInterceptorsAuthSignoutRequired = 'ute.rogers.interceptors.auth.signout.required';
                    Messages.uteUserResourceAccessPermissionDenied = 'ute.user.resource.access.permission.denied';
                    Messages.uteUserUnauthorized = 'ute.user.unauthorized';
                    Messages.uteRogersSigninSuccessful = 'ute.rogers.signin.successful';
                    Messages.uteRogersSignoutSuccessful = 'ute.rogers.signout.successful';
                    Messages.uteRogersAccountChanged = 'ute.rogers.account.has.been.changed';
                    Messages.uteRogersMobileMenuChanged = 'ute.rogers.mobile.menu.changed';
                    return Messages;
                }());
                bus.Messages = Messages;
                var MessagesService = (function () {
                    /* @ngInject */
                    function MessagesService(logger, $rootScope) {
                        var _this = this;
                        this.logger = logger;
                        this.$rootScope = $rootScope;
                        /**
                         * Simple wrap
                         * @param event
                         * @param data
                         * @return IAngularEvent
                         */
                        this.publish = function (event, data) {
                            return _this.$rootScope.$broadcast(event, data);
                        };
                        this.register = function (name, listener) {
                            return _this.$rootScope.$on(name, listener);
                        };
                        this.subscribe = this.register;
                    }
                    MessagesService.$inject = ['ute.blocks.loggerService', '$rootScope'];
                    return MessagesService;
                }());
                angular.module('ute.blocks.messages.bus').service('ute.blocks.messages.bus.service', MessagesService);
            })(bus = messages.bus || (messages.bus = {}));
        })(messages = blocks.messages || (blocks.messages = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                angular.module('ute.blocks.persistent.storage').config(configure);
                configure.$inject = ['$sessionStorageProvider', '$localStorageProvider'];
                /* @ngInject */
                function configure($sessionStorageProvider, $localStorageProvider) {
                    $sessionStorageProvider.setKeyPrefix('');
                    $localStorageProvider.setKeyPrefix('');
                    $sessionStorageProvider.setDeserializer(function (value) {
                        try {
                            return angular.fromJson(value);
                        }
                        catch (e) {
                            return value;
                        }
                    });
                    $localStorageProvider.setDeserializer(function (value) {
                        try {
                            return angular.fromJson(value);
                        }
                        catch (e) {
                            return value;
                        }
                    });
                }
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                var RogersStoreService = (function () {
                    /* @ngInject */
                    function RogersStoreService($window) {
                        var _this = this;
                        this.$window = $window;
                        this.put = function (key, value) {
                            _this.$window.sessionStorage.setItem(key, angular.isObject(value) || angular.isArray(value) ? angular.toJson(value) : value);
                            return true;
                        };
                        this.get = function (key) {
                            var value = _this.$window.sessionStorage.getItem(key);
                            try {
                                return angular.fromJson(value);
                            }
                            catch (e) {
                                return value;
                            }
                        };
                        this.remove = function (key) {
                            _this.$window.sessionStorage.removeItem(key);
                            return true;
                        };
                        this.putToLocal = function (key, value) {
                            _this.$window.localStorage.setItem(key, angular.isObject(value) || angular.isArray(value) ? angular.toJson(value) : value);
                            return true;
                        };
                        this.getFromLocal = function (key) {
                            var value = _this.$window.localStorage.getItem(key);
                            try {
                                return angular.fromJson(value);
                            }
                            catch (e) {
                                return value;
                            }
                        };
                        this.removeFromLocal = function (key) {
                            _this.$window.localStorage.removeItem(key);
                            return true;
                        };
                        this.getLocalStoreService = function () { return ({
                            put: _this.putToLocal,
                            get: _this.getFromLocal,
                            remove: _this.removeFromLocal
                        }); };
                        this.getSessionStoreService = function () { return ({
                            put: _this.putToSession,
                            get: _this.getFromSession,
                            remove: _this.removeFromSession
                        }); };
                        this.putToSession = this.put;
                        this.getFromSession = this.get;
                        this.removeFromSession = this.remove;
                    }
                    RogersStoreService.$inject = ['$window'];
                    return RogersStoreService;
                }());
                angular.module('ute.blocks.persistent.storage').service('ute.blocks.persistent.storage.service', RogersStoreService);
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
            // import UserType = ute.common.user.UserType;
            var SecurityProvider = (function () {
                /* @ngInject */
                function SecurityProvider(userProvider) {
                    var _this = this;
                    this.userProvider = userProvider;
                    // private protectedUrlPrefix: string = '/web/RogersServices.portal/totes/api/';
                    // private publicUrlPrefix: string = '/web/totes/api/';
                    /* @ngInject */
                    this.$get = function ($injector, $state) {
                        _this.$state = $state;
                        _this.userService = $injector.get('ute.common.user.service');
                        return {
                            isStateProtected: _this.isStateProtected,
                            getBackendUrl: _this.userService.getBackendUrl
                        };
                    };
                    /**
                     * @param state
                     * @returns {boolean}
                     */
                    this.isStateProtected = function (state) {
                        var roles = _.get(_.isString(state) ? _this.$state.get(state) : state, 'data.security.roles');
                        // if not exists = public
                        return !(angular.isUndefined(roles) || _.contains(roles, 'public'));
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$state'
                    ];
                    // this.config.roleToUrlBase[UserType[UserType.care]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.careRep]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.dealer]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.consumer]] = this.protectedUrlPrefix;
                }
                /**
                 * @param config
                 * @returns {boolean}
                 */
                SecurityProvider.prototype.configure = function (config) {
                    // this.config = <ISecurityConfig>_.merge(this.config, config);
                    // this.userProvider.configure({roleToUrlBase: config.roleToUrlBase});
                    return true;
                };
                SecurityProvider.$inject = ['ute.common.user.serviceProvider'];
                return SecurityProvider;
            }());
            angular.module('ute.common.security').provider('ute.common.security.service', SecurityProvider);
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function () {
                    /* @ngInject */
                    function UserTest(userService, $animate) {
                        var _this = this;
                        this.userService = userService;
                        this.$animate = $animate;
                        this.scope = {
                            uteUserHideIfAnyGranted: '@'
                        };
                        this.restrict = 'A';
                        this.multiElement = true;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.rolesArray, _this.userService.getUserType());
                        };
                        this.linkFn = function (scope, instanceElement) {
                            _this.rolesArray = scope.uteUserHideIfAnyGranted ? scope.uteUserHideIfAnyGranted.split(',').map(function (s) { return s.trim(); }) : [];
                            scope.$watch(_this.test, function (value) {
                                _this.$animate[value ? 'addClass' : 'removeClass'](instanceElement, UserTest.NG_HIDE_CLASS, {
                                    tempClasses: UserTest.NG_HIDE_IN_PROGRESS_CLASS
                                });
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        var directive = function (userService, $animate) { return new UserTest(userService, $animate); };
                        directive.$inject = ['ute.common.user.service', '$animate'];
                        return directive;
                    };
                    UserTest.NG_HIDE_CLASS = 'ng-hide';
                    UserTest.NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
                    return UserTest;
                }());
                /**
                 * <div ute-user-hide-if-any-granted='role1,role2'> directive
                 */
                angular.module('ute.common.user').directive('uteUserHideIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function () {
                    /* @ngInject */
                    function UserTest(userService, $animate) {
                        var _this = this;
                        this.userService = userService;
                        this.$animate = $animate;
                        this.scope = {
                            uteUserShowIfAnyGranted: '@'
                        };
                        this.restrict = 'A';
                        this.multiElement = true;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.rolesArray, _this.userService.getUserType());
                        };
                        this.linkFn = function (scope, instanceElement) {
                            _this.rolesArray = scope.uteUserShowIfAnyGranted ? scope.uteUserShowIfAnyGranted.split(',').map(function (s) { return s.trim(); }) : [];
                            scope.$watch(_this.test, function (value) {
                                // console.log('wwwwwwwwwwwwwwwwww', this.rolesArray, value, scope);
                                _this.$animate[value ? 'removeClass' : 'addClass'](instanceElement, UserTest.NG_HIDE_CLASS, {
                                    tempClasses: UserTest.NG_HIDE_IN_PROGRESS_CLASS
                                });
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        var directive = function (userService, $animate) { return new UserTest(userService, $animate); };
                        directive.$inject = ['ute.common.user.service', '$animate'];
                        return directive;
                    };
                    UserTest.NG_HIDE_CLASS = 'ng-hide';
                    UserTest.NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
                    return UserTest;
                }());
                /**
                 * <div ute-user-show-if-any-granted='role1,role2'> directive
                 */
                angular.module('ute.common.user').directive('uteUserShowIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.scope = {
                            roles: '@'
                        };
                        this.linkFn = function (scope) {
                            scope.rolesArray = scope.roles ? scope.roles.split(',').map(function (s) { return s.trim(); }) : [];
                        };
                        this.controller = Controller;
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.$scope.rolesArray, _this.userService.getUserType());
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-any-granted roles='consumer,dealer'> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.restrict = 'AE';
                        this.controller = Controller;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService) {
                        this.userService = userService;
                        this.test = this.userService.isSigned;
                    }
                    Controller.$inject = ['ute.common.user.service'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-logged-in> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfLoggedIn', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.scope = {
                            roles: '@'
                        };
                        this.linkFn = function (scope) {
                            scope.rolesArray = scope.roles ? scope.roles.split(',').map(function (s) { return s.trim(); }) : [];
                        };
                        this.controller = Controller;
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.test = function () {
                            return _this.userService.isSigned() && !_.include(_this.$scope.rolesArray, _this.userService.getUserType());
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-not-granted roles='consumer,dealer'> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfNotGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.restrict = 'AE';
                        this.controller = Controller;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService) {
                        var _this = this;
                        this.userService = userService;
                        this.test = function () { return !_this.userService.isSigned(); };
                    }
                    Controller.$inject = ['ute.common.user.service'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-not-logged-in> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfNotLoggedIn', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserInfo = (function () {
                    function UserInfo() {
                        this.restrict = 'E';
                        this.controllerAs = 'user';
                        this.scope = {
                            field: '@'
                        };
                        this.template = '{{user.getUserInfo()}}';
                        this.controller = Controller;
                    }
                    UserInfo.factory = function () {
                        return function () { return new UserInfo(); };
                    };
                    return UserInfo;
                }());
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.getUserInfo = function () {
                            try {
                                return _.get(_this.userService.getUser(), _this.$scope.field) || _this.userService['get' + _this.capitalize(_this.$scope.field)]();
                            }
                            catch (e) {
                            }
                        };
                        /**
                         * TODO 1. move it to ute common utils
                         * TODO 2. migrate to lodash 4.x and use _.upperFirst
                         * @param s
                         * @returns {string}
                         */
                        this.capitalize = function (s) {
                            return s && s[0].toUpperCase() + s.slice(1);
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-logged-in-user-info field='userEmail'> directive
                 * <ute-user-logged-in-user-info field='userRole'> directive
                 */
                angular.module('ute.common.user').directive('uteUserLoggedInUserInfo', UserInfo.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserSignout = (function () {
                    function UserSignout() {
                        this.restrict = 'E';
                        this.controllerAs = 'user';
                        this.scope = {
                            field: '@'
                        };
                        this.transclude = true;
                        this.template = '<div data-ng-click="user.userSignout()"><ng-transclude></ng-transclude></div>';
                        this.controller = Controller;
                    }
                    UserSignout.factory = function () {
                        return function () { return new UserSignout(); };
                    };
                    return UserSignout;
                }());
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.userSignout = function () {
                            try {
                                return _this.userService.signout();
                            }
                            catch (e) {
                            }
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-signout> directive
                 */
                angular.module('ute.common.user').directive('uteUserSignout', UserSignout.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var assembler;
    (function (assembler) {
        var mediator;
        (function (mediator) {
            var constants;
            (function (constants) {
                'use strict';
                constants.UTE_ASSEMBLER_CONSTANTS = {
                    'XHR': {
                        'FETCH_SEARCH': Immutable.Map({
                            'url': '/web/totes/api/v1/assembler/search',
                            'method': 'GET'
                        }),
                        'FETCH_ARTICLE': Immutable.Map({
                            'url': '/web/totes/api/v1/assembler/articles',
                            'method': 'GET'
                        }),
                        'PAGINATION': Immutable.Map({
                            'url': '/web/totes/api/v1/assembler/targetedSearch',
                            'method': 'GET'
                        }),
                        'FILTERS': Immutable.Map({
                            'url': '/web/totes/api/v1/assembler/targetedSearch',
                            'method': 'GET'
                        }),
                        'LOB': Immutable.Map({
                            'url': '/web/totes/api/v1/assembler/lob',
                            'method': 'GET'
                        }),
                        'SUBMIT_ARTICLE_FEEDBACK': Immutable.Map({
                            'url': '/web/totes/api/v1/article/feedback',
                            'method': 'POST'
                        })
                    },
                    'STATES': {
                        'FETCH_PAGE_RESPONSE_SUCCESS': 'assemblerPageResponse',
                        'FETCH_PAGE_RESPONSE_FAIL': 'assemblerPageResponseError'
                    },
                    'ACTIONS': {
                        'FETCH_PAGE_RESPONSE_SUCCESS': 'assemblerPageResponseReceived',
                        'FETCH_PAGE_RESPONSE_FAIL': 'assemblerPageResponseFailed'
                    },
                    'ERRORS': {
                        'INVALID_ASSEMBLER_REQUEST': 'Assembler response not formatted correctly'
                    }
                };
                angular.module('ute.assembler.mediator.constants', [])
                    .constant('UTE_ASSEMBLER_CONSTANTS', constants.UTE_ASSEMBLER_CONSTANTS);
            })(constants = mediator.constants || (mediator.constants = {}));
        })(mediator = assembler.mediator || (assembler.mediator = {}));
    })(assembler = ute.assembler || (ute.assembler = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var assembler;
    (function (assembler) {
        var mediator;
        (function (mediator) {
            'use strict';
            ;
            ;
        })(mediator = assembler.mediator || (assembler.mediator = {}));
    })(assembler = ute.assembler || (ute.assembler = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var assembler;
    (function (assembler) {
        var mediator;
        (function (mediator) {
            'use strict';
            var AssemblerMediator = (function () {
                function AssemblerMediator($http, UTE_ASSEMBLER_CONSTANTS, $log) {
                    this.$http = $http;
                    this.UTE_ASSEMBLER_CONSTANTS = UTE_ASSEMBLER_CONSTANTS;
                    this.$log = $log;
                    this.parseResponseData = function (resp) {
                        return resp.data;
                    };
                }
                AssemblerMediator.prototype.fetchSearchPageLayout = function (data) {
                    return this.fetchAssemblerData(this.UTE_ASSEMBLER_CONSTANTS.XHR.FETCH_SEARCH, data);
                };
                AssemblerMediator.prototype.fetchSupportArticle = function (language, province, article, dimensions) {
                    var data = {
                        language: language, province: province, article: article, dimensions: dimensions
                    };
                    return this.fetchAssemblerData(this.UTE_ASSEMBLER_CONSTANTS.XHR.FETCH_ARTICLE, data)
                        .then(this.parseArticlePageLayout);
                };
                AssemblerMediator.prototype.submitArticleFeedback = function (language, province, lob, faqUrl, faqId, helpFoundStatus, feedbackComment) {
                    var data = {
                        language: language, province: province, lob: lob, faqUrl: faqUrl, faqId: faqId, helpFoundStatus: helpFoundStatus, feedbackComment: feedbackComment
                    };
                    return this.fetchAssemblerData(this.UTE_ASSEMBLER_CONSTANTS.XHR.SUBMIT_ARTICLE_FEEDBACK, data);
                };
                AssemblerMediator.prototype.getChildArticleProperties = function (article, childArticleId) {
                    var childArticles = [];
                    var childArticleProperties = null;
                    // filter all the group_selector
                    article.map(function (articleContent) {
                        if (articleContent.componentType === 'group_selector') {
                            childArticles = articleContent.componentValue.values;
                        }
                    });
                    // filter the child article
                    childArticles.map(function (childArticle) {
                        if (childArticle.dimensionValue === childArticleId) {
                            childArticleProperties = childArticle;
                        }
                    });
                    return childArticleProperties;
                };
                AssemblerMediator.prototype.fetchFilteredCalloutData = function (language, searchTerm, provinceDimension, cityDimension) {
                    var dimensions = "" + provinceDimension + (cityDimension ? ',' : '') + cityDimension;
                    var data = {
                        language: language, searchTerm: searchTerm, dimensions: dimensions
                    };
                    return this.fetchAssemblerData(this.UTE_ASSEMBLER_CONSTANTS.XHR.LOB, data)
                        .then(function (calloutData) {
                        // if the city was sent in the request, the cities array needs to be stripped out in the response
                        // endeca will return the cities array containing ONLY the filtered city in this scenario
                        return angular.extend({}, calloutData, {
                            regionNavigation: {
                                provinces: _.get(calloutData, 'regionNavigation.provinces', []),
                                cities: cityDimension ? undefined : _.get(calloutData, 'regionNavigation.cities', [])
                            }
                        });
                    });
                };
                AssemblerMediator.prototype.fetchFilteredSearchResult = function (language, province, searchTerm, dimensions) {
                    var data = {
                        language: language, province: province, searchTerm: searchTerm, dimensions: dimensions
                    };
                    return this.fetchAssemblerData(this.UTE_ASSEMBLER_CONSTANTS.XHR.FILTERS, data);
                };
                AssemblerMediator.prototype.fetchPaginatedSearchResult = function (language, province, searchTerm, offset, recordsPerPage, dimensions) {
                    var paginationRequestData = {
                        language: language,
                        province: province,
                        searchTerm: searchTerm,
                        offset: offset,
                        recordsPerPage: recordsPerPage,
                        dimensions: dimensions
                    };
                    return this.fetchAssemblerData(this.UTE_ASSEMBLER_CONSTANTS.XHR.PAGINATION, paginationRequestData);
                };
                /**
                 * Returns a dimension string (as required by Endeca) when given an
                 * array of filter objects
                 * @param  {Array} filtersArray                    Array of filters
                 * @return {string}                                Dimension string
                 */
                AssemblerMediator.prototype.getDimensionsString = function (filtersArray) {
                    return filtersArray ?
                        filtersArray
                            .filter(function (filter) { return filter.selected; })
                            .map(function (filter) { return filter.dimensionValue; })
                            .join(',')
                        : '';
                };
                AssemblerMediator.prototype.fetchAssemblerData = function (type, data) {
                    return this.$http(type
                        .set(type.get('method') === 'GET' ? 'params' : 'data', data)
                        .toJS())
                        .then(this.parseResponseData);
                };
                ;
                /**
                 * Parses the article page to a format that can be rendered by the front end
                 * @param  {any}    assemblerData [data returned by assembler back end]
                 * @return {[type]}               [parsed and properly formatted assemblerData]
                 */
                AssemblerMediator.prototype.parseArticlePageLayout = function (assemblerData) {
                    var dimensions = _.get(assemblerData, 'article.dimensions', {});
                    var contents = _.get(assemblerData, 'article.contents', [])
                        .map(function (articleContent) {
                        // if group selector, grab selector details from dimensions object
                        if (articleContent.componentType === 'group_selector') {
                            var childArticleName = articleContent.componentValue.content_type_selector;
                            return angular.extend({}, articleContent, {
                                componentValue: dimensions[childArticleName]
                            });
                        }
                        // otherwise, return the object as is
                        return articleContent;
                    });
                    // replace the contents array with the new, mapped contents array
                    return angular.extend({}, assemblerData, {
                        contents: contents
                    });
                };
                AssemblerMediator.$inject = [
                    '$http',
                    'UTE_ASSEMBLER_CONSTANTS',
                    '$log'
                ];
                return AssemblerMediator;
            }());
            angular.module('ute.assembler.mediator.services', [])
                .service('AssemblerMediator', AssemblerMediator);
        })(mediator = assembler.mediator || (assembler.mediator = {}));
    })(assembler = ute.assembler || (ute.assembler = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            var badge;
            (function (badge) {
                'use strict';
                var ChannelRecommendationBadgeController = (function () {
                    function ChannelRecommendationBadgeController() {
                    }
                    ChannelRecommendationBadgeController.controllerName = 'ute.common.channelRecommendation.badge.controller';
                    ChannelRecommendationBadgeController.$inject = ['$scope'];
                    return ChannelRecommendationBadgeController;
                }());
                badge.ChannelRecommendationBadgeController = ChannelRecommendationBadgeController;
                angular.module('ute.common.channelRecommendation.badge')
                    .controller(ChannelRecommendationBadgeController.controllerName, ChannelRecommendationBadgeController);
            })(badge = channelRecommendation.badge || (channelRecommendation.badge = {}));
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            var badge;
            (function (badge) {
                'use strict';
                var ChannelRecommendationBadge = (function () {
                    function ChannelRecommendationBadge() {
                        // DDO properties
                        this.templateUrl = 'module/uteChannelRecommendation/channelRecommendationBadge/channelRecommendationBadge.directive.view.html';
                        this.restrict = 'E';
                        this.controller = 'ute.common.channelRecommendation.badge.controller';
                        this.scope = {
                            label: '=',
                            numbers: '=',
                            imageUrl: '=',
                            detailsDescription: '=',
                            detailsImages: '=',
                            channelNumberDesktopLabel: '@',
                            channelNumberMobileLabel: '@',
                            enablePopup: '=',
                            showChannelDetails: '=',
                            hideChannelDetails: '='
                        };
                    }
                    ChannelRecommendationBadge.factory = function () {
                        var directive = function () { return new ChannelRecommendationBadge(); };
                        directive.$inject = [];
                        return directive;
                    };
                    return ChannelRecommendationBadge;
                }());
                angular.module('ute.common.channelRecommendation.badge')
                    .directive('uteChannelRecommendationBadge', ChannelRecommendationBadge.factory());
            })(badge = channelRecommendation.badge || (channelRecommendation.badge = {}));
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            var badge;
            (function (badge) {
                var popover;
                (function (popover) {
                    'use strict';
                    var ChannelRecommendationBadgePopoverController = (function () {
                        function ChannelRecommendationBadgePopoverController() {
                        }
                        ChannelRecommendationBadgePopoverController.controllerName = 'ute.common.channelRecommendation.badge.popover.controller';
                        ChannelRecommendationBadgePopoverController.$inject = ['$scope'];
                        return ChannelRecommendationBadgePopoverController;
                    }());
                    popover.ChannelRecommendationBadgePopoverController = ChannelRecommendationBadgePopoverController;
                    angular.module('ute.common.channelRecommendation.badge.popover')
                        .controller(ChannelRecommendationBadgePopoverController.controllerName, ChannelRecommendationBadgePopoverController);
                })(popover = badge.popover || (badge.popover = {}));
            })(badge = channelRecommendation.badge || (channelRecommendation.badge = {}));
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var channelRecommendation;
        (function (channelRecommendation) {
            var badge;
            (function (badge) {
                var popover;
                (function (popover) {
                    'use strict';
                    var ChannelDetailsPopover = (function () {
                        function ChannelDetailsPopover() {
                            // DDO properties
                            this.templateUrl = 'module/uteChannelRecommendation/channelRecommendationBadgePopover/channelRecommendationBadgePopover.directive.view.html';
                            this.restrict = 'E';
                            this.controller = 'ute.common.channelRecommendation.badge.popover.controller';
                            this.scope = {
                                detailsData: '=',
                                showPopover: '=',
                                hidePopover: '=',
                                positionTop: '=',
                                positionLeft: '='
                            };
                            this.link = function (scope, element, attrs) {
                                scope.$watch('showPopover', function (newValue, oldValue, scope) {
                                    if (scope.showPopover) {
                                        element.css('left', scope.positionLeft).css('top', scope.positionTop);
                                    }
                                });
                            };
                        }
                        ChannelDetailsPopover.factory = function () {
                            var directive = function () { return new ChannelDetailsPopover(); };
                            directive.$inject = [];
                            return directive;
                        };
                        return ChannelDetailsPopover;
                    }());
                    angular.module('ute.common.channelRecommendation.badge.popover')
                        .directive('uteChannelDetailsPopover', ChannelDetailsPopover.factory());
                })(popover = badge.popover || (badge.popover = {}));
            })(badge = channelRecommendation.badge || (channelRecommendation.badge = {}));
        })(channelRecommendation = common.channelRecommendation || (common.channelRecommendation = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                // TODO provider
                var BrtSwitchService = (function () {
                    /* @ngInject */
                    function BrtSwitchService($http, $timeout, exceptionHandler) {
                        var _this = this;
                        this.$http = $http;
                        this.$timeout = $timeout;
                        this.exceptionHandler = exceptionHandler;
                        /**
                         * @param key
                         * @returns {IPromise<boolean>}
                         */
                        this.getValue = function (key) {
                            return _this.getBrtSwitches().then(function (val) {
                                return _.get(_.find(val, { 'id': _.isNumber(key) ? brtswitch.BrtSwitches[key] : key }), 'switchIsOn');
                            });
                        };
                        /**
                         * @param keys
                         * @returns {IPromise<boolean>}
                         */
                        this.isSome = function (keys) {
                            return _this.getBrtSwitches().then(function (vals) {
                                return _.isEmpty(keys) ? false : _.intersection(_.chain(vals)
                                    .filter({ switchIsOn: true })
                                    .map(function (e) { return e.id; })
                                    .value(), _this.getKeys(keys)).length > 0;
                            });
                        };
                        /**
                         * @param keys
                         */
                        this.getKeys = function (keys) {
                            return _.isEmpty(keys) ? [] : _.isNumber(keys[0]) ? keys.map(function (key) { return brtswitch.BrtSwitches[key]; }) : keys;
                        };
                        /**
                         * @returns {IPromise<IBrtSwitches>}
                         * @private
                         */
                        this._getBrtSwitches = function () {
                            return _this.$http.post('/web/totes/api/v1/brtSwitches', {})
                                .then(_this.processBrtSwitchesResponse)
                                .catch(_.curry(_this.fail)('processBrtSwitchesResponse failed.'));
                        };
                        /**
                         * @param response
                         * @returns {IBrtSwitches}
                         */
                        this.processBrtSwitchesResponse = function (response) {
                            // console.log(BrtSwitchService.serviceName + '->processBrtSwitchesResponse', response.data);
                            return _.get(response, 'data', []);
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {IBrtSwitches}
                         */
                        this.fail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            _this.exceptionHandler.catcher(msg)(reason, 'ute.common.core.brtswitch fail');
                            _this.$timeout(_this.cleanCache);
                            return [];
                        };
                        this.cleanCache = function () {
                            _this.getBrtSwitches.cache.clear();
                        };
                        (_.memoize).Cache = window.Map; // required https://www.npmjs.com/package/es6-shim
                        this.getBrtSwitches = _.memoize(this._getBrtSwitches);
                    }
                    BrtSwitchService.$inject = [
                        '$http',
                        '$timeout',
                        'ute.blocks.exceptionService'
                    ];
                    BrtSwitchService.serviceName = 'ute.common.core.brtswitch.service';
                    return BrtSwitchService;
                }());
                angular.module('ute.common.core.brtswitch').service(BrtSwitchService.serviceName, BrtSwitchService);
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            ;
            searchSection.SearchActionTypes = {
                CLICK_SEARCH_RESULT: 'CLICK_SEARCH_RESULT',
                FETCH_FILTERED_CHANNEL_RECOMMENDATIONS: 'FETCH_FILTERED_CHANNEL_RECOMMENDATIONS',
                FETCH_FILTERED_SEARCH_RESULTS: 'FETCH_FILTERED_SEARCH_RESULTS',
                FETCH_PAGINATED_SEARCH_RESULTS: 'FETCH_PAGINATED_SEARCH_RESULTS',
                FETCH_SEARCH_RESULTS: 'FETCH_SEARCH_RESULTS',
                GOTO_URL: 'GOTO_URL',
                GOTO_SREF: 'GOTO_SREF',
                SET_FILTERED_CHANNEL_RECOMMENDATIONS: 'SET_FILTERED_CHANNEL_RECOMMENDATIONS',
                SET_FILTERED_SEARCH_RESULTS: 'SET_FILTERED_SEARCH_RESULTS',
                SET_LANGUAGE: 'SET_LANGUAGE',
                SET_PAGINATED_SEARCH_RESULTS: 'SET_PAGINATED_SEARCH_RESULTS',
                SET_PROVINCE: 'SET_PROVINCE',
                SET_SEARCH_DIMENSIONS: 'SET_SEARCH_DIMENSIONS',
                SET_SEARCH_RESULTS: 'SET_SEARCH_RESULTS',
                UPDATE_SEARCH_LANGUAGE: 'UPDATE_SEARCH_LANGUAGE',
                SET_FETCH_EXCEPTION: 'SET_FETCH_EXCEPTION'
            };
            function SearchActionsFactory($state, $window, SearchActionTypes, AssemblerMediator) {
                function goToUrl(url) {
                    var type = SearchActionTypes.GOTO_URL;
                    $window.location.assign(url);
                    return { type: type, url: url };
                }
                function goToSref(sref) {
                    return function (dispatch, getState) {
                        var type = SearchActionTypes.GOTO_SREF;
                        $state.go('support.article', {
                            articleId: sref
                        })
                            .then(function () {
                            return dispatch({ type: type, sref: sref });
                        });
                    };
                }
                function clickSearchResult(index, title, sref, recordClass) {
                    return function (dispatch, getState) {
                        var type = SearchActionTypes.CLICK_SEARCH_RESULT;
                        dispatch({ type: type, index: index, title: title, sref: sref, recordClass: recordClass });
                        if (recordClass === 'support') {
                            dispatch(goToSref(sref));
                        }
                        else {
                            dispatch(goToUrl(sref));
                        }
                    };
                }
                function fetchFilteredChannelRecommendations(selectedProvince, selectedCity, tabId) {
                    // selectedProvince is required
                    if (!selectedProvince) {
                        throw new Error('Cannot filter channel recommendations without selecting a province');
                    }
                    // ensure we're dealing with vanilla JS objects (and not immutable objects)
                    selectedProvince = selectedProvince.toJS ? selectedProvince.toJS() : selectedProvince;
                    selectedCity = selectedCity && selectedCity.toJS ? selectedCity.toJS() : selectedCity;
                    return function (dispatch, getState) {
                        var type = SearchActionTypes.FETCH_FILTERED_CHANNEL_RECOMMENDATIONS;
                        dispatch({ type: type, selectedProvince: selectedProvince, selectedCity: selectedCity, tabId: tabId });
                        var state = getState();
                        var language = state.getIn(['search', 'locale', 'language']);
                        var searchTerm = state.getIn(['search', 'searchTerm']);
                        var provinceDimension = selectedProvince.value;
                        var cityDimension = selectedCity ? selectedCity.value : '';
                        AssemblerMediator.fetchFilteredCalloutData(language, searchTerm, provinceDimension, cityDimension)
                            .then(function (assemblerData) {
                            return dispatch(setFilteredChannelRecommendations(assemblerData, selectedProvince, selectedCity, tabId));
                        })
                            .catch(function (err) {
                            return dispatch(setFetchException(err));
                        });
                    };
                }
                function fetchFilteredSearchResults(searchTerm, filters, isChecked) {
                    return function (dispatch, getState) {
                        var type = SearchActionTypes.FETCH_FILTERED_SEARCH_RESULTS;
                        var dimensions = AssemblerMediator.getDimensionsString(filters);
                        dispatch({ type: type, searchTerm: searchTerm, filters: filters, dimensions: dimensions });
                        var state = getState();
                        var language = state.getIn(['search', 'locale', 'language']);
                        var province = state.getIn(['search', 'locale', 'province']);
                        AssemblerMediator.fetchFilteredSearchResult(language, province, searchTerm, dimensions)
                            .then(function (assemblerData) {
                            return dispatch(setFilteredSearchResult(searchTerm, assemblerData, filters, isChecked));
                        })
                            .catch(function (err) {
                            return dispatch(setFetchException(err));
                        });
                    };
                }
                function fetchPaginatedSearchResults(pageNumber, offset, recordsPerPage) {
                    return function (dispatch, getState) {
                        var type = SearchActionTypes.FETCH_PAGINATED_SEARCH_RESULTS;
                        dispatch({ type: type, pageNumber: pageNumber, offset: offset, recordsPerPage: recordsPerPage });
                        var state = getState();
                        var searchTerm = state.getIn(['search', 'searchTerm']);
                        var dimensions = state.getIn(['search', 'dimensions']);
                        var language = state.getIn(['search', 'locale', 'language']);
                        var province = state.getIn(['search', 'locale', 'province']);
                        AssemblerMediator.fetchPaginatedSearchResult(language, province, searchTerm, offset, recordsPerPage, dimensions)
                            .then(function (assemblerData) {
                            return dispatch(setPaginatedSearchResult(searchTerm, assemblerData));
                        })
                            .catch(function (err) {
                            return dispatch(setFetchException(err));
                        });
                    };
                }
                function fetchSearchResults(searchTerm, dimensions) {
                    var type = SearchActionTypes.FETCH_SEARCH_RESULTS;
                    return { type: type, searchTerm: searchTerm };
                }
                function setFilteredChannelRecommendations(assemblerData, selectedProvince, selectedCity, tabId) {
                    var type = SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS;
                    // TODO: temp while parser isn't updated
                    return { type: type, selectedProvince: selectedProvince, selectedCity: selectedCity, assemblerData: assemblerData, tabId: tabId };
                }
                function setFilteredSearchResult(searchTerm, assemblerData, filters, isChecked) {
                    var type = SearchActionTypes.SET_FILTERED_SEARCH_RESULTS;
                    var dimensions = AssemblerMediator.getDimensionsString(filters);
                    return { type: type, searchTerm: searchTerm, assemblerData: assemblerData, filters: filters, dimensions: dimensions, isChecked: isChecked };
                }
                function setPaginatedSearchResult(searchTerm, assemblerData) {
                    var type = SearchActionTypes.SET_PAGINATED_SEARCH_RESULTS;
                    return { type: type, searchTerm: searchTerm, assemblerData: assemblerData };
                }
                function setFetchException(error) {
                    var type = SearchActionTypes.SET_FETCH_EXCEPTION;
                    return { type: type, status: error.status, statusText: error.statusText, error: error };
                }
                return {
                    clickSearchResult: clickSearchResult,
                    fetchFilteredChannelRecommendations: fetchFilteredChannelRecommendations,
                    fetchFilteredSearchResults: fetchFilteredSearchResults,
                    fetchPaginatedSearchResults: fetchPaginatedSearchResults,
                    fetchSearchResults: fetchSearchResults,
                    goToUrl: goToUrl,
                    goToSref: goToSref,
                    setFilteredChannelRecommendations: setFilteredChannelRecommendations,
                    setFilteredSearchResult: setFilteredSearchResult,
                    setPaginatedSearchResult: setPaginatedSearchResult,
                    setFetchException: setFetchException
                };
            }
            angular.module('ute.common.searchSection.actions', [])
                .constant('SearchActionTypes', searchSection.SearchActionTypes)
                .factory('SearchActions', [
                '$state',
                '$window',
                'SearchActionTypes',
                'AssemblerMediator',
                SearchActionsFactory
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchReducerProvider = (function () {
                function SearchReducerProvider(SearchActionTypes, SearchBreadcrumbsReducerProvider, SearchCalloutReducerProvider, SearchTvGuideReducerProvider, SearchChannelRecommendationReducerProvider, SearchDimensionsReducerProvider, SearchFiltersReducerProvider, SearchLocaleReducerProvider, SearchPaginationReducerProvider, SearchResultsReducerProvider, SearchTermReducerProvider, TabbedCardReducerProvider) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = {
                        breadcrumbs: [],
                        channelRecommendation: {},
                        dimensions: [],
                        pagination: {},
                        results: {
                            count: null,
                            list: []
                        },
                        searchTerm: '',
                        tabbedCards: {}
                    };
                    this.breadcrumbsReducer = SearchBreadcrumbsReducerProvider.$get();
                    this.calloutReducer = SearchCalloutReducerProvider.$get();
                    this.tvGuideReducer = SearchTvGuideReducerProvider.$get();
                    this.channelRecommendationReducer = SearchChannelRecommendationReducerProvider.$get();
                    this.dimensionsReducer = SearchDimensionsReducerProvider.$get();
                    this.filtersReducer = SearchFiltersReducerProvider.$get();
                    this.localeReducer = SearchLocaleReducerProvider.$get();
                    this.paginationReducer = SearchPaginationReducerProvider.$get();
                    this.resultsReducer = SearchResultsReducerProvider.$get();
                    this.searchTermReducer = SearchTermReducerProvider.$get();
                    this.tabbedCardsReducer = TabbedCardReducerProvider.$get();
                }
                SearchReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.FETCH_FILTERED_CHANNEL_RECOMMENDATIONS:
                            case _this.SearchActionTypes.FETCH_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                            case _this.SearchActionTypes.FETCH_FILTERED_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_FILTERED_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                            case _this.SearchActionTypes.SET_LANGUAGE:
                            case _this.SearchActionTypes.SET_PAGINATED_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_PROVINCE:
                                return state
                                    .withMutations(function (temporaryState) {
                                    return temporaryState
                                        .set('breadcrumbs', _this.breadcrumbsReducer(state.get('breadcrumbs'), action))
                                        .set('callout', _this.calloutReducer(state.get('callout'), action))
                                        .set('tabbedCards', _this.tabbedCardsReducer(state.get('tabbedCards'), action))
                                        .set('dimensions', _this.dimensionsReducer(state.get('dimensions'), action))
                                        .set('filters', _this.filtersReducer(state.get('filters'), action))
                                        .set('locale', _this.localeReducer(state.get('locale'), action))
                                        .set('pagination', _this.paginationReducer(state.get('pagination'), action))
                                        .set('results', _this.resultsReducer(state.get('results'), action))
                                        .set('searchTerm', _this.searchTermReducer(state.get('searchTerm'), action))
                                        .set('tvGuide', _this.tvGuideReducer(state.get('tvGuide'), action));
                                });
                            default:
                                return state;
                        }
                    };
                };
                return SearchReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer', [
                'ute.common.searchSection.actions',
                'ute.common.searchSection.reducer.tabbedCard',
                'ute.common.searchSection.reducer.breadcrumbs',
                'ute.common.searchSection.reducer.callout',
                'ute.common.searchSection.reducer.tvGuide',
                'ute.common.searchSection.reducer.channelRecommendation',
                'ute.common.searchSection.reducer.dimensions',
                'ute.common.searchSection.reducer.filters',
                'ute.common.searchSection.reducer.locale',
                'ute.common.searchSection.reducer.pagination',
                'ute.common.searchSection.reducer.results',
                'ute.common.searchSection.reducer.searchTerm'
            ])
                .provider('SearchReducer', [
                'SearchActionTypes',
                'SearchBreadcrumbsReducerProvider',
                'SearchCalloutReducerProvider',
                'SearchTvGuideReducerProvider',
                'SearchChannelRecommendationReducerProvider',
                'SearchDimensionsReducerProvider',
                'SearchFiltersReducerProvider',
                'SearchLocaleReducerProvider',
                'SearchPaginationReducerProvider',
                'SearchResultsReducerProvider',
                'SearchTermReducerProvider',
                'TabbedCardReducerProvider',
                SearchReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var ICON_MAPPINGS = {
                'community-forums': 'ute-icon-social-hub',
                'user-v2': 'ute-icon-user',
                'cart': 'ute-icon-cart',
                'question': 'ute-icon-question',
                'CommunityForums': 'ute-icon-social-hub',
                'MyRogers': 'ute-icon-user',
                'Shop': 'ute-icon-cart',
                'Support': 'ute-icon-question'
            };
            var SearchIconMapperProvider = (function () {
                function SearchIconMapperProvider() {
                }
                SearchIconMapperProvider.prototype.getIconForCategory = function (category) {
                    return ICON_MAPPINGS[category] || '';
                };
                SearchIconMapperProvider.prototype.$get = function () {
                    return {
                        getIconForCategory: this.getIconForCategory
                    };
                };
                return SearchIconMapperProvider;
            }());
            angular.module('ute.common.searchSection.services', [])
                .constant('ICON_MAPPINGS', ICON_MAPPINGS)
                .provider('SearchIconMapper', SearchIconMapperProvider);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportActionTypes = {
                FETCH_SUPPORT_ARTICLE: 'FETCH_SUPPORT_ARTICLE',
                SET_SUPPORT_ARTICLE: 'SET_SUPPORT_ARTICLE',
                FETCH_SUPPORT_CHILD_ARTICLE: 'FETCH_SUPPORT_CHILD_ARTICLE',
                SET_SUPPORT_CHILD_ARTICLE: 'SET_SUPPORT_CHILD_ARTICLE',
                SUBMIT_ARTICLE_FEEDBACK: 'SUBMIT_ARTICLE_FEEDBACK',
                ARTICLE_FEEDBACK_SUBMITTED: 'ARTICLE_FEEDBACK_SUBMITTED',
                CLEAR_ARTICLE_FEEDBACK: 'CLEAR_ARTICLE_FEEDBACK',
                SET_FETCH_EXCEPTION: 'SET_FETCH_EXCEPTION',
                SET_ROUTE_DETAILS: 'SET_ROUTE_DETAILS'
            };
            function SupportActionsFactory(SupportActionTypes, AssemblerMediator) {
                function fetchSupportChildArticle(childArticleProperties) {
                    return function (dispatch, getState) {
                        var type = SupportActionTypes.FETCH_SUPPORT_CHILD_ARTICLE;
                        dispatch({ type: type, childArticleProperties: childArticleProperties });
                        var dimensions = childArticleProperties.dimensionId;
                        var state = getState();
                        var language = state.getIn(['app', 'language']);
                        var province = state.getIn(['app', 'province']);
                        var seoUrl = state.getIn(['support', 'article', 'seoUrl']);
                        AssemblerMediator.fetchSupportArticle(language, province, seoUrl, dimensions)
                            .then(function (assemblerData) {
                            dispatch(setRouteData(state, childArticleProperties));
                            return dispatch(setSupportChildArticle(assemblerData));
                        })
                            .catch(function (err) {
                            return dispatch(setFetchException(err));
                        });
                    };
                }
                function setRouteData(state, childArticleProperties) {
                    var type = SupportActionTypes.SET_ROUTE_DETAILS;
                    var uiState = state.getIn(['app', 'router', 'uiState']);
                    var uiParams = state.getIn(['app', 'router', 'uiParams']);
                    uiParams = uiParams.setIn(['childArticleId'], childArticleProperties.dimensionValue);
                    return { type: type, uiState: uiState, uiParams: uiParams };
                }
                function setSupportChildArticle(assemblerData) {
                    var type = SupportActionTypes.SET_SUPPORT_CHILD_ARTICLE;
                    return { type: type, assemblerData: assemblerData };
                }
                function submitArticleFeedback(feedbackReceived, helpStatus) {
                    return function (dispatch, getState) {
                        //const type: string = SupportActionTypes.SUBMIT_ARTICLE_FEEDBACK;
                        var state = getState();
                        var language = state.getIn(['app', 'language']);
                        var province = state.getIn(['app', 'province']);
                        var faqId = state.getIn(['support', 'article', 'seoUrl']);
                        var lob = state.getIn(['support', 'article', 'lob']);
                        var feedbackComment = feedbackReceived;
                        var helpFoundStatus = helpStatus;
                        var faqUrl = window.location.href;
                        // skip cassandra submission for "yes" and "no" clicks with empty feedback.
                        if (!feedbackReceived) {
                            return dispatch(articleFeedbackSubmitted(helpFoundStatus));
                        }
                        // continues to submission - in case of SUBMIT is clicked (after 'no').
                        AssemblerMediator.submitArticleFeedback(language, province, lob, faqUrl, faqId, helpFoundStatus, feedbackComment)
                            .then(function (feedbackReceived) {
                            //return dispatch(articleFeedbackSubmitted(feedbackReceived));
                        })
                            .catch(function (err) {
                            return dispatch(setFetchException(err));
                        });
                    };
                }
                function articleFeedbackSubmitted(feedback) {
                    return function (dispatch, getState) {
                        var type = SupportActionTypes.ARTICLE_FEEDBACK_SUBMITTED;
                        dispatch({ type: type, feedback: feedback });
                        return dispatch(clearArticleFeedback(feedback));
                    };
                }
                function clearArticleFeedback(feedback) {
                    var type = SupportActionTypes.CLEAR_ARTICLE_FEEDBACK;
                    return { type: type, feedback: feedback };
                }
                function setFetchException(error) {
                    var type = SupportActionTypes.SET_FETCH_EXCEPTION;
                    return { type: type, status: error.status, statusText: error.statusText, error: error };
                }
                return {
                    fetchSupportChildArticle: fetchSupportChildArticle,
                    setSupportChildArticle: setSupportChildArticle,
                    submitArticleFeedback: submitArticleFeedback,
                    articleFeedbackSubmitted: articleFeedbackSubmitted,
                    clearArticleFeedback: clearArticleFeedback,
                    setFetchException: setFetchException
                };
            }
            angular.module('ute.common.supportSection.actions', [])
                .constant('SupportActionTypes', SupportActionTypes)
                .factory('SupportActions', [
                'SupportActionTypes',
                'AssemblerMediator',
                SupportActionsFactory
            ]);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportReducerProvider = (function () {
                function SupportReducerProvider(SupportActionTypes, SupportArticleFeedbackReducerProvider, SupportArticleBreadcrumbsReducerProvider, SupportArticleReducerProvider, SupportChildArticleReducerProvider) {
                    this.SupportActionTypes = SupportActionTypes;
                    this.articleReducer = SupportArticleReducerProvider.$get();
                    this.feedbackReducer = SupportArticleFeedbackReducerProvider.$get();
                    this.breadcrumbsReducer = SupportArticleBreadcrumbsReducerProvider.$get();
                    this.childArticleReducer = SupportChildArticleReducerProvider.$get();
                }
                SupportReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.Map({}); }
                        switch (action.type) {
                            case _this.SupportActionTypes.CLEAR_ARTICLE_FEEDBACK:
                            case _this.SupportActionTypes.SUBMIT_ARTICLE_FEEDBACK:
                                return state
                                    .set('feedbackReceived', _this.feedbackReducer(state.get('feedback'), action));
                            case _this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                                return state
                                    .set('childArticle', _this.childArticleReducer(state.get('childArticle'), action))
                                    .set('article', _this.articleReducer(state.get('article'), action))
                                    .set('breadcrumbs', _this.breadcrumbsReducer(state.get('breadcrumbs'), action));
                            case _this.SupportActionTypes.SET_SUPPORT_CHILD_ARTICLE:
                                return state
                                    .set('childArticle', _this.childArticleReducer(state.get('childArticle'), action));
                            default:
                                return state;
                        }
                    };
                };
                return SupportReducerProvider;
            }());
            angular.module('ute.common.supportSection.reducer', [
                'ute.common.supportSection.actions',
                'ute.common.supportSection.reducer.feedback',
                'ute.common.supportSection.reducer.breadcrumbs',
                'ute.common.supportSection.reducer.article',
                'ute.common.supportSection.reducer.childArticle',
            ])
                .provider('SupportReducer', [
                'SupportActionTypes',
                'SupportArticleFeedbackReducerProvider',
                'SupportArticleBreadcrumbsReducerProvider',
                'SupportArticleReducerProvider',
                'SupportChildArticleReducerProvider',
                SupportReducerProvider
            ]);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            angular.module('ute.common.supportSection.services', [
                'ute.common.supportSection.services.router'
            ]);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportSectionRouterService = (function () {
                function SupportSectionRouterService() {
                }
                SupportSectionRouterService.prototype.getSupportArticleDimensions = function (stateParam) {
                    var stateParamList = stateParam.split('/');
                    var routeDetails = {
                        navigation: stateParamList[0],
                        dimensions: stateParamList.slice(1)
                    };
                    return routeDetails;
                };
                SupportSectionRouterService.prototype.isSupportRoute = function (state) {
                    return state.is('support.article');
                };
                SupportSectionRouterService.serviceName = 'ute.common.supportSection.service.router';
                SupportSectionRouterService.$inject = ['$state', '$stateParams'];
                return SupportSectionRouterService;
            }());
            angular.module('ute.common.supportSection.services.router', [])
                .service(SupportSectionRouterService.serviceName, SupportSectionRouterService);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var locale;
            (function (locale) {
                'use strict';
                var LanguageSelectorDirective = (function () {
                    /* @ngInject */
                    function LanguageSelectorDirective(languageSelectorProviderService, userPreferencesService) {
                        var _this = this;
                        this.userPreferencesService = userPreferencesService;
                        /** Synchronize scope.language value */
                        // we're not changing any HTML templates for now, so need to provide exactly the same old template variables
                        this.syncLanguage = function ($scope) {
                            var lang = _this.userPreferencesService.language || _this.config.basic.defaultLanguage;
                            $scope.language = lang;
                            _this.syncLangAttribute(lang);
                        };
                        this.syncLangAttribute = function (selectedLanguage) {
                            var langContainer = angular.element($('[lang]')); // for example: <html lang="en">
                            langContainer.attr('lang', selectedLanguage);
                        };
                        //endregion
                        //region Public
                        this.restrict = 'E';
                        this.replace = false;
                        this.scope = true;
                        this.link = function ($scope, $element, $attrs) {
                            $scope.languages = {
                                en: 'English',
                                fr: 'Français'
                            };
                            _this.syncLanguage($scope);
                            /**
                             * @name changeLanguage
                             * @description toggles between two languages en/fr
                             */
                            $scope.changeLanguage = function () {
                                // this deletes the root level 'language' cookie:
                                _this.userPreferencesService.language = null;
                                var enId = LanguageSelectorDirective.supportedLanguages[0].id;
                                var frId = LanguageSelectorDirective.supportedLanguages[1].id;
                                ;
                                if (_this.userPreferencesService.language === enId) {
                                    _this.userPreferencesService.language = frId;
                                }
                                else {
                                    _this.userPreferencesService.language = enId;
                                }
                                _this.syncLanguage($scope);
                            };
                        };
                        this.config = languageSelectorProviderService.getConfig();
                        this.templateUrl = this.config.basic.templateUrl;
                    }
                    LanguageSelectorDirective.factory = function () {
                        var directive = function (languageSelectorProviderService, userPreferencesService) {
                            return new LanguageSelectorDirective(languageSelectorProviderService, userPreferencesService);
                        };
                        directive.$inject = LanguageSelectorDirective.$inject;
                        return directive;
                    };
                    //region Static & Constructor
                    LanguageSelectorDirective.$inject = ['ute.common.core.locale.languageSelector.provider', 'ute.common.core.userPreferences.service'];
                    LanguageSelectorDirective.supportedLanguages = [
                        {
                            id: 'en',
                            name: 'English'
                        },
                        {
                            id: 'fr',
                            name: 'Français'
                        }
                    ];
                    return LanguageSelectorDirective;
                }());
                angular.module('ute.common.core.locale').directive('uteLanguageSelector', LanguageSelectorDirective.factory());
            })(locale = core.locale || (core.locale = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var locale;
            (function (locale) {
                'use strict';
            })(locale = core.locale || (core.locale = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var locale;
            (function (locale) {
                'use strict';
                var LanguageSelectorProvider = (function () {
                    //static $inject: Array<string> = [];
                    /* @ngInject */
                    function LanguageSelectorProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                templateUrl: 'module/locale/languageSelector/languageSelector.view.html',
                                defaultLanguage: 'en'
                            }
                        };
                        /* @ngInject */
                        this.$get = function () {
                            return {
                                getConfig: _this.getConfig
                            };
                        };
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        //this.$get.$inject = [];
                    }
                    return LanguageSelectorProvider;
                }());
                angular.module('ute.common.core.locale').provider('ute.common.core.locale.languageSelector.provider', LanguageSelectorProvider);
            })(locale = core.locale || (core.locale = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var locale;
            (function (locale) {
                'use strict';
                var ProvinceSelectorController = (function () {
                    /* @ngInject */
                    function ProvinceSelectorController(userPreferencesService) {
                        var _this = this;
                        this.userPreferencesService = userPreferencesService;
                        this.saveProvince = function (selectedProvince) {
                            // if province is null, undefined, or is the same as current province, don not proceed with the change
                            if (!selectedProvince) {
                                return false;
                            }
                            var newProvince = selectedProvince.toUpperCase();
                            if (_this.userPreferencesService.province && newProvince === _this.userPreferencesService.province.toUpperCase()) {
                                return false;
                            }
                            _this.userPreferencesService.province = newProvince;
                            _this.selectedProvince = newProvince;
                            return true;
                        };
                        this.selectedProvince = userPreferencesService.province.toLowerCase();
                        this.provinces = userPreferencesService.allProvinces;
                    }
                    ProvinceSelectorController.$inject = ['ute.common.core.userPreferences.service'];
                    return ProvinceSelectorController;
                }());
                var ProvinceSelectorDirective = (function () {
                    /* @ngInject */
                    function ProvinceSelectorDirective(provinceSelectorProviderService, userPreferencesService) {
                        //endregion
                        //region Public
                        this.restrict = 'E';
                        this.replace = false;
                        this.controllerAs = 'vm';
                        this.scope = true;
                        this.link = function ($scope, $element, $attrs) {
                            /**
                             * @description prevent action from the anchors in the dom
                             */
                            $($element).on('click', function (e) {
                                e.preventDefault();
                            });
                        };
                        this.config = provinceSelectorProviderService.getConfig();
                        this.templateUrl = this.config.basic.templateUrl;
                        this.controller = ProvinceSelectorController;
                        userPreferencesService.defaultProvince = this.config.basic.defaultProvince;
                        if (!userPreferencesService.province && userPreferencesService.defaultProvince) {
                            userPreferencesService.province = userPreferencesService.defaultProvince;
                        }
                    }
                    ProvinceSelectorDirective.factory = function () {
                        var directive = function (provinceSelectorProviderService, userPreferencesService) {
                            return new ProvinceSelectorDirective(provinceSelectorProviderService, userPreferencesService);
                        };
                        directive.$inject = ProvinceSelectorDirective.$inject;
                        return directive;
                    };
                    //region Static & Constructor
                    ProvinceSelectorDirective.$inject = ['ute.common.core.locale.provinceSelector.provider', 'ute.common.core.userPreferences.service'];
                    return ProvinceSelectorDirective;
                }());
                angular.module('ute.common.core.locale').directive('uteProvinceSelector', ProvinceSelectorDirective.factory());
            })(locale = core.locale || (core.locale = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var locale;
            (function (locale) {
                'use strict';
            })(locale = core.locale || (core.locale = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var locale;
            (function (locale) {
                'use strict';
                var ProvinceSelectorProvider = (function () {
                    /* @ngInject */
                    function ProvinceSelectorProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                templateUrl: 'module/locale/provinceSelector/provinceSelector.view.html',
                                provinceSelectorModalTemplateUrl: 'module/locale/provinceSelectorModal.view.html',
                                defaultProvince: 'ON'
                            },
                            meta: {}
                        };
                        /* @ngInject */
                        this.$get = function () {
                            return {
                                getConfig: _this.getConfig,
                                getProvinceMeta: _this.getProvinceMeta
                            };
                        };
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            if (!_this.config.meta) {
                                _this.config.meta = ProvinceSelectorProvider.provincesMeta;
                            }
                            return true;
                        };
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        this.getProvinceMeta = function (prov) {
                            return _this.config.meta[prov];
                        };
                        //this.$get.$inject = [];
                    }
                    //static $inject: Array<string> = [];
                    ProvinceSelectorProvider.provincesMeta = {
                        'ab': {
                            'services': ['support', 'rewards'],
                            'ageOfMajority': 18,
                            'driversLicense': '(\\d{6}\\-\\d{3})',
                            'language': 'en'
                        },
                        'bc': {
                            'services': ['support', 'rewards'],
                            'driversLicense': '(\\d{7})',
                            'ageOfMajority': 19,
                            'language': 'en'
                        },
                        'mb': {
                            'services': ['support', 'rewards'],
                            'ageOfMajority': 18,
                            'driversLicense': '([a-zA-Z]{2}\\-[a-zA-Z]{2}\\-[a-zA-Z]{2}\\-[a-zA-Z]{1}\\d{3}[a-zA-Z]{2})',
                            'language': 'en'
                        },
                        'nb': {
                            'services': ['support', 'rewards'],
                            'ageOfMajority': 18,
                            'driversLicense': '(\\d{7})',
                            'language': 'en'
                        },
                        'nl': {
                            'services': ['support', 'rewards'],
                            'driversLicense': '([a-zA-Z]{1}\\d{9})',
                            'ageOfMajority': 19,
                            'language': 'en'
                        },
                        'ns': {
                            'services': ['support', 'rewards'],
                            'driversLicense': '([a-zA-Z]{5}\\d{9})',
                            'ageOfMajority': 19,
                            'language': 'en'
                        },
                        'on': {
                            'services': ['internet', 'support', 'rewards'],
                            'ageOfMajority': 18,
                            'driversLicense': '([a-zA-Z]{1}\\d{4}\\-\\d{5}\\-\\d{5})',
                            'language': 'en'
                        },
                        'pe': {
                            'services': ['support', 'rewards'],
                            'ageOfMajority': 18,
                            'driversLicense': '(\\d{1,6})',
                            'language': 'en'
                        },
                        'qc': {
                            'services': ['support', 'rewards'],
                            'ageOfMajority': 18,
                            'driversLicense': '([a-zA-Z]{1}\\d{4}\\-\\d{6}\\-\\d{2})',
                            'language': 'fr'
                        },
                        'sk': {
                            'services': ['support', 'rewards'],
                            'ageOfMajority': 18,
                            'driversLicense': '(\\d{8})',
                            'language': 'en'
                        }
                    };
                    return ProvinceSelectorProvider;
                }());
                angular.module('ute.common.core.locale').provider('ute.common.core.locale.provinceSelector.provider', ProvinceSelectorProvider);
            })(locale = core.locale || (core.locale = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var environment;
        (function (environment) {
            'use strict';
            (function (EnvironmentType) {
                EnvironmentType[EnvironmentType["PROD"] = 0] = "PROD";
                EnvironmentType[EnvironmentType["QA"] = 1] = "QA";
                EnvironmentType[EnvironmentType["SIT"] = 2] = "SIT";
                EnvironmentType[EnvironmentType["DEV"] = 3] = "DEV";
                EnvironmentType[EnvironmentType["LOCAL"] = 4] = "LOCAL";
            })(environment.EnvironmentType || (environment.EnvironmentType = {}));
            var EnvironmentType = environment.EnvironmentType;
            var EnvironmentStatic = (function () {
                function EnvironmentStatic() {
                }
                /**
                 *
                 * @returns {ute.blocks.environment.EnvironmentType}
                 */
                EnvironmentStatic.getEnvType = function () {
                    if (location.hostname.indexOf('www.rogers.com') === 0) {
                        return ute.blocks.environment.EnvironmentType.PROD;
                    }
                    else if (location.hostname.indexOf('www.dev') === 0) {
                        return ute.blocks.environment.EnvironmentType.DEV;
                    }
                    else if (location.hostname.indexOf('www.qa') === 0) {
                        return ute.blocks.environment.EnvironmentType.QA;
                    }
                    else {
                        return ute.blocks.environment.EnvironmentType.LOCAL;
                    }
                };
                /**
                 * @returns {string}
                 */
                EnvironmentStatic.getEnvConfigPath = function () {
                    return 'environments/' + EnvironmentType[EnvironmentStatic.getEnvType()].toLowerCase() + '.js';
                };
                /**
                 *
                 * @param success
                 * @returns {JQueryXHR}
                 */
                EnvironmentStatic.getEnvConfig = function (success) {
                    return $.getScript(EnvironmentStatic.getEnvConfigPath(), success);
                };
                return EnvironmentStatic;
            }());
            environment.EnvironmentStatic = EnvironmentStatic;
            var EnvironmentHelperProvider = (function () {
                /* @ngInject */
                function EnvironmentHelperProvider(CONFIG) {
                    var _this = this;
                    this.config = {
                        url: '/environment.json'
                    };
                    /* @ngInject */
                    this.$get = function () {
                        return {
                            getProperty: _this.getProperty
                        };
                    };
                    this.configure = function (config) {
                        angular.extend(_this.config, config);
                        return true;
                    };
                    this.configureByHostName = function () {
                        _this.config.url = _this.buildEnvUrl(location.hostname);
                    };
                    this.configureByEnvType = function (envDetector) {
                        _this.config.url = _this.buildEnvUrl(EnvironmentType[envDetector ? envDetector.getEnvType() : EnvironmentStatic.getEnvType()].toLowerCase());
                    };
                    this.getProperty = function (name) {
                        return _.get(_this.envJson, name, name);
                    };
                    this.buildEnvUrl = function (name) { return '/environments/' + name + '.json'; };
                    this.$get.$inject = [];
                    this.envJson = CONFIG;
                }
                EnvironmentHelperProvider.$inject = ['CONFIG'];
                return EnvironmentHelperProvider;
            }());
            angular.module('ute.blocks.environment').provider('ute.blocks.environment', EnvironmentHelperProvider);
        })(environment = blocks.environment || (blocks.environment = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

// Include in index.html so that app level exceptions are handled.
// Exclude from testRunner.html which should run exactly what it wants to run
var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception_1) {
            'use strict';
            var ExceptionHandlerProvider = (function () {
                /* @ngInject */
                function ExceptionHandlerProvider() {
                    var _this = this;
                    this.config = {
                        appErrorPrefix: undefined
                    };
                    /* @ngInject */
                    this.$get = function () {
                        return { config: _this.config };
                    };
                    this.$get.$inject = [];
                }
                ExceptionHandlerProvider.prototype.configure = function (appErrorPrefix) {
                    this.config.appErrorPrefix = appErrorPrefix;
                };
                ExceptionHandlerProvider.$inject = [];
                return ExceptionHandlerProvider;
            }());
            config.$inject = ['$provide'];
            /* @ngInject */
            function config($provide) {
                $provide.decorator('$exceptionHandler', extendExceptionHandler);
            }
            extendExceptionHandler.$inject = ['$delegate', 'exceptionHandler', 'ute.blocks.loggerService'];
            /**
             * Extend the $exceptionHandler service to also display a toast.
             * @param  {Object} $delegate
             * @param  {Object} exceptionHandler
             * @param  {Object} logger
             * @return {Function} the decorated $exceptionHandler service
             */
            /* @ngInject */
            function extendExceptionHandler($delegate, exceptionHandler, logger) {
                return function (exception, cause) {
                    //            var appErrorPrefix = '[Error] ';
                    var appErrorPrefix = exceptionHandler.config.appErrorPrefix || '';
                    var errorData = { exception: exception, cause: cause };
                    exception.message = appErrorPrefix + exception.message;
                    $delegate(exception, cause);
                    /**
                     * Could add the error to a service's collection,
                     * add errors to $rootScope, log errors to remote web server,
                     * or log locally. Or throw hard. It is entirely up to you.
                     * throw exception;
                     * @example
                     *     throw { message: 'error message we added' };
                     */
                    logger.error(exception.message, errorData);
                };
            }
            angular.module('ute.blocks.exception').provider('exceptionHandler', ExceptionHandlerProvider).config(config);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception) {
            'use strict';
            var Exception = (function () {
                /* @ngInject */
                function Exception(logger) {
                    var _this = this;
                    this.logger = logger;
                    this.catcher = function (message) { return function (reason, title) { return _this.logger.error(message, reason, title); }; };
                }
                Exception.$inject = ['ute.blocks.loggerService'];
                return Exception;
            }());
            angular.module('ute.blocks.exception').service('ute.blocks.exceptionService', Exception);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var logger;
        (function (logger) {
            'use strict';
            var Logger = (function () {
                /* @ngInject */
                function Logger($log /*, private toastr: Toastr*/) {
                    this.$log = $log;
                }
                // straight to console; bypass toastr
                Logger.prototype.log = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i - 0] = arguments[_i];
                    }
                    this.$log.log(args);
                };
                Logger.prototype.error = function (message, data, title) {
                    //this.toastr.error(message, title);
                    this.$log.error('Error: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.info = function (message, data, title) {
                    //this.toastr.info(message, title);
                    this.$log.info('Info: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.success = function (message, data, title) {
                    //this.toastr.success(message, title);
                    this.$log.info('Success: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.warning = function (message, data, title) {
                    //this.toastr.warning(message, title);
                    this.$log.warn('Warning: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.$inject = ['$log' /*, 'toastr'*/];
                return Logger;
            }());
            angular.module('ute.blocks.logger').service('ute.blocks.loggerService', Logger);
        })(logger = blocks.logger || (blocks.logger = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var DataService = (function () {
                /* @ngInject */
                function DataService($q, exception, logger) {
                    var _this = this;
                    this.$q = $q;
                    this.exception = exception;
                    this.logger = logger;
                    this.ready = function (promises) {
                        return _this.readyForAny(promises);
                    };
                    this.readyForAny = function (promises) {
                        return _this.getReady().then(function () {
                            return promises ? _this.$q.all(promises) : _this.readyPromise;
                        }).catch(_this.exception.catcher('"ready" function failed'));
                    };
                    this.getReady = function () {
                        if (!_this.readyPromise) {
                            // Apps often pre-fetch session data ("prime the app")
                            // before showing the first view.
                            // This app doesn't need priming but we add a
                            // no-op implementation to show how it would work.
                            _this.logger.info('Primed the app data');
                            _this.readyPromise = _this.$q.when(_this);
                        }
                        return _this.readyPromise;
                    };
                }
                DataService.$inject = ['$q', 'ute.blocks.exceptionService', 'ute.blocks.loggerService'];
                return DataService;
            }());
            angular.module('ute.blocks.router').service('ute.blocks.router.dataservice', DataService);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var RouterHelperProvider = (function () {
                /* @ngInject */
                function RouterHelperProvider($stateProvider, $urlRouterProvider) {
                    var _this = this;
                    this.$stateProvider = $stateProvider;
                    this.$urlRouterProvider = $urlRouterProvider;
                    this.config = {
                        docTitle: undefined
                    };
                    this.hasOtherwise = false;
                    this.handlingStateChangeError = false;
                    this.stateCounts = { errors: 0, changes: 0 };
                    this.resolveAlways = [];
                    this.globalTransitionHandlers = { from: [], to: [] };
                    /* @ngInject */
                    this.$get = function ($location, $rootScope, $state, $injector, $translate) {
                        _this.$location = $location;
                        _this.$rootScope = $rootScope;
                        _this.$translate = $translate;
                        _this.$state = $state;
                        _this.logger = $injector.get('ute.blocks.loggerService');
                        _this.handleRoutingErrors();
                        _this.handleStateChanges();
                        _this.handleLangChanges();
                        _this.handleStateChangeStart();
                        return {
                            configureStates: _this.configureStates.bind(_this),
                            registerFromStateHandler: _this.registerFromStateHandler.bind(_this),
                            registerToStateHandler: _this.registerToStateHandler.bind(_this),
                            registerGlobalFromStateHandler: _this.registerGlobalFromStateHandler.bind(_this),
                            registerGlobalToStateHandler: _this.registerGlobalToStateHandler.bind(_this),
                            getCountFromStateHandlers: _this.getCountFromStateHandlers.bind(_this),
                            getCountToStateHandlers: _this.getCountToStateHandlers.bind(_this),
                            when: _this.when.bind(_this),
                            getState: function (state) { return _this.$state.get(state); },
                            getCurrentState: function () { return _this.currentState; },
                            getStates: function () { return _this.$state.get(); }
                        };
                    };
                    this.when = function (whenPath, toPath) {
                        return _this.$urlRouterProvider.when(whenPath, toPath);
                    };
                    this.configure = function (config) {
                        angular.extend(_this.config, config);
                        if (!_this.config.resolveAlways) {
                            // TODO this is not working
                            _this.config.resolveAlways = {
                                /* @ngInject */
                                ready: ['ute.blocks.router.dataservice', function (dataservice) {
                                        var tmp = {};
                                        this.resolveAlways.forEach(function (e) {
                                            tmp = _.merge(tmp, e());
                                        });
                                        return dataservice.ready(tmp);
                                    }]
                            };
                        }
                        return true;
                    };
                    this.addToResolveAlways = function (resolveCallback) {
                        _this.resolveAlways.push(resolveCallback);
                    };
                    //$locationProvider.html5Mode(true);
                    this.configureStates = function (states, otherwisePath) {
                        states.forEach(function (state) {
                            if (!state.abstract) {
                                state.resolve = angular.extend(state.resolve || {}, _this.config.resolveAlways || {});
                                // TODO define 'ready' in constants
                                _.forEach(state.resolve, function (val, key) {
                                    if (key !== 'ready' && angular.isObject(_this.config.resolveAlways) && _.isArray(val)) {
                                        val.splice(val.length - 1, 0, 'ready');
                                    }
                                });
                            }
                            _this.$stateProvider.state(state);
                        });
                        if (otherwisePath && !_this.hasOtherwise) {
                            _this.hasOtherwise = true;
                            _this.$urlRouterProvider.otherwise(otherwisePath);
                        }
                    };
                    this.registerStateHandler = function (fromTo, stateName, si) {
                        var state = _this.$state.get(stateName);
                        if (state) {
                            state.data = (state.data || {});
                            var transitionHandlers = state.data.$transitionHandlers = (state.data.$transitionHandlers || {
                                from: [],
                                to: []
                            });
                            transitionHandlers[fromTo].push(si);
                            // TODO upgrade to lodash 4.x
                            // state.data.$transitionHandlers[fromTo] = _.orderBy/*<IStateHandler>*/(transitionHandlers[fromTo], ['priority'], ['desc']);
                            state.data.$transitionHandlers[fromTo] = _.sortBy(transitionHandlers[fromTo], 'priority').reverse();
                        }
                        else {
                            _this.logger.info('not able to find state "' + stateName + '"');
                        }
                        //this.logger.info('state "' + stateName + '" has ' + transitionHandlers[fromTo].length + ' "' + fromTo + '" transition handlers');
                    };
                    this.registerGlobalStateHandler = function (fromTo, stateHandler) {
                        _this.globalTransitionHandlers[fromTo].push(stateHandler);
                        // this.globalTransitionHandlers[fromTo] = _.chain<IStateHandler>(this.globalTransitionHandlers[fromTo]).sortBy(['priority']).value().reverse();
                        _this.globalTransitionHandlers[fromTo] = _.sortBy(_this.globalTransitionHandlers[fromTo], 'priority').reverse();
                        //this.logger.info('global has ' + this.globalTransitionHandlers[fromTo].length + ' "' + fromTo + '" transition handlers');
                    };
                    this.registerFromStateHandler = function (stateName, stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerStateHandler('from', stateName, stateHandler);
                        }
                    };
                    this.registerToStateHandler = function (stateName, stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerStateHandler('to', stateName, stateHandler);
                        }
                    };
                    this.registerGlobalFromStateHandler = function (stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerGlobalStateHandler('from', stateHandler);
                        }
                    };
                    this.registerGlobalToStateHandler = function (stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerGlobalStateHandler('to', stateHandler);
                        }
                    };
                    this.getCountFromStateHandlers = function (stateName) {
                        var state = _this.$state.get(stateName);
                        return state ? state.data.$transitionHandlers.from.length : 0;
                    };
                    this.getCountToStateHandlers = function (stateName) {
                        var state = _this.$state.get(stateName);
                        return state ? state.data.$transitionHandlers.to.length : 0;
                    };
                    this.handleRoutingErrors = function () {
                        //TODO: must inject $state so we can kick off routing
                        // Route cancellation:
                        // On routing error, go to the dashboard.
                        // Provide an exit clause if it tries to do it twice.
                        _this.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                            if (_this.handlingStateChangeError) {
                                return;
                            }
                            _this.stateCounts.errors++;
                            _this.handlingStateChangeError = true;
                            var destination = (toState &&
                                (toState.name || toState.loadedTemplateUrl)) ||
                                'unknown target';
                            var msg = 'Error routing to ' + destination + '. ' +
                                (_.get(error, 'data') || '') + '. <br/>' + (error.statusText || '') +
                                ': ' + (error.status || '');
                            _this.logger.warning(msg, toState);
                            // TODO from settings
                            //this.$location.path('/');
                        });
                    };
                    this.handleStateChangeStart = function () {
                        _this.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                            // var promise = funcs[0](input);
                            // for (var i = 1; i < funcs.length; i++)
                            //   promise = promise.then(funcs[i]);
                            // funcs.reduce(function(prev, cur) {
                            //   return prev.then(cur);
                            // }, starting_promise);
                            (_this.globalTransitionHandlers.from).every(function (handler) {
                                try {
                                    return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                }
                                catch (e) {
                                    _this.logger.error('Exception catch during call stateTransitionHandler on globalTransitionHandlers.from:', e.message);
                                    return true;
                                }
                            });
                            (_this.globalTransitionHandlers.to).every(function (handler) {
                                try {
                                    return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                }
                                catch (e) {
                                    _this.logger.error('Exception catch during call stateTransitionHandler on globalTransitionHandlers.to:', e.message);
                                    return true;
                                }
                            });
                            if (_.get(fromState, 'data.$transitionHandlers.from')) {
                                (fromState.data.$transitionHandlers.from).every(function (handler) {
                                    try {
                                        return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                    }
                                    catch (e) {
                                        _this.logger.error('Exception catch during call stateTransitionHandler on $transitionHandlers.from:', e.message);
                                        return true;
                                    }
                                });
                            }
                            if (_.get(toState, 'data.$transitionHandlers.to')) {
                                (toState.data.$transitionHandlers.to).every(function (handler) {
                                    try {
                                        return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                    }
                                    catch (e) {
                                        _this.logger.error('Exception catch during call stateTransitionHandler on $transitionHandlers.to:', e.message);
                                        return true;
                                    }
                                });
                            }
                        });
                    };
                    this.handleStateChanges = function () {
                        _this.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                            _this.stateCounts.changes++;
                            _this.handlingStateChangeError = false;
                            _this.currentState = toState;
                            if (toState.data && toState.data.title) {
                                _this.$rootScope.title = _this.config.docTitle + ' ' + (_this.$translate.instant(toState.data.title) || '');
                            } // data bind to <title>
                        });
                    };
                    this.handleLangChanges = function () {
                        _this.$rootScope.$on('$translateChangeSuccess', function () {
                            _this.$rootScope.title = _this.config.docTitle + ' ' + (_this.$translate.instant((_.get(_this.$state, 'current.data.title'))) || ''); // data bind to <title>
                        });
                    };
                    this.$get.$inject = [
                        '$location',
                        '$rootScope',
                        '$state',
                        '$injector',
                        '$translate'
                    ];
                }
                RouterHelperProvider.$inject = ['$stateProvider', '$urlRouterProvider'];
                return RouterHelperProvider;
            }());
            angular.module('ute.blocks.router').provider('ute.blocks.router', RouterHelperProvider);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var Test = (function (_super) {
                        __extends(Test, _super);
                        function Test() {
                            _super.call(this);
                            this.scope = {
                                keys: '@'
                            };
                            this.controller = Controller;
                        }
                        Test.factory = function () {
                            return function () { return new Test(); };
                        };
                        return Test;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.service = service;
                            this.$scope = $scope;
                            this.init = function () {
                                var keysArray = angular.isDefined(_this.$scope.keys) ? _this.$scope.keys.split(',').map(function (s) { return s.trim(); }) : [];
                                return _this.service.isSome(keysArray).then(function (result) { return _this.test = result; });
                            };
                            this.init();
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-any-brt keys='RAM, REGISTRATION'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfAnyBrt', Test.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var Test = (function (_super) {
                        __extends(Test, _super);
                        function Test() {
                            _super.call(this);
                            this.scope = {
                                key: '@'
                            };
                            this.controller = Controller;
                        }
                        Test.factory = function () {
                            return function () { return new Test(); };
                        };
                        return Test;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.$scope = $scope;
                            service.getValue(this.$scope.key).then(function (result) { return _this.test = result; });
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-brt key='BSS_UCC_P1_BRT'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfBrt', Test.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var TestNot = (function (_super) {
                        __extends(TestNot, _super);
                        function TestNot() {
                            _super.call(this);
                            this.scope = {
                                key: '@'
                            };
                            this.template = '<span data-ng-if="!$ctrl.test"><ng-transclude></ng-transclude></span>';
                            this.controller = Controller;
                        }
                        TestNot.factory = function () {
                            return function () { return new TestNot(); };
                        };
                        return TestNot;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.$scope = $scope;
                            this.test = true;
                            service.getValue(this.$scope.key).then(function (result) { return _this.test = result; });
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-not-brt key='BSS_UCC_P1_BRT'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfNotBrt', TestNot.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchBreadcrumbsReducerProvider = (function () {
                function SearchBreadcrumbsReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = Immutable.List();
                }
                SearchBreadcrumbsReducerProvider.prototype.$get = function () {
                    var _this = this;
                    /*
                     * No transformations on the breadcrumbs array are expected.
                     * This reducer returns the object, as is
                     */
                    return function (state, action) {
                        if (state === void 0) { state = _this.defaultState; }
                        return state;
                    };
                };
                SearchBreadcrumbsReducerProvider.$inject = ['SearchActionTypes'];
                return SearchBreadcrumbsReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.breadcrumbs', [
                'ute.common.searchSection.actions'
            ])
                .provider('SearchBreadcrumbsReducer', [
                'SearchActionTypes',
                SearchBreadcrumbsReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchCalloutReducerProvider = (function () {
                function SearchCalloutReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = {
                        label: '',
                        icon: '',
                        description: '',
                        list: []
                    };
                }
                SearchCalloutReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var calloutType = _.get(action, 'assemblerData.Fragment.fragmentType');
                                // Check if fragment type is not equal to TVGuide
                                if (calloutType === 'TVGuide') {
                                    return state;
                                }
                                if (calloutType !== 'TVGuide') {
                                    var calloutList = _.get(action, 'assemblerData.Fragment.records', []);
                                    return state.set('list', Immutable.fromJS(calloutList));
                                }
                                return;
                            default:
                                return state;
                        }
                    };
                };
                return SearchCalloutReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.callout', [
                'ute.common.searchSection.actions'
            ])
                .provider('SearchCalloutReducer', [
                'SearchActionTypes',
                SearchCalloutReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchChannelRecommendationReducerProvider = (function () {
                function SearchChannelRecommendationReducerProvider(SearchActionTypes, ChannelRecommendationCitiesReducerProvider, ChannelRecommendationProvincesReducerProvider, ChannelRecommendationRecommendedChannelReducerProvider, ChannelRecommendationRecommendedShowReducerProvider, ChannelRecommendationRelatedChannelsReducerProvider, ChannelRecommendationSelectedCityReducerProvider, ChannelRecommendationWhatsOnReducerProvider) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = {
                        labelKey: 'ute.common.searchPage.channelRecommendation.label',
                        maxRecommendations: 30,
                        channelType: '',
                        cities: [],
                        provinces: [],
                        recommendedChannel: {},
                        recommendedShow: {},
                        relatedChannels: [],
                        selectedCity: {},
                        whatsOn: {
                            labelKey: 'ute.common.searchPage.channelRecommendation.whatsOn.label',
                            list: [
                                {
                                    labelKey: 'ute.common.searchPage.channelRecommendation.whatsOn.list.label1',
                                    url: {
                                        en: 'https://secure.rogersondemand.com/User/Register?lang=en&ReturnUrl=%2F&Callback=pvrLinkResponse',
                                        fr: 'https://secure.rogersondemand.com/User/Register?lang=fr&ReturnUrl=%2F&Callback=pvrLinkResponse'
                                    }
                                }
                            ]
                        },
                        showAllLink: {
                            beforeKey: 'ute.common.searchPage.channelRecommendation.showAllLink.before',
                            afterKey: 'ute.common.searchPage.channelRecommendation.showAllLink.after'
                        },
                        channelNumber: {
                            desktopKey: 'ute.common.searchPage.channelRecommendation.channelNumber.label',
                            mobileKey: 'ute.common.searchPage.channelRecommendation.channelNumber.labelMobile'
                        },
                    };
                    this.citiesReducer = ChannelRecommendationCitiesReducerProvider.$get();
                    this.provincesReducer = ChannelRecommendationProvincesReducerProvider.$get();
                    this.recommendedChannelReducer = ChannelRecommendationRecommendedChannelReducerProvider.$get();
                    this.recommendedShowReducer = ChannelRecommendationRecommendedShowReducerProvider.$get();
                    this.relatedChannelsReducer = ChannelRecommendationRelatedChannelsReducerProvider.$get();
                    this.selectedCityReducer = ChannelRecommendationSelectedCityReducerProvider.$get();
                    this.whatsOnReducer = ChannelRecommendationWhatsOnReducerProvider.$get();
                }
                SearchChannelRecommendationReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, cardComponents, tabId) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        var _a = [cardComponents.get(0), cardComponents.get(1)], navComponent = _a[0], tvComponent = _a[1];
                        switch (action.type) {
                            case _this.SearchActionTypes.FETCH_FILTERED_CHANNEL_RECOMMENDATIONS:
                                return state
                                    .withMutations(function (temporaryState) { return temporaryState.set('selectedCity', _this.selectedCityReducer(state.get('selectedCity'), action)); });
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var defaultProvinces = void 0, provinces_1;
                                defaultProvinces = [{ displayName: 'Ontario', value: '3191615402', dimensionName: 'ute.province' }];
                                provinces_1 = (_this.provincesReducer(state.get('provinces'), action, navComponent).size !== 0) ? _this.provincesReducer(state.get('provinces'), action, navComponent) : defaultProvinces;
                                return state
                                    .withMutations(function (temporaryState) {
                                    return temporaryState
                                        .set('cities', _this.citiesReducer(state.get('cities'), action, navComponent))
                                        .set('provinces', provinces_1)
                                        .set('recommendedChannel', _this.recommendedChannelReducer(state.get('recommendedChannel'), action, tvComponent))
                                        .set('recommendedShow', _this.recommendedShowReducer(state.get('recommendedShow'), action, tvComponent))
                                        .set('relatedChannels', _this.relatedChannelsReducer(state.get('relatedChannels'), action, state.get('maxRecommendations'), tvComponent))
                                        .set('selectedCity', _this.selectedCityReducer(state.get('selectedCity'), action, navComponent))
                                        .set('whatsOn', _this.whatsOnReducer(state.get('whatsOn'), action, tabId));
                                });
                            default:
                                return state;
                        }
                    };
                };
                return SearchChannelRecommendationReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.channelRecommendation', [
                'ute.common.searchSection.actions',
                'ute.common.searchSection.reducer.channelRecommendation.cities',
                'ute.common.searchSection.reducer.channelRecommendation.provinces',
                'ute.common.searchSection.reducer.channelRecommendation.recommendedChannel',
                'ute.common.searchSection.reducer.channelRecommendation.recommendedShow',
                'ute.common.searchSection.reducer.channelRecommendation.relatedChannels',
                'ute.common.searchSection.reducer.channelRecommendation.selectedCity',
                'ute.common.searchSection.reducer.channelRecommendation.whatsOn'
            ])
                .provider('SearchChannelRecommendationReducer', [
                'SearchActionTypes',
                'ChannelRecommendationCitiesReducerProvider',
                'ChannelRecommendationProvincesReducerProvider',
                'ChannelRecommendationRecommendedChannelReducerProvider',
                'ChannelRecommendationRecommendedShowReducerProvider',
                'ChannelRecommendationRelatedChannelsReducerProvider',
                'ChannelRecommendationSelectedCityReducerProvider',
                'ChannelRecommendationWhatsOnReducerProvider',
                SearchChannelRecommendationReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchDimensionsReducerProvider = (function () {
                function SearchDimensionsReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = Immutable.List();
                }
                SearchDimensionsReducerProvider.prototype.$get = function () {
                    var _this = this;
                    /*
                     * dimensions will be contained within the action
                     */
                    return function (state, action) {
                        if (state === void 0) { state = _this.defaultState; }
                        switch (action.type) {
                            case _this.SearchActionTypes.FETCH_FILTERED_SEARCH_RESULTS:
                                return Immutable.fromJS(action.dimensions);
                            default:
                                return state;
                        }
                    };
                };
                SearchDimensionsReducerProvider.$inject = ['SearchActionTypes'];
                return SearchDimensionsReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.dimensions', [
                'ute.common.searchSection.actions'
            ])
                .provider('SearchDimensionsReducer', [
                'SearchActionTypes',
                SearchDimensionsReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchFiltersReducerProvider = (function () {
                function SearchFiltersReducerProvider(SearchActionTypes, SearchIconMapperProvider) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.SearchIconMapperProvider = SearchIconMapperProvider;
                    this.defaultState = Immutable.List();
                }
                SearchFiltersReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = _this.defaultState; }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var searchTerm = action.searchTerm || '';
                                var searchFilters = _.get(action, 'assemblerData.GuidedNavigation', []).map(function (filter) {
                                    return angular.extend({}, filter, {
                                        dimension: filter.dimensionName,
                                        icon: _this.SearchIconMapperProvider.getIconForCategory(filter.iconCategory)
                                    });
                                });
                                return state
                                    .set('searchTerm', searchTerm)
                                    .set('list', Immutable.fromJS(searchFilters));
                            default:
                                return state;
                        }
                    };
                };
                return SearchFiltersReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.filters', [
                'ute.common.searchSection.actions',
                'ute.common.searchSection.services'
            ])
                .provider('SearchFiltersReducer', [
                'SearchActionTypes',
                'SearchIconMapperProvider',
                SearchFiltersReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchLocaleReducerProvider = (function () {
                function SearchLocaleReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = Immutable.fromJS({
                        language: '',
                        province: ''
                    });
                }
                SearchLocaleReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = _this.defaultState; }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_LANGUAGE:
                                var language = action.language;
                                return state
                                    .set('language', language);
                            case _this.SearchActionTypes.SET_PROVINCE:
                                var province = action.province;
                                return state
                                    .set('province', province);
                            default:
                                return state;
                        }
                    };
                };
                return SearchLocaleReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.locale', [
                'ute.common.searchSection.actions'
            ])
                .provider('SearchLocaleReducer', [
                'SearchActionTypes',
                SearchLocaleReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchPaginationReducerProvider = (function () {
                function SearchPaginationReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultPageOffset = 2;
                    this.defaultState = {
                        current: 1,
                        start: 1,
                        end: 1,
                        total: 1,
                        recordsPerPage: 10
                    };
                }
                SearchPaginationReducerProvider.prototype.$get = function (pageOffset) {
                    var _this = this;
                    if (pageOffset === void 0) { pageOffset = this.defaultPageOffset; }
                    this.pageOffset = pageOffset;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_FILTERED_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_PAGINATED_SEARCH_RESULTS:
                                var contentResultsList = _.get(action, 'assemblerData.ContentResultsList');
                                if (!contentResultsList) {
                                    return state;
                                }
                                var totalRecords = parseInt(contentResultsList.totalNumRecs, 10);
                                var firstRecordNum = parseInt(contentResultsList.firstRecNum, 10);
                                var recordsPerPage = parseInt(contentResultsList.recsPerPage, 10);
                                var currentPage = Math.ceil(firstRecordNum / recordsPerPage);
                                var totalPages = Math.ceil(totalRecords / recordsPerPage);
                                var startPage = Math.max(1, currentPage - _this.pageOffset);
                                var endPage = Math.min(totalPages, startPage + _this.pageOffset * 2);
                                return Immutable.Map({
                                    current: currentPage,
                                    start: startPage,
                                    end: endPage,
                                    total: totalPages,
                                    recordsPerPage: recordsPerPage
                                });
                            default:
                                return state;
                        }
                    };
                };
                return SearchPaginationReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.pagination', [
                'ute.common.searchSection.actions'
            ])
                .provider('SearchPaginationReducer', [
                'SearchActionTypes',
                SearchPaginationReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchResultsReducerProvider = (function () {
                function SearchResultsReducerProvider(SearchActionTypes, SearchIconMapperProvider) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.SearchIconMapperProvider = SearchIconMapperProvider;
                    this.defaultState = Immutable.fromJS({
                        count: 0,
                        list: []
                    });
                }
                SearchResultsReducerProvider.prototype.$get = function () {
                    var _this = this;
                    /*
                     * No transformations on the breadcrumbs array are expected.
                     * This reducer returns the object, as is
                     */
                    return function (state, action) {
                        if (state === void 0) { state = _this.defaultState; }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_FILTERED_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_PAGINATED_SEARCH_RESULTS:
                                var searchResults_1 = _.get(action, 'assemblerData.ContentResultsList');
                                // use default state if no search results were returned
                                if (!searchResults_1) {
                                    return _this.defaultState;
                                }
                                // if filters were returned, update icon mapping
                                var filters = _.get(action, 'assemblerData.ContentResultsList.records');
                                var displayNameToIconMap_1 = filters ?
                                    filters.reduce(function (mapMemo, filter) {
                                        var icon = _this.SearchIconMapperProvider.getIconForCategory(filter.icon);
                                        mapMemo[filter.icon] = icon;
                                        return mapMemo;
                                    }, {}) :
                                    state.get('displayNameToIconMap').toJS();
                                var count_1 = searchResults_1.totalNumRecs;
                                var list_1 = searchResults_1.records.map(_this.parseSearchResults.bind(_this, displayNameToIconMap_1));
                                return state
                                    .withMutations(function (temporaryState) {
                                    temporaryState
                                        .set('count', count_1)
                                        .set('displayNameToIconMap', Immutable.fromJS(displayNameToIconMap_1))
                                        .set('list', Immutable.fromJS(list_1));
                                });
                            default:
                                return state;
                        }
                    };
                };
                SearchResultsReducerProvider.prototype.parseSearchResults = function (displayNameToIconMap, searchResult) {
                    return angular.extend({}, searchResult, {
                        icon: displayNameToIconMap[searchResult.icon]
                    });
                };
                SearchResultsReducerProvider.$inject = ['SearchActionTypes'];
                return SearchResultsReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.results', [
                'ute.common.searchSection.actions'
            ])
                .provider('SearchResultsReducer', [
                'SearchActionTypes',
                'SearchIconMapperProvider',
                SearchResultsReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchTermReducerProvider = (function () {
                function SearchTermReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = Immutable.fromJS('');
                }
                SearchTermReducerProvider.prototype.$get = function () {
                    var _this = this;
                    /*
                     * searchTerm will be contained within the action
                     */
                    return function (state, action) {
                        if (state === void 0) { state = _this.defaultState; }
                        switch (action.type) {
                            case _this.SearchActionTypes.FETCH_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                            case _this.SearchActionTypes.SET_PAGINATED_SEARCH_RESULTS:
                                return Immutable.fromJS(action.searchTerm);
                            default:
                                return state;
                        }
                    };
                };
                SearchTermReducerProvider.$inject = ['SearchActionTypes'];
                return SearchTermReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.searchTerm', [
                'ute.common.searchSection.actions'
            ])
                .provider('SearchTermReducer', [
                'SearchActionTypes',
                SearchTermReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var TabbedSelectedProvinceReducerProvider = (function () {
                function TabbedSelectedProvinceReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = null;
                }
                TabbedSelectedProvinceReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, navComponent) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.FETCH_FILTERED_CHANNEL_RECOMMENDATIONS:
                                return Immutable.fromJS(action.selectedProvince);
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                                return state;
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var provinces = navComponent.get('provinces');
                                return provinces.get(0);
                            default:
                                return state;
                        }
                    };
                };
                return TabbedSelectedProvinceReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.tabbedCardSelectedProvince', [
                'ute.common.searchSection.actions'
            ])
                .provider('TabbedSelectedProvinceReducer', [
                'SearchActionTypes',
                TabbedSelectedProvinceReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var TabbedCardReducerProvider = (function () {
                function TabbedCardReducerProvider(SearchActionTypes, ChannelRecommendationReducerProvider, TabbedSelectedProvinceReducerProvider) {
                    var _this = this;
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = {
                        tabs: [{
                                id: '',
                                name: '',
                                labelEn: '',
                                tvComponents: [],
                                channelRecommendationContent: undefined,
                            }, {
                                id: '',
                                name: '',
                                labelEn: '',
                                tvComponents: [],
                                channelRecommendationContent: undefined
                            }],
                        selectedProvince: {}
                    };
                    this.isNavComponent = function (tvComponent) { return tvComponent.getIn(['contents', 'xtype']) === 'RegionGuidedNavigation'; };
                    this.isTvComponent = function (tvComponent) { return tvComponent.getIn(['contents', 'xtype']) === 'ProductResultsList'; };
                    this.mapTabsToState = function (state, action) {
                        var tabs = Immutable.fromJS([
                            {
                                xtype: 'DigitalLOBCardContainer',
                                assemblerData: _.get(action, 'assemblerData.DigitalLOBCardContainer', {}),
                                state: state.get(0)
                            },
                            {
                                xtype: 'IgniteLOBCardContainer',
                                assemblerData: _.get(action, 'assemblerData.IgniteLOBCardContainer', {}),
                                state: state.get(1)
                            }
                        ]);
                        return tabs.map(function (tab) {
                            if (tab.get('assemblerData').size === 0) {
                                return;
                            }
                            var cardComponents = Immutable.fromJS(_this.componentsFromAssemblerFor(tab.getIn(['assemblerData', 'TVCardComponents'])));
                            var id = tab.getIn(['assemblerData', 'id']);
                            return Immutable.fromJS({
                                id: id,
                                name: tab.getIn(['assemblerData', 'name']),
                                labelEn: tab.getIn(['assemblerData', 'tabLabel.en']),
                                description: tab.getIn(['assemblerData', 'description']),
                                tvComponents: cardComponents,
                                channelRecommendationContent: _this.channelRecommendationReducer(tab.getIn(['state', 'channelRecommendationContent']), action, cardComponents, id)
                            });
                        });
                    };
                    this.channelRecommendationReducer = ChannelRecommendationReducerProvider.$get();
                    this.selectedProvinceReducer = TabbedSelectedProvinceReducerProvider.$get();
                }
                TabbedCardReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        var findTabById = function (state, tabId) { return state.get('tabs').filter(function (t) { return t.get('id') === tabId; }).first(); };
                        var tabs;
                        switch (action.type) {
                            case _this.SearchActionTypes.FETCH_FILTERED_CHANNEL_RECOMMENDATIONS:
                                var tab_1 = findTabById(state, action.tabId);
                                tab_1 = tab_1.set('channelRecommendationContent', _this.channelRecommendationReducer(tab_1.get('channelRecommendationContent'), action, tab_1.get('tvComponents'), tab_1.get('id')));
                                return Immutable.fromJS({
                                    tabs: state.get('tabs').map(function (t) { return t.get('id') === tab_1.get('id') ? tab_1 : t; }),
                                    selectedProvince: _this.selectedProvinceReducer(state.get('selectedProvince'), action, state.get('tabs').get(0).get('tvComponents').get(0))
                                });
                            /** TODO: break this action down into to since there is special handling when the city is changed because the
                             *  provinces aren't returned.
                             *  The two actions could be the following:
                             *    SET_FILTERED_CHANNEL_RECOMMENDATIONS_FOR_CHANGED_CITY
                             *    SET_FILTERED_CHANNEL_RECOMMENDATIONS
                             */
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                                var currentTabs_1 = state.get('tabs');
                                tabs = _this.mapTabsToState(currentTabs_1, action);
                                if (tabs.isEmpty()) {
                                    return Immutable.fromJS(_this.defaultState);
                                }
                                // use the old provinces (if provinces don't come back. e.g on city change)
                                if (action.selectedCity) {
                                    tabs = tabs
                                        .map(function (t, i) { return t.updateIn([
                                        'tvComponents',
                                        '0',
                                        'provinces'
                                    ], function () { return currentTabs_1.getIn([i, 'tvComponents', '0', 'provinces']); }); })
                                        .map(function (t, i) { return t.updateIn([
                                        'channelRecommendationContent',
                                        'provinces'
                                    ], function () { return currentTabs_1.getIn([i, 'channelRecommendationContent', 'provinces']); }); });
                                }
                                return Immutable.fromJS({
                                    tabs: tabs,
                                    selectedProvince: _this.selectedProvinceReducer(state.get('selectedProvince'), action, tabs.getIn(['0', 'tvComponents', '0']))
                                });
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                tabs = _this.mapTabsToState(state.get('tabs'), action);
                                var navComponent = tabs.getIn(['0', 'tvComponents', '0']);
                                if (tabs.isEmpty()) {
                                    return Immutable.fromJS(_this.defaultState);
                                }
                                return Immutable.fromJS({
                                    tabs: tabs,
                                    selectedProvince: !navComponent || navComponent.size === 0 ? state.get('selectedProvince') : _this.selectedProvinceReducer(state.get('selectedProvince'), action, tabs.getIn(['0', 'tvComponents', '0']))
                                });
                            default:
                                return state;
                        }
                    };
                };
                // TODO: move this transformation to parser
                TabbedCardReducerProvider.prototype.componentsFromAssemblerFor = function (assemblerComponents) {
                    var navComponent = assemblerComponents
                        .filter(this.isNavComponent)
                        .map(function (x) { return Immutable.Map({
                        cities: x.getIn(['contents', 'navigation', 'cities', 'list']) || Immutable.List(),
                        provinces: x.getIn(['contents', 'navigation', 'provinces', 'list']) || Immutable.List()
                    }); })
                        .get(0) || Immutable.Map({ cities: Immutable.List(), provinces: Immutable.List() });
                    var tvComponent = assemblerComponents
                        .filter(this.isTvComponent)
                        .map(function (x) { return Immutable.Map({
                        channels: x.getIn(['contents', 'records']) || [],
                        showInfo: x.getIn(['showInfo']) || [],
                    }); })
                        .get(0) || Immutable.Map({ channels: Immutable.List(), showInfo: Immutable.List() });
                    // TODO: change to object
                    return [navComponent, tvComponent];
                };
                return TabbedCardReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.tabbedCard', [
                'ute.common.searchSection.actions',
                'ute.common.searchSection.reducer.channelRecommendation',
                'ute.common.searchSection.reducer.tabbedCardSelectedProvince'
            ])
                .provider('TabbedCardReducer', [
                'SearchActionTypes',
                'SearchChannelRecommendationReducerProvider',
                'TabbedSelectedProvinceReducerProvider',
                TabbedCardReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var SearchTvGuideReducerProvider = (function () {
                function SearchTvGuideReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = {
                        label: '',
                        icon: '',
                        description: '',
                        list: []
                    };
                }
                SearchTvGuideReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var fragment = _.get(action, 'assemblerData.Fragment');
                                // if (!fragment || fragment.fragmentType === 'TVGuide') {
                                //   const tvGuideList = _.get(
                                //     action,
                                //     'assemblerData.Fragment.records',
                                //     []
                                //   );
                                //   return state.set('list', Immutable.fromJS(tvGuideList));
                                // }
                                if (fragment && fragment.fragmentType === 'TVGuide') {
                                    var tvGuideList = _.get(action, 'assemblerData.Fragment.records', []);
                                    return state.set('list', Immutable.fromJS(tvGuideList));
                                }
                                return state.set('list', Immutable.fromJS([]));
                            default:
                                return state;
                        }
                    };
                };
                return SearchTvGuideReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.tvGuide', [
                'ute.common.searchSection.actions'
            ])
                .provider('SearchTvGuideReducer', [
                'SearchActionTypes',
                SearchTvGuideReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportArticleReducerProvider = (function () {
                function SupportArticleReducerProvider(SupportActionTypes) {
                    this.SupportActionTypes = SupportActionTypes;
                }
                SupportArticleReducerProvider.prototype.contents = function (state, action) {
                    if (state === void 0) { state = Immutable.fromJS([]); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            var contents = _.get(action, 'assemblerData.article.contents', []);
                            return Immutable.fromJS(contents);
                        default:
                            return state;
                    }
                };
                SupportArticleReducerProvider.prototype.seoUrl = function (state, action) {
                    if (state === void 0) { state = Immutable.fromJS(''); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            var seoUrl = action.seoUrl;
                            return Immutable.fromJS(seoUrl);
                        default:
                            return state;
                    }
                };
                SupportArticleReducerProvider.prototype.lob = function (state, action) {
                    if (state === void 0) { state = Immutable.fromJS(''); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            var lob = _.get(action, 'assemblerData.article.supportDetails.category', '');
                            return Immutable.fromJS(lob);
                        default:
                            return state;
                    }
                };
                SupportArticleReducerProvider.prototype.seo = function (state, action) {
                    if (state === void 0) { state = Immutable.Map(); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            var seo = _.get(action, 'assemblerData.article.seo', {});
                            return Immutable.fromJS(seo);
                        default:
                            return state;
                    }
                };
                SupportArticleReducerProvider.prototype.title = function (state, action) {
                    if (state === void 0) { state = Immutable.fromJS(''); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            var title = _.get(action, 'assemblerData.article.title', '');
                            return Immutable.fromJS(title);
                        default:
                            return state;
                    }
                };
                SupportArticleReducerProvider.prototype.dateModified = function (state, action) {
                    if (state === void 0) { state = Immutable.Map(); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            var date_modified = _.get(action, 'assemblerData.article.supportDetails.publishAttributes.date_modified', '');
                            return (date_modified) ? new Date(date_modified) : '';
                        default:
                            return state;
                    }
                };
                SupportArticleReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.Map({}); }
                        switch (action.type) {
                            case _this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                                return state.withMutations(function (temporaryState) {
                                    return temporaryState
                                        .set('contents', _this.contents(state.get('contents'), action))
                                        .set('seo', _this.seo(state.get('seo'), action))
                                        .set('seoUrl', _this.seoUrl(state.get('seoUrl'), action))
                                        .set('title', _this.title(state.get('title'), action))
                                        .set('lob', _this.lob(state.get('lob'), action))
                                        .set('dateModified', _this.dateModified(state.get('dateModified'), action));
                                });
                            default:
                                return state;
                        }
                    };
                };
                SupportArticleReducerProvider.$inject = ['SupportActionTypes'];
                return SupportArticleReducerProvider;
            }());
            angular.module('ute.common.supportSection.reducer.article', [])
                .provider('SupportArticleReducer', SupportArticleReducerProvider);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportArticleBreadcrumbsReducerProvider = (function () {
                function SupportArticleBreadcrumbsReducerProvider(SupportActionTypes) {
                    this.SupportActionTypes = SupportActionTypes;
                }
                SupportArticleBreadcrumbsReducerProvider.prototype.getBreadcrumbsUrl = function (state, action) {
                    if (state === void 0) { state = Immutable.fromJS(''); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            var contentType = _.get(action, 'assemblerData.article.supportDetails.contentType', '');
                            var category = _.get(action, 'assemblerData.article.supportDetails.category', '');
                            var categoryEN = _.get(action, 'assemblerData.ArticleResultsList.records[0].attributes.["ute.content.category.en"][0]', '');
                            var articleTitle = _.get(action, 'assemblerData.article.title', '');
                            var helpAndSupportUrl = void 0;
                            if (contentType === 'Help & Support' || contentType === 'Aide et soutien') {
                                switch (action.businessUnit) {
                                    case 'smallbusiness':
                                        helpAndSupportUrl = '/small-business/help-and-resources/support#/';
                                        break;
                                    case 'enterprise':
                                        helpAndSupportUrl = '';
                                        break;
                                    default:
                                        helpAndSupportUrl = '/consumer/support/';
                                }
                            }
                            var categoryUrl = ((helpAndSupportUrl && category) ? helpAndSupportUrl + categoryEN.toLowerCase().replace(/[\W_/]/g, '') : '');
                            return [
                                { label: contentType, url: helpAndSupportUrl },
                                { label: category, url: categoryUrl },
                                { label: articleTitle }
                            ];
                        default:
                            return state;
                    }
                };
                SupportArticleBreadcrumbsReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.Map({}); }
                        switch (action.type) {
                            case _this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                                var breadcrumbs = _this.getBreadcrumbsUrl(state, action)
                                    .filter(function (breadcrumb) { return breadcrumb.label; });
                                return Immutable.fromJS(breadcrumbs);
                            default:
                                return state;
                        }
                    };
                };
                SupportArticleBreadcrumbsReducerProvider.$inject = ['SupportActionTypes'];
                return SupportArticleBreadcrumbsReducerProvider;
            }());
            angular.module('ute.common.supportSection.reducer.breadcrumbs', [])
                .provider('SupportArticleBreadcrumbsReducer', SupportArticleBreadcrumbsReducerProvider);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportChildArticleReducerProvider = (function () {
                function SupportChildArticleReducerProvider(SupportActionTypes) {
                    this.SupportActionTypes = SupportActionTypes;
                }
                SupportChildArticleReducerProvider.prototype.contents = function (state, action) {
                    if (state === void 0) { state = Immutable.fromJS([]); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_CHILD_ARTICLE:
                            var contents = _.get(action, 'assemblerData.article.contents', []);
                            return Immutable.fromJS(contents);
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            return Immutable.fromJS([]);
                        default:
                            return state;
                    }
                };
                SupportChildArticleReducerProvider.prototype.seo = function (state, action) {
                    if (state === void 0) { state = Immutable.Map(); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_CHILD_ARTICLE:
                            var seo = _.get(action, 'assemblerData.article.seo', {});
                            return Immutable.fromJS(seo);
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            return Immutable.Map();
                        default:
                            return state;
                    }
                };
                SupportChildArticleReducerProvider.prototype.title = function (state, action) {
                    if (state === void 0) { state = Immutable.fromJS(''); }
                    switch (action.type) {
                        case this.SupportActionTypes.SET_SUPPORT_CHILD_ARTICLE:
                            var title = _.get(action, 'assemblerData.article.title', '');
                            return Immutable.fromJS(title);
                        case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                            return Immutable.fromJS('');
                        default:
                            return state;
                    }
                };
                SupportChildArticleReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.Map({}); }
                        switch (action.type) {
                            case _this.SupportActionTypes.SET_SUPPORT_CHILD_ARTICLE:
                            case _this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                                return state.withMutations(function (temporaryState) {
                                    return temporaryState
                                        .set('contents', _this.contents(state.get('contents'), action))
                                        .set('seo', _this.seo(state.get('seo'), action))
                                        .set('title', _this.title(state.get('title'), action));
                                });
                            default:
                                return state;
                        }
                    };
                };
                SupportChildArticleReducerProvider.$inject = ['SupportActionTypes'];
                return SupportChildArticleReducerProvider;
            }());
            angular.module('ute.common.supportSection.reducer.childArticle', [])
                .provider('SupportChildArticleReducer', SupportChildArticleReducerProvider);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

/**
 * Created by siva on 2016-10-10.
 */
var ute;
(function (ute) {
    var common;
    (function (common) {
        var supportSection;
        (function (supportSection) {
            'use strict';
            var SupportArticleFeedbackReducerProvider = (function () {
                function SupportArticleFeedbackReducerProvider(SupportActionTypes) {
                    this.SupportActionTypes = SupportActionTypes;
                }
                SupportArticleFeedbackReducerProvider.prototype.feedback = function (state, action) {
                    if (state === void 0) { state = Immutable.fromJS({ submitted: false, success: false }); }
                    switch (action.type) {
                        case this.SupportActionTypes.SUBMIT_ARTICLE_FEEDBACK:
                            var feedbackReceived = action.feedbackReceived;
                            var helpFoundStatus = action.helpFoundStatus;
                            return Immutable.fromJS({
                                submitted: true,
                                success: true,
                                response: feedbackReceived,
                                helpFoundStatus: helpFoundStatus
                            });
                        default:
                            return state;
                    }
                };
                SupportArticleFeedbackReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action) {
                        if (state === void 0) { state = Immutable.Map({}); }
                        switch (action.type) {
                            case _this.SupportActionTypes.SUBMIT_ARTICLE_FEEDBACK:
                                return _this.feedback(state.get('feedbackReceived'), action);
                            case _this.SupportActionTypes.CLEAR_ARTICLE_FEEDBACK:
                                return Immutable.fromJS({ submitted: false, success: false });
                            default:
                                return state;
                        }
                    };
                };
                SupportArticleFeedbackReducerProvider.$inject = ['SupportActionTypes'];
                return SupportArticleFeedbackReducerProvider;
            }());
            angular.module('ute.common.supportSection.reducer.feedback', [])
                .provider('SupportArticleFeedbackReducer', SupportArticleFeedbackReducerProvider);
        })(supportSection = common.supportSection || (common.supportSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var ChannelRecommendationCitiesReducerProvider = (function () {
                function ChannelRecommendationCitiesReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = [];
                }
                ChannelRecommendationCitiesReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, navComponent) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                                // only update selected city for province changes, not city changes
                                if (action.selectedCity) {
                                    return state;
                                }
                                return Immutable.fromJS(navComponent.get('cities'));
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                return Immutable.fromJS(navComponent.get('cities'));
                            default:
                                return state;
                        }
                        ;
                    };
                };
                return ChannelRecommendationCitiesReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.channelRecommendation.cities', [
                'ute.common.searchSection.actions'
            ])
                .provider('ChannelRecommendationCitiesReducer', [
                'SearchActionTypes',
                ChannelRecommendationCitiesReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var ChannelRecommendationProvincesReducerProvider = (function () {
                function ChannelRecommendationProvincesReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = [];
                }
                ChannelRecommendationProvincesReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, navComponent) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                return Immutable.fromJS(navComponent.get('provinces'));
                            default:
                                return state;
                        }
                    };
                };
                return ChannelRecommendationProvincesReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.channelRecommendation.provinces', [
                'ute.common.searchSection.actions'
            ])
                .provider('ChannelRecommendationProvincesReducer', [
                'SearchActionTypes',
                ChannelRecommendationProvincesReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var ChannelRecommendationRecommendedChannelReducerProvider = (function () {
                function ChannelRecommendationRecommendedChannelReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = [];
                }
                ChannelRecommendationRecommendedChannelReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, tvComponent) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var relatedChannels = tvComponent.get('channels');
                                var recommendedChannel = relatedChannels.get(0);
                                return Immutable.fromJS(recommendedChannel);
                            default:
                                return state;
                        }
                    };
                };
                return ChannelRecommendationRecommendedChannelReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.channelRecommendation.recommendedChannel', [
                'ute.common.searchSection.actions'
            ])
                .provider('ChannelRecommendationRecommendedChannelReducer', [
                'SearchActionTypes',
                ChannelRecommendationRecommendedChannelReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var ChannelRecommendationRecommendedShowReducerProvider = (function () {
                function ChannelRecommendationRecommendedShowReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = Immutable.Map();
                }
                ChannelRecommendationRecommendedShowReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, tvComponent) {
                        if (state === void 0) { state = _this.defaultState; }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var recommendedShow = tvComponent.get('showInfo');
                                return Immutable.fromJS(recommendedShow);
                            default:
                                return state;
                        }
                    };
                };
                return ChannelRecommendationRecommendedShowReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.channelRecommendation.recommendedShow', [
                'ute.common.searchSection.actions'
            ])
                .provider('ChannelRecommendationRecommendedShowReducer', [
                'SearchActionTypes',
                ChannelRecommendationRecommendedShowReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var ChannelRecommendationRelatedChannelsReducerProvider = (function () {
                function ChannelRecommendationRelatedChannelsReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = [];
                }
                ChannelRecommendationRelatedChannelsReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, maxRecommendations, tvComponent) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var relatedChannels = tvComponent.get('channels');
                                // get subset of the array: from 1 to the max number
                                var truncatedRelatedChannels = relatedChannels.slice(1, maxRecommendations ? maxRecommendations + 1 : relatedChannels.length);
                                return Immutable.fromJS(truncatedRelatedChannels);
                            default:
                                return state;
                        }
                    };
                };
                return ChannelRecommendationRelatedChannelsReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.channelRecommendation.relatedChannels', [
                'ute.common.searchSection.actions'
            ])
                .provider('ChannelRecommendationRelatedChannelsReducer', [
                'SearchActionTypes',
                ChannelRecommendationRelatedChannelsReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var ChannelRecommendationSelectedCityReducerProvider = (function () {
                function ChannelRecommendationSelectedCityReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = null;
                }
                ChannelRecommendationSelectedCityReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, tvComponent) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        switch (action.type) {
                            case _this.SearchActionTypes.FETCH_FILTERED_CHANNEL_RECOMMENDATIONS:
                                return action.selectedCity ?
                                    Immutable.fromJS(action.selectedCity) :
                                    state;
                            case _this.SearchActionTypes.SET_FILTERED_CHANNEL_RECOMMENDATIONS:
                                // only update selected city for province changes, not city changes
                                if (action.selectedCity) {
                                    return state;
                                }
                                var updatedSelectedCity = tvComponent.get('cities').get(0);
                                return Immutable.fromJS(updatedSelectedCity);
                            case _this.SearchActionTypes.SET_SEARCH_RESULTS:
                                var selectedCity = tvComponent.get('cities').get(0);
                                return Immutable.fromJS(selectedCity);
                            default:
                                return state;
                        }
                    };
                };
                return ChannelRecommendationSelectedCityReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.channelRecommendation.selectedCity', [
                'ute.common.searchSection.actions'
            ])
                .provider('ChannelRecommendationSelectedCityReducer', [
                'SearchActionTypes',
                ChannelRecommendationSelectedCityReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var searchSection;
        (function (searchSection) {
            'use strict';
            var ChannelRecommendationWhatsOnReducerProvider = (function () {
                function ChannelRecommendationWhatsOnReducerProvider(SearchActionTypes) {
                    this.SearchActionTypes = SearchActionTypes;
                    this.defaultState = {};
                }
                ChannelRecommendationWhatsOnReducerProvider.prototype.$get = function () {
                    var _this = this;
                    return function (state, action, tabId) {
                        if (state === void 0) { state = Immutable.fromJS(_this.defaultState); }
                        // always use default (this isn't being sent from the backend)
                        if (/ignite/.test(tabId)) {
                            return Immutable.fromJS(state).setIn(['list', '0', 'labelKey'], 'ute.common.searchPage.channelRecommendation.whatsOn.list.label2');
                        }
                        return Immutable.fromJS(state);
                    };
                };
                ;
                return ChannelRecommendationWhatsOnReducerProvider;
            }());
            angular.module('ute.common.searchSection.reducer.channelRecommendation.whatsOn', [
                'ute.common.searchSection.actions'
            ])
                .provider('ChannelRecommendationWhatsOnReducer', [
                'SearchActionTypes',
                ChannelRecommendationWhatsOnReducerProvider
            ]);
        })(searchSection = common.searchSection || (common.searchSection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var app;
(function (app) {
    'use strict';
    app.AppActionTypes = {
        GO_TO_SEARCH: 'GO_TO_SEARCH',
        REFRESH_PAGE: 'REFRESH_PAGE',
        SET_BROWSER_METADATA: 'SET_BROWSER_METADATA',
        SET_BROWSER_SEO: 'SET_BROWSER_SEO',
        SET_LANGUAGE: 'SET_LANGUAGE',
        SET_PROVINCE: 'SET_PROVINCE',
        SET_ROUTE_DETAILS: 'SET_ROUTE_DETAILS',
        SET_FETCH_EXCEPTION: 'SET_FETCH_EXCEPTION',
        SET_BUSINESS_UNIT: 'SET_BUSINESS_UNIT'
    };
    /**
     * [AppActionsFactory Action creator angular factory for app-level actions]
     * @return {IAppActions}                                                      [Angular factory action creator]
     */
    function AppActionsFactory(AppActionTypes, AssemblerMediator, localizationService, SupportActionTypes, SupportActions, SearchActionTypes, $log, $state, $translate) {
        function fetchSearchResults(searchTerm, dimensions) {
            return function (dispatch, getState) {
                var type = SearchActionTypes.FETCH_SEARCH_RESULTS;
                dispatch({ type: type, searchTerm: searchTerm, dimensions: dimensions });
                // make assembler mediator call
                var state = getState();
                var assemblerRequest = {
                    searchTerm: searchTerm,
                    dimensions: dimensions,
                    language: state.getIn(['app', 'language']),
                    province: state.getIn(['app', 'province'])
                };
                AssemblerMediator.fetchSearchPageLayout(assemblerRequest)
                    .then(function (assemblerData) {
                    return dispatch(setSearchResults(searchTerm, dimensions, assemblerData));
                })
                    .catch(function (err) {
                    return dispatch(setFetchException(err));
                });
            };
        }
        function fetchSupportArticle(articleId, childArticleId) {
            return function (dispatch, getState) {
                var type = SupportActionTypes.FETCH_SUPPORT_ARTICLE;
                dispatch({ type: type, articleId: articleId });
                var state = getState();
                var language = state.getIn(['app', 'language']);
                var province = state.getIn(['app', 'province']);
                var businessUnit = state.getIn(['app', 'businessUnit']);
                AssemblerMediator.fetchSupportArticle(language, province, articleId)
                    .then(function (assemblerData) {
                    if (assemblerData && assemblerData.article) {
                        dispatch(setBrowserSeo(assemblerData.article.seo));
                        if (assemblerData && assemblerData.article) {
                            var title = void 0;
                            if (assemblerData.article.seo && assemblerData.article.seo.title) {
                                title = assemblerData.article.seo.title;
                            }
                            else if (assemblerData.article.supportDetails && assemblerData.article.supportDetails.serializedSeoContainer) {
                                var serializedSeoContainer = JSON.parse(assemblerData.article.supportDetails.serializedSeoContainer);
                                title = serializedSeoContainer && serializedSeoContainer.seo_title;
                            }
                            title = (title || '') + ' - Rogers';
                            dispatch(setBrowserMetadata(title));
                        }
                    }
                    dispatch(setSupportArticle(articleId, businessUnit, assemblerData));
                    if (childArticleId) {
                        var childArticleProperties = AssemblerMediator.getChildArticleProperties(assemblerData.article.contents, childArticleId);
                        if (childArticleProperties) {
                            dispatch(SupportActions.fetchSupportChildArticle(childArticleProperties));
                        }
                    }
                })
                    .catch(function (err) {
                    return dispatch(setFetchException(err));
                });
            };
        }
        function goToSearch(search) {
            var type = AppActionTypes.GO_TO_SEARCH;
            // TODO: move this somewhere like the reducer
            if (search.url) {
                return window.location.href = search.url;
            }
            $state.go('search', {
                searchTerm: search.searchTerm
            });
            return {
                type: type,
                searchTerm: search.searchTerm
            };
        }
        function refreshPage(language, province, uiRouteData, businessUnit) {
            var type = AppActionTypes.REFRESH_PAGE;
            //add canonical on article deails page
            var head = document.getElementsByTagName('head')[0];
            var canonicalLink = document.createElement('link');
            canonicalLink.rel = 'canonical';
            if (uiRouteData.uiParams.articleId) {
                var canonicalURL = '/customer/support/article/' + uiRouteData.uiParams.articleId;
            }
            else {
                var canonicalURL = '/customer/search';
            }
            canonicalLink.href = canonicalURL;
            if ($('link[rel="canonical"]').length > 0) {
                $('link[rel="canonical"]').attr('href', canonicalURL);
            }
            else {
                head.appendChild(canonicalLink);
            }
            return function (dispatch, getState) {
                dispatch({ type: type, language: language, province: province, uiRouteData: uiRouteData });
                // set language, province and route data
                dispatch(setLanguage(language));
                dispatch(setProvince(province));
                dispatch(setBusinessUnit(businessUnit));
                return dispatch(setRouteDetails(uiRouteData.uiState, uiRouteData.uiParams));
            };
        }
        function setBrowserMetadata(title) {
            var type = AppActionTypes.SET_BROWSER_METADATA;
            return { type: type, title: title };
        }
        function setLanguage(language) {
            var type = AppActionTypes.SET_LANGUAGE;
            localizationService.setLanguage(language);
            return { type: type, language: language };
        }
        function setRouteDetails(uiState, uiParams) {
            return function (dispatch, getState) {
                var state = getState();
                var stateChildArticleId = state.getIn(['app', 'router', 'uiParams', 'childArticleId']);
                var articleId = uiParams.articleId;
                var childArticleId = stateChildArticleId || uiParams.childArticleId;
                var type = AppActionTypes.SET_ROUTE_DETAILS;
                dispatch({ type: type, uiState: uiState, uiParams: uiParams });
                dispatch(updateBrowserTitle());
                if (uiState.name === 'support.article' && uiParams.articleId) {
                    dispatch(SupportActions.clearArticleFeedback());
                    dispatch(fetchSupportArticle(articleId, childArticleId));
                }
                else if (uiState.name === 'search' && uiParams.searchTerm && uiParams.searchTerm.length >= 2) {
                    var searchTerm = uiParams.searchTerm;
                    var dimensions = uiParams.dimensions;
                    dispatch(fetchSearchResults(searchTerm, dimensions));
                }
            };
        }
        function setSearchResults(searchTerm, dimensions, assemblerData) {
            return {
                type: SearchActionTypes.SET_SEARCH_RESULTS,
                searchTerm: searchTerm,
                dimensions: dimensions,
                assemblerData: assemblerData
            };
        }
        function setSupportArticle(seoUrl, businessUnit, assemblerData) {
            var type = SupportActionTypes.SET_SUPPORT_ARTICLE;
            return { type: type, seoUrl: seoUrl, businessUnit: businessUnit, assemblerData: assemblerData };
        }
        function setProvince(province) {
            var type = AppActionTypes.SET_PROVINCE;
            return { type: type, province: province };
        }
        function updateBrowserTitle() {
            return function (dispatch, getState) {
                var state = getState();
                var uiStateName = state.getIn(['app', 'router', 'uiState', 'name']);
                var sectionName = uiStateName && uiStateName.split('.')[0];
                var browserTitleKey = state.getIn([sectionName, 'browserTitleKey']);
                var title = $translate.instant(browserTitleKey);
                return dispatch(setBrowserMetadata(title));
            };
        }
        function setBrowserSeo(seo) {
            var type = AppActionTypes.SET_BROWSER_SEO;
            return { type: type, seo: seo };
        }
        function setFetchException(error) {
            var type = AppActionTypes.SET_FETCH_EXCEPTION;
            return { type: type, status: error.status, statusText: error.statusText, error: error };
        }
        function setBusinessUnit(businessUnit) {
            var type = AppActionTypes.SET_BUSINESS_UNIT;
            return { type: type, value: businessUnit };
        }
        return {
            goToSearch: goToSearch,
            refreshPage: refreshPage,
            setBrowserMetadata: setBrowserMetadata,
            setLanguage: setLanguage,
            setProvince: setProvince,
            setRouteDetails: setRouteDetails,
            setBrowserSeo: setBrowserSeo,
            setFetchException: setFetchException,
            setBusinessUnit: setBusinessUnit
        };
    }
    angular.module('app.actions', [
        'app.services.localization',
        'ute.assembler.mediator'
    ])
        .constant('AppActionTypes', app.AppActionTypes)
        .factory('AppActions', [
        'AppActionTypes',
        'AssemblerMediator',
        'localizationService',
        'SupportActionTypes',
        'SupportActions',
        'SearchActionTypes',
        '$log',
        '$state',
        '$translate',
        AppActionsFactory
    ]);
})(app || (app = {}));

var TSLSSSE;
(function (TSLSSSE) {
    'use strict';
    var TSLSFooterController = (function () {
        function TSLSFooterController($ngRedux, $scope, $rootScope, $http, $compile, $timeout, $window, AppActions, tslsService) {
            this.$ngRedux = $ngRedux;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$http = $http;
            this.$compile = $compile;
            this.$timeout = $timeout;
            this.$window = $window;
            this.AppActions = AppActions;
            this.tslsService = tslsService;
            var unsubscribe = $ngRedux.connect(this.mapStateToThis, AppActions)(this);
            $scope.$on('$destroy', unsubscribe);
        }
        TSLSFooterController.prototype.mapStateToThis = function (state) {
            return {
                language: state.getIn(['app', 'language']),
                province: state.getIn(['app', 'province']),
                businessUnit: state.getIn(['app', 'businessUnit'])
            };
        };
        TSLSFooterController.prototype.toggleLanguage = function () {
            this.tslsService.toggleLanguage(this);
        };
        TSLSFooterController.prototype.setProv = function (prov) {
            this.tslsService.setProv(this, prov);
        };
        TSLSFooterController.prototype.setFooterHtml = function (el) {
            var _this = this;
            var promise = this.tslsService.fetchTemplate(this.$http, this.language, this.province, this.businessUnit, 'footer-new')
                .then(function (resp) { return resp.data; })
                .then(TSLSSSE.xmlToHtml);
            if (this.businessUnit !== 'consumer') {
                promise
                    .then(this.tslsService.bindLanguageChange('.province-language .lang-toggle a'))
                    .then(this.tslsService.bindProvinceChange('.province-language .province-dropdown li'))
                    .then(function (el) { return _this.$compile(el)(_this.$scope); });
            }
            promise
                .then(function (html) { return el.html(html); })
                .then(function () { return _this.$timeout(function () { return $(document.body).trigger('cms:loaded:footer'); }); });
        };
        TSLSFooterController.$inject = [
            '$ngRedux',
            '$scope',
            '$rootScope',
            '$http',
            '$compile',
            '$timeout',
            '$window',
            'AppActions',
            'tslsService'
        ];
        return TSLSFooterController;
    }());
    var TSLSFooter = (function () {
        function TSLSFooter($timeout) {
            this.$timeout = $timeout;
            this.restrict = 'E';
            this.controllerAs = 'vm';
            this.controller = TSLSFooterController;
            this.bindToController = true;
            this.link = function (scope, el, attrs, tslsFooterCtrl) {
                $timeout(function () {
                    scope.$watch(function () { return (tslsFooterCtrl.province + "-" + tslsFooterCtrl.language); }, function () {
                        tslsFooterCtrl.setFooterHtml(el);
                    });
                });
            };
        }
        TSLSFooter.factory = function () {
            var directive = function ($timeout) { return new TSLSFooter($timeout); };
            directive.$inject = ['$timeout'];
            return directive;
        };
        return TSLSFooter;
    }());
    angular.module('ute.sse.tsls').directive('tslsFooter', TSLSFooter.factory());
})(TSLSSSE || (TSLSSSE = {}));

var TSLSSSE;
(function (TSLSSSE) {
    'use strict';
    TSLSSSE.xmlToHtml = function (xml) { return $(xml); };
    // twice curried
    var replaceWithTypeahead = function (siteName) { return function (selector, province, lang) { return function (html) {
        html.find(selector).html("<ute-sse-typeahead\n    placeholder=\"" + (lang === 'fr' ? 'Recherche' : 'Search') + "\"\n    language=\"" + lang + "\"\n    province=\"" + province + "\"\n    site=\"" + siteName + "\">\n    </ute-sse-typeahead>");
        return html;
    }; }; };
    var TSLSHeaderController = (function () {
        function TSLSHeaderController($ngRedux, $scope, $rootScope, $http, $compile, $timeout, $window, AppActions, tslsService) {
            this.$ngRedux = $ngRedux;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$http = $http;
            this.$compile = $compile;
            this.$timeout = $timeout;
            this.$window = $window;
            this.AppActions = AppActions;
            this.tslsService = tslsService;
            var unsubscribe = $ngRedux.connect(this.mapStateToThis, AppActions)(this);
            this.hasHeaderCompLoaded = false;
            $scope.$on('$destroy', unsubscribe);
        }
        TSLSHeaderController.prototype.mapStateToThis = function (state) {
            return {
                language: state.getIn(['app', 'language']),
                province: state.getIn(['app', 'province']),
                businessUnit: state.getIn(['app', 'businessUnit'])
            };
        };
        TSLSHeaderController.prototype.toggleLanguage = function () {
            this.tslsService.toggleLanguage(this);
        };
        TSLSHeaderController.prototype.setProv = function (prov) {
            this.tslsService.setProv(this, prov);
        };
        TSLSHeaderController.prototype.headerHtml = function (el) {
            var _this = this;
            var promise = this.tslsService.fetchTemplate(this.$http, this.language, this.province, this.businessUnit, 'header-new')
                .then(function (resp) { return resp.data; })
                .then(TSLSSSE.xmlToHtml);
            if (this.businessUnit === 'consumer') {
                promise
                    .then(this.tslsService.bindLanguageChange('.lang-toggle a'))
                    .then(this.tslsService.bindProvinceChange('#province ul li'))
                    .then(function (el) { return _this.$compile(el)(_this.$scope); })
                    .then(function () {
                    if (typeof _this.$window.ddsHead != undefined) {
                        if (_this.hasHeaderCompLoaded) {
                            _this.$window.ddsHead.initializer();
                        }
                        else
                            _this.hasHeaderCompLoaded = true;
                    }
                });
            }
            else {
                promise
                    .then(replaceWithTypeahead(this.businessUnit)('.search-section', this.province, this.language));
            }
            promise
                .then(function (html) { return el.html(html); })
                .then(function () { return _this.$timeout(function () { return $(document.body).trigger('cms:loaded:header'); }); });
        };
        TSLSHeaderController.$inject = [
            '$ngRedux',
            '$scope',
            '$rootScope',
            '$http',
            '$compile',
            '$timeout',
            '$window',
            'AppActions',
            'tslsService'
        ];
        return TSLSHeaderController;
    }());
    var TSLSHeader = (function () {
        function TSLSHeader(tslsService) {
            this.tslsService = tslsService;
            this.restrict = 'E';
            this.controllerAs = 'vm';
            this.controller = TSLSHeaderController;
            this.bindToController = true;
            this.link = function (scope, el, attrs, tslsHeaderCtrl) {
                setTimeout(function () {
                    [
                        '/cms/common/dca/js/jquery.waypoints.min.js',
                        '/cms/common/dca/js/dca-main.js',
                        '/cms/rogers/js/webcomponents-lite.min.js'
                    ].map(tslsService.appendScript);
                    var stylesheet = tslsHeaderCtrl.businessUnit === 'consumer' ?
                        '/cms/rogers/css/rogers.css' : '/cms/common/dca/css/rogers-ss.css';
                    tslsService.appendStylesheet(stylesheet);
                });
                scope.$watch(function () { return (tslsHeaderCtrl.province + "-" + tslsHeaderCtrl.language); }, function () {
                    tslsHeaderCtrl.headerHtml(el);
                });
            };
        }
        TSLSHeader.factory = function () {
            var directive = function (tslsService) { return new TSLSHeader(tslsService); };
            directive.$inject = ['tslsService'];
            return directive;
        };
        return TSLSHeader;
    }());
    angular.module('ute.sse.tsls').directive('tslsHeader', TSLSHeader.factory());
})(TSLSSSE || (TSLSSSE = {}));

var TSLSSSE;
(function (TSLSSSE) {
    'use strict';
    var xmlPaths = {
        'smallbusiness': '/cms/rogers-smb-new/integration/',
        'enterprise': '/cms/rogers-enterprise/integration/',
        'consumer': '/cms/rogers/integration/',
        'consumerHeader': '/cms/rogers/integration/'
    };
    var TSLSService = (function () {
        function TSLSService($rootScope, $window, languageService) {
            this.$rootScope = $rootScope;
            this.$window = $window;
            this.languageService = languageService;
        }
        TSLSService.prototype.toggleLanguage = function (self) {
            self.$rootScope.$broadcast('ute.language.updated', self.language === 'fr' ? 'en' : 'fr');
            $(document.body).trigger('locale:lang:update', [{ language: self.language }]);
            this.languageService.changeLanguage(self.language);
            self.$window.init_page();
        };
        TSLSService.prototype.setProv = function (self, prov) {
            self.$rootScope.$broadcast('ute.province.updated', prov);
            $(document.body).trigger('locale:prov:update', [{ province: self.province }]);
            self.$window.init_page();
        };
        TSLSService.prototype.bindLanguageChange = function (selector) {
            return function ($el) {
                $el.find(selector)
                    .attr('href', 'javascript:void(0)')
                    .attr('ng-click', 'vm.toggleLanguage()');
                return $el;
            };
        };
        TSLSService.prototype.bindProvinceChange = function (selector) {
            return function ($el) {
                $el.find(selector)
                    .not(':first')
                    .find('a')
                    .each(function () {
                    var $this = $(this);
                    $this.attr('href', 'javascript:void(0)')
                        .attr('ng-click', "vm.setProv('" + $this.attr('name') + "')");
                });
                return $el;
            };
        };
        TSLSService.prototype.appendScript = function (url) {
            var scriptEl = document.createElement('script');
            scriptEl.setAttribute('src', url);
            document.body.appendChild(scriptEl);
        };
        TSLSService.prototype.appendStylesheet = function (url) {
            var stylesheetEl = document.createElement('link');
            stylesheetEl.setAttribute('rel', 'stylesheet');
            stylesheetEl.setAttribute('href', url);
            document.body.appendChild(stylesheetEl);
        };
        TSLSService.prototype.fetchTemplate = function ($http, language, province, businessUnit, headFoot) {
            var xmlPath = xmlPaths[businessUnit];
            province = province.toLowerCase();
            language = language.toLowerCase();
            return $http({
                method: 'GET',
                url: xmlPath + headFoot + '-' + language + '-' + province + '.xml',
                cache: true
            });
        };
        TSLSService.$inject = [
            '$rootScope',
            '$window',
            'ute.blocks.language.switcher'
        ];
        return TSLSService;
    }());
    angular.module('ute.sse.tsls')
        .service('tslsService', TSLSService);
})(TSLSSSE || (TSLSSSE = {}));

var TSLSSSE;
(function (TSLSSSE) {
    'use strict';
    var TSLSLocaleProvider = (function () {
        function TSLSLocaleProvider(AppActionTypes) {
            this.AppActionTypes = AppActionTypes;
            this.cookieDomain = '.rogers.com';
            this.cookieCurrentDomain = window.location.hostname.replace(/(www|localhost)/g, '');
        }
        TSLSLocaleProvider.prototype.getInjector = function () {
            return angular.element(document.documentElement).injector();
        };
        TSLSLocaleProvider.prototype.getCookieService = function (currentDomain) {
            var cookieService = this.getInjector().get('ute.services.cookies.service');
            cookieService.config.basic.domain = currentDomain ? this.cookieCurrentDomain : this.cookieDomain;
            return cookieService;
        };
        TSLSLocaleProvider.prototype.setProvince = function (state) {
            var province = state.getIn(['app', 'province']);
            this.getCookieService().setCookie('province', province);
            this.getCookieService(true).setCookie('province', province);
        };
        TSLSLocaleProvider.prototype.setLanguage = function (state) {
            var language = state.getIn(['app', 'language']);
            this.getCookieService().setCookie('language', language);
            this.getCookieService(true).setCookie('language', language);
        };
        TSLSLocaleProvider.prototype.getLanguage = function () {
            return this.getCookieService().getCookie('language');
        };
        TSLSLocaleProvider.prototype.getProvince = function () {
            return this.getCookieService().getCookie('province');
        };
        TSLSLocaleProvider.prototype.getRootScope = function () {
            return this.getInjector().get('$rootScope');
        };
        // middleware is setup during the config phase and the injector is not the same as the app runtime injector
        // due to this there are some hacks used here to retrieve angular services in an unorthodox way.
        TSLSLocaleProvider.prototype.$get = function () {
            var _this = this;
            return function (store) { return function (next) { return function (action) {
                var AppActionTypes = _this.AppActionTypes;
                var result = next(action);
                var state = store.getState();
                switch (action.type) {
                    case AppActionTypes.REFRESH_PAGE:
                    case AppActionTypes.SET_LANGUAGE:
                    case AppActionTypes.SET_PROVINCE:
                        _this.setProvince(state);
                        _this.setLanguage(state);
                        break;
                    case AppActionTypes.SET_BUSINESS_UNIT:
                        var province = _this.getProvince();
                        var language = _this.getLanguage();
                        if (province !== state.getIn(['app', 'province'])) {
                            _this.getRootScope().$broadcast('ute.province.updated', province);
                        }
                        if (language !== state.getIn(['app', 'language'])) {
                            _this.getRootScope().$broadcast('ute.language.updated', language);
                        }
                        break;
                }
                return result;
            }; }; };
        };
        TSLSLocaleProvider.$inject = [
            'AppActionTypes'
        ];
        return TSLSLocaleProvider;
    }());
    angular.module('ute.sse.tsls').provider('TSLSLocale', TSLSLocaleProvider);
})(TSLSSSE || (TSLSSSE = {}));

var app;
(function (app) {
    var boot;
    (function (boot) {
        'use strict';
        (function () {
            /**
             * example of custom implementation of environment type detector
             */
            //ute.blocks.environment.EnvironmentStatic.getEnvType = () => {
            //  if (location.hostname.indexOf('www.rogers.com') === 0) {
            //    return ute.blocks.environment.EnvironmentType.PROD;
            //  } else if (location.hostname.indexOf('www.dev') === 0) {
            //    return ute.blocks.environment.EnvironmentType.DEV;
            //  } else if (location.hostname.indexOf('www.qa') === 0) {
            //    return ute.blocks.environment.EnvironmentType.QA;
            //  } else {
            //    return ute.blocks.environment.EnvironmentType.LOCAL;
            //  }
            //};
            /**
             * or example of custom implementation of environment path detector
             */
            //ute.blocks.environment.EnvironmentStatic.getEnvConfigPath = () => {
            //  return 'environments/customEnv.js';
            //};
            /**
             * bootstrap angular app after get environment config
             */
            ute.blocks.environment.EnvironmentStatic.getEnvConfig(function () {
                angular.element(document).ready(function () {
                    angular.bootstrap(document, ['app'], {
                        strictDi: true
                    });
                });
            });
        })();
    })(boot = app.boot || (app.boot = {}));
})(app || (app = {}));

var app;
(function (app) {
    var config;
    (function (config_1) {
        'use strict';
        angular.module('app.config')
            .config(['ute.common.core.cookies.cookieManagerServiceProvider', function ($cookieManagerProvider) {
                var config = {
                    basic: {
                        domain: '.rogers.com'
                    }
                };
                $cookieManagerProvider.configure(config);
            }]);
    })(config = app.config || (app.config = {}));
})(app || (app = {}));

var app;
(function (app) {
    var config;
    (function (config) {
        'use strict';
        angular.module('app.config')
            .config(['$translateProvider', function ($translateProvider) {
                $translateProvider.preferredLanguage('en');
                $translateProvider
                    .preferredLanguage('en')
                    .useSanitizeValueStrategy(null);
            }]);
    })(config = app.config || (app.config = {}));
})(app || (app = {}));

var ute;
(function (ute) {
    var core;
    (function (core) {
        'use strict';
        var config = {
            appErrorPrefix: '[foundation-sse error] ',
            appTitle: 'foundation-sse'
        };
        angular.module('ute.core').config(toastrConfig).config(configure).value('config', config);
        toastrConfig.$inject = ['toastr'];
        /* @ngInject */
        function toastrConfig(toastr) {
            toastr.options.timeOut = 4000;
            toastr.options.positionClass = 'toast-bottom-right';
        }
        configure.$inject = ['$logProvider', 'exceptionHandlerProvider', 'ute.blocks.routerProvider', 'ute.blocks.environmentProvider'];
        /* @ngInject */
        function configure($logProvider, exceptionHandlerProvider, routerHelperProvider, environmentProvider) {
            if ($logProvider.debugEnabled) {
                $logProvider.debugEnabled(true);
            }
            exceptionHandlerProvider.configure(config.appErrorPrefix);
            configureStateHelper();
            //environmentProvider.configureByEnvType({getEnvType: getEnvType});
            //
            ///**
            // * custom implementation
            // *
            // * @returns {ute.blocks.environment.EnvironmentType}
            // */
            //function getEnvType() {
            //  if (location.hostname.indexOf('www.rogers.com') === 0) {
            //    return ute.blocks.environment.EnvironmentType.PROD;
            //  } else if (location.hostname.indexOf('www.dev') === 0) {
            //    return ute.blocks.environment.EnvironmentType.DEV;
            //  } else if (location.hostname.indexOf('www.qa') === 0) {
            //    return ute.blocks.environment.EnvironmentType.QA;
            //  } else {
            //    return ute.blocks.environment.EnvironmentType.LOCAL;
            //  }
            //}
            function configureStateHelper() {
                var resolveAlways = {
                    /* @ngInject */
                    ready: ['ute.blocks.router.dataservice', function (dataservice) {
                            return dataservice.ready();
                        }]
                };
                routerHelperProvider.configure({
                    docTitle: '',
                    resolveAlways: resolveAlways
                });
            }
        }
    })(core = ute.core || (ute.core = {}));
})(ute || (ute = {}));

/* global toastr:false, moment:false */
var ute;
(function (ute) {
    var core;
    (function (core) {
        'use strict';
        angular.module('ute.core')
            .constant('toastr', toastr)
            .constant('moment', moment);
    })(core = ute.core || (ute.core = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var core;
    (function (core) {
        'use strict';
        function configureHTML5routes($locationProvider, $httpProvider) {
            $locationProvider.html5Mode({
                enabled: true
            });
            function requestInterceptor($rootScope, $ngRedux, moment) {
                return {
                    'request': function (config) {
                        var pattern = /^\/web\/totes\/api\/v1\/assembler/;
                        if (pattern.test(config.url)) {
                            config.params.site = $ngRedux.getState().getIn(['app', 'businessUnit']);
                            if (config.method === 'GET' && isPreviewMode()) {
                                var currentDate = moment.tz(new Date(), 'America/Toronto').format();
                                config.params.date = $rootScope.previewDateToSend ? $rootScope.previewDateToSend : currentDate;
                                config.params.unpublishedContent = $rootScope.unPublishedContent ? $rootScope.unPublishedContent : false;
                            }
                        }
                        return config;
                    }
                };
            }
            requestInterceptor.$inject = ['$rootScope', '$ngRedux', 'moment'];
            $httpProvider.interceptors.push(requestInterceptor);
        }
        configureHTML5routes.$inject = ['$locationProvider', '$httpProvider'];
        angular.module('ute.core').config(configureHTML5routes).run(appRun);
        appRun.$inject = [
            'ute.blocks.router',
            'ute.blocks.environment',
            '$rootScope',
            '$ngRedux'
        ];
        /* @ngInject */
        function appRun(routerHelper, environmentService, $rootScope, ngRedux) {
            var state = ngRedux.getState();
            var businessUnit = state.getIn(['app', 'businessUnit']);
            $.each(['', '/'], function (k, v) {
                routerHelper.when(v, environmentService.getProperty('apiUrls.signinState'));
            });
            $rootScope._isPreviewMode = isPreviewMode();
            $rootScope.businessUnit = businessUnit;
            routerHelper.configureStates(getStates(businessUnit), '/404');
        }
        var SearchController = (function () {
            function SearchController(AppActions, $scope) {
                this.AppActions = AppActions;
                this.$scope = $scope;
                this.$scope.AppActions = AppActions;
            }
            SearchController.$inject = [
                'AppActions',
                '$scope'
            ];
            return SearchController;
        }());
        function getStates(businessUnit) {
            // our base url is /customer
            // for enterprise the url will be /customer/enterprise
            // for smallbusiness: /customer/small-business
            // the following will build out the paths according to the site visited
            var siteInPath = window.location.pathname.split('/')[2];
            var sites = ['small-business', 'enterprise'];
            var prefix = sites.filter(function (site) { return site.indexOf(siteInPath) > -1; })[0] || '';
            return [
                {
                    name: '404',
                    url: '/404',
                    templateUrl: 'app/core/404.html',
                    data: {
                        title: '404',
                        security: {
                            roles: ['public']
                        }
                    }
                },
                {
                    name: 'search',
                    url: (!!prefix ? "/" + prefix : '') + '/search?searchTerm&dimensions',
                    template: '<ute-search-section app-actions="AppActions"></ute-search-section>',
                    data: {
                        title: 'Search',
                        security: {
                            roles: ['public']
                        }
                    },
                    controller: SearchController
                },
                {
                    name: 'support',
                    url: (!!prefix ? "/" + prefix : '') + '/support',
                    template: '<ute-support-section></ute-support-section>',
                    data: {
                        title: 'Support',
                        security: {
                            roles: ['public']
                        }
                    },
                    abstract: true
                },
                {
                    name: 'support.article',
                    url: '/article/:articleId/:childArticleId',
                    params: {
                        childArticleId: {
                            value: null,
                            squash: true
                        }
                    },
                    data: {
                        title: 'Support',
                        security: {
                            roles: ['public']
                        }
                    }
                }
            ];
        }
        function isPreviewMode() {
            return window.location.hostname.split('.')[0] === 'preview';
        }
    })(core = ute.core || (ute.core = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var layout;
        (function (layout) {
            'use strict';
            var ShellController = (function () {
                /* @ngInject */
                function ShellController(config, $ngRedux, $modal, $scope, AppActions //ng.IScope
                    ) {
                    var _this = this;
                    this.config = config;
                    this.$ngRedux = $ngRedux;
                    this.$modal = $modal;
                    this.$scope = $scope;
                    this.AppActions = AppActions;
                    this.headerType = function () {
                        switch (_this.businessUnit) {
                            case 'consumer':
                                return 'sse';
                            default:
                                return 'dca';
                        }
                    };
                    /**
                     * Open the following overlay when use click on search from the header
                     */
                    this.openSearch = function () {
                        var modal = _this.$modal.open({
                            templateUrl: 'app/layout/typeahead-modal/typeahead.modal.view.html',
                            controller: 'ute.blocks.layout.modal.controller',
                            controllerAs: 'typeAheadModal',
                            size: 'md',
                            backdrop: 'static',
                            resolve: {
                                'ute.blocks.layout.language': function () { return _this.language; },
                                'ute.blocks.layout.province': function () { return _this.province; }
                            }
                        });
                        modal.result.then(function (result) {
                            // Result selection behaviour
                            switch (result) {
                                case 'yes':
                                    break;
                                case 'no':
                                    break;
                            }
                        });
                        /* tslint:disable */
                        // TODO: fix typings so modal.rendered is recognized
                        var focusInput = function () { return angular.element('.modal ute-sse-typeahead')[0]['inputField'].focus(); };
                        modal['rendered'].then(function () {
                            focusInput();
                            setTimeout(focusInput, 1000);
                        });
                        /* tslint:enable */
                    };
                    // unsubscribe from Redux updates when controller is destroyed
                    var unsubscribe = $ngRedux.connect(this.mapStateToThis, AppActions)(this);
                    $scope.$on('$destroy', unsubscribe);
                    this.$scope.$root.browserTitle = this.browserTitle;
                    this.$scope.$root.browserSeo = this.browserSeo;
                    var storeUnsubscribe = $ngRedux.subscribe(function () {
                        var state = $ngRedux.getState();
                        _this.$scope.$root.browserTitle = state.getIn(['app', 'browserTitle']);
                        _this.$scope.$root.browserSeo = state.getIn(['app', 'browserSeo']).toJS();
                    });
                    $scope.$on('$destroy', storeUnsubscribe);
                }
                // map Redux store's properties to controller properties
                ShellController.prototype.mapStateToThis = function (state) {
                    return {
                        language: state.getIn(['app', 'language']),
                        province: state.getIn(['app', 'province']),
                        browserTitle: state.getIn(['app', 'browserTitle']),
                        browserSeo: state.getIn(['app', 'browserSeo']).toJS(),
                        businessUnit: state.getIn(['app', 'businessUnit'])
                    };
                };
                ShellController.$inject = [
                    'config',
                    '$ngRedux',
                    '$modal',
                    '$scope',
                    'AppActions'
                ];
                return ShellController;
            }());
            angular.module('ute.blocks.layout').controller('ShellController', ShellController);
        })(layout = blocks.layout || (blocks.layout = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var app;
(function (app) {
    'use strict';
    var defaultRouter = Immutable.fromJS({
        uiState: {},
        uiParams: {}
    });
    var defaultLanguage = Immutable.fromJS('en');
    var defaultProvince = Immutable.fromJS('ON');
    var AppReducerProvider = (function () {
        function AppReducerProvider(AppActionTypes, SupportActionTypes) {
            this.AppActionTypes = AppActionTypes;
            this.SupportActionTypes = SupportActionTypes;
        }
        AppReducerProvider.prototype.language = function (state, action) {
            if (state === void 0) { state = defaultLanguage; }
            switch (action.type) {
                case this.AppActionTypes.SET_LANGUAGE:
                    return action.language;
                default:
                    return state;
            }
        };
        AppReducerProvider.prototype.browserTitle = function (state, action) {
            if (state === void 0) { state = Immutable.fromJS(''); }
            switch (action.type) {
                case this.AppActionTypes.SET_BROWSER_METADATA:
                    return action.title;
                default:
                    return state;
            }
        };
        AppReducerProvider.prototype.broweserSeo = function (state, action) {
            if (state === void 0) { state = Immutable.fromJS({ title: '', description: '' }); }
            switch (action.type) {
                case this.AppActionTypes.SET_BROWSER_SEO:
                    return Immutable.fromJS({
                        title: action.seo ? action.seo.title : '',
                        description: action.seo ? action.seo.description : ''
                    });
                default:
                    return state;
            }
        };
        AppReducerProvider.prototype.province = function (state, action) {
            if (state === void 0) { state = defaultProvince; }
            switch (action.type) {
                case this.AppActionTypes.SET_PROVINCE:
                    return action.province;
                default:
                    return state;
            }
        };
        AppReducerProvider.prototype.router = function (state, action) {
            if (state === void 0) { state = defaultRouter; }
            switch (action.type) {
                case this.AppActionTypes.SET_ROUTE_DETAILS:
                    return Immutable.fromJS({
                        uiState: action.uiState,
                        uiParams: action.uiParams
                    });
                default:
                    return state;
            }
        };
        AppReducerProvider.prototype.activeApiCalls = function (state, action) {
            if (state === void 0) { state = 0; }
            switch (action.type) {
                case this.SupportActionTypes.FETCH_SUPPORT_ARTICLE:
                    return state + 1;
                case this.SupportActionTypes.SET_SUPPORT_ARTICLE:
                    return Math.max(0, state - 1);
                default:
                    return state;
            }
        };
        AppReducerProvider.prototype.businessUnit = function (state, action) {
            if (state === void 0) { state = 'consumer'; }
            switch (action.type) {
                case this.AppActionTypes.SET_BUSINESS_UNIT:
                    return action.value;
                default:
                    return state;
            }
        };
        AppReducerProvider.prototype.$get = function () {
            var self = this;
            return function (state, action) {
                if (state === void 0) { state = Immutable.Map({}); }
                return state.merge({
                    browserTitle: self.browserTitle(state.get('browserTitle'), action),
                    browserSeo: self.broweserSeo(state.get('browserSeo'), action),
                    language: self.language(state.get('language'), action),
                    province: self.province(state.get('province'), action),
                    router: self.router(state.get('router'), action),
                    activeApiCalls: self.activeApiCalls(state.get('activeApiCalls'), action),
                    businessUnit: self.businessUnit(state.get('businessUnit'), action)
                });
            };
        };
        AppReducerProvider.$inject = ['AppActionTypes', 'SupportActionTypes'];
        return AppReducerProvider;
    }());
    angular.module('app.reducer', [
        'app.actions',
        'ute.common.supportSection.actions'
    ])
        .provider('AppReducer', AppReducerProvider);
})(app || (app = {}));

var app;
(function (app) {
    'use strict';
    var DtmProvider = (function () {
        function DtmProvider() {
        }
        DtmProvider.isMobileDevice = function (window) {
            return (window.screen.width <= 768) ? 'mobile' : 'desktop';
        };
        DtmProvider.getSearchFilterName = function (searchFilters, dimensions) {
            var filterName;
            searchFilters.filter(function (obj) {
                if (dimensions === obj.dimensionValue) {
                    filterName = obj.displayName;
                }
            });
            return filterName;
        };
        DtmProvider.getSiteName = function (state) {
            switch (state.getIn(['app', 'businessUnit'])) {
                case 'smallbusiness':
                    return 'R-BIZ';
                case 'enterprise':
                    return 'R-ENT';
                default:
                    return 'R';
            }
        };
        DtmProvider.prototype.getSearchPayload = function (action, state, $window) {
            var refferer = window.document.referrer;
            var refferurl = document.createElement('a');
            refferurl.href = refferer;
            var refferPathName = refferurl.pathname;
            var type = (refferPathName.search('consumer/support/') > 0) ? 'support' : 'global';
            return {
                site: {
                    name: DtmProvider.getSiteName(state)
                },
                page: {
                    name: 'search',
                    hierarchy: ['search results'],
                    url: $window.location.href,
                    language: state.getIn(['app', 'language']).toLowerCase(),
                    province: state.getIn(['app', 'province']).toLowerCase(),
                    referrer: $window.document.referrer,
                    responsiveVersion: DtmProvider.isMobileDevice($window)
                },
                search: {
                    type: type,
                    keyword: state.getIn(['search', 'searchTerm']),
                    resultCount: state.getIn(['search', 'results', 'count']),
                    resultsPerPage: state.getIn(['search', 'pagination', 'recordsPerPage']),
                    pageNumber: state.getIn(['search', 'pagination', 'current'])
                },
                events: {
                    type: type,
                    pageView: true,
                    search: action.paginated ? undefined : true
                }
            };
        };
        DtmProvider.prototype.getArticlePayload = function (action, state, $window) {
            return {
                site: {
                    name: DtmProvider.getSiteName(state)
                },
                page: {
                    name: state.getIn(['support', 'article', 'seoUrl']),
                    hierarchy: ['support', 'article'],
                    url: $window.location.href,
                    language: state.getIn(['app', 'language']).toLowerCase(),
                    province: state.getIn(['app', 'province']).toLowerCase(),
                    referrer: $window.document.referrer,
                    responsiveVersion: DtmProvider.isMobileDevice($window)
                },
                article: {
                    title: state.getIn(['support', 'article', 'title']),
                    type: action.assemblerData.article.supportDetails.contentType,
                    lob: state.getIn(['support', 'article', 'lob'])
                },
                events: {
                    pageView: true,
                    articleView: true
                }
            };
        };
        DtmProvider.prototype.getChildArticlePayload = function (action, state, $window) {
            var payload = this.getArticlePayload(action, state, $window);
            var href = $window.location.href.split('/');
            payload.article.title = state.getIn(['support', 'childArticle', 'title']);
            payload.page.name = payload.page.name + '/' + href[href.length - 1];
            return payload;
        };
        DtmProvider.prototype.getClickSearchResultPayload = function (action, state, $window) {
            return {
                search: {
                    resultsPerPage: state.getIn(['search', 'pagination', 'recordsPerPage']),
                    pageNumber: state.getIn(['search', 'pagination', 'current']),
                    resultLink: {
                        position: (function (pos) { return pos + 1; })(Number(action.index)),
                        url: $window.location.href.replace(/\/[^\/]+$/, '') + "/support/article/" + action.sref,
                        name: action.title
                    }
                },
                events: {
                    searchResultClick: true
                }
            };
        };
        DtmProvider.prototype.getSearchFiltersPayload = function (action, state, $window) {
            return {
                search: {
                    filters: {
                        type: 'filter your results',
                        name: (DtmProvider.getSearchFilterName(action.filters, action.dimensions))
                            ? DtmProvider.getSearchFilterName(action.filters, action.dimensions)
                            : ''
                    }
                },
                events: (action.isChecked) ? { searchFilterAdd: true } : { searchFilterRemove: true }
            };
        };
        DtmProvider.prototype.getArticleFeedbackPayload = function (action, state, $window) {
            return {
                article: {
                    helpfulness: action.feedback
                },
                events: {
                    articleHelp: true
                }
            };
        };
        DtmProvider.prototype.$get = function () {
            return {
                getSearchPayload: this.getSearchPayload,
                getArticlePayload: this.getArticlePayload,
                getChildArticlePayload: this.getChildArticlePayload,
                getClickSearchResultPayload: this.getClickSearchResultPayload,
                getSearchFiltersPayload: this.getSearchFiltersPayload,
                getArticleFeedbackPayload: this.getArticleFeedbackPayload
            };
        };
        return DtmProvider;
    }());
    angular.module('app.services.dtm', [])
        .provider('Dtm', DtmProvider);
})(app || (app = {}));

var app;
(function (app) {
    'use strict';
    angular.module('app.services', [
        'app.services.localization'
    ]);
})(app || (app = {}));

var app;
(function (app) {
    'use strict';
    var defaultLanguage = 'en';
    var LocalizationService = (function () {
        function LocalizationService($translate, $window) {
            this.$translate = $translate;
            this.$window = $window;
        }
        LocalizationService.prototype.setLanguage = function (language) {
            this.$translate.use(language);
            angular.element('html').attr('lang', language); // Added to correct CMS styling issues
            this.changeRecaptchaLanguage(language);
        };
        LocalizationService.prototype.changeRecaptchaLanguage = function (language) {
            if (this.$window.document.querySelector('.g-recaptcha')) {
                this.$window.document.querySelector('.g-recaptcha').innerHTML = '';
                var script = document.createElement('script');
                script.src = 'https://www.google.com/recaptcha/api.js?hl=' + language;
                script.async = true;
                script.defer = true;
                this.$window.document.querySelector('head').appendChild(script);
            }
        };
        LocalizationService.$inject = ['$translate', '$window'];
        return LocalizationService;
    }());
    angular.module('app.services.localization', [
        'pascalprecht.translate'
    ])
        .config(['$translateProvider', function ($translateProvider) {
            $translateProvider.preferredLanguage(defaultLanguage);
        }])
        .service('localizationService', LocalizationService);
})(app || (app = {}));

var app;
(function (app) {
    var store;
    (function (store) {
        'use strict';
        angular.module('app.store', [
            'app.store.config',
            'app.store.eventDispatchers'
        ]);
    })(store = app.store || (app.store = {}));
})(app || (app = {}));

var app;
(function (app) {
    var store;
    (function (store) {
        'use strict';
        angular.module('app.store.config', [
            'app.store.defaultAppStore',
            'app.store.middleware',
            'ute.common.searchSection',
            'ute.common.supportSection',
            'ute.sse.tsls',
            'ngRedux'
        ])
            .config([
            '$windowProvider',
            '$ngReduxProvider',
            'DtmMiddlewareProvider',
            'AppReducerProvider',
            'SearchReducerProvider',
            'SupportReducerProvider',
            'defaultAppStore',
            'TSLSLocaleProvider',
            function ($windowProvider, $ngReduxProvider, DtmMiddlewareProvider, AppReducerProvider, SearchReducerProvider, SupportReducerProvider, defaultAppStore, TSLSLocaleProvider) {
                var $window = $windowProvider.$get();
                // const Redux = $window.Redux;
                var ReduxThunk = $window.ReduxThunk.default;
                var dtmMiddleware = DtmMiddlewareProvider.$get();
                var tslsLocaleMiddleWare = TSLSLocaleProvider.$get();
                var AppReducer = AppReducerProvider.$get();
                var SearchReducer = SearchReducerProvider.$get();
                var SupportReducer = SupportReducerProvider.$get();
                var reducers = function (state, action) {
                    if (state === void 0) { state = defaultAppStore; }
                    return state
                        .withMutations(function (temporaryState) {
                        return temporaryState
                            .set('app', AppReducer(state.get('app'), action))
                            .set('search', SearchReducer(state.get('search'), action))
                            .set('support', SupportReducer(state.get('support'), action));
                    });
                };
                $ngReduxProvider.createStoreWith(reducers, [
                    ReduxThunk,
                    /*          Redux.createLogger({
                                stateTransformer: state => {
                                  return state.toJS();
                                }
                              }),*/
                    dtmMiddleware,
                    tslsLocaleMiddleWare
                ], null, defaultAppStore);
            }
        ]);
    })(store = app.store || (app.store = {}));
})(app || (app = {}));

var app;
(function (app) {
    var store;
    (function (store) {
        'use strict';
        var SseAppStore = Immutable.fromJS({
            app: {
                activeApiCalls: 0,
                language: 'en',
                province: 'ON',
                router: {
                    uiState: {},
                    uiParams: {}
                },
                browserTitle: '',
                browserSeo: {
                    title: '',
                    description: ''
                }
            },
            support: {
                browserTitleKey: 'ute.common.supportPage.browserTitle',
                printKey: 'ute.common.searchPage.print',
                emailKey: 'ute.common.searchPage.email',
                dimensions: {
                    type: '',
                    list: []
                },
                breadcrumbs: [{
                        translationKey: 'ute.common.supportPage.breadcrumbsBar.labelMain'
                    }],
                article: {
                    contents: [],
                    dimensions: {},
                    seoUrl: '',
                    seo: {}
                },
                articleFeedback: {
                    feedbackQuestion: {
                        labelKey: 'ute.common.supportPage.articleFeedback.feedbackQuestion.label',
                        yesButtonKey: 'ute.common.supportPage.articleFeedback.feedbackQuestion.yesButton',
                        noButtonKey: 'ute.common.supportPage.articleFeedback.feedbackQuestion.noButton',
                    },
                    feedbackForm: {
                        answerCountBeforeKey: 'ute.common.supportPage.articleFeedback.feedbackForm.answerCountBefore',
                        answerCountAfterKey: 'ute.common.supportPage.articleFeedback.feedbackForm.answerCountAfter',
                        captchaLabelKey: 'ute.common.supportPage.articleFeedback.feedbackForm.captchaLabel',
                        captchaKey: '6LeU8CUTAAAAAONoXYkhfUc-9a3w4jBgGCvhbavs',
                        requiredErrorKey: 'ute.common.supportPage.articleFeedback.feedbackForm.requiredError',
                        maxLengthErrorKey: 'ute.common.supportPage.articleFeedback.feedbackForm.maxLengthError',
                        captchaErrorKey: 'ute.common.supportPage.articleFeedback.feedbackForm.captchaError',
                        resetButtonKey: 'ute.common.supportPage.articleFeedback.feedbackForm.resetButton',
                        submitButtonKey: 'ute.common.supportPage.articleFeedback.feedbackForm.submitButton',
                        thankYouTitleKey: 'ute.common.supportPage.articleFeedback.feedbackForm.thankYouTitle',
                        thankYouDescriptionKey: 'ute.common.supportPage.articleFeedback.feedbackForm.thankYouDescription'
                    },
                    feedbackAnswerYes: {
                        labelKey: 'ute.common.supportPage.articleFeedback.feedbackAnswerYes.label'
                    },
                    feedbackAnswerNo: {
                        mainLabelKey: 'ute.common.supportPage.articleFeedback.feedbackAnswerNo.mainLabel',
                        labelKey: 'ute.common.supportPage.articleFeedback.feedbackAnswerNo.label',
                        chatLabelFirstKey: 'ute.common.supportPage.articleFeedback.feedbackAnswerNo.chatLabelFirst',
                        chatLabelSecondKey: 'ute.common.supportPage.articleFeedback.feedbackAnswerNo.chatLabelSecond'
                    }
                },
                childArticle: {
                    contents: []
                }
            },
            search: {
                browserTitleKey: 'ute.common.searchPage.browserTitle',
                searchTerm: '',
                dimensions: '',
                breadcrumbs: [
                    { translationKey: 'ute.common.searchPage.breadcrumbsBar.labelMain' },
                    { translationKey: 'ute.common.searchPage.breadcrumbsBar.labelSecond' }
                ],
                searchBar: {
                    labelKey: 'ute.common.searchPage.searchBar.label',
                    inputLabelKey: 'ute.common.searchPage.searchBar.inputLabel',
                    submitTextKey: 'ute.common.searchPage.searchBar.submitText',
                    placeholderKey: 'ute.common.searchPage.searchBar.placeholder'
                },
                filters: {
                    labelKey: 'ute.common.searchPage.searchFilter.label',
                    countLabelKey: 'ute.common.searchPage.searchFilter.countLabel',
                    list: []
                },
                pagination: {
                    start: 1,
                    end: 1,
                    current: 1,
                    total: 1,
                    recordsPerPage: 10
                },
                results: {
                    label: 'Search Results',
                    list: [],
                    count: null
                },
                callout: {
                    list: []
                },
                tvGuide: {
                    label: 'Rogers TV Guide',
                    list: []
                }
            },
            '404': {
                browserTitleKey: 'ute.common.404Page.browserTitle',
            },
            assembler: {}
        });
        angular.module('app.store.defaultAppStore', [])
            .constant('defaultAppStore', SseAppStore);
    })(store = app.store || (app.store = {}));
})(app || (app = {}));

var app;
(function (app) {
    var store;
    (function (store) {
        'use strict';
        angular.module('app.store.eventDispatchers', [
            'rx',
            'ute.blocks.messages.bus',
            'ute.services.cookies'
        ])
            .run([
            'rx',
            '$ngRedux',
            '$rootScope',
            'defaultAppStore',
            'AppActions',
            'ute.services.cookies.service',
            function (rx, $ngRedux, $rootScope, defaultAppStore, AppActions, cookieService) {
                // tslint:disable:no-unused-variable
                // todo: come up with a way to avoid disabling tslint
                var businessUnitFor = function (path) {
                    switch (path) {
                        case 'small-business':
                            return 'smallbusiness';
                        case 'enterprise':
                            return 'enterprise';
                        default:
                            return 'consumer';
                    }
                };
                var province$ = $rootScope.$eventToObservable('ute.province.updated')
                    .map(function (_a) {
                    var event = _a[0], province = _a[1];
                    return province;
                });
                var language$ = $rootScope.$eventToObservable('ute.language.updated')
                    .map(function (_a) {
                    var event = _a[0], language = _a[1];
                    return language;
                });
                var uiRouter$ = $rootScope.$eventToObservable('$stateChangeSuccess')
                    .map(function (_a) {
                    var event = _a[0], toState = _a[1], toParams = _a[2];
                    return ({
                        router: { uiState: toState, uiParams: toParams },
                        businessUnit: businessUnitFor(window.location.pathname.split('/')[2])
                    });
                });
                rx.Observable.combineLatest(language$, province$, uiRouter$, function (language, province, uiRouteData) { return ({
                    language: language,
                    province: province,
                    uiRouteData: uiRouteData
                }); })
                    .subscribe(function (_a) {
                    var language = _a.language, province = _a.province, uiRouteData = _a.uiRouteData;
                    try {
                        $ngRedux.dispatch(AppActions.refreshPage(language, province, uiRouteData.router, uiRouteData.businessUnit));
                    }
                    catch (e) {
                        console.error('uncaught exception', e);
                    }
                });
                //HACK to make above subscription work for first change as well.
                var appConfig = defaultAppStore.toJS().app;
                $rootScope.$emit('ute.province.updated', cookieService.getCookie('province') || appConfig.province);
                $rootScope.$emit('ute.language.updated', cookieService.getCookie('language') || appConfig.language);
            }
        ]);
    })(store = app.store || (app.store = {}));
})(app || (app = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                var TypeAheadModalController = (function () {
                    /* @ngInject */
                    function TypeAheadModalController($modalInstance, language, province) {
                        this.$modalInstance = $modalInstance;
                        this.language = language;
                        this.province = province;
                    }
                    TypeAheadModalController.prototype.cancel = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    TypeAheadModalController.$inject = [
                        '$modalInstance',
                        'ute.blocks.layout.language',
                        'ute.blocks.layout.province'
                    ];
                    return TypeAheadModalController;
                }());
                edit.TypeAheadModalController = TypeAheadModalController;
                angular.module('ute.blocks.layout').controller('ute.blocks.layout.modal.controller', TypeAheadModalController);
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var date;
    (function (date) {
        var time;
        (function (time) {
            var picker;
            (function (picker) {
                'use strict';
                var DateTimePickerController = (function () {
                    /* @ngInject */
                    function DateTimePickerController($ngRedux, $scope, $rootScope, $log, $state, moment) {
                        this.$ngRedux = $ngRedux;
                        this.$scope = $scope;
                        this.$rootScope = $rootScope;
                        this.$log = $log;
                        this.$state = $state;
                        this.moment = moment;
                        $scope.hourstep = 1;
                        $scope.minutestep = 15;
                        $scope.ismeridian = false; //AM or PM
                        $scope.showPreviewDropDown = false;
                        $scope.showDropDown = function () {
                            $scope.showPreviewDropDown = !$scope.showPreviewDropDown;
                        };
                        $scope.apply = function () {
                            $scope.showPreviewDropDown = false;
                            $rootScope.previewDateToSend = $scope.getPreviewDate();
                            $rootScope.unPublishedContent = $scope.unPublishedContent;
                            $state.reload();
                        };
                        $scope.options = {
                            minDate: new Date(),
                            showWeeks: false
                        };
                        $scope.dates = {};
                        $scope.today = function () {
                            $scope.dates.dateToSend = $scope.dates.timeTosend = new Date();
                        };
                        $scope.today();
                        $scope.dates.dateToSend = $scope.dates.timeTosend = $scope.dates.dateTimeToSend = new Date(); //selected date
                        $scope.dates.timeTosend.setMinutes(0); //selected time
                        $scope.dates.timeTosend.setSeconds(0); //selected time
                        $scope.getPreviewDate = function () {
                            var simpleDate = new Date($scope.dates.dateToSend.getFullYear(), $scope.dates.dateToSend.getMonth(), $scope.dates.dateToSend.getDate(), $scope.dates.timeTosend.getHours(), $scope.dates.timeTosend.getMinutes(), $scope.dates.timeTosend.getSeconds());
                            return $scope.dates.dateTimeToSend = moment.tz(simpleDate, 'America/Toronto').format();
                        };
                    }
                    DateTimePickerController.$inject = [
                        '$ngRedux',
                        '$scope',
                        '$rootScope',
                        '$log',
                        '$state',
                        'moment'
                    ];
                    return DateTimePickerController;
                }());
                angular.module('ute.date.time.picker').controller('DateTimePickerController', DateTimePickerController);
            })(picker = time.picker || (time.picker = {}));
        })(time = date.time || (date.time = {}));
    })(date = ute.date || (ute.date = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var date;
    (function (date) {
        var time;
        (function (time) {
            var picker;
            (function (picker) {
                'use strict';
                var DateTimePicker = (function () {
                    function DateTimePicker() {
                        this.templateUrl = 'app/module/datetimepicker/dateTimePicker.directive.view.html';
                        this.restrict = 'EA';
                        this.scope = {};
                        this.controller = 'DateTimePickerController';
                        //
                    }
                    DateTimePicker.factory = function () {
                        var directive = function () { return new DateTimePicker(); };
                        directive.$inject = [];
                        return directive;
                    };
                    return DateTimePicker;
                }());
                angular.module('ute.date.time.picker').directive('uteDateTimePicker', DateTimePicker.factory());
            })(picker = time.picker || (time.picker = {}));
        })(time = date.time || (date.time = {}));
    })(date = ute.date || (ute.date = {}));
})(ute || (ute = {}));

var app;
(function (app) {
    var store;
    (function (store_1) {
        'use strict';
        var DtmMiddlewareProvider = (function () {
            function DtmMiddlewareProvider($windowProvider, DtmProvider) {
                this.$window = $windowProvider.$get();
                this.dtmService = DtmProvider.$get();
            }
            DtmMiddlewareProvider.prototype.$get = function () {
                var _this = this;
                return function (store) { return function (next) { return function (action) {
                    var result = next(action);
                    var state = store.getState();
                    if (_this.$window._trackData) {
                        switch (action.type) {
                            case 'SET_SEARCH_RESULTS':
                                _this.$window._trackData(_this.dtmService.getSearchPayload(action, state, _this.$window));
                                break;
                            case 'SET_PAGINATED_SEARCH_RESULTS':
                                action.paginated = true;
                                _this.$window._trackData(_this.dtmService.getSearchPayload(action, state, _this.$window));
                                break;
                            case 'SET_SUPPORT_ARTICLE':
                                if (!state.getIn(['app', 'router', 'uiParams', 'childArticleId'])) {
                                    _this.$window._trackData(_this.dtmService.getArticlePayload(action, state, _this.$window));
                                }
                                break;
                            case 'SET_SUPPORT_CHILD_ARTICLE':
                                _this.$window._trackData(_this.dtmService.getChildArticlePayload(action, state, _this.$window));
                                break;
                            case 'SET_FILTERED_SEARCH_RESULTS':
                                _this.$window._trackData(_this.dtmService.getSearchFiltersPayload(action, state, _this.$window));
                                break;
                            case 'CLICK_SEARCH_RESULT':
                                _this.$window._trackData(_this.dtmService.getClickSearchResultPayload(action, state, _this.$window));
                                break;
                            case 'ARTICLE_FEEDBACK_SUBMITTED':
                                _this.$window._trackData(_this.dtmService.getArticleFeedbackPayload(action, state, _this.$window));
                                break;
                        }
                    }
                    else {
                        console.error('_trackData function missing');
                    }
                    return result;
                }; }; };
            };
            return DtmMiddlewareProvider;
        }());
        angular.module('app.store.middleware', [
            'app.services.dtm'
        ])
            .provider('DtmMiddleware', [
            '$windowProvider',
            'DtmProvider',
            DtmMiddlewareProvider
        ]);
    })(store = app.store || (app.store = {}));
})(app || (app = {}));



angular.module("ute.core").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/404.html","<div><h1>404</h1></div>");
$templateCache.put("app/layout/shell.html","<ute-date-time-picker ng-if=\"_isPreviewMode\"></ute-date-time-picker><div data-ng-controller=\"ShellController as vm\" class=\"container\"><header class=\"clearfix\" ng-class=\"vm.headerType() === \'dca\' ? \'ute-dca\' : \'consumer\'\"><tsls-header ng-class=\"{\'preview-enabled\': _isPreviewMode}\"></tsls-header></header><section id=\"content\" class=\"content\"><div data-ui-view=\"\" class=\"shuffle-animation\"></div></section></div>");
$templateCache.put("app/resource/header.html","<header role=\"banner\" class=\"navbar navbar-fixed-top ute\" ng-class=\"[headerTypeClass()]\" ute-user=\"\" ute-context=\"\" ute-customer-context=\"\"><div class=\"container\"><input type=\"checkbox\" id=\"mobile-menu\" class=\"check-mobile-menu\"> <label class=\"menu-button\" for=\"mobile-menu\" ute-tracking=\"rogers:header:togglemobilemenu\"><i class=\"ute-icon-menu\"></i></label> <a href=\"/\" class=\"nav-brand\"></a><div class=\"nav-search\"><a ng-click=\"vm.openSearch()\" title=\"Search\" ute-tracking=\"header:opensearch\"><i class=\"ute-icon-search\"></i> <span><ins translate=\"global.cta.search\"></ins></span></a></div><nav class=\"nav-bar\"><div class=\"log-in-block\"><a ng-click=\"hdr.login()\" ute-tracking=\"header:login\" ng-hide=\"hdr.isLoggedIn\"><ins translate=\"global.label.signInAndRegister\"></ins><i class=\"ute-icon-chevron-right\"></i></a> <span class=\"signed-user\" ng-show=\"hdr.isLoggedIn\"><i class=\"ute-icon-lock-small\"></i><ins translate=\"global.label.welcome\"></ins><span ute-username=\"\"></span></span><ute-user-signout><span class=\"signout\" ng-show=\"hdr.isLoggedIn\"><ins translate=\"global.label.signOut\"></ins><i class=\"ute-icon-chevron-right\"></i></span></ute-user-signout></div><div class=\"cfa-rep-view\"><div class=\"cfa-view-block\"><div class=\"rep-view\"><span><ins translate=\"global.label.repView\"></ins></span></div><div class=\"customer-view cv-avail\"><span><ins translate=\"retail.label.customerViewNotAvailable\"></ins></span> <span><ins translate=\"global.label.customerView\"></ins></span></div></div><div class=\"cfa-bgd\"></div></div><ul class=\"nav-primary\" id=\"nav-main\"><li><ute-header-link nav-to=\"findStore\" tracking=\"header:storelocator\"></ute-header-link></li><li><ute-header-link nav-to=\"shop\" tracking=\"header:mainmenu:click:shop\"></ute-header-link><ul><li><ute-header-link nav-to=\"wirelessShop\" tracking=\"header:mainmenu:click:wirelessShop\"></ute-header-link></li><li><ute-header-link nav-to=\"bundlesShop\" tracking=\"header:mainmenu:click:bundlesShop\"></ute-header-link></li><li><ute-header-link nav-to=\"tvShop\" tracking=\"header:mainmenu:click:tvShop\"></ute-header-link></li><li><ute-header-link nav-to=\"internetShop\" tracking=\"header:mainmenu:click:internetShop\"></ute-header-link></li><li><ute-header-link nav-to=\"homePhoneShop\" tracking=\"header:mainmenu:click:homePhoneShop\"></ute-header-link></li><li><ute-header-link nav-to=\"wirelessHomePhoneShop\" tracking=\"header:mainmenu:click:wirelessHomePhoneShop\"></ute-header-link></li><li><ute-header-link nav-to=\"homeMonitoringShop\" tracking=\"header:mainmenu:click:homeMonitoringShop\"></ute-header-link></li></ul></li><li><ute-header-link nav-to=\"support\" tracking=\"header:mainmenu:click:support\"></ute-header-link><ul><li><ute-header-link nav-to=\"wirelessSupport\" tracking=\"header:mainmenu:click:wirelessSupport\"></ute-header-link></li><li><ute-header-link nav-to=\"internetSupport\" tracking=\"header:mainmenu:click:internetSupport\"></ute-header-link></li><li><ute-header-link nav-to=\"tvSupport\" tracking=\"header:mainmenu:click:tvSupport\"></ute-header-link></li><li><ute-header-link nav-to=\"homePhoneSupport\" tracking=\"header:mainmenu:click:homePhoneSupport\"></ute-header-link></li><li><ute-header-link nav-to=\"homeMonitoringSupport\" tracking=\"header:mainmenu:click:homeMonitoringSupport\"></ute-header-link></li><li><ute-header-link nav-to=\"billingAndAccount\" tracking=\"header:mainmenu:click:billingAndAccount\"></ute-header-link></li><li><ute-header-link nav-to=\"additionalServices\" tracking=\"header:mainmenu:click:additionalServices\"></ute-header-link></li></ul></li><li class=\"myrogers\"><ute-header-link nav-to=\"myRogers\" tracking=\"header:mainmenu:click:myRogers\"></ute-header-link></li><li><ute-header-link nav-to=\"rewards\" tracking=\"header:mainmenu:click:rewards\"></ute-header-link><ul><li><ute-header-link nav-to=\"browse\" tracking=\"header:mainmenu:click:browse\"></ute-header-link></li><li><ute-header-link nav-to=\"myWishList\" tracking=\"header:mainmenu:click:myWishList\"></ute-header-link></li><li><ute-header-link nav-to=\"membership\" tracking=\"header:mainmenu:click:membership\"></ute-header-link></li></ul></li><li><ute-header-link nav-to=\"more\" tracking=\"header:mainmenu:click:more\"></ute-header-link><ul><li><ute-header-link nav-to=\"rogersNHLGameCentreLive\" tracking=\"header:mainmenu:click:rogersNHLGameCentreLive\"></ute-header-link></li><li><ute-header-link nav-to=\"rogersOnDemand\" tracking=\"header:mainmenu:click:rogersOnDemand\"></ute-header-link></li><li><ute-header-link nav-to=\"shomi\" tracking=\"header:mainmenu:click:shomi\"></ute-header-link></li><li><ute-header-link nav-to=\"spotify\" tracking=\"header:mainmenu:click:spotify\"></ute-header-link></li><li><ute-header-link nav-to=\"texture\" tracking=\"header:mainmenu:click:texture\"></ute-header-link></li><li><ute-header-link nav-to=\"connected\" tracking=\"header:mainmenu:click:connected\"></ute-header-link></li><li><ute-header-link nav-to=\"tsc\" tracking=\"header:mainmenu:click:tsc\"></ute-header-link></li><li><ute-header-link nav-to=\"rogersBank\" tracking=\"header:mainmenu:click:rogersBank\"></ute-header-link></li></ul></li><li><ute-header-link nav-to=\"promotions\" tracking=\"header:mainmenu:click:promos\"></ute-header-link><ul><li><ute-header-link nav-to=\"wirelessPromos\" tracking=\"header:mainmenu:click:wirelessPromos\"></ute-header-link></li><li><ute-header-link nav-to=\"internetPromos\" tracking=\"header:mainmenu:click:internePromos\"></ute-header-link></li><li><ute-header-link nav-to=\"tvPromos\" tracking=\"header:mainmenu:click:tvPromos\"></ute-header-link></li><li><ute-header-link nav-to=\"homeMonitoringPromos\" tracking=\"header:mainmenu:click:homeMonitoringPromos\"></ute-header-link></li><li><ute-header-link nav-to=\"homePhonePromos\" tracking=\"header:mainmenu:click:homePhonePromos\"></ute-header-link></li><li><ute-header-link nav-to=\"bundlesPromos\" tracking=\"header:mainmenu:click:bundlesPromos\"></ute-header-link></li></ul></li><li><ute-header-link nav-to=\"business\" tracking=\"header:mainmenu:click:business\"></ute-header-link></li></ul><div class=\"nav-context-bar\"><div class=\"cfa-links\"><ssp-dashboard></ssp-dashboard>|<ute-header-link nav-to=\"goToNova\" tracking=\"header:mainmenu:click:goToNova\"></ute-header-link></div><div class=\"province-selector\"><ute-province-selector></ute-province-selector></div><ute-language-selector></ute-language-selector></div></nav><div class=\"shadow\"></div></div></header>");
$templateCache.put("app/layout/typeahead-modal/typeahead.modal.view.html","<div class=\"ute-profileEdit-modal\"><div class=\"HeadingGroup row\"><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div class=\"ute-modal-heading\" translate=\"ute.common.searchPage.searchBar.label\"></div></div><div class=\"ute-clearfix\">&nbsp;</div></div><div class=\"BodyGroup row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-sse-typeahead placeholder=\"{{\'ute.common.searchPage.searchBar.placeholder\' | translate}}\" language=\"{{::typeAheadModal.language}}\" province=\"{{::typeAheadModal.province}}\"></ute-sse-typeahead></div></div><span class=\"ute-x-close\" aria-hidden=\"true\" data-ng-click=\"typeAheadModal.cancel()\"><span class=\"ute-icon-mobile-menu-exit\"></span></span><div class=\"ute-clearfix\">&nbsp;</div></div>");
$templateCache.put("app/module/datetimepicker/dateTimePicker.directive.view.html","<header class=\"preview-header\"><span class=\"preview-title\">PREVIEW</span><div class=\"preview-drop-down-wrapper\"><input type=\"text\" value=\"{{ getPreviewDate() | date:\'medium\' }}\" ng-click=\"showDropDown()\"><div class=\"preview-drop-down\" ng-class=\"{ \'show\': showPreviewDropDown, \'hide\': !showPreviewDropDown }\"><datepicker ng-model=\"dates.dateToSend\" min=\"minDate\" show-weeks=\"showWeeks\"></datepicker><div class=\"time-separator\">Select Time:</div><timepicker ng-model=\"dates.timeTosend\" hour-step=\"hourstep\" minute-step=\"minutestep\" template-url=\"app/module/datetimepicker/templates/timePicker.template.html\" show-meridian=\"ismeridian\"></timepicker><button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"today()\">Now</button> <button type=\"button\" class=\"btn btn-sm btn-info pull-right\" ng-click=\"apply()\">Apply</button></div></div><span class=\"preview-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"apply()\">Apply</button></span> <span class=\"checkbox\"><label><input type=\"checkbox\" value=\"\" checked=\"\" ng-model=\"unPublishedContent\"> Show Unpublished Content</label></span></header>");
$templateCache.put("app/module/datetimepicker/templates/timePicker.template.html","<table class=\"uib-timepicker\"><tbody><tr class=\"text-center\" ng-show=\"::showSpinners\"><td>Hour</td><td>&nbsp;</td><td>Minute</td><td ng-show=\"showSeconds\">&nbsp;</td><td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"rui-icon-button-left\"></span></a></td><td ng-show=\"showMeridian\"></td></tr><tr><td class=\"form-group uib-time hours\" ng-class=\"{\'has-error\': invalidHours}\"><select ng-model=\"hours\" ng-change=\"updateHours()\" ng-readonly=\"::readonlyInput\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\"><option value=\"00\">00</option><option value=\"01\">01</option><option value=\"02\">02</option><option value=\"03\">03</option><option value=\"04\">04</option><option value=\"05\">05</option><option value=\"06\">06</option><option value=\"07\">07</option><option value=\"08\">08</option><option value=\"09\">09</option><option value=\"10\">10</option><option value=\"11\">11</option><option value=\"12\">12</option><option value=\"13\">13</option><option value=\"14\">14</option><option value=\"15\">15</option><option value=\"16\">16</option><option value=\"17\">17</option><option value=\"18\">18</option><option value=\"19\">19</option><option value=\"20\">20</option><option value=\"21\">21</option><option value=\"22\">22</option><option value=\"23\">23</option></select></td><td class=\"uib-separator\">:</td><td class=\"form-group uib-time minutes\" ng-class=\"{\'has-error\': invalidMinutes}\"><select placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\"><option value=\"00\">00</option><option value=\"15\">15</option><option value=\"30\">30</option><option value=\"45\">45</option></select></td><td ng-show=\"showSeconds\" class=\"uib-separator\">:</td><td class=\"form-group uib-time seconds\" ng-class=\"{\'has-error\': invalidSeconds}\" ng-show=\"showSeconds\"><input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\"></td><td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td></tr><tr class=\"text-center\" ng-show=\"::showSpinners\"><td>&nbsp;</td><td ng-show=\"showSeconds\">&nbsp;</td><td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"rui-icon-button-right\"></span></a></td><td ng-show=\"showMeridian\"></td></tr></tbody></table>");
$templateCache.put("module/uteArticleCarousel/articleCarousel.directive.view.html","<div class=\"ute-article-carousel\"><div class=\"row\"><div class=\"col-sm-12 col-md-10 col-lg-8\"><h3 ng-if=\"articleCarousel.sectionTitle\">{{ articleCarousel.sectionTitle }}</h3><ute-owl-carousel class=\"owl-carousel ute-article-carousel\" data-options=\"{{articleCarousel.carouselOptions}}\"><div ute-owl-carousel-item=\"articleCarousel.carouselItems\" class=\"ute-article-carousel-item\" ng-repeat=\"slide in articleCarousel.carouselItems\"><div class=\"ute-article-carousel-caption\" ng-if=\"slide.carousel_title\"><div class=\"ute-article-carousel-slide-number\" ng-if=\"articleCarousel.slideNumber\"><span>{{ $index + 1 }}</span></div><div class=\"ute-article-carousel-slide-title\">{{ slide.carousel_title }}</div></div><a ng-href=\"{{slide.external_links}}\"><img ng-if=\"{{ slide.desktop_image }}\" class=\"img-responsive hidden-xs\" ng-src=\"{{ slide.desktop_image }}\" alt=\"{{ slide.alt }}\"> <img ng-if=\"{{ slide.mobile_image }}\" class=\"img-responsive visible-xs\" ng-src=\"{{ slide.mobile_image }}\" alt=\"{{ slide.alt }}\"></a><div class=\"ute-article-carousel-slide-content\" ng-if=\"slide.carousel_text\"><ute-html-content content=\"slide.carousel_text\"></ute-html-content></div></div></ute-owl-carousel></div></div></div>");
$templateCache.put("module/uteArticleChild/articleChild.directive.view.html","<div class=\"ute-common-article-child\"><h2 ng-if=\"articleTitle\"><ute-html-content content=\"articleTitle\"></ute-html-content></h2><div immutable=\"articleContents\" ng-repeat=\"articleContent in articleContents\"><ute-simple-html title=\"articleContent.componentValue.sectionTitle\" content=\"articleContent.componentValue.sectionContent\" ng-if=\"articleContent.componentType===\'simple_content\'\"></ute-simple-html><ute-html-content ng-include=\"articleContent.componentValue.webcomponent_url\" ng-if=\"articleContent.componentType===\'web_component\'\"></ute-html-content><ute-grouped-accordion parent-index=\"{{$index}}\" main-label=\"articleContent.componentValue.sectionTitle\" is-expanded=\"articleContent.componentValue.faq_expander_inner.expanded\" list=\"articleContent.componentValue.faq_expander_inner\" ng-if=\"articleContent.componentType===\'faq_expander\'\"></ute-grouped-accordion><ute-article-carousel carousel-options=\"{ navigation: true, pagination: false, rewindNav : false, items: 1, singleItem: true }\" section-title=\"articleContent.componentValue.section_title\" slide-number=\"articleContent.componentValue.slide_number\" carousel-items=\"articleContent.componentValue.carousel_inner\" ng-if=\"articleContent.componentType===\'carousel\'\"></ute-article-carousel><ute-brightcove-video video-id=\"articleContent.componentValue.brightcove.videoId\" account-number=\"articleContent.componentValue.brightcove.accountNumber\" poster-url=\"articleContent.componentValue.brightcove.posterUrl\" poster-description=\"articleContent.componentValue.brightcove.posterDescription\" player-id=\"articleContent.componentValue.brightcove.playerId\" player-key=\"articleContent.componentValue.brightcove.playerKey\" html-mode=\"articleContent.componentValue.brightcove.htmlMode\" open-in-modal=\"articleContent.componentValue.brightcove.openInModal\" ng-if=\"articleContent.componentType===\'video_brightcove\'\"></ute-brightcove-video><ute-youtube-component video-url=\"articleContent.componentValue.video_path\" video-title=\"articleContent.componentValue.video_title\" ng-if=\"articleContent.componentValue.video_type===\'youtube\'\"></ute-youtube-component><ute-related-questions label=\"articleContent.componentValue.label\" questions-list=\"articleContent.componentValue.questionsList\" ng-if=\"articleContent.componentType===\'related_questions\'\"></ute-related-questions></div></div>");
$templateCache.put("module/uteArticleComponent/articleComponent.directive.view.html","<div class=\"ute-common-article-component\"><h1><ute-html-content content=\"articleTitle\"></ute-html-content></h1><div immutable=\"articleContents\" ng-repeat=\"articleContent in articleContents\"><ute-simple-html data-title=\"articleContent.componentValue.sectionTitle\" content=\"articleContent.componentValue.sectionContent\" ng-if=\"articleContent.componentType===\'simple_content\'\"></ute-simple-html><ute-html-content ng-include=\"articleContent.componentValue.webcomponent_url\" ng-if=\"articleContent.componentType===\'web_component\'\"></ute-html-content><ute-grouped-accordion parent-index=\"{{$index}}\" main-label=\"articleContent.componentValue.sectionTitle\" list=\"articleContent.componentValue.faq_expander_inner\" ng-if=\"articleContent.componentType===\'faq_expander\'\" expanded-accordion-data=\"expandedAccordionData\"></ute-grouped-accordion><ute-article-carousel carousel-options=\"{ navigation: true, pagination: false, rewindNav : false, items: 1, singleItem: true }\" section-title=\"articleContent.componentValue.section_title\" slide-number=\"articleContent.componentValue.slide_number\" carousel-items=\"articleContent.componentValue.carousel_inner\" ng-if=\"articleContent.componentType===\'carousel\'\"></ute-article-carousel><ute-article-selector options-list=\"articleContent.componentValue.values\" main-label=\"articleContent.componentValue.mainLabel\" options-label=\"articleContent.componentValue.default_selector_text\" child-article=\"childArticle\" on-select-option=\"onSelectChildArticle({ childArticleProperties: selectedChildArticle, articleId: articleId })\" ng-if=\"articleContent.componentType===\'group_selector\'\"></ute-article-selector><ute-brightcove-video video-id=\"articleContent.componentValue.brightcove.videoId\" account-number=\"articleContent.componentValue.brightcove.accountNumber\" poster-url=\"articleContent.componentValue.brightcove.posterUrl\" poster-description=\"articleContent.componentValue.brightcove.posterDescription\" player-id=\"articleContent.componentValue.brightcove.playerId\" player-key=\"articleContent.componentValue.brightcove.playerKey\" html-mode=\"articleContent.componentValue.brightcove.htmlMode\" open-in-modal=\"articleContent.componentValue.brightcove.openInModal\" ng-if=\"articleContent.componentType===\'video_brightcove\'\"></ute-brightcove-video><ute-youtube-component video-url=\"articleContent.componentValue.video_path\" video-title=\"articleContent.componentValue.video_title\" ng-if=\"articleContent.componentValue.video_type===\'youtube\'\"></ute-youtube-component><ute-related-questions label=\"articleContent.componentValue.label\" questions-list=\"articleContent.componentValue.questionsList\" ng-if=\"articleContent.componentType===\'related_questions\'\"></ute-related-questions></div><div ng-if=\"articleDateModified\" class=\"ute-article-last-updated\"><span>{{ \'ute.articleComponent.lastUpdated\' | translate }} {{(articleDateModified | date: \'longDate\' )}}</span></div></div>");
$templateCache.put("module/uteArticleFeedback/articleFeedback.directive.view.html","<div class=\"ute-article-feedback\"><div class=\"row\"><div class=\"col-sm-10 col-md-9\"><div class=\"ute-article-feedback-wrapper\"><div class=\"ute-article-feedback-question row\" ng-if=\"articleFeedback.feedbackAnswer === \'none\'\"><div class=\"col-sm-8 ute-article-feedback-question-label\"><h2 class=\"ute-feedback-h4\">{{ articleFeedback.feedbackQuestion.get(\'labelKey\') | translate }}</h2></div><div class=\"col-sm-4 ute-article-feedback-button-wrapper\"><a class=\"ute-article-feedback-button\" href=\"\" ng-click=\"articleFeedback.feedbackQuestions(\'yes\')\">{{ articleFeedback.feedbackQuestion.get(\'yesButtonKey\') | translate }}</a> <a class=\"ute-article-feedback-button\" href=\"\" ng-click=\"articleFeedback.feedbackQuestions(\'no\')\">{{ articleFeedback.feedbackQuestion.get(\'noButtonKey\') | translate }}</a></div></div><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"articleFeedback.feedbackAnswer === \'yes\'\"><p>{{ articleFeedback.feedbackAnswerYes.get(\'labelKey\') | translate }}</p></div><div ng-if=\"articleFeedback.feedbackAnswer === \'no\'\"><div class=\"ute-article-feedback-chat-wrapper\"><h4>{{ articleFeedback.feedbackAnswerNo.get(\'mainLabelKey\') | translate }}</h4><div class=\"row\"><div class=\"col-xs-6\"><ute-bold-chat button-id=\"{{ articleFeedback.feedbackAnswerNo.get(\'chatLabelFirstKey\') | translate }}\"></ute-bold-chat></div><div class=\"col-xs-6\"><ute-bold-chat button-id=\"{{ articleFeedback.feedbackAnswerNo.get(\'chatLabelSecondKey\') | translate }}\"></ute-bold-chat></div></div></div><div><p>*{{ articleFeedback.feedbackAnswerNo.get(\'labelKey\') | translate }}</p></div></div></div><div class=\"col-xs-12\" ng-if=\"articleFeedback.feedbackAnswer == \'yes\' || articleFeedback.feedbackAnswer == \'no\'\"><form name=\"articleFeedbackForm\" novalidate=\"\"><textarea rows=\"5\" class=\"ute-article-feedback-textarea\" ng-model=\"articleFeedback.feedbackText\" name=\"feedbackText\" ng-required=\"true\" ng-minlength=\"{{ articleFeedback.minLength }}\" ng-maxlength=\"{{ articleFeedback.maxLength }}\">\n              </textarea><div ng-if=\"articleFeedbackForm.$submitted || articleFeedbackForm.feedbackText.$touched\" class=\"ute-article-feedback-error\"><span ng-if=\"articleFeedbackForm.feedbackText.$error.maxlength\">{{ articleFeedback.feedbackForm.get(\'maxLengthErrorKey\') | translate }}</span></div><div class=\"ute-article-feedback-count\"><span>{{ articleFeedback.feedbackForm.get(\'answerCountBeforeKey\') | translate }}</span> <span>{{ articleFeedback.maxLength - articleFeedback.feedbackText.length || 0 }}</span> <span>{{ articleFeedback.feedbackForm.get(\'answerCountAfterKey\') | translate }}</span></div><div class=\"ute-article-feedback-captcha\"><span>*{{ articleFeedback.feedbackForm.get(\'captchaLabelKey\') | translate }}</span><div class=\"g-recaptcha\" data-sitekey=\"{{ articleFeedback.captchaKey }}\"></div><div ng-switch=\"articleFeedback.language\"><script ng-switch-when=\"en\" src=\"//www.google.com/recaptcha/api.js?hl=en\"></script><script ng-switch-when=\"fr\" src=\"//www.google.com/recaptcha/api.js?hl=fr\"></script></div><div ng-if=\"articleFeedbackForm.$submitted\" class=\"ute-article-feedback-error\"><span ng-if=\"articleFeedback.feedbackCaptcha === \'error\'\">{{ articleFeedback.feedbackForm.get(\'captchaErrorKey\') | translate }}</span></div></div><div class=\"ute-article-feedback-button-wrapper\"><button type=\"button\" class=\"ute-article-feedback-button\" ng-click=\"articleFeedback.resetForm()\">{{ articleFeedback.feedbackForm.get(\'resetButtonKey\') | translate }}</button> <button type=\"submit\" class=\"ute-article-feedback-button\" ng-disabled=\"articleFeedbackForm.$invalid\" ng-click=\"articleFeedback.onSubmitFeedback(articleFeedback.feedbackText)\">{{ articleFeedback.feedbackForm.get(\'submitButtonKey\') | translate }}</button></div></form></div><div class=\"col-xs-12\" ng-if=\"articleFeedback.feedbackCaptcha === \'thankYou\'\"><h3>{{ articleFeedback.feedbackForm.get(\'thankYouTitleKey\') | translate }}</h3><p>{{ articleFeedback.feedbackForm.get(\'thankYouDescriptionKey\') | translate }}</p></div></div></div></div></div></div>");
$templateCache.put("module/uteArticleSelector/articleSelector.directive.view.html","<div class=\"ute-article-selector\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><p class=\"ute-article-selector-label\">{{ articleSelector.mainLabel }}</p><div class=\"ute-article-selector-container\"><div class=\"ute-ute-article-selector-panel\"><a class=\"btn dropdown-toggle ute-article-selector-dropdown-toggle\" data-toggle=\"dropdown\" ng-if=\"articleSelector.multipleSelector()\" href=\"#\"><span class=\"ute-article-selector-default\" ng-if=\"!articleSelector.selectedOption\">{{ articleSelector.optionsLabel }}</span><span class=\"ute-article-selector-selected\" ng-if=\"articleSelector.selectedOption\"><span class=\"ute-article-selector-img-wrapper\"><img ng-src=\"{{ articleSelector.selectedOption.imageUrl }}\" ng-if=\"articleSelector.selectedOption.imageUrl\" class=\"img-responsive\" alt=\"{{ articleSelector.selectedOption.displayName }}\" title=\"{{ articleSelector.selectedOption.displayName }}\"></span> <span class=\"ute-article-selector-option-label\">{{ articleSelector.selectedOption.displayName }}</span></span><div class=\"ute-article-selector-chevron-container\"><i class=\"ute-icon-chevron-down\"></i></div></a><ul ng-class=\"(articleSelector.multipleSelector()) ? \'dropdown-menu ute-article-selector-dropdown-menu\' : \'ute-article-selector-radio\'\"><li class=\"ute-article-selector-options\" ng-repeat=\"option in articleSelector.optionsList\" ng-class=\"{ \'active\': articleSelector.selectedOption === option }\"><label><i ng-class=\"(articleSelector.selectedOption === option) ? \'ute-icon-radio-on\' : \'ute-icon-radio-off\'\" ng-if=\"!articleSelector.multipleSelector()\"></i> <input type=\"radio\" name=\"article-selector-options\" class=\"ute-article-selector-list-group-item\" ng-model=\"articleSelector.selectedOption\" ng-value=\"option\" ng-change=\"articleSelector.onSelectOption({ selectedChildArticle: articleSelector.selectedOption })\"><div ng-if=\"articleSelector.multipleSelector()\" class=\"ute-article-selector-img-wrapper\"><img ng-if=\"option.imageUrl\" ng-src=\"{{ option.imageUrl }}\" class=\"img-responsive\" alt=\"{{ option.displayName }}\" role=\"presentation\" title=\"{{ option.displayName }}\"></div><div class=\"ute-article-selector-option-label\"><p>{{ option.displayName }}</p><p class=\"ute-article-selector-option-description\" ng-if=\"option.description\">{{ option.description }}</p></div></label></li></ul></div></div></div></div><div class=\"row\" ng-if=\"articleSelector.childArticle.get(\'contents\') && articleSelector.childArticle.get(\'contents\').size\"><div class=\"col-xs-12\"><ute-article-child article-title=\"articleSelector.childArticle.get(\'title\')\" article-contents=\"articleSelector.childArticle.get(\'contents\')\"></ute-article-child></div></div></div>");
$templateCache.put("module/uteBoldChat/boldChat.directive.view.html","<div class=\"ute-bold-chat\"><div id=\"{{boldChat.randomId}}\" class=\"AvailabilityNews-chat bc-chat\"></div></div>");
$templateCache.put("module/uteBreadcrumbsBar/breadcrumbsBar.directive.view.html","<div class=\"ute-breadcrumbs-bar\"><div class=\"row\"><div class=\"col-xs-12\"><ol class=\"breadcrumb ute-breadcrumb-bar-container\"><li class=\"ute-breadcrumb-bar-li\" immutable=\"breadcrumbs\" ng-repeat=\"breadcrumb in breadcrumbs\" ng-class=\"{\'active\': $last }\"><a ng-if=\"breadcrumbsBar.getUrl(breadcrumb, businessUnit)\" class=\"ute-breadcrumb-bar-a\" ng-href=\"{{breadcrumbsBar.getUrl(breadcrumb, businessUnit)}}\"><ute-html-content content=\"breadcrumb.label ? breadcrumb.label : breadcrumb.translationKey | translate\"></ute-html-content></a> <span ng-if=\"!breadcrumbsBar.getUrl(breadcrumb, businessUnit)\"><ute-html-content content=\"breadcrumb.label ? breadcrumb.label : breadcrumb.translationKey | translate\"></ute-html-content></span></li><li class=\"ute-breadcrumb-bar-li share-container\" immutable=\"breadcrumbs\" ng-class=\"{\'active\': $last }\"><div class=\"ute-print-bookmark-share__container\"><a href=\"javascript:void(0)\" ng-click=\"breadcrumbsBar.printArticle()\" title=\"{{articlePrintKey}}\" class=\"print-article-button\"><span class=\"ute-icon-print\"></span> <span class=\"sr-only ng-binding\">{{articlePrintKey}}</span></a> <a ng-href=\"{{articleEmailContent}}\" title=\"{{articleEmailKey}}\" class=\"email-article-button\" target=\"_blank\"><span class=\"ute-icon-email\"></span> <span class=\"sr-only ng-binding\">{{articleEmailKey}}</span></a></div></li></ol></div></div></div>");
$templateCache.put("module/uteBrightcoveVideo/brightcoveVideo.directive.view.html","<div class=\"ute-brightcove-video\"><div class=\"row\"><div class=\"col-sm-7\"><div class=\"ute-brightcove-video-container\"><div ng-if=\"brightcove.openInModal\"><img class=\"img-responsive\" ng-src=\"{{ brightcove.posterUrl }}\" alt=\"{{ brightcove.posterDescription }}\" ng-click=\"brightcove.uteVideoModalOpen()\"></div><div ng-if=\"!brightcove.openInModal\"><div ng-if=\"brightcove.htmlMode\"><div class=\"ute-brightcove-video-wrapper\"><video data-video-id=\"{{ brightcove.videoId }}\" data-account=\"{{ brightcove.accountNumber }}\" data-player=\"default\" data-embed=\"default\" class=\"video-js\" controls=\"\"></video><script ng-src=\"{{ brightcove.trustAsResourceUrl(brightcove.scriptUrl) }}\"></script></div></div><div ng-if=\"!brightcove.htmlMode\"><object id=\"myExperience{{ brightcove.videoId }}\" width=\"480\" height=\"300\" class=\"BrightcoveExperience\" data=\"//secure.brightcove.com/services/viewer/federated_f9?&amp;width=480&amp;height=300&amp;flashID=myExperience{{ brightcove.videoId }}&amp;bgcolor=%23FFFFFF&amp;playerID={{ brightcove.playerId }}&amp;playerKey={{ brightcove.playerKey }}&amp;isVid=true&amp;isUI=true&amp;dynamicStreaming=true&amp;%40videoPlayer={{ brightcove.videoId }}&amp;secureConnections=true&amp;secureHTMLConnections=true&amp;autoStart=false&amp;htmlFallback=true\"><param name=\"allowScriptAccess\" value=\"always\"><param name=\"allowFullScreen\" value=\"true\"><param name=\"seamlessTabbing\" value=\"false\"><param name=\"swliveconnect\" value=\"true\"><param name=\"wmode\" value=\"window\"><param name=\"quality\" value=\"high\"><param name=\"bgcolor\" value=\"#FFFFFF\"><param name=\"htmlFallback\" value=\"true\"></object></div></div></div></div></div></div>");
$templateCache.put("module/uteBrightcoveVideo/brightcoveVideoModal.directive.view.html","<div class=\"ute-brightcove-video\"><div class=\"modal-body\"><div ng-if=\"brightcove.htmlMode\"><div><video data-video-id=\"{{ brightcove.videoId }}\" data-account=\"{{ brightcove.accountNumber }}\" data-player=\"default\" data-embed=\"default\" class=\"video-js\" controls=\"\"></video><script ng-src=\"{{ brightcove.trustAsResourceUrl(brightcove.scriptUrl) }}\"></script></div></div><div ng-if=\"!brightcove.htmlMode\"><div style=\"display:none\"></div><object id=\"myExperience{{ brightcove.videoId }}\" width=\"480\" height=\"300\" class=\"BrightcoveExperience\" data=\"//secure.brightcove.com/services/viewer/federated_f9?&amp;width=480&amp;height=300&amp;flashID=myExperience{{ brightcove.videoId }}&amp;bgcolor=%23FFFFFF&amp;playerID={{ brightcove.playerId }}&amp;playerKey={{ brightcove.playerKey }}&amp;isVid=true&amp;isUI=true&amp;dynamicStreaming=true&amp;%40videoPlayer={{ brightcove.videoId }}&amp;secureConnections=true&amp;secureHTMLConnections=true&amp;autoStart=true&amp;htmlFallback=true\"><param name=\"allowScriptAccess\" value=\"always\"><param name=\"allowFullScreen\" value=\"true\"><param name=\"seamlessTabbing\" value=\"false\"><param name=\"swliveconnect\" value=\"true\"><param name=\"wmode\" value=\"window\"><param name=\"quality\" value=\"high\"><param name=\"bgcolor\" value=\"#FFFFFF\"></object></div></div></div>");
$templateCache.put("module/uteChannelRecommendation/channelRecommendation.directive.view.html","<div class=\"ute-channel-recommendation\" ng-if=\"selectedCity && selectedProvince\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"panel panel-default ute-channel-recommendation-panel\"><div class=\"panel-body ute-channel-recommendation-panel-panel-body row\"><div class=\"col-xs-12\" ng-if=\"recommendedShow.size > 0\"><div class=\"ute-channel-recommendation__show-container\"><div class=\"ute-channel-recommendation__show-image\" ng-if=\"recommendedShow.get(\'image\')\"><img class=\"img-responsive\" ng-src=\"{{ recommendedShow.get(\'image\') }}\" alt=\"\" title=\"{{ recommendedShow.get(\'name\') }}\"></div><div class=\"ute-channel-recommendation__show-description-container\"><p class=\"ute-channel-recommendation__show-name\">{{ recommendedShow.get(\'name\') }}</p><p class=\"ute-channel-recommendation__show-description\">{{ recommendedShow.get(\'description\') }}</p></div></div></div><div class=\"col-xs-12\"><h4 class=\"ute-search-h4\" data-ng-if=\"label\">{{ label }}</h4></div><div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-4\"><div class=\"dropdown ute-search__select-dropdown\"><select name=\"selectedProvince\" immutable=\"provinces\" class=\"form-control ute-search__select-dropdown-style\" ng-model=\"selectedData.selectedProvince\" ng-change=\"onSelectProvince({ selectedProvince: selectedData.selectedProvince })\" ng-options=\"province as province.displayName for province in provinces track by province.value\"></select><div class=\"ute-search-chevron-container\"><i class=\"ute-icon-chevron-down\"></i></div></div><div class=\"dropdown ute-search__select-dropdown\"><select name=\"selectedCity\" immutable=\"cities\" class=\"form-control ute-search__select-dropdown-style\" ng-model=\"selectedData.selectedCity\" ng-change=\"onSelectCity({ selectedProvince: selectedData.selectedProvince, selectedCity: selectedData.selectedCity })\" ng-options=\"city as city.displayName for city in cities track by city.value\"></select><div class=\"ute-search-chevron-container\"><i class=\"ute-icon-chevron-down\"></i></div></div></div><div class=\"col-xs-6 col-sm-4 col-md-5 col-lg-4 ute-channel-recommendation-main-badge\"><span immutable=\"recommendedChannel\"><ute-channel-recommendation-badge label=\"recommendedChannel.label\" numbers=\"recommendedChannel.channelNumbers\" image-url=\"recommendedChannel.imageUrl\" enable-popup=\"true\" channel-number-desktop-label=\"{{ channelNumberLabel.get(\'desktopKey\') | translate }}\" channel-number-mobile-label=\"{{ channelNumberLabel.get(\'mobileKey\') | translate }}\" details-description=\"recommendedChannel.detailsDescription\" details-images=\"recommendedChannel.detailsImages\" show-channel-details=\"showChannelDetails\" hide-channel-details=\"hideChannelDetails\"></ute-channel-recommendation-badge></span><div class=\"row hidden-xs\"><div class=\"col-xs-12 col-sm-4 col-md-3\">&nbsp;</div><div class=\"col-xs-12 col-sm-8 col-md-9\" ng-if=\"relatedChannels && relatedChannels.size\"><a class=\"collapsed ute-channel-recommendation__a-text\" data-toggle=\"collapse\" href=\"#channelList-1\" aria-expanded=\"false\" aria-controls=\"channelList-1\"><span>{{ showAllLink.get(\'beforeKey\') | translate }}</span> <span>{{ channelType }}</span> <span>{{ showAllLink.get(\'afterKey\') | translate }}</span> <span class=\"ute-icon-chevron-down\"></span> <span class=\"ute-icon-chevron-up\"></span></a></div></div></div><div class=\"col-xs-6 col-sm-2 col-md-2 col-lg-4 ute-channel-recommendation__whats-on\"><p class=\"ute-channel-recommendation__whats-on-label\">{{ whatsOn.get(\'labelKey\') | translate }}</p><p immutable=\"whatsOnList\" ng-repeat=\"whatsOnLink in whatsOnList\"><a class=\"ute-channel-recommendation__a-text\" ng-href=\"{{ whatsOnLink.url[userLanguage] }}\">{{ whatsOnLink.labelKey | translate }}</a></p></div><div class=\"col-xs-12 visible-xs\"><div class=\"ute-channel-recommendation__mobile-link\"><a class=\"collapsed ute-channel-recommendation__a-text\" data-toggle=\"collapse\" href=\"#channelList-1\" aria-expanded=\"false\" aria-controls=\"channelList-1\"><span>{{ showAllLink.get(\'beforeKey\') | translate }}</span> <span>{{ channelType }}</span> <span>{{ showAllLink.get(\'afterKey\') | translate }}</span> <span class=\"ute-icon-chevron-down\"></span> <span class=\"ute-icon-chevron-up\"></span></a></div></div><div id=\"channelList-1\" class=\"panel-collapse collapse row ute-channel-recommendation-panel-collapse\" role=\"tabpanel\" aria-expanded=\"false\"><div class=\"col-xs-12\"><hr class=\"ute-hr\"></div><ute-owl-carousel class=\"owl-carousel ute-channel-recommendation-carousel col-xs-10\" data-options=\"{ navigation: true, pagination: true, rewindNav : false, scrollPerPage: true, itemsDesktopSmall : [900, 3], itemsTablet: [600, 3], itemsMobile: [480, 3] }\"><div ute-owl-carousel-item=\"relatedChannels\" class=\"col-xs-4 ute-channel-recommendation-carousel-item\" immutable=\"relatedChannels\" ng-repeat=\"relatedChannel in relatedChannels\"><ute-channel-recommendation-badge label=\"relatedChannel.label\" numbers=\"relatedChannel.channelNumbers\" enable-popup=\"true\" channel-number-desktop-label=\"{{ channelNumberLabel.get(\'desktopKey\') | translate }}\" channel-number-mobile-label=\"{{ channelNumberLabel.get(\'mobileKey\') | translate }}\" image-url=\"relatedChannel.imageUrl\" details-description=\"relatedChannel.detailsDescription\" show-channel-details=\"showChannelDetails\" hide-channel-details=\"hideChannelDetails\"></ute-channel-recommendation-badge></div></ute-owl-carousel></div></div></div></div></div></div><ute-channel-details-popover class=\"ute-channel-details-popover\" details-data=\"detailsData\" show-popover=\"showPopover\" hide-popover=\"hideChannelDetails\" position-top=\"positionTop\" position-left=\"positionLeft\"></ute-channel-details-popover>");
$templateCache.put("module/uteGroupedAccordion/groupedAccordion.directive.view.html","<div class=\"ute-grouped-accordion\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ute-accordion__main-label ute-simple-html\"><h2 class=\"ute-html-content--title\" ng-if=\"groupedAccordion.mainLabel\"><ute-html-content content=\"groupedAccordion.mainLabel\"></ute-html-content></h2></div></div><div class=\"col-xs-12 col-sm-11\"><div id=\"{{ groupedAccordion.defaultId + \'-\' + groupedAccordion.parentIndex }}\" role=\"tablist\" aria-multiselectable=\"true\" class=\"panel-group ute-search__accordion\"><div class=\"panel panel-default ute-search__accordion--panel\" ng-repeat=\"accordion in groupedAccordion.list\"><a ng-click=\"groupedAccordion.expandToggle($index, !(groupedAccordion.expandedAccordionData.parentIndex == groupedAccordion.parentIndex && groupedAccordion.expandedAccordionData.expandedIndex == $index))\" data-parent=\"#{{ groupedAccordion.defaultId + \'-\' + groupedAccordion.parentIndex }}\" data-toggle=\"collapse\" ng-class=\"{\'collapsed\':(accordion.expanded != \'yes\')}\" href=\"#{{ groupedAccordion.defaultId + \'-collapse-\' + groupedAccordion.parentIndex + \'-\' + $index }}\" aria-expanded=\"{{ groupedAccordion.mainLabel }}\" aria-controls=\"{{ groupedAccordion.defaultId + \'-collapse-\' + groupedAccordion.parentIndex + \'-\' + $index }}\"><div class=\"panel-heading ute-search__accordion--panel-heading\" role=\"tab\" id=\"heading-{{ groupedAccordion.defaultId + \'-\' + groupedAccordion.parentIndex + \'-\' + $index }}\"><div class=\"media\"><div class=\"media-body media-middle\"><span class=\"panel-title ute-search__accordion--panel-title\">{{ accordion.expander_title }}</span></div><div class=\"media-right media-middle\"><i class=\"pull-right\" ng-class=\"groupedAccordion.expandedAccordionData.parentIndex == groupedAccordion.parentIndex && groupedAccordion.expandedAccordionData.expandedIndex == $index ? \'ute-icon-chevron-up\' : \'ute-icon-chevron-down\'\"></i></div></div></div></a><div id=\"{{ groupedAccordion.defaultId + \'-collapse-\' + groupedAccordion.parentIndex + \'-\' + $index }}\" class=\"panel-collapse collapse\" ng-class=\"{\'in\': (accordion.expanded == \'yes\') || ((groupedAccordion.expandedAccordionData.parentIndex == groupedAccordion.parentIndex && groupedAccordion.expandedAccordionData.expandedIndex == $index))}\" role=\"tabpanel\" aria-labelledby=\"heading-{{ groupedAccordion.defaultId + \'-\' + groupedAccordion.parentIndex + \'-\' + $index }}\" aria-expanded=\"{{ groupedAccordion.mainLabel }}\"><div class=\"panel-body ute-search-results-text\"><ute-html-content content=\"accordion.simple_content_faq.sectionContent\"></ute-html-content></div></div></div></div></div></div></div>");
$templateCache.put("module/uteHtmlContent/htmlContent.directive.view.html","<div class=\"ute-html-content\"><div class=\"ute-html-content--content\" ng-bind-html=\"asSafeContent(content)\"></div></div>");
$templateCache.put("module/utePaginationBar/paginationBar.directive.view.html","<div class=\"ute-pagination-bar\"><nav ng-if=\"paginationBar.total > 1\"><ul class=\"pagination ute-pagination-bar\"><li ng-if=\"paginationBar.current > paginationBar.start\"><a href=\"#\" ng-click=\"paginationBar.paginate(paginationBar.current - 1, paginationBar.recordsPerPage)\" aria-label=\"Previous\"><span aria-hidden=\"true\" class=\"ute-icon-chevron\"></span></a></li><li ng-repeat=\"pageNumber in paginationBar.paginationRange\" ng-class=\"{ active : pageNumber===paginationBar.current }\"><a href=\"\" ng-click=\"paginationBar.paginate(pageNumber, paginationBar.recordsPerPage)\">{{ pageNumber }}</a></li><li ng-if=\"paginationBar.current < paginationBar.total\"><a href=\"\" ng-click=\"paginationBar.paginate(paginationBar.current + 1, paginationBar.recordsPerPage)\" aria-label=\"Next\"><span aria-hidden=\"true\" class=\"ute-icon-chevron\"></span></a></li></ul></nav></div>");
$templateCache.put("module/uteRelatedQuestions/relatedQuestions.directive.view.html","<div class=\"ute-related-questions\"><div class=\"row\"><div class=\"col-xs-12\"><h3>{{ label }}</h3></div><div class=\"col-xs-12\"><div class=\"ute-related-questions-wrapper\"><div class=\"ute-related-questions-item\" immutable=\"questionsList\" ng-repeat=\"question in questionsList\"><p class=\"ute-related-questions-title\"><a ng-href=\"{{ question.url }}\">{{ question.title }}</a></p><p class=\"ute-related-questions-description\">{{ question.description }}</p></div></div></div></div></div>");
$templateCache.put("module/uteSearchBar/searchBar.directive.view.html","<div class=\"ute-search-bar\"><h1 class=\"ute-search-h1\">{{ label }}</h1><div class=\"row\"><div class=\"col-xs-12 col-md-8\"><label for=\"ute-sse-typeahead-search-box\" class=\"hide\">{{inputLabel}}</label><ute-sse-typeahead placeholder=\"{{ placeholder }}\" submit-text=\"{{ submitText }}\" search-term=\"{{ searchTerm }}\" language=\"{{ language }}\" province=\"{{ province }}\" site=\"{{ site || \'consumer\' }}\" overlay-result=\"\" capture=\"\"></ute-sse-typeahead></div></div></div>");
$templateCache.put("module/uteSearchFilter/searchFilter.directive.view.html","<div class=\"ute-search-filter\"><div class=\"row\"><div class=\"col-xs-12 ute-search-filter-wrapper\"><div class=\"ute-common-search-filter-result-count\" ng-if=\"resultCount || resultCount===0\"><span class=\"ute-common-search-filter-result-number\" ng-if=\"resultCount > 0\">{{ resultCount }}</span> <span class=\"ute-common-search-filter-result-label\">{{ resultCountLabel | translate }}</span> <span class=\"ute-common-search-filter-result-query\">{{ searchTerm }}</span></div><div class=\"ute-common-search-filter-result-filter\" ng-if=\"filters.size > 1 && resultCount > 9\"><div class=\"l-search-filterDesk btn-group ute-search-filter-btn-container\"><ul immutable=\"filters\" class=\"filter-result-desk\"><li ng-repeat=\"filter in filters\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"filter.selected\" ng-model-options=\"{ debounce: 1000 }\" ng-change=\"updateFilters(searchTerm, filters)\"> <i class=\"{{ filter.icon }}\"></i> <span class=\"ute-search__filter-txt\">{{ filter.displayName }} <span>({{ filter.count }})</span></span></label></div></li></ul></div><div class=\"l-search-filterMobile btn-group ute-search-filter-btn-container\"><a href=\"#\" class=\"btn ute-search-filter-btn dropdown-toggle ute-search-filter-dropdown-toggle\" data-toggle=\"dropdown\">{{ filterLabel }}<div class=\"ute-search-filter-chevron-container pull-right\"><i class=\"ute-icon-chevron-down pull-right\"></i></div></a><ul immutable=\"filters\" class=\"dropdown-menu ute-search-dropdown-menu\"><li ng-repeat=\"filter in filters\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"filter.selected\" ng-model-options=\"{ debounce: 1000 }\" ng-change=\"updateFilters(searchTerm, filters)\"> <i class=\"{{ filter.icon }}\"></i> <span class=\"ute-search__filter--dropdown-txt\">{{ filter.displayName }} <span>({{ filter.count }})</span></span></label></div></li></ul></div></div></div></div></div>");
$templateCache.put("module/uteSearchResults/searchResults.directive.view.html","<section class=\"ute-search-results\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ute-search-results-wrapper\"><div immutable=\"resultsList\" ng-show=\"resultsList.length < 1\" class=\"showEmpty\"></div><div class=\"media\" immutable=\"resultsList\" ng-repeat=\"searchResult in resultsList\"><div class=\"media-left\"><i class=\"ute-search-results__iconsize {{ searchResult.icon }}\"></i></div><div class=\"media-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"media-heading ute-search-h4\"><span ng-switch=\"searchResult.recordClass\"><a ng-switch-when=\"support\" ng-click=\"viewSearchResult($event, $index, searchResult.title, searchResult.sref, searchResult.recordClass)\" ui-sref=\"support.article({ articleId: searchResult.sref })\">{{ searchResult.title }}</a> <a ng-switch-default=\"\" ng-click=\"viewSearchResult($event, $index, searchResult.title, searchResult.sref, searchResult.recordClass)\" ng-href=\"{{ searchResult.sref }}\">{{ searchResult.title }}</a></span> <span class=\"ute-search-results__category-txt\">[{{ searchResult.lineOfBusiness }} - {{ searchResult.category }}]</span></div></div></div><div class=\"row\"><div class=\"col-md-10\"><p class=\"ute-search-results-text\">{{ searchResult.description | limitTo:150 }} {{ searchResult.description.length > 150 ? \'...\' : \'\' }}</p></div></div></div></div></div></div></div></section>");
$templateCache.put("module/tabbedCard/tabbedCard.directive.view.html","<div class=\"ute-tabbed-card\"><tabset><tab ng-repeat=\"i in [0, 1]\" ng-if=\"tabbedCard.isTabVisible(tabs.getIn([i]))\"><tab-heading><h2>{{ tabs.getIn([i, \'name\']) }} <span>{{ tabs.getIn([i, \'description\'])}}</span></h2></tab-heading><ute-channel-recommendation user-language=\"userLanguage\" label=\"{{ tabs.getIn([i, \'channelRecommendationContent\', \'label\']) | translate }}\" provinces=\"tabs.getIn([i, \'channelRecommendationContent\', \'provinces\'])\" selected-province=\"tabbedCard.selectedProvince\" cities=\"tabs.getIn([i, \'channelRecommendationContent\', \'cities\'])\" selected-city=\"tabs.getIn([i, \'channelRecommendationContent\', \'selectedCity\'])\" channel-type=\"\" max-recommendations=\"tabs.getIn([i, \'channelRecommendationContent\',\'maxRecommendations\'])\" recommended-channel=\"tabs.getIn([i, \'channelRecommendationContent\', \'recommendedChannel\'])\" recommended-show=\"tabs.getIn([i, \'channelRecommendationContent\', \'recommendedChannel\', \'showInfo\'])\" related-channels=\"tabs.getIn([i, \'channelRecommendationContent\', \'relatedChannels\'])\" whats-on=\"tabs.getIn([i, \'channelRecommendationContent\', \'whatsOn\'])\" show-all-link=\"tabs.getIn([i, \'channelRecommendationContent\', \'showAllLink\'])\" channel-number-label=\"tabs.getIn([i, \'channelRecommendationContent\', \'channelNumber\'])\" on-select-province=\"onSelectProvince({selectedProvince: selectedProvince, selectedCity: undefined, tabId: tabs.getIn([i, \'id\']) })\" on-select-city=\"onSelectCity({ selectedProvince: tabbedCard.selectedProvince, selectedCity: selectedCity, tabId: tabs.getIn([i, \'id\']) })\"></ute-channel-recommendation></tab></tabset></div>");
$templateCache.put("module/uteSearchSection/searchSection.directive.view.html","<div class=\"ute-common-search-section\"><ute-breadcrumbs-bar breadcrumbs=\"searchSection.search.get(\'breadcrumbs\')\"></ute-breadcrumbs-bar><ute-search-bar label=\"{{ searchSection.search.getIn([\'searchBar\', \'labelKey\']) | translate }}\" input-label=\"{{ searchSection.search.getIn([\'searchBar\', \'inputLabelKey\']) | translate }}\" submit-text=\"{{ searchSection.search.getIn([\'searchBar\', \'submitTextKey\']) | translate }}\" placeholder=\"{{ searchSection.search.getIn([\'searchBar\', \'placeholderKey\']) | translate }}\" language=\"{{ searchSection.language }}\" province=\"{{ searchSection.province }}\" search-term=\"searchSection.search.get(\'searchTerm\')\" on-search-submit=\"searchSection.searchResultsUpdated(search)\" ng-attr-site=\"searchSection.businessUnit\"></ute-search-bar><div ng-if=\"searchSection.search.get(\'searchTerm\')\"><ute-search-filter filter-label=\"{{ searchSection.search.getIn([\'filters\', \'labelKey\']) | translate }}\" result-count=\"searchSection.search.getIn([\'results\', \'count\'])\" result-count-label=\"searchSection.search.getIn([\'filters\', \'countLabelKey\'])\" filters=\"searchSection.search.getIn([\'filters\', \'list\'])\" search-term=\"searchSection.search.get(\'searchTerm\')\" on-update-filter=\"searchSection.updateSearchFilter(searchTerm, filters, isChecked)\"></ute-search-filter><ute-tabbed-card ng-if=\"searchSection.tabs && searchSection.tabs.size > 0\" tabs=\"searchSection.tabs\" user-language=\"searchSection.search.getIn([\'locale\', \'language\'])\" on-select-province=\"searchSection.fetchFilteredChannelRecommendations(selectedProvince, selectedCity, tabId)\" on-select-city=\"searchSection.fetchFilteredChannelRecommendations(selectedProvince, selectedCity, tabId)\"></ute-tabbed-card><ute-tv-guide ng-if=\"searchSection.search.getIn([\'tvGuide\', \'list\']) && searchSection.search.getIn([\'tvGuide\', \'list\']).size > 0\" label=\"searchSection.search.getIn([\'tvGuide\', \'label\'])\" list=\"searchSection.search.getIn([\'tvGuide\', \'list\'])\"></ute-tv-guide><ute-spotlight-callout ng-class=\"(searchSection.businessUnit != \'consumer\' ) ? \'ute-dca-spotlight-in-search-border\' : \'\'\" ng-if=\"searchSection.search.getIn([\'callout\', \'list\']) && searchSection.search.getIn([\'callout\', \'list\']).size > 0\" label=\"searchSection.search.getIn([\'callout\', \'label\'])\" icon=\"searchSection.search.getIn([\'callout\', \'icon\'])\" description=\"searchSection.search.getIn([\'callout\', \'description\'])\" list=\"searchSection.search.getIn([\'callout\', \'list\'])\"></ute-spotlight-callout><ute-search-results ng-class=\"(searchSection.businessUnit != \'consumer\' ) ? \'ute-dca-override\' : \'\'\" results-list=\"searchSection.search.getIn([\'results\', \'list\'])\" on-result-click=\"searchSection.clickSearchResult(index, title, sref, recordClass)\"></ute-search-results><ute-pagination-bar start=\"searchSection.search.getIn([\'pagination\', \'start\'])\" end=\"searchSection.search.getIn([\'pagination\', \'end\'])\" current=\"searchSection.search.getIn([\'pagination\', \'current\'])\" total=\"searchSection.search.getIn([\'pagination\', \'total\'])\" records-per-page=\"searchSection.search.getIn([\'pagination\', \'recordsPerPage\'])\" on-go-to-page=\"searchSection.fetchPaginatedSearchResults\"></ute-pagination-bar></div></div>");
$templateCache.put("module/uteSimpleHtml/simpleHtml.directive.view.html","<div class=\"ute-simple-html\"><h2 ng-class=\"{\'ute-html-content--title\': simpleHtml.title && simpleHtml.title.length>0}\" ng-if=\"simpleHtml.title && simpleHtml.title.length>0\"><ute-html-content content=\"simpleHtml.title\"></ute-html-content></h2><ute-html-content content=\"simpleHtml.content\"></ute-html-content></div>");
$templateCache.put("module/uteSpotlightCallout/spotlightCallout.directive.view.html","<section class=\"ute-spotlight-callout\"><div class=\"row\"><div class=\"col-xs-10\"><div class=\"ute-spotlight-callout-wrapper\"><div class=\"media\"><div><span immutable=\"list\" ng-repeat=\"calloutItem in list | isHighlightFilter:true\"><div class=\"media-left\"><i ng-if=\"calloutItem.highlight_icon\" class=\"{{ calloutItem.highlight_icon }} ute-spotlight-callout__iconsize\"></i></div><div class=\"media-body\"><div class=\"ute-spotlight-callout-list\"><ute-html-content content=\"calloutItem.html\"></ute-html-content></div></div></span></div><div class=\"ute-highlight-false\"><span immutable=\"list\" ng-repeat=\"calloutItem in list | isHighlightFilter:false\"><div class=\"col-sm-6\"><ute-html-content content=\"calloutItem.html\"></ute-html-content></div></span></div></div></div></div></div></section>");
$templateCache.put("module/uteSupportSection/supportSection.directive.view.html","<div class=\"ute-common-support-section\"><ute-breadcrumbs-bar breadcrumbs=\"supportSection.breadcrumbs\" article-email-content=\"supportSection.getEmailContent(supportSection.support.getIn([\'article\', \'title\']))\" article-email-key=\"supportSection.support.getIn([\'emailKey\']) | translate\" article-print-key=\"supportSection.support.getIn([\'printKey\']) | translate\"></ute-breadcrumbs-bar><div class=\"row share-container-d\"><div class=\"ute-print-bookmark-share__container\"><a href=\"javascript:void(0)\" class=\"print-article-button\" ng-click=\"supportSection.printArticle()\" title=\"{{supportSection.support.getIn([\'printKey\']) | translate }}\"><span class=\"ute-icon-print\"></span> <span class=\"sr-only\">{{supportSection.support.getIn([\'printKey\']) | translate }}</span></a> <a ng-href=\"{{supportSection.getEmailContent(supportSection.support.getIn([\'article\', \'title\']))}}\" title=\"{{supportSection.support.getIn([\'emailKey\']) | translate }}\" class=\"email-article-button\" target=\"_blank\"><span class=\"ute-icon-email\"></span> <span class=\"sr-only\">{{supportSection.support.getIn([\'emailKey\']) | translate }}</span></a></div></div><ute-article-component article-id=\"{{supportSection.support.getIn([\'article\', \'seoUrl\'])}}\" article-title=\"supportSection.support.getIn([\'article\', \'title\'])\" article-contents=\"supportSection.support.getIn([\'article\', \'contents\'])\" article-date-modified=\"supportSection.support.getIn([\'article\', \'dateModified\'])\" child-article=\"supportSection.support.get(\'childArticle\')\" on-select-child-article=\"supportSection.onSelectChildArticle(childArticleProperties, articleId)\"></ute-article-component><ute-article-feedback ng-if=\"supportSection.businessUnit === \'consumer\' && supportSection.isNotOnlineAndPaperBillingFaqs()\" max-length=\"500\" min-length=\"2\" captcha-key=\"supportSection.support.getIn([\'articleFeedback\', \'feedbackForm\', \'captchaKey\'])\" feedback-question=\"supportSection.support.getIn([\'articleFeedback\', \'feedbackQuestion\'])\" feedback-form=\"supportSection.support.getIn([\'articleFeedback\', \'feedbackForm\'])\" feedback-answer-yes=\"supportSection.support.getIn([\'articleFeedback\', \'feedbackAnswerYes\'])\" feedback-answer-no=\"supportSection.support.getIn([\'articleFeedback\', \'feedbackAnswerNo\'])\" language=\"{{supportSection.app.getIn([\'language\'])}}\"></ute-article-feedback><script type=\"text/javascript\" src=\"//s7.addthis.com/js/250/addthis_widget.js#username=rogersecomm\"></script></div>");
$templateCache.put("module/uteTvGuide/tvGuide.directive.view.html","<div class=\"ute-tv-guide\"><div class=\"panel panel-default ute-tv-guide-panel\"><div class=\"panel-body ute-tv-guide-panel-panel-body row\"><div class=\"col-xs-12\"><div class=\"ute-tv-guide-wrapper\"><div class=\"media\"><div class=\"media-body\"><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"media-heading ute-search-h4\">{{ label }}</h4></div></div><div class=\"row ute-tv-guide-list\"><div class=\"col-sm-6 ute-tv-guide-list__section\" immutable=\"list\" ng-repeat=\"guideList in list\"><ute-html-content content=\"guideList.html\"></ute-html-content></div></div></div></div></div></div></div></div></div>");
$templateCache.put("module/uteYoutubeComponent/youtubeComponent.directive.view.html","<div class=\"ute-youtube-component\"><h2 class=\"ute-youtube-component-title\">{{youtube.videoTitle}}</h2><div class=\"row\"><div class=\"col-sm-7\"><div class=\"ute-youtube-component-wrapper\"><iframe width=\"560\" height=\"315\" ng-src=\"{{ youtube.trustAsResourceUrl(youtube.videoUrl) }}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div></div>");
$templateCache.put("module/language.switcher/languageSwitch.html","<ul class=\"nav navbar-nav pull-right\"><li><a href=\"\" data-ng-click=\"languageSwitch.changeLanguage()\" translate=\"ute.blocks.language.switcher.label\"></a></li></ul>");
$templateCache.put("module/uteChannelRecommendation/channelRecommendationBadge/channelRecommendationBadge.directive.view.html","<div class=\"ute-channel-recommendation-badge\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3 ute-channel-recommendation__channelicon-container\"><img class=\"img-responsive\" ng-click=\"showChannelDetails(detailsDescription,detailsImages,imageUrl, $event)\" ng-src=\"{{ imageUrl }}\" alt=\"{{ detailsImages }}\"></div><div class=\"col-xs-12 col-sm-8 col-md-9 ute-channel-recommendation__channel-info-container\"><p class=\"ute-channel-recommendation__channel-name\">{{ label }}</p><p class=\"ute-channel-recommendation__channel-num\" ng-if=\"numbers && numbers.length\"><span class=\"hidden-xs\">{{ channelNumberDesktopLabel }}</span> <span class=\"visible-xs\">{{ channelNumberMobileLabel }}</span> <span>{{ numbers.join(\' / \') }}</span></p></div></div></div>");
$templateCache.put("module/uteChannelRecommendation/channelRecommendationBadgePopover/channelRecommendationBadgePopover.directive.view.html","<div class=\"ute-channel-recommendation-badge-popover\"><div class=\"ute-channel-recommendation__channel-details\" ng-class=\"{\'open\': showPopover}\"><div class=\"ute-channel-recommendation__channel-details--close\" ng-click=\"hidePopover()\"><span class=\"ute-icon-circle-cross\"></span></div><div class=\"ute-channel-recommendation__channel-details-wrapper\"><div class=\"ute-channel-recommendation__channel-details--channelicon-container\"><div><img class=\"img-responsive\" ng-src=\"{{ detailsData.logo }}\"></div></div><div class=\"ute-channel-recommendation__channel-details--img-container\" ng-if=\"detailsImages\"><span immutable=\"detailsImages\" ng-repeat=\"image in detailsData.images\"><img ng-src=\"{{ image }}\"></span></div><div class=\"ute-channel-recommendation__channel-details--p\"><p>{{ detailsData.description | limitTo : 200}}{{ detailsData.description && detailsData.description.length >200 ? \' ...\':\'\' }}</p></div></div></div></div>");
$templateCache.put("module/locale/languageSelector/languageSelector.view.html","<div class=\"language-selector\" ng-click=\"changeLanguage()\"><button class=\"btn btn-default active\" type=\"button\" ute-language-selector=\"{{language | lowercase}}\"><span class=\"language-abbrv\"></span></button></div>");
$templateCache.put("module/locale/provinceSelector/provinceSelector.view.html","<div class=\"dropdown\" dropdown=\"\"><a aria-expanded=\"false\" role=\"button\" class=\"dropdown-toggle\" dropdown-toggle=\"\" href=\"#\">{{ vm.selectedProvince | uppercase }} <i class=\"ute-icon-circle-down\"></i></a><ul role=\"menu\" class=\"dropdown-menu\"><li class=\"region-header\">Select A Province</li><li ng-repeat=\"(index, province) in ::vm.provinces\"><a id=\"{{::province | uppercase}}\" name=\"{{::province | uppercase}}\" href=\"#\" ng-click=\"vm.saveProvince(province)\"><ins translate=\"global.province.{{::province}}.name\">{{::province}}</ins></a></li></ul><select ng-model=\"vm.selectedProvince\" ng-change=\"vm.saveProvince(vm.selectedProvince)\"><option ng-repeat=\"province in vm.provinces\" label=\"{{province}}\" value=\"{{province}}\" ng-selected=\"province === vm.selectedProvince.toLowerCase()\"></option></select></div>");
$templateCache.put("module/locale/provinceSelector/provinceSelectorModal.view.html","<div class=\"modal-header\"><button type=\"button\" ng-click=\"cancel()\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\"><span class=\"ute-icon-circle-x\"></span></span></button><h2 class=\"modal-title province-selection-modal\"><ins translate=\"global.label.provinceSelectionGreeting\"></ins></h2><h3 class=\"copy-1\"><ins translate=\"global.label.selectRegion\"></ins></h3></div><div class=\"modal-body\"><div class=\"row province-group\"><div class=\"col-sm-4 col-xs-12\"><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"ab\" ng-model=\"selectedProvince\" value=\"ab\"><label for=\"ab\"><ins translate=\"global.province.ab.name\"></ins></label></div><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"nb\" ng-model=\"selectedProvince\" value=\"nb\"><label for=\"nb\"><ins translate=\"global.province.nb.name\"></ins></label></div><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"on\" ng-model=\"selectedProvince\" value=\"on\"><label for=\"on\"><ins translate=\"global.province.on.name\"></ins></label></div><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"sk\" ng-model=\"selectedProvince\" value=\"sk\"><label for=\"sk\"><ins translate=\"global.province.sk.name\"></ins></label></div></div><div class=\"col-sm-4 col-xs-12\"><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"bc\" ng-model=\"selectedProvince\" value=\"bc\"><label for=\"bc\"><ins translate=\"global.province.bc.name\"></ins></label></div><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"nl\" ng-model=\"selectedProvince\" value=\"nl\"><label for=\"nl\"><ins translate=\"global.province.nl.name\"></ins></label></div><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"pe\" ng-model=\"selectedProvince\" value=\"pe\"><label for=\"pe\"><ins translate=\"global.province.pe.name\"></ins></label></div></div><div class=\"col-sm-4 col-xs-12\"><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"mb\" ng-model=\"selectedProvince\" value=\"mb\"><label for=\"mb\"><ins translate=\"global.province.mb.name\"></ins></label></div><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"ns\" ng-model=\"selectedProvince\" value=\"ns\"><label for=\"ns\"><ins translate=\"global.province.ns.name\"></ins></label></div><div><input class=\"ute-input-radio\" type=\"radio\" name=\"provinceChoices\" id=\"qc\" ng-model=\"selectedProvince\" value=\"qc\"><label for=\"qc\"><ins translate=\"global.province.qc.name\"></ins></label></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><p><ins translate=\"global.label.provinceWhy\"></ins><a href=\"#province-click-here\" ng-click=\"$event.preventDefault();\" data-toggle=\"collapse\" aria-expanded=\"false\" aria-control=\"{{item.tierId}}\" class=\"ute-link\"><ins translate=\"global.label.provinceWhyLink\"></ins></a><ins translate=\"global.label.provinceWhyLearn\"></ins>.</p><div id=\"province-click-here\" class=\"collapse\"><p><ins translate=\"global.message.provinceWhy\"></ins></p></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6 text-left modal-footer-cancel\"><a data-dismiss=\"modal\" class=\"ute-link uppercase\" ng-click=\"cancel()\"><ins translate=\"global.cta.cancel\"></ins></a></div><div class=\"col-xs-6 text-right\"><button class=\"ute-btn-primary\" ng-click=\"ok(selectedProvince)\"><ins translate=\"global.cta.continue\"></ins></button></div></div></div>");}]);
angular.module("translations", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en", {"ute":{"common":{"label":{"edit":"Edit","cancel":"Cancel","check.form.errors":"There are errors on this page.  Please review the message(s) above each line.","contact.info":"Contact Information","continue":"Continue","email.address":"Email Address","email.confirm":"Confirm Email Address","email.invalid":"Please enter a valid email address","email.verification":"Email Verification","myRogers":"MyRogers","username":"Username","username.edit":"Edit username","username.change":"Change username","username.and.password":"Username and Password","username.guildeline":"Username guidelines","username.guildeline.list":"<br>Your username must be a valid email address. An email will be sent to the address<br>you enter containing a link to verify your address","password":"Password","password.old":"Old Password","password.incorrect":"Old password incorrect.","password.new":"New Password","password.change":"Change Password","password.confirm.new":"Confirm New Password","password.invalid":"Please enter a valid password","password.forgot":"Forgot Password","password.reset":"reset password","password.wrong":"You can use only numbers and letters in your password, not special characters. Please try again.","password.reenter":"Please confirm your password by re-entering it.","password.notmatch":"Your password confirmation entry does not match.","password.edit":"Edit password","password.guildeline":"Password guidelines","password.guildeline.list":"<br>Your password must be 7–16 characters long and must contain both letters and numbers.","language.preference":"Language Preference","system.error.message":"It seems something went wrong on our end. Please contact us on &nbsp;","system.error.message.p2":" to get this sorted out.","save.changes":"Save Changes","chat.live":"Live Chat","need.help":"Need Help?","contactUs":"Contact Us","findStore":"Find a store","learnHowTo":"Learn how to","moving":"Moving","andMore":", and more","needHelpWith":"Need help with","tv":"TV","wireless":"Wireless","internet":"Internet","bundles":"Bundles","homePhone":"Home Phone","smartHomePhone":"Smart Home Phone","homeMonitoring":"Home Monitoring","visitSupport":"Visit Support","troubleshoot":"Troubleshoot","signIn":"Sign In","newToRogers":"New to Rogers?","registerNow":"Register now"},"articleCarousel":{},"articleChild":{},"articleFeedback":{},"weather.widget":{"navigation":{}},"boldChat":{},"brightcoveVideo":{},"channelRecommendation":{},"htmlContent":{},"form":{"secured":"Secured Form"},"error":{"general":"Sorry, something went wrong. We’re working on fixing it as quickly as we can. Please check back in a few minutes.","maintenance":"Looks like you’re trying to access your services through MyRogers. We apologize, unfortunately the information you’re looking for is temporarily unavailable. Please check back later and thank you for your patience!"},"owlCarousel":{},"paginationBar":{},"relatedQuestions":{},"searchBar":{},"searchFilter":{},"searchResults":{},"searchSection":{},"simpleHtml":{},"spotlightCallout":{},"tvGuide":{},"youtubeComponent":{},"404Page":{"browserTitle":"Not Found"},"searchPage":{"print":"Print this article","email":"Email this article to a friend","browserTitle":"Search","breadcrumbsBar":{"labelMain":"Search","labelSecond":"Search Results"},"searchBar":{"label":"What do you need help with?","inputLabel":"Enter your question here","submitText":"Search help and support","placeholder":"Search Rogers.com"},"searchFilter":{"label":"Filter Results","countLabel":"Results for"},"channelRecommendation":{"label":"What channel is this on in your area?","whatsOn":{"label":"What's On","list":{"label1":"Digital TV Guide","label2":"Ignite TV Guide"}},"showAllLink":{"before":"Show all","after":"channels"},"channelNumber":{"label":"Channel","labelMobile":"CH."}}},"supportPage":{"browserTitle":"Support","breadcrumbsBar":{"labelMain":"Help & Support"},"articleFeedback":{"feedbackQuestion":{"label":"Did you find what you were looking for?","yesButton":"Yes","noButton":"No"},"feedbackForm":{"answerCountBefore":"Maximum of","answerCountAfter":"characters","captchaLabel":"Please select the box below:","requiredError":"This field is required","maxLengthError":"Please enter less than 500 characters","captchaError":"Oops! Please click the checkbox above.","resetButton":"No, thanks","submitButton":"Submit","thankYouTitle":"Thank you!","thankYouDescription":"We appreciate your feedback."},"feedbackAnswerYes":{"label":"Any feedback to help us improve the site?"},"feedbackAnswerNo":{"mainLabel":"We're sorry. For additional help, please Chat with us.","label":"Any feedback to help us improve the site?","chatLabelFirst":"chatIDLiveChatEN","chatLabelSecond":"chatIDLiveChatTechEN"}}}},"articleComponent":{"lastUpdated":"Last updated: "},"supportSection":{}},"ute.blocks":{"language.switcher":{"to":"fr","label":"Français"}}});

$translateProvider.translations("fr", {"ute":{"common":{"label":{"edit":"Modifier","cancel":"Annuler","check.form.errors":"Des erreurs de validation ont été détectées sur cette page. Veuillez consulter le message au-dessus de chaque ligne.","contact.info":"Coordonnées","continue":"Continuer","email.address":"Adresse électronique","email.confirm":"Confirmez l’adresse électronique","email.invalid":"Veuillez entrer une adresse &eacute;lectronique valide.","email.verification":"V&eacute;rification","myRogers":"MonRogers","username":"Nom d'utilisateur :","username.edit":"Modifier le nom d&rsquo;utilisateur","username.change":"Changer le nom d&rsquo;utilisateur","username.and.password":"Nom d&rsquo;utilisateur et mot de passe","username.guildeline":"Instructions pour cr&eacute;er votre nom d&rsquo;utilisateur","username.guildeline.list":"<br>Votre nom d&rsquo;utilisateur doit &ecirc;tre une adresse &eacute;lectronique valide. Un courriel contenant un lien de v&eacute;rification sera envoy&eacute; &agrave; cette adresse.","password":"Mot de passe :","password.old":"Ancien mot de passe","password.incorrect":"Ancien mot de passe est incorrect.","password.new":"Nouveau mot de passe","password.change":"Changer le Mot de passe","password.confirm.new":"Confirmer le nouveau mot de passe","password.invalid":"Veuillez entrer un mot de passe valide","password.forgot":"Vous avez oubli&eacute; votre mot de passe","password.reset":"R&eacute;initialisez votre mot de passe","password.wrong":"Votre mot de passe ne peut contenir que des chiffres et des lettres, et non des caract&egrave;res sp&eacute;ciaux. Veuillez r&eacute;essayer.","password.reenter":"Veuillez confirmer votre mot de passe en le saisissant de nouveau.","password.notmatch":"Votre mot de passe et celui de confirmation ne sont pas semblables.","password.edit":"Modifier le Mot de passe","password.guildeline":"Instructions pour cr&eacute;er votre mot de passe","password.guildeline.list":"<br>Votre mot de passe doit &ecirc;tre compos&eacute; de 7 &agrave; 16 caract&egrave;res et contenir des lettres et des chiffres.","language.preference":"Langue de préférence","system.error.message":"Il semble qu’une erreur se soit produite de notre côté. Veuillez communiquer avec nous au moyen du &nbsp;","system.error.message.p2":" pour démêler le tout. ","save.changes":"Enregistrer les changements","chat.live":"Clavardage en direct","need.help":"Besoin d'aide?","contactUs":"Contactez-nous","findStore":"Trouver un magasin","learnHowTo":"Apprendre à","moving":"Vous déménagez","andMore":" et plus encore","needHelpWith":"Besoin d'aide avec","tv":"Télé","wireless":"Sans fil","internet":"Internet","bundles":"Liasses","homePhone":"Téléphonie résidentielle","smartHomePhone":"Téléphonie résidentielle","homeMonitoring":"Système domotique","visitSupport":"Consulter le service de soutien","troubleshoot":"Obtenir du dépannage","signIn":"Connexion","newToRogers":"Vous êtes nouveau client de Rogers?","registerNow":"Inscrivez-vous dès maintenant!"},"articleCarousel":{},"articleChild":{},"articleFeedback":{},"weather.widget":{"navigation":{}},"boldChat":{},"brightcoveVideo":{},"channelRecommendation":{},"htmlContent":{},"form":{"secured":"Formulaire sécurisé"},"error":{"general":"D&eacute;sol&eacute;, une erreur s&rsquo;est produite. Nous tentons de r&eacute;gler le probl&egrave;me le plus rapidement possible. Les changements apport&eacute;s &agrave; vos forfaits n&rsquo;ont pas &eacute;t&eacute; enregistr&eacute;s. Veuillez rev&eacute;rifier dans quelques minutes.","maintenance":"Il semble que vous essayer d&rsquo;acc&eacute;der &agrave; ce service par l&rsquo;entremise de MonRogers. Nous sommes d&eacute;sol&eacute;s; l&rsquo;information que vous cherchez n&rsquo;est malheureusement pas disponible en ce moment. Veuillez r&eacute;essayer plus tard. Merci de votre patience!"},"owlCarousel":{},"paginationBar":{},"relatedQuestions":{},"searchBar":{},"searchFilter":{},"searchResults":{},"searchSection":{},"simpleHtml":{},"spotlightCallout":{},"tvGuide":{},"youtubeComponent":{},"404Page":{"browserTitle":"Not Found"},"searchPage":{"print":"Imprimer cet article","email":"Envoyer cet article par courriel à un(e) ami(e)","browserTitle":"Recherche","breadcrumbsBar":{"labelMain":"Recherche","labelSecond":"Résultats de recherché"},"searchBar":{"label":"Que cherchez-vous?","inputLabel":"Entrez votre question ici","submitText":"Rechercher dans Aide et soutien","placeholder":"Chercher sur Rogers.com"},"searchFilter":{"label":"Filtrer les résultats","countLabel":"Résultats pour"},"channelRecommendation":{"label":"À quelle chaîne est-ce diffusé dans votre région?","whatsOn":{"label":"Qu’est-ce qui est en cours de diffusion?","list":{"label1":"Guide de la Télé numérique","label2":"Guide de la Télé Élan"}},"showAllLink":{"before":"Afficher les","after":"chaînes"},"channelNumber":{"label":"Chaîne","labelMobile":"CH."}}},"supportPage":{"browserTitle":"Soutien","breadcrumbsBar":{"labelMain":"FR: Help & Support"},"articleFeedback":{"feedbackQuestion":{"label":"Avez-vous trouvé ce que vous cherchiez?","yesButton":"Oui","noButton":"Non"},"feedbackForm":{"answerCountBefore":"Maximum de","answerCountAfter":"caractères","captchaLabel":"Veuillez cocher la case ci-dessous:","requiredError":"This field is required","maxLengthError":"Please enter less than 500 characters","captchaError":"Oups! Veuillez cocher la case ci-dessus.","resetButton":"Non, merci.","submitButton":"Soumettre","thankYouTitle":"Merci!","thankYouDescription":"Nous vous remercions pour vos commentaires."},"feedbackAnswerYes":{"label":"Avez-vous des suggestions d'améliorations pour le site?"},"feedbackAnswerNo":{"mainLabel":"Désolés, veuillez communiquer avec nous pour obtenir de l'aide.","label":"Avez-vous des suggestions d'améliorations pour le site?","chatLabelFirst":"chatIDLiveChatFR","chatLabelSecond":"chatIDLiveChatTechFR"}}}},"articleComponent":{"lastUpdated":"Dernière mise à jour: "},"supportSection":{}},"ute.blocks":{"language.switcher":{"to":"en","label":"English"}}});
}]);
